
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2a67"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2a67"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h3MMF", function(module, exports) {
"use strict";
var $c6b88ef8ba6a41da$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c6b88ef8ba6a41da$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c6b88ef8ba6a41da$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c6b88ef8ba6a41da$var$__exportStar((parcelRequire("iz3n1")), module.exports);

});
parcelRegister("iz3n1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebcryptoKey = void 0;

var $4EOoK = parcelRequire("4EOoK");

var $gWe7n = parcelRequire("gWe7n");

var $24DA2 = parcelRequire("24DA2");
class $d83e1c28351a485b$var$WebcryptoKey extends $gWe7n.JoseKey {
    // We need to override the static method generate from JoseKey because
    // the browser needs both the private and public keys
    static async generate(allowedAlgos = [
        "ES256"
    ], kid = crypto.randomUUID(), options) {
        const keyPair = await this.generateKeyPair(allowedAlgos, options);
        // Type safety only: in the browser, 'jose' always generates a CryptoKeyPair
        if (!(0, $24DA2.isCryptoKeyPair)(keyPair)) throw new TypeError("Invalid CryptoKeyPair");
        return this.fromKeypair(keyPair, kid);
    }
    static async fromKeypair(cryptoKeyPair, kid) {
        // https://datatracker.ietf.org/doc/html/rfc7517
        // > The "use" and "key_ops" JWK members SHOULD NOT be used together; [...]
        // > Applications should specify which of these members they use.
        const { key_ops: _, ...jwk } = await crypto.subtle.exportKey("jwk", cryptoKeyPair.privateKey.extractable ? cryptoKeyPair.privateKey : cryptoKeyPair.publicKey);
        const use = jwk.use ?? "sig";
        const alg = jwk.alg ?? (0, $24DA2.fromSubtleAlgorithm)(cryptoKeyPair.privateKey.algorithm);
        if (use !== "sig") throw new TypeError("Unsupported JWK use");
        return new $d83e1c28351a485b$var$WebcryptoKey($4EOoK.jwkSchema.parse({
            ...jwk,
            use: use,
            kid: kid,
            alg: alg
        }), cryptoKeyPair);
    }
    constructor(jwk, cryptoKeyPair){
        super(jwk);
        Object.defineProperty(this, "cryptoKeyPair", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: cryptoKeyPair
        });
    }
    get isPrivate() {
        return true;
    }
    get privateJwk() {
        if (super.isPrivate) return this.jwk;
        throw new Error("Private Webcrypto Key not exportable");
    }
    async getKey() {
        return this.cryptoKeyPair.privateKey;
    }
}
module.exports.WebcryptoKey = $d83e1c28351a485b$var$WebcryptoKey;

});
parcelRegister("4EOoK", function(module, exports) {
"use strict";
var $3641fde537da1b69$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3641fde537da1b69$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3641fde537da1b69$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3641fde537da1b69$var$__exportStar((parcelRequire("cTCpq")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("32upx")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("apYKl")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("5C5JC")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("3crJS")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("1vWbg")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("9mG6e")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("32AL6")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("5gaBM")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("6M5ug")), module.exports);

});
parcelRegister("cTCpq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jwkAlgorithms = void 0;

var $32upx = parcelRequire("32upx");
// Copy variable to prevent bundlers from automatically polyfilling "process" (e.g. parcel)
const { process: $96386a570b6a8e50$var$process } = globalThis;
const $96386a570b6a8e50$var$IS_NODE_RUNTIME = typeof $96386a570b6a8e50$var$process !== "undefined" && typeof $96386a570b6a8e50$var$process?.versions?.node === "string";
function* $96386a570b6a8e50$var$jwkAlgorithms(jwk) {
    // Ed25519, Ed448, and secp256k1 always have "alg"
    // OKP always has "use"
    if (jwk.alg) {
        yield jwk.alg;
        return;
    }
    switch(jwk.kty){
        case "EC":
            if (jwk.use === "enc" || jwk.use === undefined) {
                yield "ECDH-ES";
                yield "ECDH-ES+A128KW";
                yield "ECDH-ES+A192KW";
                yield "ECDH-ES+A256KW";
            }
            if (jwk.use === "sig" || jwk.use === undefined) {
                const crv = "crv" in jwk ? jwk.crv : undefined;
                switch(crv){
                    case "P-256":
                    case "P-384":
                        yield `ES${crv.slice(-3)}`;
                        break;
                    case "P-521":
                        yield "ES512";
                        break;
                    case "secp256k1":
                        if ($96386a570b6a8e50$var$IS_NODE_RUNTIME) yield "ES256K";
                        break;
                    default:
                        throw new $32upx.JwkError(`Unsupported crv "${crv}"`);
                }
            }
            return;
        case "OKP":
            if (!jwk.use) throw new $32upx.JwkError('Missing "use" Parameter value');
            yield "ECDH-ES";
            yield "ECDH-ES+A128KW";
            yield "ECDH-ES+A192KW";
            yield "ECDH-ES+A256KW";
            return;
        case "RSA":
            if (jwk.use === "enc" || jwk.use === undefined) {
                yield "RSA-OAEP";
                yield "RSA-OAEP-256";
                yield "RSA-OAEP-384";
                yield "RSA-OAEP-512";
                if ($96386a570b6a8e50$var$IS_NODE_RUNTIME) yield "RSA1_5";
            }
            if (jwk.use === "sig" || jwk.use === undefined) {
                yield "PS256";
                yield "PS384";
                yield "PS512";
                yield "RS256";
                yield "RS384";
                yield "RS512";
            }
            return;
        case "oct":
            if (jwk.use === "enc" || jwk.use === undefined) {
                yield "A128GCMKW";
                yield "A192GCMKW";
                yield "A256GCMKW";
                yield "A128KW";
                yield "A192KW";
                yield "A256KW";
            }
            if (jwk.use === "sig" || jwk.use === undefined) {
                yield "HS256";
                yield "HS384";
                yield "HS512";
            }
            return;
        default:
            throw new $32upx.JwkError(`Unsupported kty "${jwk.kty}"`);
    }
}
module.exports.jwkAlgorithms = $96386a570b6a8e50$var$jwkAlgorithms;

});
parcelRegister("32upx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JwtVerifyError = module.exports.JwtCreateError = module.exports.JwkError = module.exports.ERR_JWT_VERIFY = module.exports.ERR_JWT_CREATE = module.exports.ERR_JWT_INVALID = module.exports.ERR_JWK_NOT_FOUND = module.exports.ERR_JWK_INVALID = module.exports.ERR_JWKS_NO_MATCHING_KEY = void 0;
module.exports.ERR_JWKS_NO_MATCHING_KEY = "ERR_JWKS_NO_MATCHING_KEY";
module.exports.ERR_JWK_INVALID = "ERR_JWK_INVALID";
module.exports.ERR_JWK_NOT_FOUND = "ERR_JWK_NOT_FOUND";
module.exports.ERR_JWT_INVALID = "ERR_JWT_INVALID";
module.exports.ERR_JWT_CREATE = "ERR_JWT_CREATE";
module.exports.ERR_JWT_VERIFY = "ERR_JWT_VERIFY";
class $236925f78d1b8093$var$JwkError extends TypeError {
    constructor(message = "JWK error", code = module.exports.ERR_JWK_INVALID, options){
        super(message, options);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: code
        });
    }
}
module.exports.JwkError = $236925f78d1b8093$var$JwkError;
class $236925f78d1b8093$var$JwtCreateError extends Error {
    constructor(message = "Unable to create JWT", code = module.exports.ERR_JWT_CREATE, options){
        super(message, options);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: code
        });
    }
    static from(cause, code, message) {
        if (cause instanceof $236925f78d1b8093$var$JwtCreateError) return cause;
        if (cause instanceof $236925f78d1b8093$var$JwkError) return new $236925f78d1b8093$var$JwtCreateError(message, cause.code, {
            cause: cause
        });
        return new $236925f78d1b8093$var$JwtCreateError(message, code, {
            cause: cause
        });
    }
}
module.exports.JwtCreateError = $236925f78d1b8093$var$JwtCreateError;
class $236925f78d1b8093$var$JwtVerifyError extends Error {
    constructor(message = "Invalid JWT", code = module.exports.ERR_JWT_VERIFY, options){
        super(message, options);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: code
        });
    }
    static from(cause, code, message) {
        if (cause instanceof $236925f78d1b8093$var$JwtVerifyError) return cause;
        if (cause instanceof $236925f78d1b8093$var$JwkError) return new $236925f78d1b8093$var$JwtVerifyError(message, cause.code, {
            cause: cause
        });
        return new $236925f78d1b8093$var$JwtVerifyError(message, code, {
            cause: cause
        });
    }
}
module.exports.JwtVerifyError = $236925f78d1b8093$var$JwtVerifyError;

});


parcelRegister("apYKl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jwkPubSchema = module.exports.jwkValidator = module.exports.jwkSchema = module.exports.jwkUnknownKeySchema = module.exports.jwkSymKeySchema = module.exports.jwkOkpKeySchema = module.exports.jwkEcSecp256k1KeySchema = module.exports.jwkEcKeySchema = module.exports.jwkRsaKeySchema = module.exports.jwkBaseSchema = module.exports.keyUsageSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.keyUsageSchema = $2zDt6.z.enum([
    "sign",
    "verify",
    "encrypt",
    "decrypt",
    "wrapKey",
    "unwrapKey",
    "deriveKey",
    "deriveBits"
]);
/**
 * The "use" and "key_ops" JWK members SHOULD NOT be used together;
 * however, if both are used, the information they convey MUST be
 * consistent.  Applications should specify which of these members they
 * use, if either is to be used by the application.
 *
 * @todo Actually check that "use" and "key_ops" are consistent when both are present.
 * @see {@link https://datatracker.ietf.org/doc/html/rfc7517#section-4.3}
 */ module.exports.jwkBaseSchema = $2zDt6.z.object({
    kty: $2zDt6.z.string().min(1),
    alg: $2zDt6.z.string().min(1).optional(),
    kid: $2zDt6.z.string().min(1).optional(),
    ext: $2zDt6.z.boolean().optional(),
    use: $2zDt6.z.enum([
        "sig",
        "enc"
    ]).optional(),
    key_ops: $2zDt6.z.array(module.exports.keyUsageSchema).optional(),
    x5c: $2zDt6.z.array($2zDt6.z.string()).optional(),
    x5t: $2zDt6.z.string().min(1).optional(),
    "x5t#S256": $2zDt6.z.string().min(1).optional(),
    x5u: $2zDt6.z.string().url().optional()
});
/**
 * @todo: properly implement this
 */ module.exports.jwkRsaKeySchema = module.exports.jwkBaseSchema.extend({
    kty: $2zDt6.z.literal("RSA"),
    alg: $2zDt6.z.enum([
        "RS256",
        "RS384",
        "RS512",
        "PS256",
        "PS384",
        "PS512"
    ]).optional(),
    n: $2zDt6.z.string().min(1),
    e: $2zDt6.z.string().min(1),
    d: $2zDt6.z.string().min(1).optional(),
    p: $2zDt6.z.string().min(1).optional(),
    q: $2zDt6.z.string().min(1).optional(),
    dp: $2zDt6.z.string().min(1).optional(),
    dq: $2zDt6.z.string().min(1).optional(),
    qi: $2zDt6.z.string().min(1).optional(),
    oth: $2zDt6.z.array($2zDt6.z.object({
        r: $2zDt6.z.string().optional(),
        d: $2zDt6.z.string().optional(),
        t: $2zDt6.z.string().optional()
    })).nonempty().optional()
});
module.exports.jwkEcKeySchema = module.exports.jwkBaseSchema.extend({
    kty: $2zDt6.z.literal("EC"),
    alg: $2zDt6.z.enum([
        "ES256",
        "ES384",
        "ES512"
    ]).optional(),
    crv: $2zDt6.z.enum([
        "P-256",
        "P-384",
        "P-521"
    ]),
    x: $2zDt6.z.string().min(1),
    y: $2zDt6.z.string().min(1),
    d: $2zDt6.z.string().min(1).optional()
});
module.exports.jwkEcSecp256k1KeySchema = module.exports.jwkBaseSchema.extend({
    kty: $2zDt6.z.literal("EC"),
    alg: $2zDt6.z.enum([
        "ES256K"
    ]).optional(),
    crv: $2zDt6.z.enum([
        "secp256k1"
    ]),
    x: $2zDt6.z.string().min(1),
    y: $2zDt6.z.string().min(1),
    d: $2zDt6.z.string().min(1).optional()
});
module.exports.jwkOkpKeySchema = module.exports.jwkBaseSchema.extend({
    kty: $2zDt6.z.literal("OKP"),
    alg: $2zDt6.z.enum([
        "EdDSA"
    ]).optional(),
    crv: $2zDt6.z.enum([
        "Ed25519",
        "Ed448"
    ]),
    x: $2zDt6.z.string().min(1),
    d: $2zDt6.z.string().min(1).optional()
});
module.exports.jwkSymKeySchema = module.exports.jwkBaseSchema.extend({
    kty: $2zDt6.z.literal("oct"),
    alg: $2zDt6.z.enum([
        "HS256",
        "HS384",
        "HS512"
    ]).optional(),
    k: $2zDt6.z.string()
});
module.exports.jwkUnknownKeySchema = module.exports.jwkBaseSchema.extend({
    kty: $2zDt6.z.string().refine((v)=>v !== "RSA" && v !== "EC" && v !== "OKP" && v !== "oct")
});
module.exports.jwkSchema = $2zDt6.z.union([
    module.exports.jwkUnknownKeySchema,
    module.exports.jwkRsaKeySchema,
    module.exports.jwkEcKeySchema,
    module.exports.jwkEcSecp256k1KeySchema,
    module.exports.jwkOkpKeySchema,
    module.exports.jwkSymKeySchema
]);
module.exports.jwkValidator = module.exports.jwkSchema.refine((k)=>k.use != null || k.key_ops != null, "use or key_ops required").refine((k)=>!k.use || !k.key_ops || k.key_ops.every((o)=>k.use === "sig" ? o === "sign" || o === "verify" : o === "encrypt" || o === "decrypt"), "use and key_ops must be consistent");
module.exports.jwkPubSchema = module.exports.jwkValidator.refine((k)=>k.kid != null, "kid is required").refine((k)=>!("k" in k) && !("d" in k), "private key not allowed");

});
parcelRegister("2zDt6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "util", () => $9ee9c7b494d01fc9$export$7debb50ef11d5e0b);
$parcel$export(module.exports, "objectUtil", () => $9ee9c7b494d01fc9$export$4aa2142c225fd5c7);
$parcel$export(module.exports, "ZodParsedType", () => $9ee9c7b494d01fc9$export$5716da67bfaa244d);
$parcel$export(module.exports, "getParsedType", () => $9ee9c7b494d01fc9$export$3e9057828ebd5c7a);
$parcel$export(module.exports, "ZodIssueCode", () => $9ee9c7b494d01fc9$export$5ba560653e4a1035);
$parcel$export(module.exports, "quotelessJson", () => $9ee9c7b494d01fc9$export$913eddeaf297cfea);
$parcel$export(module.exports, "ZodError", () => $9ee9c7b494d01fc9$export$f98dac4b251ab333);
$parcel$export(module.exports, "defaultErrorMap", () => $9ee9c7b494d01fc9$export$341b0b6e0a6f5099);
$parcel$export(module.exports, "setErrorMap", () => $9ee9c7b494d01fc9$export$1097a8289cfd22d7);
$parcel$export(module.exports, "getErrorMap", () => $9ee9c7b494d01fc9$export$32f27c719778d4c4);
$parcel$export(module.exports, "makeIssue", () => $9ee9c7b494d01fc9$export$244a85fde9c419ed);
$parcel$export(module.exports, "EMPTY_PATH", () => $9ee9c7b494d01fc9$export$1526d2e05f74572);
$parcel$export(module.exports, "addIssueToContext", () => $9ee9c7b494d01fc9$export$db7caee60e5d514d);
$parcel$export(module.exports, "ParseStatus", () => $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f);
$parcel$export(module.exports, "INVALID", () => $9ee9c7b494d01fc9$export$9a105a556e65c2c0);
$parcel$export(module.exports, "DIRTY", () => $9ee9c7b494d01fc9$export$325a211da9693fcf);
$parcel$export(module.exports, "OK", () => $9ee9c7b494d01fc9$export$c6813a8d51f77eaf);
$parcel$export(module.exports, "isAborted", () => $9ee9c7b494d01fc9$export$afa861e3c5730743);
$parcel$export(module.exports, "isDirty", () => $9ee9c7b494d01fc9$export$910b6cdd390341b3);
$parcel$export(module.exports, "isValid", () => $9ee9c7b494d01fc9$export$1ea939691cdc45b8);
$parcel$export(module.exports, "isAsync", () => $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e);
$parcel$export(module.exports, "Schema", () => $9ee9c7b494d01fc9$export$19342e026b58ebb7);
$parcel$export(module.exports, "ZodEffects", () => $9ee9c7b494d01fc9$export$a60af00cc0ce2582);
$parcel$export(module.exports, "ZodFirstPartyTypeKind", () => $9ee9c7b494d01fc9$export$558106ce543bd011);
$parcel$export(module.exports, "ZodOptional", () => $9ee9c7b494d01fc9$export$aa56fec1e9d629b8);
$parcel$export(module.exports, "ZodNullable", () => $9ee9c7b494d01fc9$export$aaac0b8b429cef5);
$parcel$export(module.exports, "ZodArray", () => $9ee9c7b494d01fc9$export$7acfc3e64785411);
$parcel$export(module.exports, "ZodPromise", () => $9ee9c7b494d01fc9$export$3f196b0127d6e50a);
$parcel$export(module.exports, "ZodUnion", () => $9ee9c7b494d01fc9$export$a8b236cb5070a311);
$parcel$export(module.exports, "ZodIntersection", () => $9ee9c7b494d01fc9$export$c02deaf0bb5203d4);
$parcel$export(module.exports, "ZodDefault", () => $9ee9c7b494d01fc9$export$bb19b37874861e7e);
$parcel$export(module.exports, "ZodBranded", () => $9ee9c7b494d01fc9$export$66b0c798a395271f);
$parcel$export(module.exports, "ZodCatch", () => $9ee9c7b494d01fc9$export$75a44ec6249ac76b);
$parcel$export(module.exports, "ZodPipeline", () => $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da);
$parcel$export(module.exports, "ZodReadonly", () => $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a);
$parcel$export(module.exports, "datetimeRegex", () => $9ee9c7b494d01fc9$export$a4b563879add27a);
$parcel$export(module.exports, "ZodString", () => $9ee9c7b494d01fc9$export$1230eb29b8d3b502);
$parcel$export(module.exports, "ZodNumber", () => $9ee9c7b494d01fc9$export$5b070a55c0c43e09);
$parcel$export(module.exports, "ZodBigInt", () => $9ee9c7b494d01fc9$export$67d741fd70ff98f4);
$parcel$export(module.exports, "ZodBoolean", () => $9ee9c7b494d01fc9$export$723d146f80596191);
$parcel$export(module.exports, "ZodDate", () => $9ee9c7b494d01fc9$export$e974be33bdc55521);
$parcel$export(module.exports, "ZodSymbol", () => $9ee9c7b494d01fc9$export$bcc3b40f6b638044);
$parcel$export(module.exports, "ZodUndefined", () => $9ee9c7b494d01fc9$export$4e780e961c30340d);
$parcel$export(module.exports, "ZodNull", () => $9ee9c7b494d01fc9$export$a96281f914484f2d);
$parcel$export(module.exports, "ZodAny", () => $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb);
$parcel$export(module.exports, "ZodUnknown", () => $9ee9c7b494d01fc9$export$ef3b1bb1630977ae);
$parcel$export(module.exports, "ZodNever", () => $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5);
$parcel$export(module.exports, "ZodVoid", () => $9ee9c7b494d01fc9$export$7d39f5df85f21031);
$parcel$export(module.exports, "ZodObject", () => $9ee9c7b494d01fc9$export$736315c5b55efbad);
$parcel$export(module.exports, "ZodTuple", () => $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3);
$parcel$export(module.exports, "ZodLazy", () => $9ee9c7b494d01fc9$export$378d0cfce37406e6);
$parcel$export(module.exports, "ZodLiteral", () => $9ee9c7b494d01fc9$export$7e44096782a165d3);
$parcel$export(module.exports, "ZodEnum", () => $9ee9c7b494d01fc9$export$d325d1f0e1c20179);
$parcel$export(module.exports, "ZodNativeEnum", () => $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56);
$parcel$export(module.exports, "ZodDiscriminatedUnion", () => $9ee9c7b494d01fc9$export$5ef2424805ac76a3);
$parcel$export(module.exports, "ZodRecord", () => $9ee9c7b494d01fc9$export$a2acc09968cb4b7f);
$parcel$export(module.exports, "ZodMap", () => $9ee9c7b494d01fc9$export$163b6a2b712d9542);
$parcel$export(module.exports, "ZodSet", () => $9ee9c7b494d01fc9$export$977057706f816712);
$parcel$export(module.exports, "ZodFunction", () => $9ee9c7b494d01fc9$export$d4602ba55673f53c);
$parcel$export(module.exports, "ZodNaN", () => $9ee9c7b494d01fc9$export$26ccfa0145e8511f);
$parcel$export(module.exports, "BRAND", () => $9ee9c7b494d01fc9$export$cf2deea74cde46b4);
$parcel$export(module.exports, "custom", () => $9ee9c7b494d01fc9$export$4c00f665f0d4b443);
$parcel$export(module.exports, "late", () => $9ee9c7b494d01fc9$export$1ee8ee30835eab8b);
$parcel$export(module.exports, "instanceof", () => $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5);
$parcel$export(module.exports, "string", () => $9ee9c7b494d01fc9$export$22b082955e083ec3);
$parcel$export(module.exports, "number", () => $9ee9c7b494d01fc9$export$98e628dec113755e);
$parcel$export(module.exports, "nan", () => $9ee9c7b494d01fc9$export$9e06de0973666692);
$parcel$export(module.exports, "bigint", () => $9ee9c7b494d01fc9$export$a0f65b52274bcc00);
$parcel$export(module.exports, "boolean", () => $9ee9c7b494d01fc9$export$4a21f16c33752377);
$parcel$export(module.exports, "date", () => $9ee9c7b494d01fc9$export$324d90190a8b822a);
$parcel$export(module.exports, "symbol", () => $9ee9c7b494d01fc9$export$8f701197936bc2a6);
$parcel$export(module.exports, "undefined", () => $9ee9c7b494d01fc9$export$1db45310990710a5);
$parcel$export(module.exports, "null", () => $9ee9c7b494d01fc9$export$7b1b591b262c240);
$parcel$export(module.exports, "any", () => $9ee9c7b494d01fc9$export$4154a199d7d90455);
$parcel$export(module.exports, "unknown", () => $9ee9c7b494d01fc9$export$19282c40b967aec6);
$parcel$export(module.exports, "never", () => $9ee9c7b494d01fc9$export$b3e22bcfd64c1022);
$parcel$export(module.exports, "void", () => $9ee9c7b494d01fc9$export$490e536ee7389aeb);
$parcel$export(module.exports, "array", () => $9ee9c7b494d01fc9$export$2f23118c22fb2630);
$parcel$export(module.exports, "object", () => $9ee9c7b494d01fc9$export$be5493f9613cbbe);
$parcel$export(module.exports, "strictObject", () => $9ee9c7b494d01fc9$export$8fb0df5f40d0b477);
$parcel$export(module.exports, "union", () => $9ee9c7b494d01fc9$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "discriminatedUnion", () => $9ee9c7b494d01fc9$export$4b888e40c4ee26dd);
$parcel$export(module.exports, "intersection", () => $9ee9c7b494d01fc9$export$bc86dfbf7795668c);
$parcel$export(module.exports, "tuple", () => $9ee9c7b494d01fc9$export$65e3907585753458);
$parcel$export(module.exports, "record", () => $9ee9c7b494d01fc9$export$e5185e241753e543);
$parcel$export(module.exports, "map", () => $9ee9c7b494d01fc9$export$871de8747c9eaa88);
$parcel$export(module.exports, "set", () => $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "function", () => $9ee9c7b494d01fc9$export$44e51c8aac7c2deb);
$parcel$export(module.exports, "lazy", () => $9ee9c7b494d01fc9$export$488013bae63b21da);
$parcel$export(module.exports, "literal", () => $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0);
$parcel$export(module.exports, "enum", () => $9ee9c7b494d01fc9$export$78a99c8d44d72635);
$parcel$export(module.exports, "nativeEnum", () => $9ee9c7b494d01fc9$export$6fe7eca19ebe5199);
$parcel$export(module.exports, "promise", () => $9ee9c7b494d01fc9$export$c957ef27a0ebfd4);
$parcel$export(module.exports, "effect", () => $9ee9c7b494d01fc9$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "optional", () => $9ee9c7b494d01fc9$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "nullable", () => $9ee9c7b494d01fc9$export$133fc36489ac9add);
$parcel$export(module.exports, "preprocess", () => $9ee9c7b494d01fc9$export$fc37fe19dfda43ee);
$parcel$export(module.exports, "pipeline", () => $9ee9c7b494d01fc9$export$43f28b24e1eb8181);
$parcel$export(module.exports, "ostring", () => $9ee9c7b494d01fc9$export$3b3d07727c5b702c);
$parcel$export(module.exports, "onumber", () => $9ee9c7b494d01fc9$export$eb150471a61fced6);
$parcel$export(module.exports, "oboolean", () => $9ee9c7b494d01fc9$export$269251733cdcbbf1);
$parcel$export(module.exports, "coerce", () => $9ee9c7b494d01fc9$export$8c14e57e778d3873);
$parcel$export(module.exports, "NEVER", () => $9ee9c7b494d01fc9$export$96c94437c95d7862);
$parcel$export(module.exports, "default", () => $9ee9c7b494d01fc9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ZodSchema", () => $9ee9c7b494d01fc9$export$19342e026b58ebb7);
$parcel$export(module.exports, "ZodTransformer", () => $9ee9c7b494d01fc9$export$a60af00cc0ce2582);
$parcel$export(module.exports, "ZodType", () => $9ee9c7b494d01fc9$export$19342e026b58ebb7);
$parcel$export(module.exports, "transformer", () => $9ee9c7b494d01fc9$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "z", () => $9ee9c7b494d01fc9$export$2e2bcd8739ae039);
var $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($9ee9c7b494d01fc9$export$7debb50ef11d5e0b || ($9ee9c7b494d01fc9$export$7debb50ef11d5e0b = {}));
var $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 || ($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 = {}));
const $9ee9c7b494d01fc9$export$5716da67bfaa244d = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $9ee9c7b494d01fc9$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined;
        case "string":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan : $9ee9c7b494d01fc9$export$5716da67bfaa244d.number;
        case "boolean":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean;
        case "function":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.function;
        case "bigint":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.array;
            if (data === null) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.date;
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.object;
        default:
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.unknown;
    }
};
const $9ee9c7b494d01fc9$export$5ba560653e4a1035 = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $9ee9c7b494d01fc9$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $9ee9c7b494d01fc9$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $9ee9c7b494d01fc9$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$9ee9c7b494d01fc9$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues);
    return error;
};
const $9ee9c7b494d01fc9$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $9ee9c7b494d01fc9$var$overrideErrorMap = $9ee9c7b494d01fc9$export$341b0b6e0a6f5099;
function $9ee9c7b494d01fc9$export$1097a8289cfd22d7(map) {
    $9ee9c7b494d01fc9$var$overrideErrorMap = map;
}
function $9ee9c7b494d01fc9$export$32f27c719778d4c4() {
    return $9ee9c7b494d01fc9$var$overrideErrorMap;
}
const $9ee9c7b494d01fc9$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $9ee9c7b494d01fc9$export$1526d2e05f74572 = [];
function $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $9ee9c7b494d01fc9$export$32f27c719778d4c4();
    const issue = $9ee9c7b494d01fc9$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $9ee9c7b494d01fc9$export$341b0b6e0a6f5099 ? undefined : $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $9ee9c7b494d01fc9$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $9ee9c7b494d01fc9$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $9ee9c7b494d01fc9$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $9ee9c7b494d01fc9$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $9ee9c7b494d01fc9$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $9ee9c7b494d01fc9$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $9ee9c7b494d01fc9$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $9ee9c7b494d01fc9$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $9ee9c7b494d01fc9$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($9ee9c7b494d01fc9$var$errorUtil || ($9ee9c7b494d01fc9$var$errorUtil = {}));
var $9ee9c7b494d01fc9$var$_ZodEnum_cache, $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache;
class $9ee9c7b494d01fc9$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $9ee9c7b494d01fc9$var$handleResult = (ctx, result)=>{
    if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $9ee9c7b494d01fc9$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $9ee9c7b494d01fc9$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $9ee9c7b494d01fc9$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $9ee9c7b494d01fc9$export$66b0c798a395271f({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $9ee9c7b494d01fc9$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $9ee9c7b494d01fc9$var$cuid2Regex = /^[0-9a-z]+$/;
const $9ee9c7b494d01fc9$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $9ee9c7b494d01fc9$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $9ee9c7b494d01fc9$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $9ee9c7b494d01fc9$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $9ee9c7b494d01fc9$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $9ee9c7b494d01fc9$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $9ee9c7b494d01fc9$var$emojiRegex;
// faster, simpler, safer
const $9ee9c7b494d01fc9$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $9ee9c7b494d01fc9$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $9ee9c7b494d01fc9$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $9ee9c7b494d01fc9$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $9ee9c7b494d01fc9$var$dateRegex = new RegExp(`^${$9ee9c7b494d01fc9$var$dateRegexSource}$`);
function $9ee9c7b494d01fc9$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $9ee9c7b494d01fc9$var$timeRegex(args) {
    return new RegExp(`^${$9ee9c7b494d01fc9$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $9ee9c7b494d01fc9$export$a4b563879add27a(args) {
    let regex = `${$9ee9c7b494d01fc9$var$dateRegexSource}T${$9ee9c7b494d01fc9$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $9ee9c7b494d01fc9$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $9ee9c7b494d01fc9$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $9ee9c7b494d01fc9$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $9ee9c7b494d01fc9$export$1230eb29b8d3b502 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$9ee9c7b494d01fc9$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$9ee9c7b494d01fc9$var$emojiRegex) $9ee9c7b494d01fc9$var$emojiRegex = new RegExp($9ee9c7b494d01fc9$var$_emojiRegex, "u");
                if (!$9ee9c7b494d01fc9$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$9ee9c7b494d01fc9$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$9ee9c7b494d01fc9$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$9ee9c7b494d01fc9$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$9ee9c7b494d01fc9$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$9ee9c7b494d01fc9$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $9ee9c7b494d01fc9$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $9ee9c7b494d01fc9$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $9ee9c7b494d01fc9$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$9ee9c7b494d01fc9$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$9ee9c7b494d01fc9$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$9ee9c7b494d01fc9$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $9ee9c7b494d01fc9$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $9ee9c7b494d01fc9$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $9ee9c7b494d01fc9$export$5b070a55c0c43e09 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($9ee9c7b494d01fc9$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$67d741fd70ff98f4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$723d146f80596191 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$723d146f80596191.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$723d146f80596191({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e974be33bdc55521 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$9ee9c7b494d01fc9$export$e974be33bdc55521.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDate,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bcc3b40f6b638044 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$bcc3b40f6b638044.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$bcc3b40f6b638044({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSymbol,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$4e780e961c30340d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$4e780e961c30340d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$4e780e961c30340d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUndefined,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a96281f914484f2d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$a96281f914484f2d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$a96281f914484f2d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNull,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodAny,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$ef3b1bb1630977ae extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$ef3b1bb1630977ae({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnknown,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
            expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
    }
}
$9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNever,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7d39f5df85f21031 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$7d39f5df85f21031.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$7d39f5df85f21031({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodVoid,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7acfc3e64785411 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big : $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$7acfc3e64785411.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodArray,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$deepPartialify(schema) {
    if (schema instanceof $9ee9c7b494d01fc9$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(fieldSchema));
        }
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $9ee9c7b494d01fc9$export$7acfc3e64785411) return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        ...schema._def,
        type: $9ee9c7b494d01fc9$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8) return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$aaac0b8b429cef5) return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3) return $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$9ee9c7b494d01fc9$var$deepPartialify(item)));
    else return schema;
}
class $9ee9c7b494d01fc9$export$736315c5b55efbad extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $9ee9c7b494d01fc9$var$errorUtil.errToObj;
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $9ee9c7b494d01fc9$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $9ee9c7b494d01fc9$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $9ee9c7b494d01fc9$var$createZodEnum($9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$9ee9c7b494d01fc9$export$736315c5b55efbad.create = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a8b236cb5070a311 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(result.ctx.common.issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$9ee9c7b494d01fc9$export$a8b236cb5070a311.create = (types, params)=>{
    return new $9ee9c7b494d01fc9$export$a8b236cb5070a311({
        options: types,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnion,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $9ee9c7b494d01fc9$var$getDiscriminator = (type)=>{
    if (type instanceof $9ee9c7b494d01fc9$export$378d0cfce37406e6) return $9ee9c7b494d01fc9$var$getDiscriminator(type.schema);
    else if (type instanceof $9ee9c7b494d01fc9$export$a60af00cc0ce2582) return $9ee9c7b494d01fc9$var$getDiscriminator(type.innerType());
    else if (type instanceof $9ee9c7b494d01fc9$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $9ee9c7b494d01fc9$export$bb19b37874861e7e) return $9ee9c7b494d01fc9$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $9ee9c7b494d01fc9$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8) return [
        undefined,
        ...$9ee9c7b494d01fc9$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$aaac0b8b429cef5) return [
        null,
        ...$9ee9c7b494d01fc9$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$66b0c798a395271f) return $9ee9c7b494d01fc9$var$getDiscriminator(type.unwrap());
    else if (type instanceof $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a) return $9ee9c7b494d01fc9$var$getDiscriminator(type.unwrap());
    else if (type instanceof $9ee9c7b494d01fc9$export$75a44ec6249ac76b) return $9ee9c7b494d01fc9$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $9ee9c7b494d01fc9$export$5ef2424805ac76a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $9ee9c7b494d01fc9$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $9ee9c7b494d01fc9$export$5ef2424805ac76a3({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
function $9ee9c7b494d01fc9$var$mergeValues(a, b) {
    const aType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(a);
    const bType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
        const bKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $9ee9c7b494d01fc9$export$c02deaf0bb5203d4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($9ee9c7b494d01fc9$export$afa861e3c5730743(parsedLeft) || $9ee9c7b494d01fc9$export$afa861e3c5730743(parsedRight)) return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            const merged = $9ee9c7b494d01fc9$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            }
            if ($9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedLeft) || $9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $9ee9c7b494d01fc9$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodIntersection,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a2acc09968cb4b7f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $9ee9c7b494d01fc9$export$19342e026b58ebb7) return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(third)
        });
        return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(second)
        });
    }
}
class $9ee9c7b494d01fc9$export$163b6a2b712d9542 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.map) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$9ee9c7b494d01fc9$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodMap,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$977057706f816712 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.set) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$977057706f816712.create = (valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSet,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$d4602ba55673f53c extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.function) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $9ee9c7b494d01fc9$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            args: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(items).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            args: args ? args : $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create([]).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create()),
            returns: returns || $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create(),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodFunction,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
class $9ee9c7b494d01fc9$export$378d0cfce37406e6 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$9ee9c7b494d01fc9$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $9ee9c7b494d01fc9$export$378d0cfce37406e6({
        getter: getter,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLazy,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7e44096782a165d3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$9ee9c7b494d01fc9$export$7e44096782a165d3.create = (value, params)=>{
    return new $9ee9c7b494d01fc9$export$7e44096782a165d3({
        value: value,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLiteral,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$createZodEnum(values, params) {
    return new $9ee9c7b494d01fc9$export$d325d1f0e1c20179({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
}
class $9ee9c7b494d01fc9$export$d325d1f0e1c20179 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $9ee9c7b494d01fc9$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (!$9ee9c7b494d01fc9$var$__classPrivateFieldGet(this, $9ee9c7b494d01fc9$var$_ZodEnum_cache, "f")) $9ee9c7b494d01fc9$var$__classPrivateFieldSet(this, $9ee9c7b494d01fc9$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$9ee9c7b494d01fc9$var$__classPrivateFieldGet(this, $9ee9c7b494d01fc9$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$9ee9c7b494d01fc9$var$_ZodEnum_cache = new WeakMap();
$9ee9c7b494d01fc9$export$d325d1f0e1c20179.create = $9ee9c7b494d01fc9$var$createZodEnum;
class $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string && ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (!$9ee9c7b494d01fc9$var$__classPrivateFieldGet(this, $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache, "f")) $9ee9c7b494d01fc9$var$__classPrivateFieldSet(this, $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache, new Set($9ee9c7b494d01fc9$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$9ee9c7b494d01fc9$var$__classPrivateFieldGet(this, $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$9ee9c7b494d01fc9$var$_ZodNativeEnum_cache = new WeakMap();
$9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNativeEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$3f196b0127d6e50a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$9ee9c7b494d01fc9$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$3f196b0127d6e50a({
        type: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPromise,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a60af00cc0ce2582 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $9ee9c7b494d01fc9$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $9ee9c7b494d01fc9$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $9ee9c7b494d01fc9$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $9ee9c7b494d01fc9$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aa56fec1e9d629b8 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodOptional,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aaac0b8b429cef5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNullable,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bb19b37874861e7e extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$bb19b37874861e7e.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$75a44ec6249ac76b extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$26ccfa0145e8511f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$9ee9c7b494d01fc9$export$26ccfa0145e8511f.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$26ccfa0145e8511f({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNaN,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
const $9ee9c7b494d01fc9$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $9ee9c7b494d01fc9$export$66b0c798a395271f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $9ee9c7b494d01fc9$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodReadonly,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create();
}
const $9ee9c7b494d01fc9$export$1ee8ee30835eab8b = {
    object: $9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate
};
var $9ee9c7b494d01fc9$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($9ee9c7b494d01fc9$export$558106ce543bd011 || ($9ee9c7b494d01fc9$export$558106ce543bd011 = {}));
const $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$9ee9c7b494d01fc9$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $9ee9c7b494d01fc9$export$22b082955e083ec3 = $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create;
const $9ee9c7b494d01fc9$export$98e628dec113755e = $9ee9c7b494d01fc9$export$5b070a55c0c43e09.create;
const $9ee9c7b494d01fc9$export$9e06de0973666692 = $9ee9c7b494d01fc9$export$26ccfa0145e8511f.create;
const $9ee9c7b494d01fc9$export$a0f65b52274bcc00 = $9ee9c7b494d01fc9$export$67d741fd70ff98f4.create;
const $9ee9c7b494d01fc9$export$4a21f16c33752377 = $9ee9c7b494d01fc9$export$723d146f80596191.create;
const $9ee9c7b494d01fc9$export$324d90190a8b822a = $9ee9c7b494d01fc9$export$e974be33bdc55521.create;
const $9ee9c7b494d01fc9$export$8f701197936bc2a6 = $9ee9c7b494d01fc9$export$bcc3b40f6b638044.create;
const $9ee9c7b494d01fc9$export$1db45310990710a5 = $9ee9c7b494d01fc9$export$4e780e961c30340d.create;
const $9ee9c7b494d01fc9$export$7b1b591b262c240 = $9ee9c7b494d01fc9$export$a96281f914484f2d.create;
const $9ee9c7b494d01fc9$export$4154a199d7d90455 = $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create;
const $9ee9c7b494d01fc9$export$19282c40b967aec6 = $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create;
const $9ee9c7b494d01fc9$export$b3e22bcfd64c1022 = $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create;
const $9ee9c7b494d01fc9$export$490e536ee7389aeb = $9ee9c7b494d01fc9$export$7d39f5df85f21031.create;
const $9ee9c7b494d01fc9$export$2f23118c22fb2630 = $9ee9c7b494d01fc9$export$7acfc3e64785411.create;
const $9ee9c7b494d01fc9$export$be5493f9613cbbe = $9ee9c7b494d01fc9$export$736315c5b55efbad.create;
const $9ee9c7b494d01fc9$export$8fb0df5f40d0b477 = $9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate;
const $9ee9c7b494d01fc9$export$971dd5b0dfd021b6 = $9ee9c7b494d01fc9$export$a8b236cb5070a311.create;
const $9ee9c7b494d01fc9$export$4b888e40c4ee26dd = $9ee9c7b494d01fc9$export$5ef2424805ac76a3.create;
const $9ee9c7b494d01fc9$export$bc86dfbf7795668c = $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create;
const $9ee9c7b494d01fc9$export$65e3907585753458 = $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create;
const $9ee9c7b494d01fc9$export$e5185e241753e543 = $9ee9c7b494d01fc9$export$a2acc09968cb4b7f.create;
const $9ee9c7b494d01fc9$export$871de8747c9eaa88 = $9ee9c7b494d01fc9$export$163b6a2b712d9542.create;
const $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be = $9ee9c7b494d01fc9$export$977057706f816712.create;
const $9ee9c7b494d01fc9$export$44e51c8aac7c2deb = $9ee9c7b494d01fc9$export$d4602ba55673f53c.create;
const $9ee9c7b494d01fc9$export$488013bae63b21da = $9ee9c7b494d01fc9$export$378d0cfce37406e6.create;
const $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0 = $9ee9c7b494d01fc9$export$7e44096782a165d3.create;
const $9ee9c7b494d01fc9$export$78a99c8d44d72635 = $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create;
const $9ee9c7b494d01fc9$export$6fe7eca19ebe5199 = $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create;
const $9ee9c7b494d01fc9$export$c957ef27a0ebfd4 = $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create;
const $9ee9c7b494d01fc9$export$dc573d8a6576cdb3 = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.create;
const $9ee9c7b494d01fc9$export$516e28dec6a4b6d4 = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create;
const $9ee9c7b494d01fc9$export$133fc36489ac9add = $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create;
const $9ee9c7b494d01fc9$export$fc37fe19dfda43ee = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess;
const $9ee9c7b494d01fc9$export$43f28b24e1eb8181 = $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create;
const $9ee9c7b494d01fc9$export$3b3d07727c5b702c = ()=>$9ee9c7b494d01fc9$export$22b082955e083ec3().optional();
const $9ee9c7b494d01fc9$export$eb150471a61fced6 = ()=>$9ee9c7b494d01fc9$export$98e628dec113755e().optional();
const $9ee9c7b494d01fc9$export$269251733cdcbbf1 = ()=>$9ee9c7b494d01fc9$export$4a21f16c33752377().optional();
const $9ee9c7b494d01fc9$export$8c14e57e778d3873 = {
    string: (arg)=>$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$9ee9c7b494d01fc9$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$9ee9c7b494d01fc9$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $9ee9c7b494d01fc9$export$96c94437c95d7862 = $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
var $9ee9c7b494d01fc9$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $9ee9c7b494d01fc9$export$341b0b6e0a6f5099,
    setErrorMap: $9ee9c7b494d01fc9$export$1097a8289cfd22d7,
    getErrorMap: $9ee9c7b494d01fc9$export$32f27c719778d4c4,
    makeIssue: $9ee9c7b494d01fc9$export$244a85fde9c419ed,
    EMPTY_PATH: $9ee9c7b494d01fc9$export$1526d2e05f74572,
    addIssueToContext: $9ee9c7b494d01fc9$export$db7caee60e5d514d,
    ParseStatus: $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f,
    INVALID: $9ee9c7b494d01fc9$export$9a105a556e65c2c0,
    DIRTY: $9ee9c7b494d01fc9$export$325a211da9693fcf,
    OK: $9ee9c7b494d01fc9$export$c6813a8d51f77eaf,
    isAborted: $9ee9c7b494d01fc9$export$afa861e3c5730743,
    isDirty: $9ee9c7b494d01fc9$export$910b6cdd390341b3,
    isValid: $9ee9c7b494d01fc9$export$1ea939691cdc45b8,
    isAsync: $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e,
    get util () {
        return $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $9ee9c7b494d01fc9$export$5716da67bfaa244d,
    getParsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a,
    ZodType: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    datetimeRegex: $9ee9c7b494d01fc9$export$a4b563879add27a,
    ZodString: $9ee9c7b494d01fc9$export$1230eb29b8d3b502,
    ZodNumber: $9ee9c7b494d01fc9$export$5b070a55c0c43e09,
    ZodBigInt: $9ee9c7b494d01fc9$export$67d741fd70ff98f4,
    ZodBoolean: $9ee9c7b494d01fc9$export$723d146f80596191,
    ZodDate: $9ee9c7b494d01fc9$export$e974be33bdc55521,
    ZodSymbol: $9ee9c7b494d01fc9$export$bcc3b40f6b638044,
    ZodUndefined: $9ee9c7b494d01fc9$export$4e780e961c30340d,
    ZodNull: $9ee9c7b494d01fc9$export$a96281f914484f2d,
    ZodAny: $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb,
    ZodUnknown: $9ee9c7b494d01fc9$export$ef3b1bb1630977ae,
    ZodNever: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5,
    ZodVoid: $9ee9c7b494d01fc9$export$7d39f5df85f21031,
    ZodArray: $9ee9c7b494d01fc9$export$7acfc3e64785411,
    ZodObject: $9ee9c7b494d01fc9$export$736315c5b55efbad,
    ZodUnion: $9ee9c7b494d01fc9$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $9ee9c7b494d01fc9$export$5ef2424805ac76a3,
    ZodIntersection: $9ee9c7b494d01fc9$export$c02deaf0bb5203d4,
    ZodTuple: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3,
    ZodRecord: $9ee9c7b494d01fc9$export$a2acc09968cb4b7f,
    ZodMap: $9ee9c7b494d01fc9$export$163b6a2b712d9542,
    ZodSet: $9ee9c7b494d01fc9$export$977057706f816712,
    ZodFunction: $9ee9c7b494d01fc9$export$d4602ba55673f53c,
    ZodLazy: $9ee9c7b494d01fc9$export$378d0cfce37406e6,
    ZodLiteral: $9ee9c7b494d01fc9$export$7e44096782a165d3,
    ZodEnum: $9ee9c7b494d01fc9$export$d325d1f0e1c20179,
    ZodNativeEnum: $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56,
    ZodPromise: $9ee9c7b494d01fc9$export$3f196b0127d6e50a,
    ZodEffects: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodTransformer: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodOptional: $9ee9c7b494d01fc9$export$aa56fec1e9d629b8,
    ZodNullable: $9ee9c7b494d01fc9$export$aaac0b8b429cef5,
    ZodDefault: $9ee9c7b494d01fc9$export$bb19b37874861e7e,
    ZodCatch: $9ee9c7b494d01fc9$export$75a44ec6249ac76b,
    ZodNaN: $9ee9c7b494d01fc9$export$26ccfa0145e8511f,
    BRAND: $9ee9c7b494d01fc9$export$cf2deea74cde46b4,
    ZodBranded: $9ee9c7b494d01fc9$export$66b0c798a395271f,
    ZodPipeline: $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da,
    ZodReadonly: $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a,
    custom: $9ee9c7b494d01fc9$export$4c00f665f0d4b443,
    Schema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    ZodSchema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    late: $9ee9c7b494d01fc9$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $9ee9c7b494d01fc9$export$558106ce543bd011;
    },
    coerce: $9ee9c7b494d01fc9$export$8c14e57e778d3873,
    any: $9ee9c7b494d01fc9$export$4154a199d7d90455,
    array: $9ee9c7b494d01fc9$export$2f23118c22fb2630,
    bigint: $9ee9c7b494d01fc9$export$a0f65b52274bcc00,
    boolean: $9ee9c7b494d01fc9$export$4a21f16c33752377,
    date: $9ee9c7b494d01fc9$export$324d90190a8b822a,
    discriminatedUnion: $9ee9c7b494d01fc9$export$4b888e40c4ee26dd,
    effect: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    "enum": $9ee9c7b494d01fc9$export$78a99c8d44d72635,
    "function": $9ee9c7b494d01fc9$export$44e51c8aac7c2deb,
    "instanceof": $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5,
    intersection: $9ee9c7b494d01fc9$export$bc86dfbf7795668c,
    lazy: $9ee9c7b494d01fc9$export$488013bae63b21da,
    literal: $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0,
    map: $9ee9c7b494d01fc9$export$871de8747c9eaa88,
    nan: $9ee9c7b494d01fc9$export$9e06de0973666692,
    nativeEnum: $9ee9c7b494d01fc9$export$6fe7eca19ebe5199,
    never: $9ee9c7b494d01fc9$export$b3e22bcfd64c1022,
    "null": $9ee9c7b494d01fc9$export$7b1b591b262c240,
    nullable: $9ee9c7b494d01fc9$export$133fc36489ac9add,
    number: $9ee9c7b494d01fc9$export$98e628dec113755e,
    object: $9ee9c7b494d01fc9$export$be5493f9613cbbe,
    oboolean: $9ee9c7b494d01fc9$export$269251733cdcbbf1,
    onumber: $9ee9c7b494d01fc9$export$eb150471a61fced6,
    optional: $9ee9c7b494d01fc9$export$516e28dec6a4b6d4,
    ostring: $9ee9c7b494d01fc9$export$3b3d07727c5b702c,
    pipeline: $9ee9c7b494d01fc9$export$43f28b24e1eb8181,
    preprocess: $9ee9c7b494d01fc9$export$fc37fe19dfda43ee,
    promise: $9ee9c7b494d01fc9$export$c957ef27a0ebfd4,
    record: $9ee9c7b494d01fc9$export$e5185e241753e543,
    set: $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be,
    strictObject: $9ee9c7b494d01fc9$export$8fb0df5f40d0b477,
    string: $9ee9c7b494d01fc9$export$22b082955e083ec3,
    symbol: $9ee9c7b494d01fc9$export$8f701197936bc2a6,
    transformer: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    tuple: $9ee9c7b494d01fc9$export$65e3907585753458,
    "undefined": $9ee9c7b494d01fc9$export$1db45310990710a5,
    union: $9ee9c7b494d01fc9$export$971dd5b0dfd021b6,
    unknown: $9ee9c7b494d01fc9$export$19282c40b967aec6,
    "void": $9ee9c7b494d01fc9$export$490e536ee7389aeb,
    NEVER: $9ee9c7b494d01fc9$export$96c94437c95d7862,
    ZodIssueCode: $9ee9c7b494d01fc9$export$5ba560653e4a1035,
    quotelessJson: $9ee9c7b494d01fc9$export$913eddeaf297cfea,
    ZodError: $9ee9c7b494d01fc9$export$f98dac4b251ab333
});

});


parcelRegister("5C5JC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jwksPubSchema = module.exports.jwksSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $apYKl = parcelRequire("apYKl");
module.exports.jwksSchema = $2zDt6.z.object({
    keys: $2zDt6.z.array($apYKl.jwkSchema)
});
module.exports.jwksPubSchema = $2zDt6.z.object({
    keys: $2zDt6.z.array($apYKl.jwkPubSchema)
});

});

parcelRegister("3crJS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unsafeDecodeJwt = void 0;

var $32upx = parcelRequire("32upx");

var $9mG6e = parcelRequire("9mG6e");

var $6M5ug = parcelRequire("6M5ug");
function $2548027a7e677e98$var$unsafeDecodeJwt(jwt) {
    const { 0: headerEnc, 1: payloadEnc, length: length } = jwt.split(".");
    if (length > 3 || length < 2) throw new $32upx.JwtVerifyError(undefined, $32upx.ERR_JWT_INVALID);
    const header = $9mG6e.jwtHeaderSchema.parse((0, $6M5ug.parseB64uJson)(headerEnc));
    if (length === 2 && header?.alg !== "none") throw new $32upx.JwtVerifyError(undefined, $32upx.ERR_JWT_INVALID);
    const payload = $9mG6e.jwtPayloadSchema.parse((0, $6M5ug.parseB64uJson)(payloadEnc));
    return {
        header: header,
        payload: payload
    };
}
module.exports.unsafeDecodeJwt = $2548027a7e677e98$var$unsafeDecodeJwt;

});
parcelRegister("9mG6e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jwtPayloadSchema = module.exports.jwtHeaderSchema = module.exports.isUnsignedJwt = module.exports.unsignedJwtSchema = module.exports.isSignedJwt = module.exports.signedJwtSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $apYKl = parcelRequire("apYKl");

var $6M5ug = parcelRequire("6M5ug");
module.exports.signedJwtSchema = $2zDt6.z.string().superRefine($6M5ug.jwtCharsRefinement).superRefine((0, $6M5ug.segmentedStringRefinementFactory)(3));
const $6d16d339d26710f4$var$isSignedJwt = (data)=>module.exports.signedJwtSchema.safeParse(data).success;
module.exports.isSignedJwt = $6d16d339d26710f4$var$isSignedJwt;
module.exports.unsignedJwtSchema = $2zDt6.z.string().superRefine($6M5ug.jwtCharsRefinement).superRefine((0, $6M5ug.segmentedStringRefinementFactory)(2));
const $6d16d339d26710f4$var$isUnsignedJwt = (data)=>module.exports.unsignedJwtSchema.safeParse(data).success;
module.exports.isUnsignedJwt = $6d16d339d26710f4$var$isUnsignedJwt;
/**
 * @see {@link https://www.rfc-editor.org/rfc/rfc7515.html#section-4}
 */ module.exports.jwtHeaderSchema = $2zDt6.z.object({
    /** "alg" (Algorithm) Header Parameter */ alg: $2zDt6.z.string(),
    /** "jku" (JWK Set URL) Header Parameter */ jku: $2zDt6.z.string().url().optional(),
    /** "jwk" (JSON Web Key) Header Parameter */ jwk: $2zDt6.z.object({
        kty: $2zDt6.z.string(),
        crv: $2zDt6.z.string().optional(),
        x: $2zDt6.z.string().optional(),
        y: $2zDt6.z.string().optional(),
        e: $2zDt6.z.string().optional(),
        n: $2zDt6.z.string().optional()
    }).optional(),
    /** "kid" (Key ID) Header Parameter */ kid: $2zDt6.z.string().optional(),
    /** "x5u" (X.509 URL) Header Parameter */ x5u: $2zDt6.z.string().optional(),
    /** "x5c" (X.509 Certificate Chain) Header Parameter */ x5c: $2zDt6.z.array($2zDt6.z.string()).optional(),
    /** "x5t" (X.509 Certificate SHA-1 Thumbprint) Header Parameter */ x5t: $2zDt6.z.string().optional(),
    /** "x5t#S256" (X.509 Certificate SHA-256 Thumbprint) Header Parameter */ "x5t#S256": $2zDt6.z.string().optional(),
    /** "typ" (Type) Header Parameter */ typ: $2zDt6.z.string().optional(),
    /** "cty" (Content Type) Header Parameter */ cty: $2zDt6.z.string().optional(),
    /** "crit" (Critical) Header Parameter */ crit: $2zDt6.z.array($2zDt6.z.string()).optional()
});
// https://www.iana.org/assignments/jwt/jwt.xhtml
module.exports.jwtPayloadSchema = $2zDt6.z.object({
    iss: $2zDt6.z.string().optional(),
    aud: $2zDt6.z.union([
        $2zDt6.z.string(),
        $2zDt6.z.array($2zDt6.z.string()).nonempty()
    ]).optional(),
    sub: $2zDt6.z.string().optional(),
    exp: $2zDt6.z.number().int().optional(),
    nbf: $2zDt6.z.number().int().optional(),
    iat: $2zDt6.z.number().int().optional(),
    jti: $2zDt6.z.string().optional(),
    htm: $2zDt6.z.string().optional(),
    htu: $2zDt6.z.string().optional(),
    ath: $2zDt6.z.string().optional(),
    acr: $2zDt6.z.string().optional(),
    azp: $2zDt6.z.string().optional(),
    amr: $2zDt6.z.array($2zDt6.z.string()).optional(),
    // https://datatracker.ietf.org/doc/html/rfc7800
    cnf: $2zDt6.z.object({
        kid: $2zDt6.z.string().optional(),
        jwk: $apYKl.jwkPubSchema.optional(),
        jwe: $2zDt6.z.string().optional(),
        jku: $2zDt6.z.string().url().optional(),
        // https://datatracker.ietf.org/doc/html/rfc9449#section-6.1
        jkt: $2zDt6.z.string().optional(),
        // https://datatracker.ietf.org/doc/html/rfc8705
        "x5t#S256": $2zDt6.z.string().optional(),
        // https://datatracker.ietf.org/doc/html/rfc9203
        osc: $2zDt6.z.string().optional()
    }).optional(),
    client_id: $2zDt6.z.string().optional(),
    scope: $2zDt6.z.string().optional(),
    nonce: $2zDt6.z.string().optional(),
    at_hash: $2zDt6.z.string().optional(),
    c_hash: $2zDt6.z.string().optional(),
    s_hash: $2zDt6.z.string().optional(),
    auth_time: $2zDt6.z.number().int().optional(),
    // https://openid.net/specs/openid-connect-core-1_0.html#StandardClaims
    // OpenID: "profile" scope
    name: $2zDt6.z.string().optional(),
    family_name: $2zDt6.z.string().optional(),
    given_name: $2zDt6.z.string().optional(),
    middle_name: $2zDt6.z.string().optional(),
    nickname: $2zDt6.z.string().optional(),
    preferred_username: $2zDt6.z.string().optional(),
    gender: $2zDt6.z.string().optional(),
    picture: $2zDt6.z.string().url().optional(),
    profile: $2zDt6.z.string().url().optional(),
    website: $2zDt6.z.string().url().optional(),
    birthdate: $2zDt6.z.string().regex(/\d{4}-\d{2}-\d{2}/) // YYYY-MM-DD
    .optional(),
    zoneinfo: $2zDt6.z.string().regex(/^[A-Za-z0-9_/]+$/).optional(),
    locale: $2zDt6.z.string().regex(/^[a-z]{2}(-[A-Z]{2})?$/).optional(),
    updated_at: $2zDt6.z.number().int().optional(),
    // OpenID: "email" scope
    email: $2zDt6.z.string().optional(),
    email_verified: $2zDt6.z.boolean().optional(),
    // OpenID: "phone" scope
    phone_number: $2zDt6.z.string().optional(),
    phone_number_verified: $2zDt6.z.boolean().optional(),
    // OpenID: "address" scope
    // https://openid.net/specs/openid-connect-core-1_0.html#AddressClaim
    address: $2zDt6.z.object({
        formatted: $2zDt6.z.string().optional(),
        street_address: $2zDt6.z.string().optional(),
        locality: $2zDt6.z.string().optional(),
        region: $2zDt6.z.string().optional(),
        postal_code: $2zDt6.z.string().optional(),
        country: $2zDt6.z.string().optional()
    }).optional(),
    // https://datatracker.ietf.org/doc/html/rfc9396#section-14.2
    authorization_details: $2zDt6.z.array($2zDt6.z.object({
        type: $2zDt6.z.string(),
        // https://datatracker.ietf.org/doc/html/rfc9396#section-2.2
        locations: $2zDt6.z.array($2zDt6.z.string()).optional(),
        actions: $2zDt6.z.array($2zDt6.z.string()).optional(),
        datatypes: $2zDt6.z.array($2zDt6.z.string()).optional(),
        identifier: $2zDt6.z.string().optional(),
        privileges: $2zDt6.z.array($2zDt6.z.string()).optional()
    }).passthrough()).optional()
});

});
parcelRegister("6M5ug", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.segmentedStringRefinementFactory = module.exports.jwtCharsRefinement = module.exports.parseB64uJson = module.exports.cachedGetter = module.exports.matchesAny = module.exports.preferredOrderCmp = module.exports.isDefined = void 0;

var $j3YM6 = parcelRequire("j3YM6");

var $2zDt6 = parcelRequire("2zDt6");
const $4eeb7b6a289d901e$var$isDefined = (i)=>i !== undefined;
module.exports.isDefined = $4eeb7b6a289d901e$var$isDefined;
const $4eeb7b6a289d901e$var$preferredOrderCmp = (order)=>(a, b)=>{
        const aIdx = order.indexOf(a);
        const bIdx = order.indexOf(b);
        if (aIdx === bIdx) return 0;
        if (aIdx === -1) return 1;
        if (bIdx === -1) return -1;
        return aIdx - bIdx;
    };
module.exports.preferredOrderCmp = $4eeb7b6a289d901e$var$preferredOrderCmp;
function $4eeb7b6a289d901e$var$matchesAny(value) {
    return value == null ? (v)=>true : Array.isArray(value) ? (v)=>value.includes(v) : (v)=>v === value;
}
module.exports.matchesAny = $4eeb7b6a289d901e$var$matchesAny;
/**
 * Decorator to cache the result of a getter on a class instance.
 */ const $4eeb7b6a289d901e$var$cachedGetter = (target, _context)=>{
    return function() {
        const value = target.call(this);
        Object.defineProperty(this, target.name, {
            get: ()=>value,
            enumerable: true,
            configurable: true
        });
        return value;
    };
};
module.exports.cachedGetter = $4eeb7b6a289d901e$var$cachedGetter;
const $4eeb7b6a289d901e$var$decoder = new TextDecoder();
function $4eeb7b6a289d901e$var$parseB64uJson(input) {
    const inputBytes = $j3YM6.base64url.baseDecode(input);
    const json = $4eeb7b6a289d901e$var$decoder.decode(inputBytes);
    return JSON.parse(json);
}
module.exports.parseB64uJson = $4eeb7b6a289d901e$var$parseB64uJson;
/**
 * @example
 * ```ts
 * // jwtSchema will only allow base64url chars & "." (dot)
 * const jwtSchema = z.string().superRefine(jwtCharsRefinement)
 * ```
 */ const $4eeb7b6a289d901e$var$jwtCharsRefinement = (data, ctx)=>{
    // Note: this is a hot path, let's avoid using a RegExp
    let char;
    for(let i = 0; i < data.length; i++){
        char = data.charCodeAt(i);
        if (// Base64 URL encoding (most frequent)
        65 <= char && char <= 90 || // A-Z
        97 <= char && char <= 122 || // a-z
        48 <= char && char <= 57 || // 0-9
        char === 45 || // -
        char === 95 || // _
        // Boundary (least frequent, check last)
        char === 46 // .
        ) ;
        else {
            // Invalid char might be a surrogate pair
            const invalidChar = String.fromCodePoint(data.codePointAt(i));
            return ctx.addIssue({
                code: $2zDt6.ZodIssueCode.custom,
                message: `Invalid character "${invalidChar}" in JWT at position ${i}`
            });
        }
    }
};
module.exports.jwtCharsRefinement = $4eeb7b6a289d901e$var$jwtCharsRefinement;
/**
 * @example
 * ```ts
 * const jwtSchema = z.string().superRefine(segmentedStringRefinementFactory(3))
 * type Jwt = z.infer<typeof jwtSchema> // `${string}.${string}.${string}`
 * ```
 */ const $4eeb7b6a289d901e$var$segmentedStringRefinementFactory = (count, minPartLength = 2)=>{
    if (!Number.isFinite(count) || count < 1 || (count | 0) !== count) throw new TypeError(`Count must be a natural number (got ${count})`);
    const minTotalLength = count * minPartLength + (count - 1);
    const errorPrefix = `Invalid JWT format`;
    return (data, ctx)=>{
        if (data.length < minTotalLength) {
            ctx.addIssue({
                code: $2zDt6.ZodIssueCode.custom,
                message: `${errorPrefix}: too short`
            });
            return false;
        }
        let currentStart = 0;
        for(let i = 0; i < count - 1; i++){
            const nextDot = data.indexOf(".", currentStart);
            if (nextDot === -1) {
                ctx.addIssue({
                    code: $2zDt6.ZodIssueCode.custom,
                    message: `${errorPrefix}: expected ${count} segments, got ${i + 1}`
                });
                return false;
            }
            if (nextDot - currentStart < minPartLength) {
                ctx.addIssue({
                    code: $2zDt6.ZodIssueCode.custom,
                    message: `${errorPrefix}: segment ${i + 1} is too short`
                });
                return false;
            }
            currentStart = nextDot + 1;
        }
        if (data.indexOf(".", currentStart) !== -1) {
            ctx.addIssue({
                code: $2zDt6.ZodIssueCode.custom,
                message: `${errorPrefix}: too many segments`
            });
            return false;
        }
        if (data.length - currentStart < minPartLength) {
            ctx.addIssue({
                code: $2zDt6.ZodIssueCode.custom,
                message: `${errorPrefix}: last segment is too short`
            });
            return false;
        }
        return true;
    };
};
module.exports.segmentedStringRefinementFactory = $4eeb7b6a289d901e$var$segmentedStringRefinementFactory;

});
parcelRegister("j3YM6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $de0d70bb34ca5e4e$var$base64 = $j5XlC.rfc4648({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64pad = $j5XlC.rfc4648({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64url = $j5XlC.rfc4648({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64urlpad = $j5XlC.rfc4648({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
module.exports.base64 = $de0d70bb34ca5e4e$var$base64;
module.exports.base64pad = $de0d70bb34ca5e4e$var$base64pad;
module.exports.base64url = $de0d70bb34ca5e4e$var$base64url;
module.exports.base64urlpad = $de0d70bb34ca5e4e$var$base64urlpad;

});
parcelRegister("j5XlC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hjHF0 = parcelRequire("hjHF0");

var $6DEzE = parcelRequire("6DEzE");
class $de6c852f920490b4$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $de6c852f920490b4$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
}
class $de6c852f920490b4$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $de6c852f920490b4$var$or = (left, right)=>new $de6c852f920490b4$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $de6c852f920490b4$var$Codec {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $de6c852f920490b4$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $de6c852f920490b4$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $de6c852f920490b4$var$from = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $de6c852f920490b4$var$Codec(name, prefix, encode, decode);
const $de6c852f920490b4$var$baseX = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = $hjHF0(alphabet, name);
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>$6DEzE.coerce(decode(text))
    });
};
const $de6c852f920490b4$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $de6c852f920490b4$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $de6c852f920490b4$var$rfc4648 = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode (input) {
            return $de6c852f920490b4$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $de6c852f920490b4$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};
module.exports.Codec = $de6c852f920490b4$var$Codec;
module.exports.baseX = $de6c852f920490b4$var$baseX;
module.exports.from = $de6c852f920490b4$var$from;
module.exports.or = $de6c852f920490b4$var$or;
module.exports.rfc4648 = $de6c852f920490b4$var$rfc4648;

});
parcelRegister("hjHF0", function(module, exports) {
"use strict";
function $0340df4a7a7e39d8$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $0340df4a7a7e39d8$var$src = $0340df4a7a7e39d8$var$base;
var $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX = $0340df4a7a7e39d8$var$src;
module.exports = $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX;

});

parcelRegister("6DEzE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $4d55dbc11a5f1aec$var$empty = new Uint8Array(0);
const $4d55dbc11a5f1aec$var$toHex = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $4d55dbc11a5f1aec$var$fromHex = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $4d55dbc11a5f1aec$var$empty;
};
const $4d55dbc11a5f1aec$var$equals = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $4d55dbc11a5f1aec$var$coerce = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $4d55dbc11a5f1aec$var$isBinary = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $4d55dbc11a5f1aec$var$fromString = (str)=>new TextEncoder().encode(str);
const $4d55dbc11a5f1aec$var$toString = (b)=>new TextDecoder().decode(b);
module.exports.coerce = $4d55dbc11a5f1aec$var$coerce;
module.exports.empty = $4d55dbc11a5f1aec$var$empty;
module.exports.equals = $4d55dbc11a5f1aec$var$equals;
module.exports.fromHex = $4d55dbc11a5f1aec$var$fromHex;
module.exports.fromString = $4d55dbc11a5f1aec$var$fromString;
module.exports.isBinary = $4d55dbc11a5f1aec$var$isBinary;
module.exports.toHex = $4d55dbc11a5f1aec$var$toHex;
module.exports.toString = $4d55dbc11a5f1aec$var$toString;

});






parcelRegister("1vWbg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("32AL6", function(module, exports) {
"use strict";
var $236e12839ef7900f$var$__runInitializers = module.exports && module.exports.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $236e12839ef7900f$var$__esDecorate = module.exports && module.exports.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Key = void 0;

var $cTCpq = parcelRequire("cTCpq");

var $32upx = parcelRequire("32upx");

var $apYKl = parcelRequire("apYKl");

var $6M5ug = parcelRequire("6M5ug");
let $236e12839ef7900f$var$Key = (()=>{
    var _a;
    let _instanceExtraInitializers = [];
    let _get_publicJwk_decorators;
    let _get_bareJwk_decorators;
    let _get_algorithms_decorators;
    return _a = class Key {
        constructor(jwk){
            Object.defineProperty(this, "jwk", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($236e12839ef7900f$var$__runInitializers(this, _instanceExtraInitializers), jwk)
            });
            // A key should always be used either for signing or encryption.
            if (!jwk.use) throw new $32upx.JwkError('Missing "use" Parameter value');
        }
        get isPrivate() {
            const { jwk: jwk } = this;
            if ("d" in jwk && jwk.d !== undefined) return true;
            if ("k" in jwk && jwk.k !== undefined) return true;
            return false;
        }
        get isSymetric() {
            const { jwk: jwk } = this;
            if ("k" in jwk && jwk.k !== undefined) return true;
            return false;
        }
        get privateJwk() {
            return this.isPrivate ? this.jwk : undefined;
        }
        get publicJwk() {
            if (this.isSymetric) return undefined;
            if (this.isPrivate) {
                const { d: _, ...jwk } = this.jwk;
                return jwk;
            }
            return this.jwk;
        }
        get bareJwk() {
            if (this.isSymetric) return undefined;
            const { kty: kty, crv: crv, e: e, n: n, x: x, y: y } = this.jwk;
            return $apYKl.jwkSchema.parse({
                crv: crv,
                e: e,
                kty: kty,
                n: n,
                x: x,
                y: y
            });
        }
        get use() {
            return this.jwk.use;
        }
        /**
             * The (forced) algorithm to use. If not provided, the key will be usable with
             * any of the algorithms in {@link algorithms}.
             *
             * @see {@link https://datatracker.ietf.org/doc/html/rfc7518#section-3.1 | "alg" (Algorithm) Header Parameter Values for JWS}
             */ get alg() {
            return this.jwk.alg;
        }
        get kid() {
            return this.jwk.kid;
        }
        get crv() {
            return this.jwk.crv;
        }
        /**
             * All the algorithms that this key can be used with. If `alg` is provided,
             * this set will only contain that algorithm.
             */ get algorithms() {
            return Array.from((0, $cTCpq.jwkAlgorithms)(this.jwk));
        }
    }, (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _get_publicJwk_decorators = [
            $6M5ug.cachedGetter
        ];
        _get_bareJwk_decorators = [
            $6M5ug.cachedGetter
        ];
        _get_algorithms_decorators = [
            $6M5ug.cachedGetter
        ];
        $236e12839ef7900f$var$__esDecorate(_a, null, _get_publicJwk_decorators, {
            kind: "getter",
            name: "publicJwk",
            static: false,
            private: false,
            access: {
                has: (obj)=>"publicJwk" in obj,
                get: (obj)=>obj.publicJwk
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $236e12839ef7900f$var$__esDecorate(_a, null, _get_bareJwk_decorators, {
            kind: "getter",
            name: "bareJwk",
            static: false,
            private: false,
            access: {
                has: (obj)=>"bareJwk" in obj,
                get: (obj)=>obj.bareJwk
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $236e12839ef7900f$var$__esDecorate(_a, null, _get_algorithms_decorators, {
            kind: "getter",
            name: "algorithms",
            static: false,
            private: false,
            access: {
                has: (obj)=>"algorithms" in obj,
                get: (obj)=>obj.algorithms
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
module.exports.Key = $236e12839ef7900f$var$Key;

});

parcelRegister("5gaBM", function(module, exports) {
"use strict";
var $3d46acfa9f3c7959$var$__runInitializers = module.exports && module.exports.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $3d46acfa9f3c7959$var$__esDecorate = module.exports && module.exports.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Keyset = void 0;

var $32upx = parcelRequire("32upx");

var $3crJS = parcelRequire("3crJS");

var $6M5ug = parcelRequire("6M5ug");
const $3d46acfa9f3c7959$var$extractPrivateJwk = (key)=>key.privateJwk;
const $3d46acfa9f3c7959$var$extractPublicJwk = (key)=>key.publicJwk;
let $3d46acfa9f3c7959$var$Keyset = (()=>{
    var _a;
    let _instanceExtraInitializers = [];
    let _get_signAlgorithms_decorators;
    let _get_publicJwks_decorators;
    let _get_privateJwks_decorators;
    return _a = class Keyset {
        constructor(iterable, /**
             * The preferred algorithms to use when signing a JWT using this keyset.
             *
             * @see {@link https://datatracker.ietf.org/doc/html/rfc7518#section-3.1}
             */ preferredSigningAlgorithms = iterable instanceof _a ? [
            ...iterable.preferredSigningAlgorithms
        ] : [
            // Prefer elliptic curve algorithms
            "EdDSA",
            "ES256K",
            "ES256",
            // https://datatracker.ietf.org/doc/html/rfc7518#section-3.5
            "PS256",
            "PS384",
            "PS512",
            "HS256",
            "HS384",
            "HS512"
        ]){
            Object.defineProperty(this, "preferredSigningAlgorithms", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($3d46acfa9f3c7959$var$__runInitializers(this, _instanceExtraInitializers), preferredSigningAlgorithms)
            });
            Object.defineProperty(this, "keys", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            const keys = [];
            const kids = new Set();
            for (const key of iterable){
                if (!key) continue;
                keys.push(key);
                if (key.kid) {
                    if (kids.has(key.kid)) throw new $32upx.JwkError(`Duplicate key: ${key.kid}`);
                    else kids.add(key.kid);
                }
            }
            this.keys = Object.freeze(keys);
        }
        get size() {
            return this.keys.length;
        }
        get signAlgorithms() {
            const algorithms = new Set();
            for (const key of this){
                if (key.use !== "sig") continue;
                for (const alg of key.algorithms)algorithms.add(alg);
            }
            return Object.freeze([
                ...algorithms
            ].sort((0, $6M5ug.preferredOrderCmp)(this.preferredSigningAlgorithms)));
        }
        get publicJwks() {
            return {
                keys: Array.from(this, $3d46acfa9f3c7959$var$extractPublicJwk).filter($6M5ug.isDefined)
            };
        }
        get privateJwks() {
            return {
                keys: Array.from(this, $3d46acfa9f3c7959$var$extractPrivateJwk).filter($6M5ug.isDefined)
            };
        }
        has(kid) {
            return this.keys.some((key)=>key.kid === kid);
        }
        get(search) {
            for (const key of this.list(search))return key;
            throw new $32upx.JwkError(`Key not found ${search.kid || search.alg || "<unknown>"}`, $32upx.ERR_JWK_NOT_FOUND);
        }
        *list(search) {
            // Optimization: Empty string or empty array will not match any key
            if (search.kid?.length === 0) return;
            if (search.alg?.length === 0) return;
            for (const key of this){
                if (search.use && key.use !== search.use) continue;
                if (Array.isArray(search.kid)) {
                    if (!key.kid || !search.kid.includes(key.kid)) continue;
                } else if (search.kid) {
                    if (key.kid !== search.kid) continue;
                }
                if (Array.isArray(search.alg)) {
                    if (!search.alg.some((a)=>key.algorithms.includes(a))) continue;
                } else if (typeof search.alg === "string") {
                    if (!key.algorithms.includes(search.alg)) continue;
                }
                yield key;
            }
        }
        findKey({ kid: kid, alg: alg, use: use }) {
            const matchingKeys = [];
            for (const key of this.list({
                kid: kid,
                alg: alg,
                use: use
            })){
                // Not a signing key
                if (!key.isPrivate) continue;
                // Skip negotiation if a specific "alg" was provided
                if (typeof alg === "string") return [
                    key,
                    alg
                ];
                matchingKeys.push(key);
            }
            const isAllowedAlg = (0, $6M5ug.matchesAny)(alg);
            const candidates = matchingKeys.map((key)=>[
                    key,
                    key.algorithms.filter(isAllowedAlg)
                ]);
            // Return the first candidates that matches the preferred algorithms
            for (const prefAlg of this.preferredSigningAlgorithms)for (const [matchingKey, matchingAlgs] of candidates){
                if (matchingAlgs.includes(prefAlg)) return [
                    matchingKey,
                    prefAlg
                ];
            }
            // Return any candidate
            for (const [matchingKey, matchingAlgs] of candidates){
                for (const alg of matchingAlgs)return [
                    matchingKey,
                    alg
                ];
            }
            throw new $32upx.JwkError(`No singing key found for ${kid || alg || use || "<unknown>"}`, $32upx.ERR_JWK_NOT_FOUND);
        }
        [(_get_signAlgorithms_decorators = [
            $6M5ug.cachedGetter
        ], _get_publicJwks_decorators = [
            $6M5ug.cachedGetter
        ], _get_privateJwks_decorators = [
            $6M5ug.cachedGetter
        ], Symbol.iterator)]() {
            return this.keys.values();
        }
        async createJwt({ alg: sAlg, kid: sKid, ...header }, payload) {
            try {
                const [key, alg] = this.findKey({
                    alg: sAlg,
                    kid: sKid,
                    use: "sig"
                });
                const protectedHeader = {
                    ...header,
                    alg: alg,
                    kid: key.kid
                };
                if (typeof payload === "function") payload = await payload(protectedHeader, key);
                return await key.createJwt(protectedHeader, payload);
            } catch (err) {
                throw $32upx.JwtCreateError.from(err);
            }
        }
        async verifyJwt(token, options) {
            const { header: header } = (0, $3crJS.unsafeDecodeJwt)(token);
            const { kid: kid, alg: alg } = header;
            const errors = [];
            for (const key of this.list({
                kid: kid,
                alg: alg
            }))try {
                const result = await key.verifyJwt(token, options);
                return {
                    ...result,
                    key: key
                };
            } catch (err) {
                errors.push(err);
            }
            switch(errors.length){
                case 0:
                    throw new $32upx.JwtVerifyError("No key matched", $32upx.ERR_JWKS_NO_MATCHING_KEY);
                case 1:
                    throw $32upx.JwtVerifyError.from(errors[0], $32upx.ERR_JWT_INVALID);
                default:
                    throw $32upx.JwtVerifyError.from(errors, $32upx.ERR_JWT_INVALID);
            }
        }
        toJSON() {
            // Make a copy to prevent mutation of the original keyset
            return structuredClone(this.publicJwks);
        }
    }, (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        $3d46acfa9f3c7959$var$__esDecorate(_a, null, _get_signAlgorithms_decorators, {
            kind: "getter",
            name: "signAlgorithms",
            static: false,
            private: false,
            access: {
                has: (obj)=>"signAlgorithms" in obj,
                get: (obj)=>obj.signAlgorithms
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $3d46acfa9f3c7959$var$__esDecorate(_a, null, _get_publicJwks_decorators, {
            kind: "getter",
            name: "publicJwks",
            static: false,
            private: false,
            access: {
                has: (obj)=>"publicJwks" in obj,
                get: (obj)=>obj.publicJwks
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $3d46acfa9f3c7959$var$__esDecorate(_a, null, _get_privateJwks_decorators, {
            kind: "getter",
            name: "privateJwks",
            static: false,
            private: false,
            access: {
                has: (obj)=>"privateJwks" in obj,
                get: (obj)=>obj.privateJwks
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
module.exports.Keyset = $3d46acfa9f3c7959$var$Keyset;

});


parcelRegister("gWe7n", function(module, exports) {
"use strict";
var $c54d03a50c745a72$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c54d03a50c745a72$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c54d03a50c745a72$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c54d03a50c745a72$var$__exportStar((parcelRequire("7diKV")), module.exports);

});
parcelRegister("7diKV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JoseKey = void 0;

var $4EOoK = parcelRequire("4EOoK");

var $7GXIC = parcelRequire("7GXIC");
var $dDGOp = parcelRequire("dDGOp");
var $lwVFZ = parcelRequire("lwVFZ");
var $icdnu = parcelRequire("icdnu");
var $tU6kV = parcelRequire("tU6kV");
var $hrT3a = parcelRequire("hrT3a");

var $4EOoK = parcelRequire("4EOoK");

var $akcrY = parcelRequire("akcrY");
const { JOSEError: $54084bcc5c0d4685$var$JOSEError } = $7GXIC;
class $54084bcc5c0d4685$var$JoseKey extends $4EOoK.Key {
    #keyObj;
    async getKey() {
        try {
            return this.#keyObj ||= await (0, $icdnu.importJWK)(this.jwk);
        } catch (cause) {
            throw new $4EOoK.JwkError("Failed to import JWK", undefined, {
                cause: cause
            });
        }
    }
    async createJwt(header, payload) {
        if (header.kid && header.kid !== this.kid) throw new $4EOoK.JwtCreateError(`Invalid "kid" (${header.kid}) used to sign with key "${this.kid}"`);
        if (!header.alg || !this.algorithms.includes(header.alg)) throw new $4EOoK.JwtCreateError(`Invalid "alg" (${header.alg}) used to sign with key "${this.kid}"`);
        const keyObj = await this.getKey();
        return new $hrT3a.SignJWT(payload).setProtectedHeader({
            ...header,
            kid: this.kid
        }).sign(keyObj);
    }
    async verifyJwt(token, options) {
        try {
            const keyObj = await this.getKey();
            const result = await (0, $tU6kV.jwtVerify)(token, keyObj, {
                ...options,
                algorithms: this.algorithms
            });
            return result;
        } catch (error) {
            if (error instanceof $54084bcc5c0d4685$var$JOSEError) throw new $4EOoK.JwtVerifyError(error.message, error.code, {
                cause: error
            });
            else throw $4EOoK.JwtVerifyError.from(error);
        }
    }
    static async generateKeyPair(allowedAlgos = [
        "ES256"
    ], options) {
        if (!allowedAlgos.length) throw new $4EOoK.JwkError("No algorithms provided for key generation");
        const errors = [];
        for (const alg of allowedAlgos)try {
            return await (0, $lwVFZ.generateKeyPair)(alg, options);
        } catch (err) {
            errors.push(err);
        }
        throw new $4EOoK.JwkError("Failed to generate key pair", undefined, {
            cause: new AggregateError(errors, "None of the algorithms worked")
        });
    }
    static async generate(allowedAlgos = [
        "ES256"
    ], kid, options) {
        const kp = await this.generateKeyPair(allowedAlgos, {
            ...options,
            extractable: true
        });
        return this.fromImportable(kp.privateKey, kid);
    }
    static async fromImportable(input, kid) {
        if (typeof input === "string") {
            // PKCS8
            if (input.startsWith("-----")) // The "alg" is only needed in WebCrypto (NodeJS will be fine)
            return this.fromPKCS8(input, "", kid);
            // Jwk (string)
            if (input.startsWith("{")) return this.fromJWK(input, kid);
            throw new $4EOoK.JwkError("Invalid input");
        }
        if (typeof input === "object") {
            // Jwk
            if ("kty" in input || "alg" in input) return this.fromJWK(input, kid);
            // KeyLike
            return this.fromKeyLike(input, kid);
        }
        throw new $4EOoK.JwkError("Invalid input");
    }
    /**
     * @see {@link exportJWK}
     */ static async fromKeyLike(keyLike, kid, alg) {
        const jwk = await (0, $dDGOp.exportJWK)(keyLike);
        if (alg) {
            if (!jwk.alg) jwk.alg = alg;
            else if (jwk.alg !== alg) throw new $4EOoK.JwkError('Invalid "alg" in JWK');
        }
        return this.fromJWK(jwk, kid);
    }
    /**
     * @see {@link importPKCS8}
     */ static async fromPKCS8(pem, alg, kid) {
        const keyLike = await (0, $icdnu.importPKCS8)(pem, alg, {
            extractable: true
        });
        return this.fromKeyLike(keyLike, kid);
    }
    static async fromJWK(input, inputKid) {
        const jwk = typeof input === "string" ? JSON.parse(input) : input;
        if (!jwk || typeof jwk !== "object") throw new $4EOoK.JwkError("Invalid JWK");
        const kid = (0, $akcrY.either)(jwk.kid, inputKid);
        const use = jwk.use || "sig";
        return new $54084bcc5c0d4685$var$JoseKey($4EOoK.jwkValidator.parse({
            ...jwk,
            kid: kid,
            use: use
        }));
    }
}
module.exports.JoseKey = $54084bcc5c0d4685$var$JoseKey;

});
parcelRegister("7GXIC", function(module, exports) {

$parcel$export(module.exports, "JOSEError", () => $599ac781534a947a$export$f754d6850d76bf87);
$parcel$export(module.exports, "JWTClaimValidationFailed", () => $599ac781534a947a$export$f1e14efb908196e9);
$parcel$export(module.exports, "JWTExpired", () => $599ac781534a947a$export$4b386bf852b7863d);
$parcel$export(module.exports, "JOSEAlgNotAllowed", () => $599ac781534a947a$export$d51fd7fedeccc338);
$parcel$export(module.exports, "JOSENotSupported", () => $599ac781534a947a$export$19ddbcbf2016ab28);
$parcel$export(module.exports, "JWEDecryptionFailed", () => $599ac781534a947a$export$1a57512ad9773b2a);
$parcel$export(module.exports, "JWEInvalid", () => $599ac781534a947a$export$19f281f2275f6a15);
$parcel$export(module.exports, "JWSInvalid", () => $599ac781534a947a$export$e838de724af3d116);
$parcel$export(module.exports, "JWTInvalid", () => $599ac781534a947a$export$936b39ada0bbfceb);
$parcel$export(module.exports, "JWKInvalid", () => $599ac781534a947a$export$b3992e0f88fb07e3);
$parcel$export(module.exports, "JWKSInvalid", () => $599ac781534a947a$export$9b22c2a1e2403b8e);
$parcel$export(module.exports, "JWKSNoMatchingKey", () => $599ac781534a947a$export$3d5ed1a538bed04e);
$parcel$export(module.exports, "JWKSMultipleMatchingKeys", () => $599ac781534a947a$export$dc036de401a5c284);
$parcel$export(module.exports, "JWKSTimeout", () => $599ac781534a947a$export$3f30acebf25c04e6);
$parcel$export(module.exports, "JWSSignatureVerificationFailed", () => $599ac781534a947a$export$c67a0218e7c50378);
class $599ac781534a947a$export$f754d6850d76bf87 extends Error {
    static get code() {
        return "ERR_JOSE_GENERIC";
    }
    constructor(message){
        super(message);
        this.code = "ERR_JOSE_GENERIC";
        this.name = this.constructor.name;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
class $599ac781534a947a$export$f1e14efb908196e9 extends $599ac781534a947a$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_CLAIM_VALIDATION_FAILED";
    }
    constructor(message, payload, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
        this.claim = claim;
        this.reason = reason;
        this.payload = payload;
    }
}
class $599ac781534a947a$export$4b386bf852b7863d extends $599ac781534a947a$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_EXPIRED";
    }
    constructor(message, payload, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_EXPIRED";
        this.claim = claim;
        this.reason = reason;
        this.payload = payload;
    }
}
class $599ac781534a947a$export$d51fd7fedeccc338 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
    }
    static get code() {
        return "ERR_JOSE_ALG_NOT_ALLOWED";
    }
}
class $599ac781534a947a$export$19ddbcbf2016ab28 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_NOT_SUPPORTED";
    }
    static get code() {
        return "ERR_JOSE_NOT_SUPPORTED";
    }
}
class $599ac781534a947a$export$1a57512ad9773b2a extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_DECRYPTION_FAILED";
        this.message = "decryption operation failed";
    }
    static get code() {
        return "ERR_JWE_DECRYPTION_FAILED";
    }
}
class $599ac781534a947a$export$19f281f2275f6a15 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_INVALID";
    }
    static get code() {
        return "ERR_JWE_INVALID";
    }
}
class $599ac781534a947a$export$e838de724af3d116 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_INVALID";
    }
    static get code() {
        return "ERR_JWS_INVALID";
    }
}
class $599ac781534a947a$export$936b39ada0bbfceb extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWT_INVALID";
    }
    static get code() {
        return "ERR_JWT_INVALID";
    }
}
class $599ac781534a947a$export$b3992e0f88fb07e3 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWK_INVALID";
    }
    static get code() {
        return "ERR_JWK_INVALID";
    }
}
class $599ac781534a947a$export$9b22c2a1e2403b8e extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_INVALID";
    }
    static get code() {
        return "ERR_JWKS_INVALID";
    }
}
class $599ac781534a947a$export$3d5ed1a538bed04e extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_NO_MATCHING_KEY";
        this.message = "no applicable key found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_NO_MATCHING_KEY";
    }
}
class $599ac781534a947a$export$dc036de401a5c284 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
        this.message = "multiple matching keys found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
    }
}
Symbol.asyncIterator;
class $599ac781534a947a$export$3f30acebf25c04e6 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_TIMEOUT";
        this.message = "request timed out";
    }
    static get code() {
        return "ERR_JWKS_TIMEOUT";
    }
}
class $599ac781534a947a$export$c67a0218e7c50378 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
        this.message = "signature verification failed";
    }
    static get code() {
        return "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
    }
}

});

parcelRegister("dDGOp", function(module, exports) {

$parcel$export(module.exports, "exportJWK", () => $9ee02072b0883f32$export$ffb510cfd482ce82);

var $fPTdg = parcelRequire("fPTdg");

var $bLBy3 = parcelRequire("bLBy3");
async function $9ee02072b0883f32$export$7f687badbeed246d(key) {
    return (0, $fPTdg.toSPKI)(key);
}
async function $9ee02072b0883f32$export$ba4a7192ac1a47fe(key) {
    return (0, $fPTdg.toPKCS8)(key);
}
async function $9ee02072b0883f32$export$ffb510cfd482ce82(key) {
    return (0, $bLBy3.default)(key);
}

});
parcelRegister("fPTdg", function(module, exports) {

$parcel$export(module.exports, "toSPKI", () => $b876728f20516af6$export$cfba7e924fe414ca);
$parcel$export(module.exports, "toPKCS8", () => $b876728f20516af6$export$cac76a78a90b914d);
$parcel$export(module.exports, "fromPKCS8", () => $b876728f20516af6$export$224b0a6339c7267f);
$parcel$export(module.exports, "fromSPKI", () => $b876728f20516af6$export$f9a3505cdaa1fb3e);
$parcel$export(module.exports, "fromX509", () => $b876728f20516af6$export$ed788b6a8533858f);

var $5pzZh = parcelRequire("5pzZh");

var $31Bep = parcelRequire("31Bep");

var $7gBc4 = parcelRequire("7gBc4");

var $dJzoD = parcelRequire("dJzoD");

var $7GXIC = parcelRequire("7GXIC");

var $0UxFO = parcelRequire("0UxFO");
const $b876728f20516af6$var$genericExport = async (keyType, keyFormat, key)=>{
    if (!(0, $5pzZh.isCryptoKey)(key)) throw new TypeError((0, $31Bep.default)(key, ...(0, $0UxFO.types)));
    if (!key.extractable) throw new TypeError("CryptoKey is not extractable");
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return (0, $dJzoD.default)((0, $7gBc4.encodeBase64)(new Uint8Array(await (0, $5pzZh.default).subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const $b876728f20516af6$export$cfba7e924fe414ca = (key)=>{
    return $b876728f20516af6$var$genericExport("public", "spki", key);
};
const $b876728f20516af6$export$cac76a78a90b914d = (key)=>{
    return $b876728f20516af6$var$genericExport("private", "pkcs8", key);
};
const $b876728f20516af6$var$findOid = (keyData, oid, from = 0)=>{
    if (from === 0) {
        oid.unshift(oid.length);
        oid.unshift(0x06);
    }
    const i = keyData.indexOf(oid[0], from);
    if (i === -1) return false;
    const sub = keyData.subarray(i, i + oid.length);
    if (sub.length !== oid.length) return false;
    return sub.every((value, index)=>value === oid[index]) || $b876728f20516af6$var$findOid(keyData, oid, i + 1);
};
const $b876728f20516af6$var$getNamedCurve = (keyData)=>{
    switch(true){
        case $b876728f20516af6$var$findOid(keyData, [
            0x2a,
            0x86,
            0x48,
            0xce,
            0x3d,
            0x03,
            0x01,
            0x07
        ]):
            return "P-256";
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x22
        ]):
            return "P-384";
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x23
        ]):
            return "P-521";
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6e
        ]):
            return "X25519";
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6f
        ]):
            return "X448";
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x70
        ]):
            return "Ed25519";
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x71
        ]):
            return "Ed448";
        default:
            throw new (0, $7GXIC.JOSENotSupported)("Invalid or unsupported EC Key Curve or OKP Key Sub Type");
    }
};
const $b876728f20516af6$var$genericImport = async (replace, keyFormat, pem, alg, options)=>{
    let algorithm;
    let keyUsages;
    const keyData = new Uint8Array(atob(pem.replace(replace, "")).split("").map((c)=>c.charCodeAt(0)));
    const isPublic = keyFormat === "spki";
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = isPublic ? [
                "encrypt",
                "wrapKey"
            ] : [
                "decrypt",
                "unwrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                const namedCurve = $b876728f20516af6$var$getNamedCurve(keyData);
                algorithm = namedCurve.startsWith("P-") ? {
                    name: "ECDH",
                    namedCurve: namedCurve
                } : {
                    name: namedCurve
                };
                keyUsages = isPublic ? [] : [
                    "deriveBits"
                ];
                break;
            }
        case "EdDSA":
            algorithm = {
                name: $b876728f20516af6$var$getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        default:
            throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported "alg" (Algorithm) value');
    }
    return (0, $5pzZh.default).subtle.importKey(keyFormat, keyData, algorithm, options?.extractable ?? false, keyUsages);
};
const $b876728f20516af6$export$224b0a6339c7267f = (pem, alg, options)=>{
    return $b876728f20516af6$var$genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, "pkcs8", pem, alg, options);
};
const $b876728f20516af6$export$f9a3505cdaa1fb3e = (pem, alg, options)=>{
    return $b876728f20516af6$var$genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, "spki", pem, alg, options);
};
function $b876728f20516af6$var$getElement(seq) {
    const result = [];
    let next = 0;
    while(next < seq.length){
        const nextPart = $b876728f20516af6$var$parseElement(seq.subarray(next));
        result.push(nextPart);
        next += nextPart.byteLength;
    }
    return result;
}
function $b876728f20516af6$var$parseElement(bytes) {
    let position = 0;
    let tag = bytes[0] & 0x1f;
    position++;
    if (tag === 0x1f) {
        tag = 0;
        while(bytes[position] >= 0x80){
            tag = tag * 128 + bytes[position] - 0x80;
            position++;
        }
        tag = tag * 128 + bytes[position] - 0x80;
        position++;
    }
    let length = 0;
    if (bytes[position] < 0x80) {
        length = bytes[position];
        position++;
    } else if (length === 0x80) {
        length = 0;
        while(bytes[position + length] !== 0 || bytes[position + length + 1] !== 0){
            if (length > bytes.byteLength) throw new TypeError("invalid indefinite form length");
            length++;
        }
        const byteLength = position + length + 2;
        return {
            byteLength: byteLength,
            contents: bytes.subarray(position, position + length),
            raw: bytes.subarray(0, byteLength)
        };
    } else {
        const numberOfDigits = bytes[position] & 0x7f;
        position++;
        length = 0;
        for(let i = 0; i < numberOfDigits; i++){
            length = length * 256 + bytes[position];
            position++;
        }
    }
    const byteLength = position + length;
    return {
        byteLength: byteLength,
        contents: bytes.subarray(position, byteLength),
        raw: bytes.subarray(0, byteLength)
    };
}
function $b876728f20516af6$var$spkiFromX509(buf) {
    const tbsCertificate = $b876728f20516af6$var$getElement($b876728f20516af6$var$getElement($b876728f20516af6$var$parseElement(buf).contents)[0].contents);
    return (0, $7gBc4.encodeBase64)(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function $b876728f20516af6$var$getSPKI(x509) {
    const pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, "");
    const raw = (0, $7gBc4.decodeBase64)(pem);
    return (0, $dJzoD.default)($b876728f20516af6$var$spkiFromX509(raw), "PUBLIC KEY");
}
const $b876728f20516af6$export$ed788b6a8533858f = (pem, alg, options)=>{
    let spki;
    try {
        spki = $b876728f20516af6$var$getSPKI(pem);
    } catch (cause) {
        throw new TypeError("Failed to parse the X.509 certificate", {
            cause: cause
        });
    }
    return $b876728f20516af6$export$f9a3505cdaa1fb3e(spki, alg, options);
};

});
parcelRegister("5pzZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f0b33e7ccc65ae0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isCryptoKey", () => $3f0b33e7ccc65ae0$export$600b5603bbac4c6);
var $3f0b33e7ccc65ae0$export$2e2bcd8739ae039 = crypto;
const $3f0b33e7ccc65ae0$export$600b5603bbac4c6 = (key)=>key instanceof CryptoKey;

});

parcelRegister("31Bep", function(module, exports) {

$parcel$export(module.exports, "default", () => $233e587bc0c17441$export$2e2bcd8739ae039);
$parcel$export(module.exports, "withAlg", () => $233e587bc0c17441$export$e94f758d09bc1828);
function $233e587bc0c17441$var$message(msg, actual, ...types) {
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(", ")}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === "function" && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === "object" && actual != null) {
        if (actual.constructor?.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
var $233e587bc0c17441$export$2e2bcd8739ae039 = (actual, ...types)=>{
    return $233e587bc0c17441$var$message("Key must be ", actual, ...types);
};
function $233e587bc0c17441$export$e94f758d09bc1828(alg, actual, ...types) {
    return $233e587bc0c17441$var$message(`Key for the ${alg} algorithm must be `, actual, ...types);
}

});

parcelRegister("7gBc4", function(module, exports) {

$parcel$export(module.exports, "encodeBase64", () => $54a6e0e463467b0a$export$8fb536984ec8b4d7);
$parcel$export(module.exports, "encode", () => $54a6e0e463467b0a$export$c564cdbbe6da493);
$parcel$export(module.exports, "decodeBase64", () => $54a6e0e463467b0a$export$94fdf11bafc8de6b);
$parcel$export(module.exports, "decode", () => $54a6e0e463467b0a$export$2f872c0f2117be69);

var $c2uWE = parcelRequire("c2uWE");
const $54a6e0e463467b0a$export$8fb536984ec8b4d7 = (input)=>{
    let unencoded = input;
    if (typeof unencoded === "string") unencoded = (0, $c2uWE.encoder).encode(unencoded);
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < unencoded.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(""));
};
const $54a6e0e463467b0a$export$c564cdbbe6da493 = (input)=>{
    return $54a6e0e463467b0a$export$8fb536984ec8b4d7(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
const $54a6e0e463467b0a$export$94fdf11bafc8de6b = (encoded)=>{
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
};
const $54a6e0e463467b0a$export$2f872c0f2117be69 = (input)=>{
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, $c2uWE.decoder).decode(encoded);
    encoded = encoded.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
    try {
        return $54a6e0e463467b0a$export$94fdf11bafc8de6b(encoded);
    } catch  {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
};

});
parcelRegister("c2uWE", function(module, exports) {

$parcel$export(module.exports, "encoder", () => $8c3dacf85b96b392$export$5486af06137bf21a);
$parcel$export(module.exports, "decoder", () => $8c3dacf85b96b392$export$124c96e6ce37090b);
$parcel$export(module.exports, "concat", () => $8c3dacf85b96b392$export$ee1b3e54f0441b22);

var $6h3SS = parcelRequire("6h3SS");
const $8c3dacf85b96b392$export$5486af06137bf21a = new TextEncoder();
const $8c3dacf85b96b392$export$124c96e6ce37090b = new TextDecoder();
const $8c3dacf85b96b392$var$MAX_INT32 = 2 ** 32;
function $8c3dacf85b96b392$export$ee1b3e54f0441b22(...buffers) {
    const size = buffers.reduce((acc, { length: length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    for (const buffer of buffers){
        buf.set(buffer, i);
        i += buffer.length;
    }
    return buf;
}
function $8c3dacf85b96b392$export$256d3ca12372f112(alg, p2sInput) {
    return $8c3dacf85b96b392$export$ee1b3e54f0441b22($8c3dacf85b96b392$export$5486af06137bf21a.encode(alg), new Uint8Array([
        0
    ]), p2sInput);
}
function $8c3dacf85b96b392$var$writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= $8c3dacf85b96b392$var$MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${$8c3dacf85b96b392$var$MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function $8c3dacf85b96b392$export$e7b531e00a18fdd7(value) {
    const high = Math.floor(value / $8c3dacf85b96b392$var$MAX_INT32);
    const low = value % $8c3dacf85b96b392$var$MAX_INT32;
    const buf = new Uint8Array(8);
    $8c3dacf85b96b392$var$writeUInt32BE(buf, high, 0);
    $8c3dacf85b96b392$var$writeUInt32BE(buf, low, 4);
    return buf;
}
function $8c3dacf85b96b392$export$74c16dba6c885532(value) {
    const buf = new Uint8Array(4);
    $8c3dacf85b96b392$var$writeUInt32BE(buf, value);
    return buf;
}
function $8c3dacf85b96b392$export$c1498c4a3718d967(input) {
    return $8c3dacf85b96b392$export$ee1b3e54f0441b22($8c3dacf85b96b392$export$74c16dba6c885532(input.length), input);
}
async function $8c3dacf85b96b392$export$67163693c21af44f(secret, bits, value) {
    const iterations = Math.ceil((bits >> 3) / 32);
    const res = new Uint8Array(iterations * 32);
    for(let iter = 0; iter < iterations; iter++){
        const buf = new Uint8Array(4 + secret.length + value.length);
        buf.set($8c3dacf85b96b392$export$74c16dba6c885532(iter + 1));
        buf.set(secret, 4);
        buf.set(value, 4 + secret.length);
        res.set(await (0, $6h3SS.default)("sha256", buf), iter * 32);
    }
    return res.slice(0, bits >> 3);
}

});
parcelRegister("6h3SS", function(module, exports) {

$parcel$export(module.exports, "default", () => $491757e359519ceb$export$2e2bcd8739ae039);

var $5pzZh = parcelRequire("5pzZh");
const $491757e359519ceb$var$digest = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await (0, $5pzZh.default).subtle.digest(subtleDigest, data));
};
var $491757e359519ceb$export$2e2bcd8739ae039 = $491757e359519ceb$var$digest;

});



parcelRegister("dJzoD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ffaef5451229e15$export$2e2bcd8739ae039);
var $9ffaef5451229e15$export$2e2bcd8739ae039 = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join("\n");
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};

});

parcelRegister("0UxFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $002bdc4a0215a55c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "types", () => $002bdc4a0215a55c$export$b14ad400b1d09e0f);

var $5pzZh = parcelRequire("5pzZh");
var $002bdc4a0215a55c$export$2e2bcd8739ae039 = (key)=>{
    if ((0, $5pzZh.isCryptoKey)(key)) return true;
    return key?.[Symbol.toStringTag] === "KeyObject";
};
const $002bdc4a0215a55c$export$b14ad400b1d09e0f = [
    "CryptoKey"
];

});


parcelRegister("bLBy3", function(module, exports) {

$parcel$export(module.exports, "default", () => $891135ce5ed081a3$export$2e2bcd8739ae039);

var $5pzZh = parcelRequire("5pzZh");

var $31Bep = parcelRequire("31Bep");

var $7gBc4 = parcelRequire("7gBc4");

var $0UxFO = parcelRequire("0UxFO");
const $891135ce5ed081a3$var$keyToJWK = async (key)=>{
    if (key instanceof Uint8Array) return {
        kty: "oct",
        k: (0, $7gBc4.encode)(key)
    };
    if (!(0, $5pzZh.isCryptoKey)(key)) throw new TypeError((0, $31Bep.default)(key, ...(0, $0UxFO.types), "Uint8Array"));
    if (!key.extractable) throw new TypeError("non-extractable CryptoKey cannot be exported as a JWK");
    const { ext: ext, key_ops: key_ops, alg: alg, use: use, ...jwk } = await (0, $5pzZh.default).subtle.exportKey("jwk", key);
    return jwk;
};
var $891135ce5ed081a3$export$2e2bcd8739ae039 = $891135ce5ed081a3$var$keyToJWK;

});


parcelRegister("lwVFZ", function(module, exports) {

$parcel$export(module.exports, "generateKeyPair", () => $fac953757d12c296$export$a949d36eab55b41f);

var $3qqU2 = parcelRequire("3qqU2");
async function $fac953757d12c296$export$a949d36eab55b41f(alg, options) {
    return (0, $3qqU2.generateKeyPair)(alg, options);
}

});
parcelRegister("3qqU2", function(module, exports) {

$parcel$export(module.exports, "generateKeyPair", () => $27e8ab24924f68d3$export$a949d36eab55b41f);

var $5pzZh = parcelRequire("5pzZh");

var $7GXIC = parcelRequire("7GXIC");

var $eVkwU = parcelRequire("eVkwU");
async function $27e8ab24924f68d3$export$25395fe8d170ad7(alg, options) {
    let length;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            length = parseInt(alg.slice(-3), 10);
            algorithm = {
                name: "HMAC",
                hash: `SHA-${length}`,
                length: length
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            length = parseInt(alg.slice(-3), 10);
            return (0, $eVkwU.default)(new Uint8Array(length >> 3));
        case "A128KW":
        case "A192KW":
        case "A256KW":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-KW",
                length: length
            };
            keyUsages = [
                "wrapKey",
                "unwrapKey"
            ];
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-GCM",
                length: length
            };
            keyUsages = [
                "encrypt",
                "decrypt"
            ];
            break;
        default:
            throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $5pzZh.default).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}
function $27e8ab24924f68d3$var$getModulusLengthOption(options) {
    const modulusLength = options?.modulusLength ?? 2048;
    if (typeof modulusLength !== "number" || modulusLength < 2048) throw new (0, $7GXIC.JOSENotSupported)("Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used");
    return modulusLength;
}
async function $27e8ab24924f68d3$export$a949d36eab55b41f(alg, options) {
    let algorithm;
    let keyUsages;
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $27e8ab24924f68d3$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $27e8ab24924f68d3$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $27e8ab24924f68d3$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "decrypt",
                "unwrapKey",
                "encrypt",
                "wrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "EdDSA":
            {
                keyUsages = [
                    "sign",
                    "verify"
                ];
                const crv = options?.crv ?? "Ed25519";
                switch(crv){
                    case "Ed25519":
                    case "Ed448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $7GXIC.JOSENotSupported)("Invalid or unsupported crv option provided");
                }
                break;
            }
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                keyUsages = [
                    "deriveKey",
                    "deriveBits"
                ];
                const crv = options?.crv ?? "P-256";
                switch(crv){
                    case "P-256":
                    case "P-384":
                    case "P-521":
                        algorithm = {
                            name: "ECDH",
                            namedCurve: crv
                        };
                        break;
                    case "X25519":
                    case "X448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $7GXIC.JOSENotSupported)("Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448");
                }
                break;
            }
        default:
            throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $5pzZh.default).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}

});
parcelRegister("eVkwU", function(module, exports) {

$parcel$export(module.exports, "default", () => $add6505a95ba3e92$export$2e2bcd8739ae039);

var $5pzZh = parcelRequire("5pzZh");
var $add6505a95ba3e92$export$2e2bcd8739ae039 = (0, $5pzZh.default).getRandomValues.bind((0, $5pzZh.default));

});



parcelRegister("icdnu", function(module, exports) {

$parcel$export(module.exports, "importPKCS8", () => $d3f3b992c534ed5a$export$17f5e7f6d2848df5);
$parcel$export(module.exports, "importJWK", () => $d3f3b992c534ed5a$export$2b70d37b4d0b888b);

var $7gBc4 = parcelRequire("7gBc4");

var $fPTdg = parcelRequire("fPTdg");

var $4pRQo = parcelRequire("4pRQo");

var $7GXIC = parcelRequire("7GXIC");

var $4g1L0 = parcelRequire("4g1L0");
async function $d3f3b992c534ed5a$export$7cdfc961c11d0266(spki, alg, options) {
    if (typeof spki !== "string" || spki.indexOf("-----BEGIN PUBLIC KEY-----") !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, $fPTdg.fromSPKI)(spki, alg, options);
}
async function $d3f3b992c534ed5a$export$948757ecbbf4a918(x509, alg, options) {
    if (typeof x509 !== "string" || x509.indexOf("-----BEGIN CERTIFICATE-----") !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, $fPTdg.fromX509)(x509, alg, options);
}
async function $d3f3b992c534ed5a$export$17f5e7f6d2848df5(pkcs8, alg, options) {
    if (typeof pkcs8 !== "string" || pkcs8.indexOf("-----BEGIN PRIVATE KEY-----") !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, $fPTdg.fromPKCS8)(pkcs8, alg, options);
}
async function $d3f3b992c534ed5a$export$2b70d37b4d0b888b(jwk, alg) {
    if (!(0, $4g1L0.default)(jwk)) throw new TypeError("JWK must be an object");
    alg || (alg = jwk.alg);
    switch(jwk.kty){
        case "oct":
            if (typeof jwk.k !== "string" || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            return (0, $7gBc4.decode)(jwk.k);
        case "RSA":
            if (jwk.oth !== undefined) throw new (0, $7GXIC.JOSENotSupported)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
        case "EC":
        case "OKP":
            return (0, $4pRQo.default)({
                ...jwk,
                alg: alg
            });
        default:
            throw new (0, $7GXIC.JOSENotSupported)('Unsupported "kty" (Key Type) Parameter value');
    }
}

});
parcelRegister("4pRQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $337343867c42a494$export$2e2bcd8739ae039);

var $5pzZh = parcelRequire("5pzZh");

var $7GXIC = parcelRequire("7GXIC");
function $337343867c42a494$var$subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case "RSA":
            switch(jwk.alg){
                case "PS256":
                case "PS384":
                case "PS512":
                    algorithm = {
                        name: "RSA-PSS",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RS256":
                case "RS384":
                case "RS512":
                    algorithm = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RSA-OAEP":
                case "RSA-OAEP-256":
                case "RSA-OAEP-384":
                case "RSA-OAEP-512":
                    algorithm = {
                        name: "RSA-OAEP",
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        "decrypt",
                        "unwrapKey"
                    ] : [
                        "encrypt",
                        "wrapKey"
                    ];
                    break;
                default:
                    throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "EC":
            switch(jwk.alg){
                case "ES256":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-256"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES384":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-384"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES512":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-521"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: "ECDH",
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "OKP":
            switch(jwk.alg){
                case "EdDSA":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm: algorithm,
        keyUsages: keyUsages
    };
}
const $337343867c42a494$var$parse = async (jwk)=>{
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: algorithm, keyUsages: keyUsages } = $337343867c42a494$var$subtleMapping(jwk);
    const rest = [
        algorithm,
        jwk.ext ?? false,
        jwk.key_ops ?? keyUsages
    ];
    const keyData = {
        ...jwk
    };
    delete keyData.alg;
    delete keyData.use;
    return (0, $5pzZh.default).subtle.importKey("jwk", keyData, ...rest);
};
var $337343867c42a494$export$2e2bcd8739ae039 = $337343867c42a494$var$parse;

});

parcelRegister("4g1L0", function(module, exports) {

$parcel$export(module.exports, "default", () => $319a04fbce04ffdb$export$2e2bcd8739ae039);
function $319a04fbce04ffdb$var$isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
function $319a04fbce04ffdb$export$2e2bcd8739ae039(input) {
    if (!$319a04fbce04ffdb$var$isObjectLike(input) || Object.prototype.toString.call(input) !== "[object Object]") return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}

});


parcelRegister("tU6kV", function(module, exports) {

$parcel$export(module.exports, "jwtVerify", () => $059e3a140d30ed13$export$c878fd0f8381da51);

var $8BLzp = parcelRequire("8BLzp");

var $fwBhj = parcelRequire("fwBhj");

var $7GXIC = parcelRequire("7GXIC");
async function $059e3a140d30ed13$export$c878fd0f8381da51(jwt, key, options) {
    const verified = await (0, $8BLzp.compactVerify)(jwt, key, options);
    if (verified.protectedHeader.crit?.includes("b64") && verified.protectedHeader.b64 === false) throw new (0, $7GXIC.JWTInvalid)("JWTs MUST NOT use unencoded payload");
    const payload = (0, $fwBhj.default)(verified.protectedHeader, verified.payload, options);
    const result = {
        payload: payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}

});
parcelRegister("8BLzp", function(module, exports) {

$parcel$export(module.exports, "compactVerify", () => $6446add785626fa5$export$996150e72a8992e);

var $ffAor = parcelRequire("ffAor");

var $7GXIC = parcelRequire("7GXIC");

var $c2uWE = parcelRequire("c2uWE");
async function $6446add785626fa5$export$996150e72a8992e(jws, key, options) {
    if (jws instanceof Uint8Array) jws = (0, $c2uWE.decoder).decode(jws);
    if (typeof jws !== "string") throw new (0, $7GXIC.JWSInvalid)("Compact JWS must be a string or Uint8Array");
    const { 0: protectedHeader, 1: payload, 2: signature, length: length } = jws.split(".");
    if (length !== 3) throw new (0, $7GXIC.JWSInvalid)("Invalid Compact JWS");
    const verified = await (0, $ffAor.flattenedVerify)({
        payload: payload,
        protected: protectedHeader,
        signature: signature
    }, key, options);
    const result = {
        payload: verified.payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}

});
parcelRegister("ffAor", function(module, exports) {

$parcel$export(module.exports, "flattenedVerify", () => $b1a47cad1ba554c8$export$b2614975507c40c9);

var $7gBc4 = parcelRequire("7gBc4");

var $iRtjS = parcelRequire("iRtjS");

var $7GXIC = parcelRequire("7GXIC");

var $c2uWE = parcelRequire("c2uWE");

var $a3qBq = parcelRequire("a3qBq");

var $4g1L0 = parcelRequire("4g1L0");

var $bSsO7 = parcelRequire("bSsO7");

var $YmF4A = parcelRequire("YmF4A");

var $4peTa = parcelRequire("4peTa");
async function $b1a47cad1ba554c8$export$b2614975507c40c9(jws, key, options) {
    if (!(0, $4g1L0.default)(jws)) throw new (0, $7GXIC.JWSInvalid)("Flattened JWS must be an object");
    if (jws.protected === undefined && jws.header === undefined) throw new (0, $7GXIC.JWSInvalid)('Flattened JWS must have either of the "protected" or "header" members');
    if (jws.protected !== undefined && typeof jws.protected !== "string") throw new (0, $7GXIC.JWSInvalid)("JWS Protected Header incorrect type");
    if (jws.payload === undefined) throw new (0, $7GXIC.JWSInvalid)("JWS Payload missing");
    if (typeof jws.signature !== "string") throw new (0, $7GXIC.JWSInvalid)("JWS Signature missing or incorrect type");
    if (jws.header !== undefined && !(0, $4g1L0.default)(jws.header)) throw new (0, $7GXIC.JWSInvalid)("JWS Unprotected Header incorrect type");
    let parsedProt = {};
    if (jws.protected) try {
        const protectedHeader = (0, $7gBc4.decode)(jws.protected);
        parsedProt = JSON.parse((0, $c2uWE.decoder).decode(protectedHeader));
    } catch  {
        throw new (0, $7GXIC.JWSInvalid)("JWS Protected Header is invalid");
    }
    if (!(0, $a3qBq.default)(parsedProt, jws.header)) throw new (0, $7GXIC.JWSInvalid)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jws.header
    };
    const extensions = (0, $YmF4A.default)((0, $7GXIC.JWSInvalid), new Map([
        [
            "b64",
            true
        ]
    ]), options?.crit, parsedProt, joseHeader);
    let b64 = true;
    if (extensions.has("b64")) {
        b64 = parsedProt.b64;
        if (typeof b64 !== "boolean") throw new (0, $7GXIC.JWSInvalid)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
    const { alg: alg } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $7GXIC.JWSInvalid)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const algorithms = options && (0, $4peTa.default)("algorithms", options.algorithms);
    if (algorithms && !algorithms.has(alg)) throw new (0, $7GXIC.JOSEAlgNotAllowed)('"alg" (Algorithm) Header Parameter value not allowed');
    if (b64) {
        if (typeof jws.payload !== "string") throw new (0, $7GXIC.JWSInvalid)("JWS Payload must be a string");
    } else if (typeof jws.payload !== "string" && !(jws.payload instanceof Uint8Array)) throw new (0, $7GXIC.JWSInvalid)("JWS Payload must be a string or an Uint8Array instance");
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jws);
        resolvedKey = true;
    }
    (0, $bSsO7.default)(alg, key, "verify");
    const data = (0, $c2uWE.concat)((0, $c2uWE.encoder).encode(jws.protected ?? ""), (0, $c2uWE.encoder).encode("."), typeof jws.payload === "string" ? (0, $c2uWE.encoder).encode(jws.payload) : jws.payload);
    let signature;
    try {
        signature = (0, $7gBc4.decode)(jws.signature);
    } catch  {
        throw new (0, $7GXIC.JWSInvalid)("Failed to base64url decode the signature");
    }
    const verified = await (0, $iRtjS.default)(alg, key, signature, data);
    if (!verified) throw new (0, $7GXIC.JWSSignatureVerificationFailed)();
    let payload;
    if (b64) try {
        payload = (0, $7gBc4.decode)(jws.payload);
    } catch  {
        throw new (0, $7GXIC.JWSInvalid)("Failed to base64url decode the payload");
    }
    else if (typeof jws.payload === "string") payload = (0, $c2uWE.encoder).encode(jws.payload);
    else payload = jws.payload;
    const result = {
        payload: payload
    };
    if (jws.protected !== undefined) result.protectedHeader = parsedProt;
    if (jws.header !== undefined) result.unprotectedHeader = jws.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}

});
parcelRegister("iRtjS", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbb3eb797cbe0e44$export$2e2bcd8739ae039);

var $lM2r3 = parcelRequire("lM2r3");

var $5pzZh = parcelRequire("5pzZh");

var $3OU1R = parcelRequire("3OU1R");

var $j15wt = parcelRequire("j15wt");
const $dbb3eb797cbe0e44$var$verify = async (alg, key, signature, data)=>{
    const cryptoKey = await (0, $j15wt.default)(alg, key, "verify");
    (0, $3OU1R.default)(alg, cryptoKey);
    const algorithm = (0, $lM2r3.default)(alg, cryptoKey.algorithm);
    try {
        return await (0, $5pzZh.default).subtle.verify(algorithm, cryptoKey, signature, data);
    } catch  {
        return false;
    }
};
var $dbb3eb797cbe0e44$export$2e2bcd8739ae039 = $dbb3eb797cbe0e44$var$verify;

});
parcelRegister("lM2r3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd9ff84d4ad74129$export$2e2bcd8739ae039);

var $7GXIC = parcelRequire("7GXIC");
function $fd9ff84d4ad74129$export$2e2bcd8739ae039(alg, algorithm) {
    const hash = `SHA-${alg.slice(-3)}`;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            return {
                hash: hash,
                name: "HMAC"
            };
        case "PS256":
        case "PS384":
        case "PS512":
            return {
                hash: hash,
                name: "RSA-PSS",
                saltLength: alg.slice(-3) >> 3
            };
        case "RS256":
        case "RS384":
        case "RS512":
            return {
                hash: hash,
                name: "RSASSA-PKCS1-v1_5"
            };
        case "ES256":
        case "ES384":
        case "ES512":
            return {
                hash: hash,
                name: "ECDSA",
                namedCurve: algorithm.namedCurve
            };
        case "EdDSA":
            return {
                name: algorithm.name
            };
        default:
            throw new (0, $7GXIC.JOSENotSupported)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}

});

parcelRegister("3OU1R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c8180cef663e103$export$2e2bcd8739ae039);
var $2c8180cef663e103$export$2e2bcd8739ae039 = (alg, key)=>{
    if (alg.startsWith("RS") || alg.startsWith("PS")) {
        const { modulusLength: modulusLength } = key.algorithm;
        if (typeof modulusLength !== "number" || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};

});

parcelRegister("j15wt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd8265016b6a4c59$export$2e2bcd8739ae039);

var $5pzZh = parcelRequire("5pzZh");

var $geh5Z = parcelRequire("geh5Z");

var $31Bep = parcelRequire("31Bep");

var $0UxFO = parcelRequire("0UxFO");

var $cK18k = parcelRequire("cK18k");
async function $dd8265016b6a4c59$export$2e2bcd8739ae039(alg, key, usage) {
    if (usage === "sign") key = await (0, $cK18k.default).normalizePrivateKey(key, alg);
    if (usage === "verify") key = await (0, $cK18k.default).normalizePublicKey(key, alg);
    if ((0, $5pzZh.isCryptoKey)(key)) {
        (0, $geh5Z.checkSigCryptoKey)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) {
        if (!alg.startsWith("HS")) throw new TypeError((0, $31Bep.default)(key, ...(0, $0UxFO.types)));
        return (0, $5pzZh.default).subtle.importKey("raw", key, {
            hash: `SHA-${alg.slice(-3)}`,
            name: "HMAC"
        }, false, [
            usage
        ]);
    }
    throw new TypeError((0, $31Bep.default)(key, ...(0, $0UxFO.types), "Uint8Array"));
}

});
parcelRegister("geh5Z", function(module, exports) {

$parcel$export(module.exports, "checkSigCryptoKey", () => $bd0b36fb17abf4f5$export$39a36029eee6729);
function $bd0b36fb17abf4f5$var$unusable(name, prop = "algorithm.name") {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function $bd0b36fb17abf4f5$var$isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function $bd0b36fb17abf4f5$var$getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function $bd0b36fb17abf4f5$var$getNamedCurve(alg) {
    switch(alg){
        case "ES256":
            return "P-256";
        case "ES384":
            return "P-384";
        case "ES512":
            return "P-521";
        default:
            throw new Error("unreachable");
    }
}
function $bd0b36fb17abf4f5$var$checkUsage(key, usages) {
    if (usages.length && !usages.some((expected)=>key.usages.includes(expected))) {
        let msg = "CryptoKey does not support this operation, its usages must include ";
        if (usages.length > 2) {
            const last = usages.pop();
            msg += `one of ${usages.join(", ")}, or ${last}.`;
        } else if (usages.length === 2) msg += `one of ${usages[0]} or ${usages[1]}.`;
        else msg += `${usages[0]}.`;
        throw new TypeError(msg);
    }
}
function $bd0b36fb17abf4f5$export$39a36029eee6729(key, alg, ...usages) {
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "HMAC")) throw $bd0b36fb17abf4f5$var$unusable("HMAC");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "RS256":
        case "RS384":
        case "RS512":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "RSASSA-PKCS1-v1_5")) throw $bd0b36fb17abf4f5$var$unusable("RSASSA-PKCS1-v1_5");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "PS256":
        case "PS384":
        case "PS512":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "RSA-PSS")) throw $bd0b36fb17abf4f5$var$unusable("RSA-PSS");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "EdDSA":
            if (key.algorithm.name !== "Ed25519" && key.algorithm.name !== "Ed448") throw $bd0b36fb17abf4f5$var$unusable("Ed25519 or Ed448");
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "ECDSA")) throw $bd0b36fb17abf4f5$var$unusable("ECDSA");
                const expected = $bd0b36fb17abf4f5$var$getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(expected, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $bd0b36fb17abf4f5$var$checkUsage(key, usages);
}
function $bd0b36fb17abf4f5$export$41a67f89f6678b35(key, alg, ...usages) {
    switch(alg){
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "AES-GCM")) throw $bd0b36fb17abf4f5$var$unusable("AES-GCM");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(expected, "algorithm.length");
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "AES-KW")) throw $bd0b36fb17abf4f5$var$unusable("AES-KW");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(expected, "algorithm.length");
                break;
            }
        case "ECDH":
            switch(key.algorithm.name){
                case "ECDH":
                case "X25519":
                case "X448":
                    break;
                default:
                    throw $bd0b36fb17abf4f5$var$unusable("ECDH, X25519, or X448");
            }
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "PBKDF2")) throw $bd0b36fb17abf4f5$var$unusable("PBKDF2");
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "RSA-OAEP")) throw $bd0b36fb17abf4f5$var$unusable("RSA-OAEP");
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $bd0b36fb17abf4f5$var$checkUsage(key, usages);
}

});

parcelRegister("cK18k", function(module, exports) {

$parcel$export(module.exports, "default", () => $946aa8f62005044f$export$2e2bcd8739ae039);

var $7gBc4 = parcelRequire("7gBc4");

var $4pRQo = parcelRequire("4pRQo");
const $946aa8f62005044f$var$normalizeSecretKey = (k)=>(0, $7gBc4.decode)(k);
let $946aa8f62005044f$var$privCache;
let $946aa8f62005044f$var$pubCache;
const $946aa8f62005044f$var$isKeyObject = (key)=>{
    return key?.[Symbol.toStringTag] === "KeyObject";
};
const $946aa8f62005044f$var$importAndCache = async (cache, key, jwk, alg)=>{
    let cached = cache.get(key);
    if (cached?.[alg]) return cached[alg];
    const cryptoKey = await (0, $4pRQo.default)({
        ...jwk,
        alg: alg
    });
    if (!cached) cache.set(key, {
        [alg]: cryptoKey
    });
    else cached[alg] = cryptoKey;
    return cryptoKey;
};
const $946aa8f62005044f$var$normalizePublicKey = (key, alg)=>{
    if ($946aa8f62005044f$var$isKeyObject(key)) {
        let jwk = key.export({
            format: "jwk"
        });
        delete jwk.d;
        delete jwk.dp;
        delete jwk.dq;
        delete jwk.p;
        delete jwk.q;
        delete jwk.qi;
        if (jwk.k) return $946aa8f62005044f$var$normalizeSecretKey(jwk.k);
        $946aa8f62005044f$var$pubCache || ($946aa8f62005044f$var$pubCache = new WeakMap());
        return $946aa8f62005044f$var$importAndCache($946aa8f62005044f$var$pubCache, key, jwk, alg);
    }
    return key;
};
const $946aa8f62005044f$var$normalizePrivateKey = (key, alg)=>{
    if ($946aa8f62005044f$var$isKeyObject(key)) {
        let jwk = key.export({
            format: "jwk"
        });
        if (jwk.k) return $946aa8f62005044f$var$normalizeSecretKey(jwk.k);
        $946aa8f62005044f$var$privCache || ($946aa8f62005044f$var$privCache = new WeakMap());
        return $946aa8f62005044f$var$importAndCache($946aa8f62005044f$var$privCache, key, jwk, alg);
    }
    return key;
};
var $946aa8f62005044f$export$2e2bcd8739ae039 = {
    normalizePublicKey: $946aa8f62005044f$var$normalizePublicKey,
    normalizePrivateKey: $946aa8f62005044f$var$normalizePrivateKey
};

});



parcelRegister("a3qBq", function(module, exports) {

$parcel$export(module.exports, "default", () => $751ed1ebc64f8b96$export$2e2bcd8739ae039);
const $751ed1ebc64f8b96$var$isDisjoint = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};
var $751ed1ebc64f8b96$export$2e2bcd8739ae039 = $751ed1ebc64f8b96$var$isDisjoint;

});

parcelRegister("bSsO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a5b1565e0dee973$export$2e2bcd8739ae039);

var $31Bep = parcelRequire("31Bep");

var $0UxFO = parcelRequire("0UxFO");
const $8a5b1565e0dee973$var$tag = (key)=>key?.[Symbol.toStringTag];
const $8a5b1565e0dee973$var$symmetricTypeCheck = (alg, key)=>{
    if (key instanceof Uint8Array) return;
    if (!(0, $0UxFO.default)(key)) throw new TypeError((0, $31Bep.withAlg)(alg, key, ...(0, $0UxFO.types), "Uint8Array"));
    if (key.type !== "secret") throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for symmetric algorithms must be of type "secret"`);
};
const $8a5b1565e0dee973$var$asymmetricTypeCheck = (alg, key, usage)=>{
    if (!(0, $0UxFO.default)(key)) throw new TypeError((0, $31Bep.withAlg)(alg, key, ...(0, $0UxFO.types)));
    if (key.type === "secret") throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithms must not be of type "secret"`);
    if (usage === "sign" && key.type === "public") throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithm signing must be of type "private"`);
    if (usage === "decrypt" && key.type === "public") throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithm decryption must be of type "private"`);
    if (key.algorithm && usage === "verify" && key.type === "private") throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithm verifying must be of type "public"`);
    if (key.algorithm && usage === "encrypt" && key.type === "private") throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithm encryption must be of type "public"`);
};
const $8a5b1565e0dee973$var$checkKeyType = (alg, key, usage)=>{
    const symmetric = alg.startsWith("HS") || alg === "dir" || alg.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(alg);
    if (symmetric) $8a5b1565e0dee973$var$symmetricTypeCheck(alg, key);
    else $8a5b1565e0dee973$var$asymmetricTypeCheck(alg, key, usage);
};
var $8a5b1565e0dee973$export$2e2bcd8739ae039 = $8a5b1565e0dee973$var$checkKeyType;

});

parcelRegister("YmF4A", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b572ece71b785f0$export$2e2bcd8739ae039);

var $7GXIC = parcelRequire("7GXIC");
function $0b572ece71b785f0$var$validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
    if (joseHeader.crit !== undefined && protectedHeader?.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== "string" || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, $7GXIC.JOSENotSupported)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
}
var $0b572ece71b785f0$export$2e2bcd8739ae039 = $0b572ece71b785f0$var$validateCrit;

});

parcelRegister("4peTa", function(module, exports) {

$parcel$export(module.exports, "default", () => $33550bd8f4719411$export$2e2bcd8739ae039);
const $33550bd8f4719411$var$validateAlgorithms = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== "string"))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};
var $33550bd8f4719411$export$2e2bcd8739ae039 = $33550bd8f4719411$var$validateAlgorithms;

});



parcelRegister("fwBhj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4d6c2e00c056d92$export$2e2bcd8739ae039);

var $7GXIC = parcelRequire("7GXIC");

var $c2uWE = parcelRequire("c2uWE");

var $hmjA4 = parcelRequire("hmjA4");

var $jeEIZ = parcelRequire("jeEIZ");

var $4g1L0 = parcelRequire("4g1L0");
const $b4d6c2e00c056d92$var$normalizeTyp = (value)=>value.toLowerCase().replace(/^application\//, "");
const $b4d6c2e00c056d92$var$checkAudiencePresence = (audPayload, audOption)=>{
    if (typeof audPayload === "string") return audOption.includes(audPayload);
    if (Array.isArray(audPayload)) return audOption.some(Set.prototype.has.bind(new Set(audPayload)));
    return false;
};
var $b4d6c2e00c056d92$export$2e2bcd8739ae039 = (protectedHeader, encodedPayload, options = {})=>{
    let payload;
    try {
        payload = JSON.parse((0, $c2uWE.decoder).decode(encodedPayload));
    } catch  {}
    if (!(0, $4g1L0.default)(payload)) throw new (0, $7GXIC.JWTInvalid)("JWT Claims Set must be a top-level JSON object");
    const { typ: typ } = options;
    if (typ && (typeof protectedHeader.typ !== "string" || $b4d6c2e00c056d92$var$normalizeTyp(protectedHeader.typ) !== $b4d6c2e00c056d92$var$normalizeTyp(typ))) throw new (0, $7GXIC.JWTClaimValidationFailed)('unexpected "typ" JWT header value', payload, "typ", "check_failed");
    const { requiredClaims: requiredClaims = [], issuer: issuer, subject: subject, audience: audience, maxTokenAge: maxTokenAge } = options;
    const presenceCheck = [
        ...requiredClaims
    ];
    if (maxTokenAge !== undefined) presenceCheck.push("iat");
    if (audience !== undefined) presenceCheck.push("aud");
    if (subject !== undefined) presenceCheck.push("sub");
    if (issuer !== undefined) presenceCheck.push("iss");
    for (const claim of new Set(presenceCheck.reverse())){
        if (!(claim in payload)) throw new (0, $7GXIC.JWTClaimValidationFailed)(`missing required "${claim}" claim`, payload, claim, "missing");
    }
    if (issuer && !(Array.isArray(issuer) ? issuer : [
        issuer
    ]).includes(payload.iss)) throw new (0, $7GXIC.JWTClaimValidationFailed)('unexpected "iss" claim value', payload, "iss", "check_failed");
    if (subject && payload.sub !== subject) throw new (0, $7GXIC.JWTClaimValidationFailed)('unexpected "sub" claim value', payload, "sub", "check_failed");
    if (audience && !$b4d6c2e00c056d92$var$checkAudiencePresence(payload.aud, typeof audience === "string" ? [
        audience
    ] : audience)) throw new (0, $7GXIC.JWTClaimValidationFailed)('unexpected "aud" claim value', payload, "aud", "check_failed");
    let tolerance;
    switch(typeof options.clockTolerance){
        case "string":
            tolerance = (0, $jeEIZ.default)(options.clockTolerance);
            break;
        case "number":
            tolerance = options.clockTolerance;
            break;
        case "undefined":
            tolerance = 0;
            break;
        default:
            throw new TypeError("Invalid clockTolerance option type");
    }
    const { currentDate: currentDate } = options;
    const now = (0, $hmjA4.default)(currentDate || new Date());
    if ((payload.iat !== undefined || maxTokenAge) && typeof payload.iat !== "number") throw new (0, $7GXIC.JWTClaimValidationFailed)('"iat" claim must be a number', payload, "iat", "invalid");
    if (payload.nbf !== undefined) {
        if (typeof payload.nbf !== "number") throw new (0, $7GXIC.JWTClaimValidationFailed)('"nbf" claim must be a number', payload, "nbf", "invalid");
        if (payload.nbf > now + tolerance) throw new (0, $7GXIC.JWTClaimValidationFailed)('"nbf" claim timestamp check failed', payload, "nbf", "check_failed");
    }
    if (payload.exp !== undefined) {
        if (typeof payload.exp !== "number") throw new (0, $7GXIC.JWTClaimValidationFailed)('"exp" claim must be a number', payload, "exp", "invalid");
        if (payload.exp <= now - tolerance) throw new (0, $7GXIC.JWTExpired)('"exp" claim timestamp check failed', payload, "exp", "check_failed");
    }
    if (maxTokenAge) {
        const age = now - payload.iat;
        const max = typeof maxTokenAge === "number" ? maxTokenAge : (0, $jeEIZ.default)(maxTokenAge);
        if (age - tolerance > max) throw new (0, $7GXIC.JWTExpired)('"iat" claim timestamp check failed (too far in the past)', payload, "iat", "check_failed");
        if (age < 0 - tolerance) throw new (0, $7GXIC.JWTClaimValidationFailed)('"iat" claim timestamp check failed (it should be in the past)', payload, "iat", "check_failed");
    }
    return payload;
};

});
parcelRegister("hmjA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca33ae1426f1aba8$export$2e2bcd8739ae039);
var $ca33ae1426f1aba8$export$2e2bcd8739ae039 = (date)=>Math.floor(date.getTime() / 1000);

});

parcelRegister("jeEIZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e00eea37b383aa7e$export$2e2bcd8739ae039);
const $e00eea37b383aa7e$var$minute = 60;
const $e00eea37b383aa7e$var$hour = $e00eea37b383aa7e$var$minute * 60;
const $e00eea37b383aa7e$var$day = $e00eea37b383aa7e$var$hour * 24;
const $e00eea37b383aa7e$var$week = $e00eea37b383aa7e$var$day * 7;
const $e00eea37b383aa7e$var$year = $e00eea37b383aa7e$var$day * 365.25;
const $e00eea37b383aa7e$var$REGEX = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
var $e00eea37b383aa7e$export$2e2bcd8739ae039 = (str)=>{
    const matched = $e00eea37b383aa7e$var$REGEX.exec(str);
    if (!matched || matched[4] && matched[1]) throw new TypeError("Invalid time period format");
    const value = parseFloat(matched[2]);
    const unit = matched[3].toLowerCase();
    let numericDate;
    switch(unit){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            numericDate = Math.round(value);
            break;
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            numericDate = Math.round(value * $e00eea37b383aa7e$var$minute);
            break;
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            numericDate = Math.round(value * $e00eea37b383aa7e$var$hour);
            break;
        case "day":
        case "days":
        case "d":
            numericDate = Math.round(value * $e00eea37b383aa7e$var$day);
            break;
        case "week":
        case "weeks":
        case "w":
            numericDate = Math.round(value * $e00eea37b383aa7e$var$week);
            break;
        default:
            numericDate = Math.round(value * $e00eea37b383aa7e$var$year);
            break;
    }
    if (matched[1] === "-" || matched[4] === "ago") return -numericDate;
    return numericDate;
};

});



parcelRegister("hrT3a", function(module, exports) {

$parcel$export(module.exports, "SignJWT", () => $cb3fa919fa1549c0$export$88d4e5d23fbe6c84);

var $1ChXF = parcelRequire("1ChXF");

var $7GXIC = parcelRequire("7GXIC");

var $c2uWE = parcelRequire("c2uWE");

var $65ENa = parcelRequire("65ENa");
class $cb3fa919fa1549c0$export$88d4e5d23fbe6c84 extends (0, $65ENa.ProduceJWT) {
    setProtectedHeader(protectedHeader) {
        this._protectedHeader = protectedHeader;
        return this;
    }
    async sign(key, options) {
        const sig = new (0, $1ChXF.CompactSign)((0, $c2uWE.encoder).encode(JSON.stringify(this._payload)));
        sig.setProtectedHeader(this._protectedHeader);
        if (Array.isArray(this._protectedHeader?.crit) && this._protectedHeader.crit.includes("b64") && this._protectedHeader.b64 === false) throw new (0, $7GXIC.JWTInvalid)("JWTs MUST NOT use unencoded payload");
        return sig.sign(key, options);
    }
}

});
parcelRegister("1ChXF", function(module, exports) {

$parcel$export(module.exports, "CompactSign", () => $12d745ca26469470$export$b6738d8e70498d17);

var $kymxc = parcelRequire("kymxc");
class $12d745ca26469470$export$b6738d8e70498d17 {
    constructor(payload){
        this._flattened = new (0, $kymxc.FlattenedSign)(payload);
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    async sign(key, options) {
        const jws = await this._flattened.sign(key, options);
        if (jws.payload === undefined) throw new TypeError("use the flattened module for creating JWS with b64: false");
        return `${jws.protected}.${jws.payload}.${jws.signature}`;
    }
}

});
parcelRegister("kymxc", function(module, exports) {

$parcel$export(module.exports, "FlattenedSign", () => $ef6876836c58b0e4$export$9a8af5200da5ddb1);

var $7gBc4 = parcelRequire("7gBc4");

var $f3gN6 = parcelRequire("f3gN6");

var $a3qBq = parcelRequire("a3qBq");

var $7GXIC = parcelRequire("7GXIC");

var $c2uWE = parcelRequire("c2uWE");

var $bSsO7 = parcelRequire("bSsO7");

var $YmF4A = parcelRequire("YmF4A");
class $ef6876836c58b0e4$export$9a8af5200da5ddb1 {
    constructor(payload){
        if (!(payload instanceof Uint8Array)) throw new TypeError("payload must be an instance of Uint8Array");
        this._payload = payload;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    async sign(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader) throw new (0, $7GXIC.JWSInvalid)("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
        if (!(0, $a3qBq.default)(this._protectedHeader, this._unprotectedHeader)) throw new (0, $7GXIC.JWSInvalid)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader
        };
        const extensions = (0, $YmF4A.default)((0, $7GXIC.JWSInvalid), new Map([
            [
                "b64",
                true
            ]
        ]), options?.crit, this._protectedHeader, joseHeader);
        let b64 = true;
        if (extensions.has("b64")) {
            b64 = this._protectedHeader.b64;
            if (typeof b64 !== "boolean") throw new (0, $7GXIC.JWSInvalid)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
        }
        const { alg: alg } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $7GXIC.JWSInvalid)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
        (0, $bSsO7.default)(alg, key, "sign");
        let payload = this._payload;
        if (b64) payload = (0, $c2uWE.encoder).encode((0, $7gBc4.encode)(payload));
        let protectedHeader;
        if (this._protectedHeader) protectedHeader = (0, $c2uWE.encoder).encode((0, $7gBc4.encode)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $c2uWE.encoder).encode("");
        const data = (0, $c2uWE.concat)(protectedHeader, (0, $c2uWE.encoder).encode("."), payload);
        const signature = await (0, $f3gN6.default)(alg, key, data);
        const jws = {
            signature: (0, $7gBc4.encode)(signature),
            payload: ""
        };
        if (b64) jws.payload = (0, $c2uWE.decoder).decode(payload);
        if (this._unprotectedHeader) jws.header = this._unprotectedHeader;
        if (this._protectedHeader) jws.protected = (0, $c2uWE.decoder).decode(protectedHeader);
        return jws;
    }
}

});
parcelRegister("f3gN6", function(module, exports) {

$parcel$export(module.exports, "default", () => $af54292801bcc1f9$export$2e2bcd8739ae039);

var $lM2r3 = parcelRequire("lM2r3");

var $5pzZh = parcelRequire("5pzZh");

var $3OU1R = parcelRequire("3OU1R");

var $j15wt = parcelRequire("j15wt");
const $af54292801bcc1f9$var$sign = async (alg, key, data)=>{
    const cryptoKey = await (0, $j15wt.default)(alg, key, "sign");
    (0, $3OU1R.default)(alg, cryptoKey);
    const signature = await (0, $5pzZh.default).subtle.sign((0, $lM2r3.default)(alg, cryptoKey.algorithm), cryptoKey, data);
    return new Uint8Array(signature);
};
var $af54292801bcc1f9$export$2e2bcd8739ae039 = $af54292801bcc1f9$var$sign;

});



parcelRegister("65ENa", function(module, exports) {

$parcel$export(module.exports, "ProduceJWT", () => $46f2da2b3de4ed34$export$2ef1b74b7c7e6eb3);

var $hmjA4 = parcelRequire("hmjA4");

var $4g1L0 = parcelRequire("4g1L0");

var $jeEIZ = parcelRequire("jeEIZ");
function $46f2da2b3de4ed34$var$validateInput(label, input) {
    if (!Number.isFinite(input)) throw new TypeError(`Invalid ${label} input`);
    return input;
}
class $46f2da2b3de4ed34$export$2ef1b74b7c7e6eb3 {
    constructor(payload = {}){
        if (!(0, $4g1L0.default)(payload)) throw new TypeError("JWT Claims Set MUST be an object");
        this._payload = payload;
    }
    setIssuer(issuer) {
        this._payload = {
            ...this._payload,
            iss: issuer
        };
        return this;
    }
    setSubject(subject) {
        this._payload = {
            ...this._payload,
            sub: subject
        };
        return this;
    }
    setAudience(audience) {
        this._payload = {
            ...this._payload,
            aud: audience
        };
        return this;
    }
    setJti(jwtId) {
        this._payload = {
            ...this._payload,
            jti: jwtId
        };
        return this;
    }
    setNotBefore(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            nbf: $46f2da2b3de4ed34$var$validateInput("setNotBefore", input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            nbf: $46f2da2b3de4ed34$var$validateInput("setNotBefore", (0, $hmjA4.default)(input))
        };
        else this._payload = {
            ...this._payload,
            nbf: (0, $hmjA4.default)(new Date()) + (0, $jeEIZ.default)(input)
        };
        return this;
    }
    setExpirationTime(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            exp: $46f2da2b3de4ed34$var$validateInput("setExpirationTime", input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            exp: $46f2da2b3de4ed34$var$validateInput("setExpirationTime", (0, $hmjA4.default)(input))
        };
        else this._payload = {
            ...this._payload,
            exp: (0, $hmjA4.default)(new Date()) + (0, $jeEIZ.default)(input)
        };
        return this;
    }
    setIssuedAt(input) {
        if (typeof input === "undefined") this._payload = {
            ...this._payload,
            iat: (0, $hmjA4.default)(new Date())
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            iat: $46f2da2b3de4ed34$var$validateInput("setIssuedAt", (0, $hmjA4.default)(input))
        };
        else if (typeof input === "string") this._payload = {
            ...this._payload,
            iat: $46f2da2b3de4ed34$var$validateInput("setIssuedAt", (0, $hmjA4.default)(new Date()) + (0, $jeEIZ.default)(input))
        };
        else this._payload = {
            ...this._payload,
            iat: $46f2da2b3de4ed34$var$validateInput("setIssuedAt", input)
        };
        return this;
    }
}

});


parcelRegister("akcrY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.either = void 0;
function $78456df826f6a4d3$var$either(a, b) {
    if (a != null && b != null && a !== b) throw new TypeError(`Expected "${b}", got "${a}"`);
    return a ?? b ?? undefined;
}
module.exports.either = $78456df826f6a4d3$var$either;

});



parcelRegister("24DA2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isCryptoKeyPair = module.exports.fromSubtleAlgorithm = module.exports.toSubtleAlgorithm = void 0;
function $182aa850173982cc$var$toSubtleAlgorithm(alg, crv, options) {
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            return {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`,
                modulusLength: options?.modulusLength ?? 2048,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ])
            };
        case "RS256":
        case "RS384":
        case "RS512":
            return {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`,
                modulusLength: options?.modulusLength ?? 2048,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ])
            };
        case "ES256":
        case "ES384":
            return {
                name: "ECDSA",
                namedCurve: `P-${alg.slice(-3)}`
            };
        case "ES512":
            return {
                name: "ECDSA",
                namedCurve: "P-521"
            };
        default:
            // https://github.com/w3c/webcrypto/issues/82#issuecomment-849856773
            throw new TypeError(`Unsupported alg "${alg}"`);
    }
}
module.exports.toSubtleAlgorithm = $182aa850173982cc$var$toSubtleAlgorithm;
function $182aa850173982cc$var$fromSubtleAlgorithm(algorithm) {
    switch(algorithm.name){
        case "RSA-PSS":
        case "RSASSA-PKCS1-v1_5":
            {
                const hash = algorithm.hash.name;
                switch(hash){
                    case "SHA-256":
                    case "SHA-384":
                    case "SHA-512":
                        {
                            const prefix = algorithm.name === "RSA-PSS" ? "PS" : "RS";
                            return `${prefix}${hash.slice(-3)}`;
                        }
                    default:
                        throw new TypeError("unsupported RsaHashedKeyAlgorithm hash");
                }
            }
        case "ECDSA":
            {
                const namedCurve = algorithm.namedCurve;
                switch(namedCurve){
                    case "P-256":
                    case "P-384":
                    case "P-512":
                        return `ES${namedCurve.slice(-3)}`;
                    case "P-521":
                        return "ES512";
                    default:
                        throw new TypeError("unsupported EcKeyAlgorithm namedCurve");
                }
            }
        case "Ed448":
        case "Ed25519":
            return "EdDSA";
        default:
            // https://github.com/w3c/webcrypto/issues/82#issuecomment-849856773
            throw new TypeError(`Unexpected algorithm "${algorithm.name}"`);
    }
}
module.exports.fromSubtleAlgorithm = $182aa850173982cc$var$fromSubtleAlgorithm;
function $182aa850173982cc$var$isCryptoKeyPair(v, extractable) {
    return typeof v === "object" && v !== null && "privateKey" in v && v.privateKey instanceof CryptoKey && v.privateKey.type === "private" && (extractable == null || v.privateKey.extractable === extractable) && v.privateKey.usages.includes("sign") && "publicKey" in v && v.publicKey instanceof CryptoKey && v.publicKey.type === "public" && v.publicKey.extractable === true && v.publicKey.usages.includes("verify");
}
module.exports.isCryptoKeyPair = $182aa850173982cc$var$isCryptoKeyPair;

});



parcelRegister("cNZAj", function(module, exports) {
"use strict";
var $9529d518a516ff35$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9529d518a516ff35$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9529d518a516ff35$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchResponseError = module.exports.FetchRequestError = module.exports.FetchError = void 0;

$9529d518a516ff35$var$__exportStar((parcelRequire("k2dJf")), module.exports);

var $8oTqd = parcelRequire("8oTqd");
Object.defineProperty(module.exports, "FetchError", {
    enumerable: true,
    get: function() {
        return $8oTqd.FetchError;
    }
});
Object.defineProperty(module.exports, "FetchRequestError", {
    enumerable: true,
    get: function() {
        return $8oTqd.FetchRequestError;
    }
});
Object.defineProperty(module.exports, "FetchResponseError", {
    enumerable: true,
    get: function() {
        return $8oTqd.FetchResponseError;
    }
});

$9529d518a516ff35$var$__exportStar((parcelRequire("fYfau")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("hoXKl")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("auA9I")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("6oTi5")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("lfpNx")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("gwEzH")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("fFwT5")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("90baw")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("3e91q")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("eXxXt")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("4H3QM")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("6aqH9")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("8vaR3")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("5u6ZB")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("lfiD0")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("fr8VS")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("5F6X2")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("gbHhk")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("5QfU8")), module.exports);

});
parcelRegister("k2dJf", function(module, exports) {
"use strict";
var $03c3974dafbe68ad$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $03c3974dafbe68ad$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $03c3974dafbe68ad$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$03c3974dafbe68ad$var$__exportStar((parcelRequire("hoXKl")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("h8kQI")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("9NhYU")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("9x0MW")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("h0Y9m")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("fNvbt")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("kLeG9")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("iPo4S")), module.exports);

});
parcelRegister("hoXKl", function(module, exports) {
"use strict";
var $cab305fac27e14fb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cab305fac27e14fb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cab305fac27e14fb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cab305fac27e14fb$var$__exportStar((parcelRequire("di7jZ")), module.exports);

$cab305fac27e14fb$var$__exportStar((parcelRequire("4vBZ2")), module.exports);

$cab305fac27e14fb$var$__exportStar((parcelRequire("1ucW1")), module.exports);

$cab305fac27e14fb$var$__exportStar((parcelRequire("8xDRX")), module.exports);

$cab305fac27e14fb$var$__exportStar((parcelRequire("2imNQ")), module.exports);

});
parcelRegister("di7jZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isAtprotoDidWeb = module.exports.checkAtprotoDid = module.exports.asAtprotoDid = module.exports.isAtprotoDid = void 0;

var $1ucW1 = parcelRequire("1ucW1");

var $2imNQ = parcelRequire("2imNQ");
function $9ad2a2b3a965ea28$var$isAtprotoDid(input) {
    // Optimized equivalent of:
    // return isDidPlc(input) || isAtprotoDidWeb(input)
    if (typeof input !== "string") return false;
    else if (input.startsWith($2imNQ.DID_PLC_PREFIX)) return (0, $2imNQ.isDidPlc)(input);
    else if (input.startsWith($2imNQ.DID_WEB_PREFIX)) return $9ad2a2b3a965ea28$var$isAtprotoDidWeb(input);
    else return false;
}
module.exports.isAtprotoDid = $9ad2a2b3a965ea28$var$isAtprotoDid;
function $9ad2a2b3a965ea28$var$asAtprotoDid(input) {
    $9ad2a2b3a965ea28$var$checkAtprotoDid(input);
    return input;
}
module.exports.asAtprotoDid = $9ad2a2b3a965ea28$var$asAtprotoDid;
function $9ad2a2b3a965ea28$var$checkAtprotoDid(input) {
    if (typeof input !== "string") throw new $1ucW1.InvalidDidError(typeof input, `DID must be a string`);
    else if (input.startsWith($2imNQ.DID_PLC_PREFIX)) (0, $2imNQ.checkDidPlc)(input);
    else if (input.startsWith($2imNQ.DID_WEB_PREFIX)) (0, $2imNQ.checkDidWeb)(input);
    else throw new $1ucW1.InvalidDidError(input, `Atproto only allows "plc" and "web" DID methods`);
}
module.exports.checkAtprotoDid = $9ad2a2b3a965ea28$var$checkAtprotoDid;
/**
 * @see {@link https://atproto.com/specs/did#blessed-did-methods}
 */ function $9ad2a2b3a965ea28$var$isAtprotoDidWeb(input) {
    // Optimization: make cheap checks first
    if (typeof input !== "string") return false;
    // Path are not allowed
    if (input.includes(":", $2imNQ.DID_WEB_PREFIX.length)) return false;
    // Port numbers are not allowed, except for localhost
    if (input.includes("%3A", $2imNQ.DID_WEB_PREFIX.length) && !input.startsWith("did:web:localhost%3A")) return false;
    return (0, $2imNQ.isDidWeb)(input);
}
module.exports.isAtprotoDidWeb = $9ad2a2b3a965ea28$var$isAtprotoDidWeb;

});
parcelRegister("1ucW1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidDidError = module.exports.DidError = void 0;
class $1152a06229c1f991$var$DidError extends Error {
    constructor(did, message, code, status = 400, cause){
        super(message, {
            cause: cause
        });
        Object.defineProperty(this, "did", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: did
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: code
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: status
        });
    }
    /**
     * For compatibility with error handlers in common HTTP frameworks.
     */ get statusCode() {
        return this.status;
    }
    toString() {
        return `${this.constructor.name} ${this.code} (${this.did}): ${this.message}`;
    }
    static from(cause, did) {
        if (cause instanceof $1152a06229c1f991$var$DidError) return cause;
        const message = cause instanceof Error ? cause.message : typeof cause === "string" ? cause : "An unknown error occurred";
        const status = (typeof cause?.["statusCode"] === "number" ? cause["statusCode"] : undefined) ?? (typeof cause?.["status"] === "number" ? cause["status"] : undefined);
        return new $1152a06229c1f991$var$DidError(did, message, "did-unknown-error", status, cause);
    }
}
module.exports.DidError = $1152a06229c1f991$var$DidError;
class $1152a06229c1f991$var$InvalidDidError extends $1152a06229c1f991$var$DidError {
    constructor(did, message, cause){
        super(did, message, "did-invalid", 400, cause);
    }
}
module.exports.InvalidDidError = $1152a06229c1f991$var$InvalidDidError;

});

parcelRegister("2imNQ", function(module, exports) {
"use strict";
var $1abef36158b9e510$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1abef36158b9e510$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1abef36158b9e510$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1abef36158b9e510$var$__exportStar((parcelRequire("h8Isf")), module.exports);

$1abef36158b9e510$var$__exportStar((parcelRequire("aujvv")), module.exports);

});
parcelRegister("h8Isf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkDidPlc = module.exports.asDidPlc = module.exports.isDidPlc = module.exports.DID_PLC_PREFIX = void 0;

var $1ucW1 = parcelRequire("1ucW1");
const $c7a5aac2ff3431d2$var$DID_PLC_PREFIX = `did:plc:`;
module.exports.DID_PLC_PREFIX = $c7a5aac2ff3431d2$var$DID_PLC_PREFIX;
const $c7a5aac2ff3431d2$var$DID_PLC_PREFIX_LENGTH = $c7a5aac2ff3431d2$var$DID_PLC_PREFIX.length;
const $c7a5aac2ff3431d2$var$DID_PLC_LENGTH = 32;
function $c7a5aac2ff3431d2$var$isDidPlc(input) {
    // Optimization: make cheap checks first
    if (typeof input !== "string") return false;
    try {
        $c7a5aac2ff3431d2$var$checkDidPlc(input);
        return true;
    } catch  {
        return false;
    }
}
module.exports.isDidPlc = $c7a5aac2ff3431d2$var$isDidPlc;
function $c7a5aac2ff3431d2$var$asDidPlc(input) {
    $c7a5aac2ff3431d2$var$checkDidPlc(input);
    return input;
}
module.exports.asDidPlc = $c7a5aac2ff3431d2$var$asDidPlc;
function $c7a5aac2ff3431d2$var$checkDidPlc(input) {
    if (typeof input !== "string") throw new $1ucW1.InvalidDidError(typeof input, `DID must be a string`);
    if (input.length !== $c7a5aac2ff3431d2$var$DID_PLC_LENGTH) throw new $1ucW1.InvalidDidError(input, `did:plc must be ${$c7a5aac2ff3431d2$var$DID_PLC_LENGTH} characters long`);
    if (!input.startsWith($c7a5aac2ff3431d2$var$DID_PLC_PREFIX)) throw new $1ucW1.InvalidDidError(input, `Invalid did:plc prefix`);
    let c;
    for(let i = $c7a5aac2ff3431d2$var$DID_PLC_PREFIX_LENGTH; i < $c7a5aac2ff3431d2$var$DID_PLC_LENGTH; i++){
        c = input.charCodeAt(i);
        // Base32 encoding ([a-z2-7])
        if ((c < 0x61 || c > 0x7a) && (c < 0x32 || c > 0x37)) throw new $1ucW1.InvalidDidError(input, `Invalid character at position ${i}`);
    }
}
module.exports.checkDidPlc = $c7a5aac2ff3431d2$var$checkDidPlc;

});

parcelRegister("aujvv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.urlToDidWeb = module.exports.didWebToUrl = module.exports.checkDidWeb = module.exports.asDidWeb = module.exports.isDidWeb = module.exports.DID_WEB_PREFIX = void 0;

var $1ucW1 = parcelRequire("1ucW1");

var $8xDRX = parcelRequire("8xDRX");
module.exports.DID_WEB_PREFIX = `did:web:`;
/**
 * This function checks if the input is a valid Web DID, as per DID spec.
 */ function $7a2bd670f2648172$var$isDidWeb(input) {
    // Optimization: make cheap checks first
    if (typeof input !== "string") return false;
    try {
        $7a2bd670f2648172$var$checkDidWeb(input);
        return true;
    } catch  {
        return false;
    }
}
module.exports.isDidWeb = $7a2bd670f2648172$var$isDidWeb;
function $7a2bd670f2648172$var$asDidWeb(input) {
    $7a2bd670f2648172$var$checkDidWeb(input);
    return input;
}
module.exports.asDidWeb = $7a2bd670f2648172$var$asDidWeb;
function $7a2bd670f2648172$var$checkDidWeb(input) {
    if (typeof input !== "string") throw new $1ucW1.InvalidDidError(typeof input, `DID must be a string`);
    $7a2bd670f2648172$var$didWebToUrl(input);
}
module.exports.checkDidWeb = $7a2bd670f2648172$var$checkDidWeb;
function $7a2bd670f2648172$var$didWebToUrl(did) {
    if (!did.startsWith(module.exports.DID_WEB_PREFIX)) throw new $1ucW1.InvalidDidError(did, `did:web must start with ${module.exports.DID_WEB_PREFIX}`);
    if (did.charAt(module.exports.DID_WEB_PREFIX.length) === ":") throw new $1ucW1.InvalidDidError(did, "did:web MSID must not start with a colon");
    // Make sure every char is valid (per DID spec)
    (0, $8xDRX.checkDidMsid)(did, module.exports.DID_WEB_PREFIX.length);
    try {
        const msid = did.slice(module.exports.DID_WEB_PREFIX.length);
        const parts = msid.split(":").map(decodeURIComponent);
        return new URL(`https://${parts.join("/")}`);
    } catch (cause) {
        throw new $1ucW1.InvalidDidError(did, "Invalid Web DID", cause);
    }
}
module.exports.didWebToUrl = $7a2bd670f2648172$var$didWebToUrl;
function $7a2bd670f2648172$var$urlToDidWeb(url) {
    const path = url.pathname === "/" ? "" : url.pathname.slice(1).split("/").map(encodeURIComponent).join(":");
    return `did:web:${encodeURIComponent(url.host)}${path ? `:${path}` : ""}`;
}
module.exports.urlToDidWeb = $7a2bd670f2648172$var$urlToDidWeb;

});
parcelRegister("8xDRX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.didSchema = module.exports.asDid = module.exports.isDid = module.exports.checkDid = module.exports.checkDidMsid = module.exports.extractDidMethod = module.exports.checkDidMethod = module.exports.DID_PREFIX = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $1ucW1 = parcelRequire("1ucW1");
const $6380550494a93d86$var$DID_PREFIX = "did:";
module.exports.DID_PREFIX = $6380550494a93d86$var$DID_PREFIX;
const $6380550494a93d86$var$DID_PREFIX_LENGTH = $6380550494a93d86$var$DID_PREFIX.length;
/**
 * DID Method-name check function.
 *
 * Check if the input is a valid DID method name, at the position between
 * `start` (inclusive) and `end` (exclusive).
 */ function $6380550494a93d86$var$checkDidMethod(input, start = 0, end = input.length) {
    if (!Number.isFinite(end) || !Number.isFinite(start) || end < start || end > input.length) throw new TypeError("Invalid start or end position");
    if (end === start) throw new $1ucW1.InvalidDidError(input, `Empty method name`);
    let c;
    for(let i = start; i < end; i++){
        c = input.charCodeAt(i);
        if ((c < 0x61 || c > 0x7a) && // a-z
        (c < 0x30 || c > 0x39 // 0-9
        )) throw new $1ucW1.InvalidDidError(input, `Invalid character at position ${i} in DID method name`);
    }
}
module.exports.checkDidMethod = $6380550494a93d86$var$checkDidMethod;
/**
 * This method assumes the input is a valid Did
 */ function $6380550494a93d86$var$extractDidMethod(did) {
    const msidSep = did.indexOf(":", $6380550494a93d86$var$DID_PREFIX_LENGTH);
    const method = did.slice($6380550494a93d86$var$DID_PREFIX_LENGTH, msidSep);
    return method;
}
module.exports.extractDidMethod = $6380550494a93d86$var$extractDidMethod;
/**
 * DID Method-specific identifier check function.
 *
 * Check if the input is a valid DID method-specific identifier, at the position
 * between `start` (inclusive) and `end` (exclusive).
 */ function $6380550494a93d86$var$checkDidMsid(input, start = 0, end = input.length) {
    if (!Number.isFinite(end) || !Number.isFinite(start) || end < start || end > input.length) throw new TypeError("Invalid start or end position");
    if (end === start) throw new $1ucW1.InvalidDidError(input, `DID method-specific id must not be empty`);
    let c;
    for(let i = start; i < end; i++){
        c = input.charCodeAt(i);
        // Check for frequent chars first
        if ((c < 0x61 || c > 0x7a) && // a-z
        (c < 0x41 || c > 0x5a) && // A-Z
        (c < 0x30 || c > 0x39) && // 0-9
        c !== 0x2e && // .
        c !== 0x2d && // -
        c !== 0x5f // _
        ) {
            // Less frequent chars are checked here
            // ":"
            if (c === 0x3a) {
                if (i === end - 1) throw new $1ucW1.InvalidDidError(input, `DID cannot end with ":"`);
                continue;
            }
            // pct-encoded
            if (c === 0x25) {
                c = input.charCodeAt(++i);
                if ((c < 0x30 || c > 0x39) && (c < 0x41 || c > 0x46)) throw new $1ucW1.InvalidDidError(input, `Invalid pct-encoded character at position ${i}`);
                c = input.charCodeAt(++i);
                if ((c < 0x30 || c > 0x39) && (c < 0x41 || c > 0x46)) throw new $1ucW1.InvalidDidError(input, `Invalid pct-encoded character at position ${i}`);
                // There must always be 2 HEXDIG after a "%"
                if (i >= end) throw new $1ucW1.InvalidDidError(input, `Incomplete pct-encoded character at position ${i - 2}`);
                continue;
            }
            throw new $1ucW1.InvalidDidError(input, `Disallowed character in DID at position ${i}`);
        }
    }
}
module.exports.checkDidMsid = $6380550494a93d86$var$checkDidMsid;
function $6380550494a93d86$var$checkDid(input) {
    if (typeof input !== "string") throw new $1ucW1.InvalidDidError(typeof input, `DID must be a string`);
    const { length: length } = input;
    if (length > 2048) throw new $1ucW1.InvalidDidError(input, `DID is too long (2048 chars max)`);
    if (!input.startsWith($6380550494a93d86$var$DID_PREFIX)) throw new $1ucW1.InvalidDidError(input, `DID requires "${$6380550494a93d86$var$DID_PREFIX}" prefix`);
    const idSep = input.indexOf(":", $6380550494a93d86$var$DID_PREFIX_LENGTH);
    if (idSep === -1) throw new $1ucW1.InvalidDidError(input, `Missing colon after method name`);
    $6380550494a93d86$var$checkDidMethod(input, $6380550494a93d86$var$DID_PREFIX_LENGTH, idSep);
    $6380550494a93d86$var$checkDidMsid(input, idSep + 1, length);
}
module.exports.checkDid = $6380550494a93d86$var$checkDid;
function $6380550494a93d86$var$isDid(input) {
    try {
        $6380550494a93d86$var$checkDid(input);
        return true;
    } catch (err) {
        if (err instanceof $1ucW1.DidError) return false;
        // Unexpected TypeError (should never happen)
        throw err;
    }
}
module.exports.isDid = $6380550494a93d86$var$isDid;
function $6380550494a93d86$var$asDid(input) {
    $6380550494a93d86$var$checkDid(input);
    return input;
}
module.exports.asDid = $6380550494a93d86$var$asDid;
module.exports.didSchema = $2zDt6.z.string().superRefine((value, ctx)=>{
    try {
        $6380550494a93d86$var$checkDid(value);
        return true;
    } catch (err) {
        ctx.addIssue({
            code: $2zDt6.z.ZodIssueCode.custom,
            message: err instanceof Error ? err.message : "Unexpected error"
        });
        return false;
    }
});

});




parcelRegister("4vBZ2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.didDocumentValidator = module.exports.didDocumentSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $8xDRX = parcelRequire("8xDRX");
/**
 * RFC3968 compliant URI
 *
 * @see {@link https://www.rfc-editor.org/rfc/rfc3986}
 */ const $34878568ec6ab058$var$rfc3968UriSchema = $2zDt6.z.string().refine((data)=>{
    try {
        new URL(data);
        return true;
    } catch  {
        return false;
    }
}, "RFC3968 compliant URI");
const $34878568ec6ab058$var$didControllerSchema = $2zDt6.z.union([
    $8xDRX.didSchema,
    $2zDt6.z.array($8xDRX.didSchema)
]);
/**
 * @note this schema might be too permissive
 */ const $34878568ec6ab058$var$didRelativeUriSchema = $2zDt6.z.union([
    $34878568ec6ab058$var$rfc3968UriSchema,
    $2zDt6.z.string().regex(/^#[^#]+$/)
]);
const $34878568ec6ab058$var$didVerificationMethodSchema = $2zDt6.z.object({
    id: $34878568ec6ab058$var$didRelativeUriSchema,
    type: $2zDt6.z.string().min(1),
    controller: $34878568ec6ab058$var$didControllerSchema,
    publicKeyJwk: $2zDt6.z.record($2zDt6.z.string(), $2zDt6.z.unknown()).optional(),
    publicKeyMultibase: $2zDt6.z.string().optional()
});
/**
 * The value of the id property MUST be a URI conforming to [RFC3986]. A
 * conforming producer MUST NOT produce multiple service entries with the same
 * id. A conforming consumer MUST produce an error if it detects multiple
 * service entries with the same id.
 *
 * @note Normally, only rfc3968UriSchema should be allowed here. However, the
 *   did:plc uses relative URI. For this reason, we also allow relative URIs
 *   here.
 */ const $34878568ec6ab058$var$didServiceIdSchema = $34878568ec6ab058$var$didRelativeUriSchema;
/**
 * The value of the type property MUST be a string or a set of strings. In order
 * to maximize interoperability, the service type and its associated properties
 * SHOULD be registered in the DID Specification Registries
 * [DID-SPEC-REGISTRIES].
 */ const $34878568ec6ab058$var$didServiceTypeSchema = $2zDt6.z.union([
    $2zDt6.z.string(),
    $2zDt6.z.array($2zDt6.z.string())
]);
/**
 * The value of the serviceEndpoint property MUST be a string, a map, or a set
 * composed of one or more strings and/or maps. All string values MUST be valid
 * URIs conforming to [RFC3986] and normalized according to the Normalization
 * and Comparison rules in RFC3986 and to any normalization rules in its
 * applicable URI scheme specification.
 */ const $34878568ec6ab058$var$didServiceEndpointSchema = $2zDt6.z.union([
    $34878568ec6ab058$var$rfc3968UriSchema,
    $2zDt6.z.record($2zDt6.z.string(), $34878568ec6ab058$var$rfc3968UriSchema),
    $2zDt6.z.array($2zDt6.z.union([
        $34878568ec6ab058$var$rfc3968UriSchema,
        $2zDt6.z.record($2zDt6.z.string(), $34878568ec6ab058$var$rfc3968UriSchema)
    ])).nonempty()
]);
/**
 * Each service map MUST contain id, type, and serviceEndpoint properties.
 * @see {@link https://www.w3.org/TR/did-core/#services}
 */ const $34878568ec6ab058$var$didServiceSchema = $2zDt6.z.object({
    id: $34878568ec6ab058$var$didServiceIdSchema,
    type: $34878568ec6ab058$var$didServiceTypeSchema,
    serviceEndpoint: $34878568ec6ab058$var$didServiceEndpointSchema
});
const $34878568ec6ab058$var$didAuthenticationSchema = $2zDt6.z.union([
    //
    $34878568ec6ab058$var$didRelativeUriSchema,
    $34878568ec6ab058$var$didVerificationMethodSchema
]);
/**
 * @note This schema is incomplete
 * @see {@link https://www.w3.org/TR/did-core/#production-0}
 */ module.exports.didDocumentSchema = $2zDt6.z.object({
    "@context": $2zDt6.z.union([
        $2zDt6.z.literal("https://www.w3.org/ns/did/v1"),
        $2zDt6.z.array($2zDt6.z.string().url()).nonempty().refine((data)=>data[0] === "https://www.w3.org/ns/did/v1", {
            message: "First @context must be https://www.w3.org/ns/did/v1"
        })
    ]),
    id: $8xDRX.didSchema,
    controller: $34878568ec6ab058$var$didControllerSchema.optional(),
    alsoKnownAs: $2zDt6.z.array($34878568ec6ab058$var$rfc3968UriSchema).optional(),
    service: $2zDt6.z.array($34878568ec6ab058$var$didServiceSchema).optional(),
    authentication: $2zDt6.z.array($34878568ec6ab058$var$didAuthenticationSchema).optional(),
    verificationMethod: $2zDt6.z.array($2zDt6.z.union([
        $34878568ec6ab058$var$didVerificationMethodSchema,
        $34878568ec6ab058$var$didRelativeUriSchema
    ])).optional()
});
// @TODO: add other refinements ?
module.exports.didDocumentValidator = module.exports.didDocumentSchema.superRefine((data, ctx)=>{
    if (data.service) {
        for(let i = 0; i < data.service.length; i++)if (data.service[i].id === data.id) ctx.addIssue({
            code: $2zDt6.z.ZodIssueCode.custom,
            message: `Service id must be different from the document id`,
            path: [
                "service",
                i,
                "id"
            ]
        });
    }
}).superRefine((data, ctx)=>{
    if (data.service) {
        const normalizedIds = data.service.map((s)=>s.id?.startsWith("#") ? `${data.id}${s.id}` : s.id);
        for(let i = 0; i < normalizedIds.length; i++){
            for(let j = i + 1; j < normalizedIds.length; j++)if (normalizedIds[i] === normalizedIds[j]) ctx.addIssue({
                code: $2zDt6.z.ZodIssueCode.custom,
                message: `Duplicate service id (${normalizedIds[j]}) found in the document`,
                path: [
                    "service",
                    j,
                    "id"
                ]
            });
        }
    }
});

});


parcelRegister("h8kQI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DidCacheMemory = void 0;

var $9eBhV = parcelRequire("9eBhV");
const $c7935b41b3a49136$var$DEFAULT_TTL = 3600000; // 1 hour
const $c7935b41b3a49136$var$DEFAULT_MAX_SIZE = 52428800; // ~50MB
class $c7935b41b3a49136$var$DidCacheMemory extends $9eBhV.SimpleStoreMemory {
    constructor(options){
        super(options?.max == null ? {
            ttl: $c7935b41b3a49136$var$DEFAULT_TTL,
            maxSize: $c7935b41b3a49136$var$DEFAULT_MAX_SIZE,
            ...options
        } : {
            ttl: $c7935b41b3a49136$var$DEFAULT_TTL,
            ...options
        });
    }
}
module.exports.DidCacheMemory = $c7935b41b3a49136$var$DidCacheMemory;

});
parcelRegister("9eBhV", function(module, exports) {
"use strict";
var $6b92587be94aa254$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6b92587be94aa254$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6b92587be94aa254$var$_SimpleStoreMemory_cache;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleStoreMemory = void 0;

var $cqpOy = parcelRequire("cqpOy");

var $Xr4fk = parcelRequire("Xr4fk");
// LRUCache does not allow storing "null", so we use a symbol to represent it.
const $6b92587be94aa254$var$nullSymbol = Symbol("nullItem");
const $6b92587be94aa254$var$toLruValue = (value)=>value === null ? $6b92587be94aa254$var$nullSymbol : value;
const $6b92587be94aa254$var$fromLruValue = (value)=>value === $6b92587be94aa254$var$nullSymbol ? null : value;
class $6b92587be94aa254$var$SimpleStoreMemory {
    constructor({ sizeCalculation: sizeCalculation, ...options }){
        $6b92587be94aa254$var$_SimpleStoreMemory_cache.set(this, void 0);
        $6b92587be94aa254$var$__classPrivateFieldSet(this, $6b92587be94aa254$var$_SimpleStoreMemory_cache, new $cqpOy.LRUCache({
            ...options,
            allowStale: false,
            updateAgeOnGet: false,
            updateAgeOnHas: false,
            sizeCalculation: sizeCalculation ? (value, key)=>sizeCalculation($6b92587be94aa254$var$fromLruValue(value), key) : options.maxEntrySize != null || options.maxSize != null ? $Xr4fk.roughSizeOfObject : undefined
        }), "f");
    }
    get(key) {
        const value = $6b92587be94aa254$var$__classPrivateFieldGet(this, $6b92587be94aa254$var$_SimpleStoreMemory_cache, "f").get(key);
        if (value === undefined) return undefined;
        return $6b92587be94aa254$var$fromLruValue(value);
    }
    set(key, value) {
        $6b92587be94aa254$var$__classPrivateFieldGet(this, $6b92587be94aa254$var$_SimpleStoreMemory_cache, "f").set(key, $6b92587be94aa254$var$toLruValue(value));
    }
    del(key) {
        $6b92587be94aa254$var$__classPrivateFieldGet(this, $6b92587be94aa254$var$_SimpleStoreMemory_cache, "f").delete(key);
    }
    clear() {
        $6b92587be94aa254$var$__classPrivateFieldGet(this, $6b92587be94aa254$var$_SimpleStoreMemory_cache, "f").clear();
    }
}
module.exports.SimpleStoreMemory = $6b92587be94aa254$var$SimpleStoreMemory;
$6b92587be94aa254$var$_SimpleStoreMemory_cache = new WeakMap();

});
parcelRegister("cqpOy", function(module, exports) {

$parcel$export(module.exports, "LRUCache", () => $90bbefef4dc25bab$export$182500e6725aad9a);
/**
 * @module LRUCache
 */ 
var $hPtJY = parcelRequire("hPtJY");
const $90bbefef4dc25bab$var$perf = typeof performance === "object" && performance && typeof performance.now === "function" ? performance : Date;
const $90bbefef4dc25bab$var$warned = new Set();
/* c8 ignore start */ const $90bbefef4dc25bab$var$PROCESS = typeof $hPtJY === "object" && !!$hPtJY ? $hPtJY : {};
/* c8 ignore start */ const $90bbefef4dc25bab$var$emitWarning = (msg, type, code, fn)=>{
    typeof $90bbefef4dc25bab$var$PROCESS.emitWarning === "function" ? $90bbefef4dc25bab$var$PROCESS.emitWarning(msg, type, code, fn) : console.error(`[${code}] ${type}: ${msg}`);
};
let $90bbefef4dc25bab$var$AC = globalThis.AbortController;
let $90bbefef4dc25bab$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $90bbefef4dc25bab$var$AC === "undefined") {
    //@ts-ignore
    $90bbefef4dc25bab$var$AS = class AbortSignal {
        onabort;
        _onabort = [];
        reason;
        aborted = false;
        addEventListener(_, fn) {
            this._onabort.push(fn);
        }
    };
    //@ts-ignore
    $90bbefef4dc25bab$var$AC = class AbortController {
        constructor(){
            warnACPolyfill();
        }
        signal = new $90bbefef4dc25bab$var$AS();
        abort(reason) {
            if (this.signal.aborted) return;
            //@ts-ignore
            this.signal.reason = reason;
            //@ts-ignore
            this.signal.aborted = true;
            //@ts-ignore
            for (const fn of this.signal._onabort)fn(reason);
            this.signal.onabort?.(reason);
        }
    };
    let printACPolyfillWarning = $90bbefef4dc25bab$var$PROCESS.env?.LRU_CACHE_IGNORE_AC_WARNING !== "1";
    const warnACPolyfill = ()=>{
        if (!printACPolyfillWarning) return;
        printACPolyfillWarning = false;
        $90bbefef4dc25bab$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", "NO_ABORT_CONTROLLER", "ENOTSUP", warnACPolyfill);
    };
}
/* c8 ignore stop */ const $90bbefef4dc25bab$var$shouldWarn = (code)=>!$90bbefef4dc25bab$var$warned.has(code);
const $90bbefef4dc25bab$var$TYPE = Symbol("type");
const $90bbefef4dc25bab$var$isPosInt = (n)=>n && n === Math.floor(n) && n > 0 && isFinite(n);
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
const $90bbefef4dc25bab$var$getUintArray = (max)=>!$90bbefef4dc25bab$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $90bbefef4dc25bab$var$ZeroArray : null;
/* c8 ignore stop */ class $90bbefef4dc25bab$var$ZeroArray extends Array {
    constructor(size){
        super(size);
        this.fill(0);
    }
}
class $90bbefef4dc25bab$var$Stack {
    heap;
    length;
    // private constructor
    static #constructing = false;
    static create(max) {
        const HeapCls = $90bbefef4dc25bab$var$getUintArray(max);
        if (!HeapCls) return [];
        $90bbefef4dc25bab$var$Stack.#constructing = true;
        const s = new $90bbefef4dc25bab$var$Stack(max, HeapCls);
        $90bbefef4dc25bab$var$Stack.#constructing = false;
        return s;
    }
    constructor(max, HeapCls){
        /* c8 ignore start */ if (!$90bbefef4dc25bab$var$Stack.#constructing) throw new TypeError("instantiate Stack using Stack.create(n)");
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
    push(n) {
        this.heap[this.length++] = n;
    }
    pop() {
        return this.heap[--this.length];
    }
}
class $90bbefef4dc25bab$export$182500e6725aad9a {
    // options that cannot be changed without disaster
    #max;
    #maxSize;
    #dispose;
    #disposeAfter;
    #fetchMethod;
    #memoMethod;
    /**
     * {@link LRUCache.OptionsBase.ttl}
     */ ttl;
    /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ ttlResolution;
    /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ ttlAutopurge;
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ updateAgeOnGet;
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ updateAgeOnHas;
    /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ allowStale;
    /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ noDisposeOnSet;
    /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ noUpdateTTL;
    /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ maxEntrySize;
    /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ sizeCalculation;
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ noDeleteOnFetchRejection;
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ noDeleteOnStaleGet;
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ allowStaleOnFetchAbort;
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ allowStaleOnFetchRejection;
    /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ ignoreFetchAbort;
    // computed properties
    #size;
    #calculatedSize;
    #keyMap;
    #keyList;
    #valList;
    #next;
    #prev;
    #head;
    #tail;
    #free;
    #disposed;
    #sizes;
    #starts;
    #ttls;
    #hasDispose;
    #hasFetchMethod;
    #hasDisposeAfter;
    /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ static unsafeExposeInternals(c) {
        return {
            // properties
            starts: c.#starts,
            ttls: c.#ttls,
            sizes: c.#sizes,
            keyMap: c.#keyMap,
            keyList: c.#keyList,
            valList: c.#valList,
            next: c.#next,
            prev: c.#prev,
            get head () {
                return c.#head;
            },
            get tail () {
                return c.#tail;
            },
            free: c.#free,
            // methods
            isBackgroundFetch: (p)=>c.#isBackgroundFetch(p),
            backgroundFetch: (k, index, options, context)=>c.#backgroundFetch(k, index, options, context),
            moveToTail: (index)=>c.#moveToTail(index),
            indexes: (options)=>c.#indexes(options),
            rindexes: (options)=>c.#rindexes(options),
            isStale: (index)=>c.#isStale(index)
        };
    }
    // Protected read-only members
    /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ get max() {
        return this.#max;
    }
    /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ get maxSize() {
        return this.#maxSize;
    }
    /**
     * The total computed size of items in the cache (read-only)
     */ get calculatedSize() {
        return this.#calculatedSize;
    }
    /**
     * The number of items stored in the cache (read-only)
     */ get size() {
        return this.#size;
    }
    /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ get fetchMethod() {
        return this.#fetchMethod;
    }
    get memoMethod() {
        return this.#memoMethod;
    }
    /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ get dispose() {
        return this.#dispose;
    }
    /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ get disposeAfter() {
        return this.#disposeAfter;
    }
    constructor(options){
        const { max: max = 0, ttl: ttl, ttlResolution: ttlResolution = 1, ttlAutopurge: ttlAutopurge, updateAgeOnGet: updateAgeOnGet, updateAgeOnHas: updateAgeOnHas, allowStale: allowStale, dispose: dispose, disposeAfter: disposeAfter, noDisposeOnSet: noDisposeOnSet, noUpdateTTL: noUpdateTTL, maxSize: maxSize = 0, maxEntrySize: maxEntrySize = 0, sizeCalculation: sizeCalculation, fetchMethod: fetchMethod, memoMethod: memoMethod, noDeleteOnFetchRejection: noDeleteOnFetchRejection, noDeleteOnStaleGet: noDeleteOnStaleGet, allowStaleOnFetchRejection: allowStaleOnFetchRejection, allowStaleOnFetchAbort: allowStaleOnFetchAbort, ignoreFetchAbort: ignoreFetchAbort } = options;
        if (max !== 0 && !$90bbefef4dc25bab$var$isPosInt(max)) throw new TypeError("max option must be a nonnegative integer");
        const UintArray = max ? $90bbefef4dc25bab$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error("invalid max value: " + max);
        this.#max = max;
        this.#maxSize = maxSize;
        this.maxEntrySize = maxEntrySize || this.#maxSize;
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!this.#maxSize && !this.maxEntrySize) throw new TypeError("cannot set sizeCalculation without setting maxSize or maxEntrySize");
            if (typeof this.sizeCalculation !== "function") throw new TypeError("sizeCalculation set to non-function");
        }
        if (memoMethod !== undefined && typeof memoMethod !== "function") throw new TypeError("memoMethod must be a function if defined");
        this.#memoMethod = memoMethod;
        if (fetchMethod !== undefined && typeof fetchMethod !== "function") throw new TypeError("fetchMethod must be a function if specified");
        this.#fetchMethod = fetchMethod;
        this.#hasFetchMethod = !!fetchMethod;
        this.#keyMap = new Map();
        this.#keyList = new Array(max).fill(undefined);
        this.#valList = new Array(max).fill(undefined);
        this.#next = new UintArray(max);
        this.#prev = new UintArray(max);
        this.#head = 0;
        this.#tail = 0;
        this.#free = $90bbefef4dc25bab$var$Stack.create(max);
        this.#size = 0;
        this.#calculatedSize = 0;
        if (typeof dispose === "function") this.#dispose = dispose;
        if (typeof disposeAfter === "function") {
            this.#disposeAfter = disposeAfter;
            this.#disposed = [];
        } else {
            this.#disposeAfter = undefined;
            this.#disposed = undefined;
        }
        this.#hasDispose = !!this.#dispose;
        this.#hasDisposeAfter = !!this.#disposeAfter;
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if (this.#maxSize !== 0) {
                if (!$90bbefef4dc25bab$var$isPosInt(this.#maxSize)) throw new TypeError("maxSize must be a positive integer if specified");
            }
            if (!$90bbefef4dc25bab$var$isPosInt(this.maxEntrySize)) throw new TypeError("maxEntrySize must be a positive integer if specified");
            this.#initializeSizeTracking();
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $90bbefef4dc25bab$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$90bbefef4dc25bab$var$isPosInt(this.ttl)) throw new TypeError("ttl must be a positive integer if specified");
            this.#initializeTTLTracking();
        }
        // do not allow completely unbounded caches
        if (this.#max === 0 && this.ttl === 0 && this.#maxSize === 0) throw new TypeError("At least one of max, maxSize, or ttl is required");
        if (!this.ttlAutopurge && !this.#max && !this.#maxSize) {
            const code = "LRU_CACHE_UNBOUNDED";
            if ($90bbefef4dc25bab$var$shouldWarn(code)) {
                $90bbefef4dc25bab$var$warned.add(code);
                const msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $90bbefef4dc25bab$var$emitWarning(msg, "UnboundedCacheWarning", code, $90bbefef4dc25bab$export$182500e6725aad9a);
            }
        }
    }
    /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ getRemainingTTL(key) {
        return this.#keyMap.has(key) ? Infinity : 0;
    }
    #initializeTTLTracking() {
        const ttls = new $90bbefef4dc25bab$var$ZeroArray(this.#max);
        const starts = new $90bbefef4dc25bab$var$ZeroArray(this.#max);
        this.#ttls = ttls;
        this.#starts = starts;
        this.#setItemTTL = (index, ttl, start = $90bbefef4dc25bab$var$perf.now())=>{
            starts[index] = ttl !== 0 ? start : 0;
            ttls[index] = ttl;
            if (ttl !== 0 && this.ttlAutopurge) {
                const t = setTimeout(()=>{
                    if (this.#isStale(index)) this.#delete(this.#keyList[index], "expire");
                }, ttl + 1);
                // unref() not supported on all platforms
                /* c8 ignore start */ if (t.unref) t.unref();
            /* c8 ignore stop */ }
        };
        this.#updateItemAge = (index)=>{
            starts[index] = ttls[index] !== 0 ? $90bbefef4dc25bab$var$perf.now() : 0;
        };
        this.#statusTTL = (status, index)=>{
            if (ttls[index]) {
                const ttl = ttls[index];
                const start = starts[index];
                /* c8 ignore next */ if (!ttl || !start) return;
                status.ttl = ttl;
                status.start = start;
                status.now = cachedNow || getNow();
                const age = status.now - start;
                status.remainingTTL = ttl - age;
            }
        };
        // debounce calls to perf.now() to 1s so we're not hitting
        // that costly call repeatedly.
        let cachedNow = 0;
        const getNow = ()=>{
            const n = $90bbefef4dc25bab$var$perf.now();
            if (this.ttlResolution > 0) {
                cachedNow = n;
                const t = setTimeout(()=>cachedNow = 0, this.ttlResolution);
                // not available on all platforms
                /* c8 ignore start */ if (t.unref) t.unref();
            /* c8 ignore stop */ }
            return n;
        };
        this.getRemainingTTL = (key)=>{
            const index = this.#keyMap.get(key);
            if (index === undefined) return 0;
            const ttl = ttls[index];
            const start = starts[index];
            if (!ttl || !start) return Infinity;
            const age = (cachedNow || getNow()) - start;
            return ttl - age;
        };
        this.#isStale = (index)=>{
            const s = starts[index];
            const t = ttls[index];
            return !!t && !!s && (cachedNow || getNow()) - s > t;
        };
    }
    // conditionally set private methods related to TTL
    #updateItemAge = ()=>{};
    #statusTTL = ()=>{};
    #setItemTTL = ()=>{};
    /* c8 ignore stop */ #isStale = ()=>false;
    #initializeSizeTracking() {
        const sizes = new $90bbefef4dc25bab$var$ZeroArray(this.#max);
        this.#calculatedSize = 0;
        this.#sizes = sizes;
        this.#removeItemSize = (index)=>{
            this.#calculatedSize -= sizes[index];
            sizes[index] = 0;
        };
        this.#requireSize = (k, v, size, sizeCalculation)=>{
            // provisionally accept background fetches.
            // actual value size will be checked when they return.
            if (this.#isBackgroundFetch(v)) return 0;
            if (!$90bbefef4dc25bab$var$isPosInt(size)) {
                if (sizeCalculation) {
                    if (typeof sizeCalculation !== "function") throw new TypeError("sizeCalculation must be a function");
                    size = sizeCalculation(v, k);
                    if (!$90bbefef4dc25bab$var$isPosInt(size)) throw new TypeError("sizeCalculation return invalid (expect positive integer)");
                } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
            }
            return size;
        };
        this.#addItemSize = (index, size, status)=>{
            sizes[index] = size;
            if (this.#maxSize) {
                const maxSize = this.#maxSize - sizes[index];
                while(this.#calculatedSize > maxSize)this.#evict(true);
            }
            this.#calculatedSize += sizes[index];
            if (status) {
                status.entrySize = size;
                status.totalCalculatedSize = this.#calculatedSize;
            }
        };
    }
    #removeItemSize = (_i)=>{};
    #addItemSize = (_i, _s, _st)=>{};
    #requireSize = (_k, _v, size, sizeCalculation)=>{
        if (size || sizeCalculation) throw new TypeError("cannot set size without setting maxSize or maxEntrySize on cache");
        return 0;
    };
    *#indexes({ allowStale: allowStale = this.allowStale } = {}) {
        if (this.#size) for(let i = this.#tail;;){
            if (!this.#isValidIndex(i)) break;
            if (allowStale || !this.#isStale(i)) yield i;
            if (i === this.#head) break;
            else i = this.#prev[i];
        }
    }
    *#rindexes({ allowStale: allowStale = this.allowStale } = {}) {
        if (this.#size) for(let i = this.#head;;){
            if (!this.#isValidIndex(i)) break;
            if (allowStale || !this.#isStale(i)) yield i;
            if (i === this.#tail) break;
            else i = this.#next[i];
        }
    }
    #isValidIndex(index) {
        return index !== undefined && this.#keyMap.get(this.#keyList[index]) === index;
    }
    /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ *entries() {
        for (const i of this.#indexes())if (this.#valList[i] !== undefined && this.#keyList[i] !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield [
            this.#keyList[i],
            this.#valList[i]
        ];
    }
    /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ *rentries() {
        for (const i of this.#rindexes())if (this.#valList[i] !== undefined && this.#keyList[i] !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield [
            this.#keyList[i],
            this.#valList[i]
        ];
    }
    /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ *keys() {
        for (const i of this.#indexes()){
            const k = this.#keyList[i];
            if (k !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield k;
        }
    }
    /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ *rkeys() {
        for (const i of this.#rindexes()){
            const k = this.#keyList[i];
            if (k !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield k;
        }
    }
    /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ *values() {
        for (const i of this.#indexes()){
            const v = this.#valList[i];
            if (v !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield this.#valList[i];
        }
    }
    /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ *rvalues() {
        for (const i of this.#rindexes()){
            const v = this.#valList[i];
            if (v !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield this.#valList[i];
        }
    }
    /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ [Symbol.toStringTag] = "LRUCache";
    /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ find(fn, getOptions = {}) {
        for (const i of this.#indexes()){
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            if (fn(value, this.#keyList[i], this)) return this.get(this.#keyList[i], getOptions);
        }
    }
    /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ forEach(fn, thisp = this) {
        for (const i of this.#indexes()){
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, this.#keyList[i], this);
        }
    }
    /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ rforEach(fn, thisp = this) {
        for (const i of this.#rindexes()){
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, this.#keyList[i], this);
        }
    }
    /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ purgeStale() {
        let deleted = false;
        for (const i of this.#rindexes({
            allowStale: true
        }))if (this.#isStale(i)) {
            this.#delete(this.#keyList[i], "expire");
            deleted = true;
        }
        return deleted;
    }
    /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ info(key) {
        const i = this.#keyMap.get(key);
        if (i === undefined) return undefined;
        const v = this.#valList[i];
        const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
        if (value === undefined) return undefined;
        const entry = {
            value: value
        };
        if (this.#ttls && this.#starts) {
            const ttl = this.#ttls[i];
            const start = this.#starts[i];
            if (ttl && start) {
                const remain = ttl - ($90bbefef4dc25bab$var$perf.now() - start);
                entry.ttl = remain;
                entry.start = Date.now();
            }
        }
        if (this.#sizes) entry.size = this.#sizes[i];
        return entry;
    }
    /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ dump() {
        const arr = [];
        for (const i of this.#indexes({
            allowStale: true
        })){
            const key = this.#keyList[i];
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined || key === undefined) continue;
            const entry = {
                value: value
            };
            if (this.#ttls && this.#starts) {
                entry.ttl = this.#ttls[i];
                // always dump the start relative to a portable timestamp
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = $90bbefef4dc25bab$var$perf.now() - this.#starts[i];
                entry.start = Math.floor(Date.now() - age);
            }
            if (this.#sizes) entry.size = this.#sizes[i];
            arr.unshift([
                key,
                entry
            ]);
        }
        return arr;
    }
    /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ load(arr) {
        this.clear();
        for (const [key, entry] of arr){
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset, so that
                // we get the intended remaining TTL, no matter how long it's
                // been on ice.
                //
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = Date.now() - entry.start;
                entry.start = $90bbefef4dc25bab$var$perf.now() - age;
            }
            this.set(key, entry.value, entry);
        }
    }
    /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ set(k, v, setOptions = {}) {
        if (v === undefined) {
            this.delete(k);
            return this;
        }
        const { ttl: ttl = this.ttl, start: start, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, sizeCalculation: sizeCalculation = this.sizeCalculation, status: status } = setOptions;
        let { noUpdateTTL: noUpdateTTL = this.noUpdateTTL } = setOptions;
        const size = this.#requireSize(k, v, setOptions.size || 0, sizeCalculation);
        // if the item doesn't fit, don't do anything
        // NB: maxEntrySize set to maxSize by default
        if (this.maxEntrySize && size > this.maxEntrySize) {
            if (status) {
                status.set = "miss";
                status.maxEntrySizeExceeded = true;
            }
            // have to delete, in case something is there already.
            this.#delete(k, "set");
            return this;
        }
        let index = this.#size === 0 ? undefined : this.#keyMap.get(k);
        if (index === undefined) {
            // addition
            index = this.#size === 0 ? this.#tail : this.#free.length !== 0 ? this.#free.pop() : this.#size === this.#max ? this.#evict(false) : this.#size;
            this.#keyList[index] = k;
            this.#valList[index] = v;
            this.#keyMap.set(k, index);
            this.#next[this.#tail] = index;
            this.#prev[index] = this.#tail;
            this.#tail = index;
            this.#size++;
            this.#addItemSize(index, size, status);
            if (status) status.set = "add";
            noUpdateTTL = false;
        } else {
            // update
            this.#moveToTail(index);
            const oldVal = this.#valList[index];
            if (v !== oldVal) {
                if (this.#hasFetchMethod && this.#isBackgroundFetch(oldVal)) {
                    oldVal.__abortController.abort(new Error("replaced"));
                    const { __staleWhileFetching: s } = oldVal;
                    if (s !== undefined && !noDisposeOnSet) {
                        if (this.#hasDispose) this.#dispose?.(s, k, "set");
                        if (this.#hasDisposeAfter) this.#disposed?.push([
                            s,
                            k,
                            "set"
                        ]);
                    }
                } else if (!noDisposeOnSet) {
                    if (this.#hasDispose) this.#dispose?.(oldVal, k, "set");
                    if (this.#hasDisposeAfter) this.#disposed?.push([
                        oldVal,
                        k,
                        "set"
                    ]);
                }
                this.#removeItemSize(index);
                this.#addItemSize(index, size, status);
                this.#valList[index] = v;
                if (status) {
                    status.set = "replace";
                    const oldValue = oldVal && this.#isBackgroundFetch(oldVal) ? oldVal.__staleWhileFetching : oldVal;
                    if (oldValue !== undefined) status.oldValue = oldValue;
                }
            } else if (status) status.set = "update";
        }
        if (ttl !== 0 && !this.#ttls) this.#initializeTTLTracking();
        if (this.#ttls) {
            if (!noUpdateTTL) this.#setItemTTL(index, ttl, start);
            if (status) this.#statusTTL(status, index);
        }
        if (!noDisposeOnSet && this.#hasDisposeAfter && this.#disposed) {
            const dt = this.#disposed;
            let task;
            while(task = dt?.shift())this.#disposeAfter?.(...task);
        }
        return this;
    }
    /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ pop() {
        try {
            while(this.#size){
                const val = this.#valList[this.#head];
                this.#evict(true);
                if (this.#isBackgroundFetch(val)) {
                    if (val.__staleWhileFetching) return val.__staleWhileFetching;
                } else if (val !== undefined) return val;
            }
        } finally{
            if (this.#hasDisposeAfter && this.#disposed) {
                const dt = this.#disposed;
                let task;
                while(task = dt?.shift())this.#disposeAfter?.(...task);
            }
        }
    }
    #evict(free) {
        const head = this.#head;
        const k = this.#keyList[head];
        const v = this.#valList[head];
        if (this.#hasFetchMethod && this.#isBackgroundFetch(v)) v.__abortController.abort(new Error("evicted"));
        else if (this.#hasDispose || this.#hasDisposeAfter) {
            if (this.#hasDispose) this.#dispose?.(v, k, "evict");
            if (this.#hasDisposeAfter) this.#disposed?.push([
                v,
                k,
                "evict"
            ]);
        }
        this.#removeItemSize(head);
        // if we aren't about to use the index, then null these out
        if (free) {
            this.#keyList[head] = undefined;
            this.#valList[head] = undefined;
            this.#free.push(head);
        }
        if (this.#size === 1) {
            this.#head = this.#tail = 0;
            this.#free.length = 0;
        } else this.#head = this.#next[head];
        this.#keyMap.delete(k);
        this.#size--;
        return head;
    }
    /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ has(k, hasOptions = {}) {
        const { updateAgeOnHas: updateAgeOnHas = this.updateAgeOnHas, status: status } = hasOptions;
        const index = this.#keyMap.get(k);
        if (index !== undefined) {
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v) && v.__staleWhileFetching === undefined) return false;
            if (!this.#isStale(index)) {
                if (updateAgeOnHas) this.#updateItemAge(index);
                if (status) {
                    status.has = "hit";
                    this.#statusTTL(status, index);
                }
                return true;
            } else if (status) {
                status.has = "stale";
                this.#statusTTL(status, index);
            }
        } else if (status) status.has = "miss";
        return false;
    }
    /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ peek(k, peekOptions = {}) {
        const { allowStale: allowStale = this.allowStale } = peekOptions;
        const index = this.#keyMap.get(k);
        if (index === undefined || !allowStale && this.#isStale(index)) return;
        const v = this.#valList[index];
        // either stale and allowed, or forcing a refresh of non-stale value
        return this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
    }
    #backgroundFetch(k, index, options, context) {
        const v = index === undefined ? undefined : this.#valList[index];
        if (this.#isBackgroundFetch(v)) return v;
        const ac = new $90bbefef4dc25bab$var$AC();
        const { signal: signal } = options;
        // when/if our AC signals, then stop listening to theirs.
        signal?.addEventListener("abort", ()=>ac.abort(signal.reason), {
            signal: ac.signal
        });
        const fetchOpts = {
            signal: ac.signal,
            options: options,
            context: context
        };
        const cb = (v, updateCache = false)=>{
            const { aborted: aborted } = ac.signal;
            const ignoreAbort = options.ignoreFetchAbort && v !== undefined;
            if (options.status) {
                if (aborted && !updateCache) {
                    options.status.fetchAborted = true;
                    options.status.fetchError = ac.signal.reason;
                    if (ignoreAbort) options.status.fetchAbortIgnored = true;
                } else options.status.fetchResolved = true;
            }
            if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
            // either we didn't abort, and are still here, or we did, and ignored
            const bf = p;
            if (this.#valList[index] === p) {
                if (v === undefined) {
                    if (bf.__staleWhileFetching) this.#valList[index] = bf.__staleWhileFetching;
                    else this.#delete(k, "fetch");
                } else {
                    if (options.status) options.status.fetchUpdated = true;
                    this.set(k, v, fetchOpts.options);
                }
            }
            return v;
        };
        const eb = (er)=>{
            if (options.status) {
                options.status.fetchRejected = true;
                options.status.fetchError = er;
            }
            return fetchFail(er);
        };
        const fetchFail = (er)=>{
            const { aborted: aborted } = ac.signal;
            const allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
            const allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
            const noDelete = allowStale || options.noDeleteOnFetchRejection;
            const bf = p;
            if (this.#valList[index] === p) {
                // if we allow stale on fetch rejections, then we need to ensure that
                // the stale value is not removed from the cache when the fetch fails.
                const del = !noDelete || bf.__staleWhileFetching === undefined;
                if (del) this.#delete(k, "fetch");
                else if (!allowStaleAborted) // still replace the *promise* with the stale value,
                // since we are done with the promise at this point.
                // leave it untouched if we're still waiting for an
                // aborted background fetch that hasn't yet returned.
                this.#valList[index] = bf.__staleWhileFetching;
            }
            if (allowStale) {
                if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
                return bf.__staleWhileFetching;
            } else if (bf.__returned === bf) throw er;
        };
        const pcall = (res, rej)=>{
            const fmp = this.#fetchMethod?.(k, v, fetchOpts);
            if (fmp && fmp instanceof Promise) fmp.then((v)=>res(v === undefined ? undefined : v), rej);
            // ignored, we go until we finish, regardless.
            // defer check until we are actually aborting,
            // so fetchMethod can override.
            ac.signal.addEventListener("abort", ()=>{
                if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                    res(undefined);
                    // when it eventually resolves, update the cache.
                    if (options.allowStaleOnFetchAbort) res = (v)=>cb(v, true);
                }
            });
        };
        if (options.status) options.status.fetchDispatched = true;
        const p = new Promise(pcall).then(cb, eb);
        const bf = Object.assign(p, {
            __abortController: ac,
            __staleWhileFetching: v,
            __returned: undefined
        });
        if (index === undefined) {
            // internal, don't expose status.
            this.set(k, bf, {
                ...fetchOpts.options,
                status: undefined
            });
            index = this.#keyMap.get(k);
        } else this.#valList[index] = bf;
        return bf;
    }
    #isBackgroundFetch(p) {
        if (!this.#hasFetchMethod) return false;
        const b = p;
        return !!b && b instanceof Promise && b.hasOwnProperty("__staleWhileFetching") && b.__abortController instanceof $90bbefef4dc25bab$var$AC;
    }
    async fetch(k, fetchOptions = {}) {
        const { allowStale: // get options
        allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, ttl: // set options
        ttl = this.ttl, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, size: size = 0, sizeCalculation: sizeCalculation = this.sizeCalculation, noUpdateTTL: noUpdateTTL = this.noUpdateTTL, noDeleteOnFetchRejection: // fetch exclusive options
        noDeleteOnFetchRejection = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: allowStaleOnFetchRejection = this.allowStaleOnFetchRejection, ignoreFetchAbort: ignoreFetchAbort = this.ignoreFetchAbort, allowStaleOnFetchAbort: allowStaleOnFetchAbort = this.allowStaleOnFetchAbort, context: context, forceRefresh: forceRefresh = false, status: status, signal: signal } = fetchOptions;
        if (!this.#hasFetchMethod) {
            if (status) status.fetch = "get";
            return this.get(k, {
                allowStale: allowStale,
                updateAgeOnGet: updateAgeOnGet,
                noDeleteOnStaleGet: noDeleteOnStaleGet,
                status: status
            });
        }
        const options = {
            allowStale: allowStale,
            updateAgeOnGet: updateAgeOnGet,
            noDeleteOnStaleGet: noDeleteOnStaleGet,
            ttl: ttl,
            noDisposeOnSet: noDisposeOnSet,
            size: size,
            sizeCalculation: sizeCalculation,
            noUpdateTTL: noUpdateTTL,
            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
            ignoreFetchAbort: ignoreFetchAbort,
            status: status,
            signal: signal
        };
        let index = this.#keyMap.get(k);
        if (index === undefined) {
            if (status) status.fetch = "miss";
            const p = this.#backgroundFetch(k, index, options, context);
            return p.__returned = p;
        } else {
            // in cache, maybe already fetching
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v)) {
                const stale = allowStale && v.__staleWhileFetching !== undefined;
                if (status) {
                    status.fetch = "inflight";
                    if (stale) status.returnedStale = true;
                }
                return stale ? v.__staleWhileFetching : v.__returned = v;
            }
            // if we force a refresh, that means do NOT serve the cached value,
            // unless we are already in the process of refreshing the cache.
            const isStale = this.#isStale(index);
            if (!forceRefresh && !isStale) {
                if (status) status.fetch = "hit";
                this.#moveToTail(index);
                if (updateAgeOnGet) this.#updateItemAge(index);
                if (status) this.#statusTTL(status, index);
                return v;
            }
            // ok, it is stale or a forced refresh, and not already fetching.
            // refresh the cache.
            const p = this.#backgroundFetch(k, index, options, context);
            const hasStale = p.__staleWhileFetching !== undefined;
            const staleVal = hasStale && allowStale;
            if (status) {
                status.fetch = isStale ? "stale" : "refresh";
                if (staleVal && isStale) status.returnedStale = true;
            }
            return staleVal ? p.__staleWhileFetching : p.__returned = p;
        }
    }
    async forceFetch(k, fetchOptions = {}) {
        const v = await this.fetch(k, fetchOptions);
        if (v === undefined) throw new Error("fetch() returned undefined");
        return v;
    }
    memo(k, memoOptions = {}) {
        const memoMethod = this.#memoMethod;
        if (!memoMethod) throw new Error("no memoMethod provided to constructor");
        const { context: context, forceRefresh: forceRefresh, ...options } = memoOptions;
        const v = this.get(k, options);
        if (!forceRefresh && v !== undefined) return v;
        const vv = memoMethod(k, v, {
            options: options,
            context: context
        });
        this.set(k, vv, options);
        return vv;
    }
    /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ get(k, getOptions = {}) {
        const { allowStale: allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, status: status } = getOptions;
        const index = this.#keyMap.get(k);
        if (index !== undefined) {
            const value = this.#valList[index];
            const fetching = this.#isBackgroundFetch(value);
            if (status) this.#statusTTL(status, index);
            if (this.#isStale(index)) {
                if (status) status.get = "stale";
                // delete only if not an in-flight background fetch
                if (!fetching) {
                    if (!noDeleteOnStaleGet) this.#delete(k, "expire");
                    if (status && allowStale) status.returnedStale = true;
                    return allowStale ? value : undefined;
                } else {
                    if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                    return allowStale ? value.__staleWhileFetching : undefined;
                }
            } else {
                if (status) status.get = "hit";
                // if we're currently fetching it, we don't actually have it yet
                // it's not stale, which means this isn't a staleWhileRefetching.
                // If it's not stale, and fetching, AND has a __staleWhileFetching
                // value, then that means the user fetched with {forceRefresh:true},
                // so it's safe to return that value.
                if (fetching) return value.__staleWhileFetching;
                this.#moveToTail(index);
                if (updateAgeOnGet) this.#updateItemAge(index);
                return value;
            }
        } else if (status) status.get = "miss";
    }
    #connect(p, n) {
        this.#prev[n] = p;
        this.#next[p] = n;
    }
    #moveToTail(index) {
        // if tail already, nothing to do
        // if head, move head to next[index]
        // else
        //   move next[prev[index]] to next[index] (head has no prev)
        //   move prev[next[index]] to prev[index]
        // prev[index] = tail
        // next[tail] = index
        // tail = index
        if (index !== this.#tail) {
            if (index === this.#head) this.#head = this.#next[index];
            else this.#connect(this.#prev[index], this.#next[index]);
            this.#connect(this.#tail, index);
            this.#tail = index;
        }
    }
    /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ delete(k) {
        return this.#delete(k, "delete");
    }
    #delete(k, reason) {
        let deleted = false;
        if (this.#size !== 0) {
            const index = this.#keyMap.get(k);
            if (index !== undefined) {
                deleted = true;
                if (this.#size === 1) this.#clear(reason);
                else {
                    this.#removeItemSize(index);
                    const v = this.#valList[index];
                    if (this.#isBackgroundFetch(v)) v.__abortController.abort(new Error("deleted"));
                    else if (this.#hasDispose || this.#hasDisposeAfter) {
                        if (this.#hasDispose) this.#dispose?.(v, k, reason);
                        if (this.#hasDisposeAfter) this.#disposed?.push([
                            v,
                            k,
                            reason
                        ]);
                    }
                    this.#keyMap.delete(k);
                    this.#keyList[index] = undefined;
                    this.#valList[index] = undefined;
                    if (index === this.#tail) this.#tail = this.#prev[index];
                    else if (index === this.#head) this.#head = this.#next[index];
                    else {
                        const pi = this.#prev[index];
                        this.#next[pi] = this.#next[index];
                        const ni = this.#next[index];
                        this.#prev[ni] = this.#prev[index];
                    }
                    this.#size--;
                    this.#free.push(index);
                }
            }
        }
        if (this.#hasDisposeAfter && this.#disposed?.length) {
            const dt = this.#disposed;
            let task;
            while(task = dt?.shift())this.#disposeAfter?.(...task);
        }
        return deleted;
    }
    /**
     * Clear the cache entirely, throwing away all values.
     */ clear() {
        return this.#clear("delete");
    }
    #clear(reason) {
        for (const index of this.#rindexes({
            allowStale: true
        })){
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v)) v.__abortController.abort(new Error("deleted"));
            else {
                const k = this.#keyList[index];
                if (this.#hasDispose) this.#dispose?.(v, k, reason);
                if (this.#hasDisposeAfter) this.#disposed?.push([
                    v,
                    k,
                    reason
                ]);
            }
        }
        this.#keyMap.clear();
        this.#valList.fill(undefined);
        this.#keyList.fill(undefined);
        if (this.#ttls && this.#starts) {
            this.#ttls.fill(0);
            this.#starts.fill(0);
        }
        if (this.#sizes) this.#sizes.fill(0);
        this.#head = 0;
        this.#tail = 0;
        this.#free.length = 0;
        this.#calculatedSize = 0;
        this.#size = 0;
        if (this.#hasDisposeAfter && this.#disposed) {
            const dt = this.#disposed;
            let task;
            while(task = dt?.shift())this.#disposeAfter?.(...task);
        }
    }
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("Xr4fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.roughSizeOfObject = void 0;
const $0b2a81d79110b115$var$knownSizes = new WeakMap();
/**
 * @see {@link https://stackoverflow.com/a/11900218/356537}
 */ function $0b2a81d79110b115$var$roughSizeOfObject(value) {
    const objectList = new Set();
    const stack = [
        value
    ]; // This would be more efficient using a circular buffer
    let bytes = 0;
    while(stack.length){
        const value = stack.pop();
        // > All objects on the heap start with a shape descriptor, which takes one
        // > pointer size (usually 4 bytes these days, thanks to "pointer
        // > compression" on 64-bit platforms).
        switch(typeof value){
            // Types are ordered by frequency
            case "string":
                // https://stackoverflow.com/a/68791382/356537
                bytes += 12 + 4 * Math.ceil(value.length / 4);
                break;
            case "number":
                bytes += 12; // Shape descriptor + double
                break;
            case "boolean":
                bytes += 4; // Shape descriptor
                break;
            case "object":
                bytes += 4; // Shape descriptor
                if (value === null) break;
                if ($0b2a81d79110b115$var$knownSizes.has(value)) {
                    bytes += $0b2a81d79110b115$var$knownSizes.get(value);
                    break;
                }
                if (objectList.has(value)) continue;
                objectList.add(value);
                if (Array.isArray(value)) {
                    bytes += 4;
                    stack.push(...value);
                } else {
                    bytes += 8;
                    const keys = Object.getOwnPropertyNames(value);
                    for(let i = 0; i < keys.length; i++){
                        bytes += 4;
                        const key = keys[i];
                        const val = value[key];
                        if (val !== undefined) stack.push(val);
                        stack.push(key);
                    }
                }
                break;
            case "function":
                bytes += 8; // Shape descriptor + pointer (assuming functions are shared)
                break;
            case "symbol":
                bytes += 8; // Shape descriptor + pointer
                break;
            case "bigint":
                bytes += 16; // Shape descriptor + BigInt
                break;
        }
    }
    if (typeof value === "object" && value !== null) $0b2a81d79110b115$var$knownSizes.set(value, bytes);
    return bytes;
}
module.exports.roughSizeOfObject = $0b2a81d79110b115$var$roughSizeOfObject;

});



parcelRegister("9NhYU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DidResolverCached = void 0;

var $559MJ = parcelRequire("559MJ");

var $h8kQI = parcelRequire("h8kQI");
class $7216a363f3af6f09$var$DidResolverCached {
    constructor(resolver, cache = new $h8kQI.DidCacheMemory()){
        Object.defineProperty(this, "getter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.getter = new $559MJ.CachedGetter((did, options)=>resolver.resolve(did, options), cache);
    }
    async resolve(did, options) {
        return this.getter.get(did, options);
    }
}
module.exports.DidResolverCached = $7216a363f3af6f09$var$DidResolverCached;

});
parcelRegister("559MJ", function(module, exports) {
"use strict";
var $3b350277c85e809c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3b350277c85e809c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3b350277c85e809c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3b350277c85e809c$var$__exportStar((parcelRequire("gGU8b")), module.exports);

$3b350277c85e809c$var$__exportStar((parcelRequire("4vlHV")), module.exports);

});
parcelRegister("gGU8b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CachedGetter = void 0;
const $c26c1c02bd1549ff$var$returnTrue = ()=>true;
const $c26c1c02bd1549ff$var$returnFalse = ()=>false;
/**
 * Wrapper utility that uses a store to speed up the retrieval of values from an
 * (expensive) getter function.
 */ class $c26c1c02bd1549ff$var$CachedGetter {
    constructor(getter, store, options){
        Object.defineProperty(this, "getter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: getter
        });
        Object.defineProperty(this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: store
        });
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(this, "pending", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
    }
    async get(key, options) {
        options?.signal?.throwIfAborted();
        const isStale = this.options?.isStale;
        const allowStored = options?.noCache ? $c26c1c02bd1549ff$var$returnFalse // Never allow stored values to be returned
         : options?.allowStale || isStale == null ? $c26c1c02bd1549ff$var$returnTrue // Always allow stored values to be returned
         : async (value)=>!await isStale(key, value);
        // As long as concurrent requests are made for the same key, only one
        // request will be made to the cache & getter function at a time. This works
        // because there is no async operation between the while() loop and the
        // pending.set() call. Because of the "single threaded" nature of
        // JavaScript, the pending item will be set before the next iteration of the
        // while loop.
        let previousExecutionFlow;
        while(previousExecutionFlow = this.pending.get(key)){
            try {
                const { isFresh: isFresh, value: value } = await previousExecutionFlow;
                if (isFresh) return value;
                if (await allowStored(value)) return value;
            } catch  {
            // Ignore errors from previous execution flows (they will have been
            // propagated by that flow).
            }
            options?.signal?.throwIfAborted();
        }
        const currentExecutionFlow = Promise.resolve().then(async ()=>{
            const storedValue = await this.getStored(key, options);
            if (storedValue !== undefined && await allowStored(storedValue)) // Use the stored value as return value for the current execution
            // flow. Notify other concurrent execution flows (that should be
            // "stuck" in the loop before until this promise resolves) that we got
            // a value, but that it came from the store (isFresh = false).
            return {
                isFresh: false,
                value: storedValue
            };
            return Promise.resolve().then(async ()=>(0, this.getter)(key, options, storedValue)).catch(async (err)=>{
                if (storedValue !== undefined) try {
                    const deleteOnError = this.options?.deleteOnError;
                    if (await deleteOnError?.(err, key, storedValue)) await this.delStored(key, err);
                } catch (error) {
                    throw new AggregateError([
                        err,
                        error
                    ], "Error while deleting stored value");
                }
                throw err;
            }).then(async (value)=>{
                // The value should be stored even is the signal was aborted.
                await this.setStored(key, value);
                return {
                    isFresh: true,
                    value: value
                };
            });
        }).finally(()=>{
            this.pending.delete(key);
        });
        if (this.pending.has(key)) // This should never happen. Indeed, there must not be any 'await'
        // statement between this and the loop iteration check meaning that
        // this.pending.get returned undefined. It is there to catch bugs that
        // would occur in future changes to the code.
        throw new Error("Concurrent request for the same key");
        this.pending.set(key, currentExecutionFlow);
        const { value: value } = await currentExecutionFlow;
        return value;
    }
    bind(key) {
        return async (options)=>this.get(key, options);
    }
    async getStored(key, options) {
        try {
            return await this.store.get(key, options);
        } catch (err) {
            return undefined;
        }
    }
    async setStored(key, value) {
        try {
            await this.store.set(key, value);
        } catch (err) {
            const onStoreError = this.options?.onStoreError;
            await onStoreError?.(err, key, value);
        }
    }
    async delStored(key, _cause) {
        await this.store.del(key);
    }
}
module.exports.CachedGetter = $c26c1c02bd1549ff$var$CachedGetter;

});

parcelRegister("4vlHV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("9x0MW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("h0Y9m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DidResolverCommon = void 0;

var $44L7D = parcelRequire("44L7D");

var $jrEAi = parcelRequire("jrEAi");

var $dAkxw = parcelRequire("dAkxw");
class $c631185004327223$var$DidResolverCommon extends $44L7D.DidResolverBase {
    constructor(options){
        super({
            plc: new $jrEAi.DidPlcMethod(options),
            web: new $dAkxw.DidWebMethod(options)
        });
    }
}
module.exports.DidResolverCommon = $c631185004327223$var$DidResolverCommon;

});
parcelRegister("44L7D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DidResolverBase = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $hoXKl = parcelRequire("hoXKl");

var $2zDt6 = parcelRequire("2zDt6");
class $2f7c16a23592308b$var$DidResolverBase {
    constructor(methods){
        Object.defineProperty(this, "methods", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.methods = new Map(Object.entries(methods));
    }
    async resolve(did, options) {
        options?.signal?.throwIfAborted();
        const method = (0, $hoXKl.extractDidMethod)(did);
        const resolver = this.methods.get(method);
        if (!resolver) throw new $hoXKl.DidError(did, `Unsupported DID method`, "did-method-invalid", 400);
        try {
            const document = await resolver.resolve(did, options);
            if (document.id !== did) throw new $hoXKl.DidError(did, `DID document id (${document.id}) does not match DID`, "did-document-id-mismatch", 400);
            return document;
        } catch (err) {
            if (err instanceof $8oTqd.FetchRequestError) throw new $hoXKl.DidError(did, err.message, "did-fetch-error", 400, err);
            if (err instanceof $2zDt6.ZodError) throw new $hoXKl.DidError(did, err.message, "did-document-format-error", 503, err);
            throw $hoXKl.DidError.from(err, did);
        }
    }
}
module.exports.DidResolverBase = $2f7c16a23592308b$var$DidResolverBase;

});
parcelRegister("8oTqd", function(module, exports) {
"use strict";
var $61db8e3f82f60462$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $61db8e3f82f60462$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $61db8e3f82f60462$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$61db8e3f82f60462$var$__exportStar((parcelRequire("bZDQr")), module.exports);

$61db8e3f82f60462$var$__exportStar((parcelRequire("7jgWp")), module.exports);

$61db8e3f82f60462$var$__exportStar((parcelRequire("eVzTV")), module.exports);

$61db8e3f82f60462$var$__exportStar((parcelRequire("gnp1v")), module.exports);

$61db8e3f82f60462$var$__exportStar((parcelRequire("5Qs1e")), module.exports);

$61db8e3f82f60462$var$__exportStar((parcelRequire("skwSd")), module.exports);

});
parcelRegister("bZDQr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchError = void 0;
class $8bb44c94f2804457$var$FetchError extends Error {
    constructor(statusCode, message, options){
        if (statusCode == null || !message) {
            const info = $8bb44c94f2804457$var$extractInfo($8bb44c94f2804457$var$extractRootCause(options?.cause));
            statusCode = statusCode ?? info[0];
            message = message || info[1];
        }
        super(message, options);
        Object.defineProperty(this, "statusCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.statusCode = statusCode;
    }
}
module.exports.FetchError = $8bb44c94f2804457$var$FetchError;
function $8bb44c94f2804457$var$extractRootCause(err) {
    // Unwrap the Network error from undici (i.e. Node's internal fetch() implementation)
    // https://github.com/nodejs/undici/blob/3274c975947ce11a08508743df026f73598bfead/lib/web/fetch/index.js#L223-L228
    if (err instanceof TypeError && err.message === "fetch failed" && err.cause !== undefined) return err.cause;
    return err;
}
function $8bb44c94f2804457$var$extractInfo(err) {
    if (typeof err === "string" && err.length > 0) return [
        500,
        err
    ];
    if (!(err instanceof Error)) return [
        500,
        "Failed to fetch"
    ];
    const code = err["code"];
    if (typeof code === "string") switch(true){
        case code === "ENOTFOUND":
            return [
                400,
                "Invalid hostname"
            ];
        case code === "ECONNREFUSED":
            return [
                502,
                "Connection refused"
            ];
        case code === "DEPTH_ZERO_SELF_SIGNED_CERT":
            return [
                502,
                "Self-signed certificate"
            ];
        case code.startsWith("ERR_TLS"):
            return [
                502,
                "TLS error"
            ];
        case code.startsWith("ECONN"):
            return [
                502,
                "Connection error"
            ];
        default:
            return [
                500,
                `${code} error`
            ];
    }
    return [
        500,
        err.message
    ];
}

});

parcelRegister("7jgWp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.forbiddenDomainNameRequestTransform = module.exports.DEFAULT_FORBIDDEN_DOMAIN_NAMES = module.exports.requireHostHeaderTranform = module.exports.protocolCheckRequestTransform = module.exports.FetchRequestError = void 0;

var $bZDQr = parcelRequire("bZDQr");

var $5Qs1e = parcelRequire("5Qs1e");

var $skwSd = parcelRequire("skwSd");
class $552772e14e4a289c$var$FetchRequestError extends $bZDQr.FetchError {
    constructor(request, statusCode, message, options){
        super(statusCode, message, options);
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: request
        });
    }
    static from(request, cause) {
        if (cause instanceof $552772e14e4a289c$var$FetchRequestError) return cause;
        return new $552772e14e4a289c$var$FetchRequestError(request, undefined, undefined, {
            cause: cause
        });
    }
}
module.exports.FetchRequestError = $552772e14e4a289c$var$FetchRequestError;
const $552772e14e4a289c$var$extractUrl = (input)=>typeof input === "string" ? new URL(input) : input instanceof URL ? input : new URL(input.url);
function $552772e14e4a289c$var$protocolCheckRequestTransform(protocols) {
    const allowedProtocols = new Set(protocols);
    return (input, init)=>{
        const { protocol: protocol } = $552772e14e4a289c$var$extractUrl(input);
        const request = (0, $5Qs1e.asRequest)(input, init);
        if (!allowedProtocols.has(protocol)) throw new $552772e14e4a289c$var$FetchRequestError(request, 400, `"${protocol}" protocol is not allowed`);
        return request;
    };
}
module.exports.protocolCheckRequestTransform = $552772e14e4a289c$var$protocolCheckRequestTransform;
function $552772e14e4a289c$var$requireHostHeaderTranform() {
    return (input, init)=>{
        // Note that fetch() will automatically add the Host header from the URL and
        // discard any Host header manually set in the request.
        const { protocol: protocol, hostname: hostname } = $552772e14e4a289c$var$extractUrl(input);
        const request = (0, $5Qs1e.asRequest)(input, init);
        // "Host" header only makes sense in the context of an HTTP request
        if (protocol !== "http:" && protocol !== "https:") throw new $552772e14e4a289c$var$FetchRequestError(request, 400, `"${protocol}" requests are not allowed`);
        if (!hostname || (0, $skwSd.isIp)(hostname)) throw new $552772e14e4a289c$var$FetchRequestError(request, 400, "Invalid hostname");
        return request;
    };
}
module.exports.requireHostHeaderTranform = $552772e14e4a289c$var$requireHostHeaderTranform;
module.exports.DEFAULT_FORBIDDEN_DOMAIN_NAMES = [
    "example.com",
    "*.example.com",
    "example.org",
    "*.example.org",
    "example.net",
    "*.example.net",
    "googleusercontent.com",
    "*.googleusercontent.com"
];
function $552772e14e4a289c$var$forbiddenDomainNameRequestTransform(denyList = module.exports.DEFAULT_FORBIDDEN_DOMAIN_NAMES) {
    const denySet = new Set(denyList);
    // Optimization: if no forbidden domain names are provided, we can skip the
    // check entirely.
    if (denySet.size === 0) return async (request)=>request;
    return async (input, init)=>{
        const { hostname: hostname } = $552772e14e4a289c$var$extractUrl(input);
        const request = (0, $5Qs1e.asRequest)(input, init);
        // Full domain name check
        if (denySet.has(hostname)) throw new $552772e14e4a289c$var$FetchRequestError(request, 403, "Forbidden hostname");
        // Sub domain name check
        let curDot = hostname.indexOf(".");
        while(curDot !== -1){
            const subdomain = hostname.slice(curDot + 1);
            if (denySet.has(`*.${subdomain}`)) throw new $552772e14e4a289c$var$FetchRequestError(request, 403, "Forbidden hostname");
            curDot = hostname.indexOf(".", curDot + 1);
        }
        return request;
    };
}
module.exports.forbiddenDomainNameRequestTransform = $552772e14e4a289c$var$forbiddenDomainNameRequestTransform;

});
parcelRegister("5Qs1e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.asRequest = module.exports.toRequestTransformer = void 0;
function $44178b09bc5a15bc$var$toRequestTransformer(requestTransformer) {
    return function(input, init) {
        return requestTransformer.call(this, $44178b09bc5a15bc$var$asRequest(input, init));
    };
}
module.exports.toRequestTransformer = $44178b09bc5a15bc$var$toRequestTransformer;
function $44178b09bc5a15bc$var$asRequest(input, init) {
    if (!init && input instanceof Request) return input;
    return new Request(input, init);
}
module.exports.asRequest = $44178b09bc5a15bc$var$asRequest;

});

parcelRegister("skwSd", function(module, exports) {
"use strict";
// @TODO: Move some of these to a shared package ?
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringifyMessage = module.exports.logCancellationError = module.exports.cancelBody = module.exports.padLines = module.exports.MaxBytesTransformStream = module.exports.ifString = module.exports.ifObject = module.exports.isIp = void 0;
function $05528a5088791459$var$isIp(hostname) {
    // IPv4
    if (hostname.match(/^\d+\.\d+\.\d+\.\d+$/)) return true;
    // IPv6
    if (hostname.startsWith("[") && hostname.endsWith("]")) return true;
    return false;
}
module.exports.isIp = $05528a5088791459$var$isIp;
const $05528a5088791459$var$plainObjectProto = Object.prototype;
const $05528a5088791459$var$ifObject = (v)=>{
    if (typeof v === "object" && v != null && !Array.isArray(v)) {
        const proto = Object.getPrototypeOf(v);
        if (proto === null || proto === $05528a5088791459$var$plainObjectProto) // eslint-disable-next-line @typescript-eslint/ban-types
        return v;
    }
    return undefined;
};
module.exports.ifObject = $05528a5088791459$var$ifObject;
const $05528a5088791459$var$ifString = (v)=>typeof v === "string" ? v : undefined;
module.exports.ifString = $05528a5088791459$var$ifString;
class $05528a5088791459$var$MaxBytesTransformStream extends TransformStream {
    constructor(maxBytes){
        // Note: negation accounts for invalid value types (NaN, non numbers)
        if (!(maxBytes >= 0)) throw new TypeError("maxBytes must be a non-negative number");
        let bytesRead = 0;
        super({
            transform: (chunk, ctrl)=>{
                if ((bytesRead += chunk.length) <= maxBytes) ctrl.enqueue(chunk);
                else ctrl.error(new Error("Response too large"));
            }
        });
    }
}
module.exports.MaxBytesTransformStream = $05528a5088791459$var$MaxBytesTransformStream;
const $05528a5088791459$var$LINE_BREAK = /\r?\n/g;
function $05528a5088791459$var$padLines(input, pad) {
    if (!input) return input;
    return pad + input.replace($05528a5088791459$var$LINE_BREAK, `$&${pad}`);
}
module.exports.padLines = $05528a5088791459$var$padLines;
/**
 * @param [onCancellationError] - Callback that will trigger to asynchronously
 * handle any error that occurs while cancelling the response body. Providing
 * this will speed up the process and avoid potential deadlocks. Defaults to
 * awaiting the cancellation operation. use `"log"` to log the error.
 * @see {@link https://undici.nodejs.org/#/?id=garbage-collection}
 * @note awaiting this function's result, when no `onCancellationError` is
 * provided, might result in a dead lock. Indeed, if the response was cloned(),
 * the response.body.cancel() method will not resolve until the other response's
 * body is consumed/cancelled.
 *
 * @example
 * ```ts
 * // Make sure response was not cloned, or that every cloned response was
 * // consumed/cancelled before awaiting this function's result.
 * await cancelBody(response)
 * ```
 * @example
 * ```ts
 * await cancelBody(response, (err) => {
 *   // No biggie, let's just log the error
 *   console.warn('Failed to cancel response body', err)
 * })
 * ```
 * @example
 * ```ts
 * // Will generate an "unhandledRejection" if an error occurs while cancelling
 * // the response body. This will likely crash the process.
 * await cancelBody(response, (err) => { throw err })
 * ```
 */ async function $05528a5088791459$var$cancelBody(body, onCancellationError) {
    if (body.body && !body.bodyUsed && !body.body.locked && // Support for alternative fetch implementations
    typeof body.body.cancel === "function") {
        if (typeof onCancellationError === "function") body.body.cancel().catch(onCancellationError);
        else if (onCancellationError === "log") body.body.cancel().catch($05528a5088791459$var$logCancellationError);
        else await body.body.cancel();
    }
}
module.exports.cancelBody = $05528a5088791459$var$cancelBody;
function $05528a5088791459$var$logCancellationError(err) {
    console.warn("Failed to cancel response body", err);
}
module.exports.logCancellationError = $05528a5088791459$var$logCancellationError;
async function $05528a5088791459$var$stringifyMessage(input) {
    try {
        const headers = $05528a5088791459$var$stringifyHeaders(input.headers);
        const payload = await $05528a5088791459$var$stringifyBody(input);
        return headers && payload ? `${headers}\n${payload}` : headers || payload;
    } finally{
        $05528a5088791459$var$cancelBody(input, "log");
    }
}
module.exports.stringifyMessage = $05528a5088791459$var$stringifyMessage;
function $05528a5088791459$var$stringifyHeaders(headers) {
    return Array.from(headers).map(([name, value])=>`${name}: ${value}`).join("\n");
}
async function $05528a5088791459$var$stringifyBody(body) {
    try {
        const blob = await body.blob();
        if (blob.type?.startsWith("text/")) {
            const text = await blob.text();
            return JSON.stringify(text);
        }
        if (/application\/(?:\w+\+)?json/.test(blob.type)) {
            const text = await blob.text();
            return text.includes("\n") ? JSON.stringify(JSON.parse(text)) : text;
        }
        return `[Body size: ${blob.size}, type: ${JSON.stringify(blob.type)} ]`;
    } catch  {
        return "[Body could not be read]";
    }
}

});


parcelRegister("eVzTV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchJsonZodProcessor = module.exports.fetchJsonProcessor = module.exports.fetchResponseJsonTranformer = module.exports.fetchResponseTypeChecker = module.exports.fetchTypeProcessor = module.exports.fetchResponseMaxSizeChecker = module.exports.fetchMaxSizeProcessor = module.exports.fetchOkTransformer = module.exports.fetchOkProcessor = module.exports.cancelBodyOnError = module.exports.extractMime = module.exports.extractLength = module.exports.checkLength = module.exports.peekJson = module.exports.FetchResponseError = void 0;

var $dmR8n = parcelRequire("dmR8n");

var $bZDQr = parcelRequire("bZDQr");

var $70tGi = parcelRequire("70tGi");

var $skwSd = parcelRequire("skwSd");
class $ade23cc36d243777$var$FetchResponseError extends $bZDQr.FetchError {
    constructor(response, statusCode = response.status, message = response.statusText, options){
        super(statusCode, message, options);
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: response
        });
    }
    static async from(response, customMessage = $ade23cc36d243777$var$extractResponseMessage, statusCode = response.status, options) {
        const message = typeof customMessage === "string" ? customMessage : typeof customMessage === "function" ? await customMessage(response) : undefined;
        return new $ade23cc36d243777$var$FetchResponseError(response, statusCode, message, options);
    }
}
module.exports.FetchResponseError = $ade23cc36d243777$var$FetchResponseError;
const $ade23cc36d243777$var$extractResponseMessage = async (response)=>{
    const mimeType = $ade23cc36d243777$var$extractMime(response);
    if (!mimeType) return undefined;
    try {
        if (mimeType === "text/plain") return await response.text();
        else if (/^application\/(?:[^+]+\+)?json$/i.test(mimeType)) {
            const json = await response.json();
            if (typeof json === "string") return json;
            const errorDescription = (0, $skwSd.ifString)((0, $skwSd.ifObject)(json)?.["error_description"]);
            if (errorDescription) return errorDescription;
            const error = (0, $skwSd.ifString)((0, $skwSd.ifObject)(json)?.["error"]);
            if (error) return error;
            const message = (0, $skwSd.ifString)((0, $skwSd.ifObject)(json)?.["message"]);
            if (message) return message;
        }
    } catch  {
    // noop
    }
    return undefined;
};
async function $ade23cc36d243777$var$peekJson(response, maxSize = Infinity) {
    const type = $ade23cc36d243777$var$extractMime(response);
    if (type !== "application/json") return undefined;
    $ade23cc36d243777$var$checkLength(response, maxSize);
    // 1) Clone the request so we can consume the body
    const clonedResponse = response.clone();
    // 2) Make sure the request's body is not too large
    const limitedResponse = response.body && maxSize < Infinity ? new $70tGi.TransformedResponse(clonedResponse, new $skwSd.MaxBytesTransformStream(maxSize)) : clonedResponse;
    // 3) Parse the JSON
    return limitedResponse.json();
}
module.exports.peekJson = $ade23cc36d243777$var$peekJson;
function $ade23cc36d243777$var$checkLength(response, maxBytes) {
    // Note: negation accounts for invalid value types (NaN, non numbers)
    if (!(maxBytes >= 0)) throw new TypeError("maxBytes must be a non-negative number");
    const length = $ade23cc36d243777$var$extractLength(response);
    if (length != null && length > maxBytes) throw new $ade23cc36d243777$var$FetchResponseError(response, 502, "Response too large");
    return length;
}
module.exports.checkLength = $ade23cc36d243777$var$checkLength;
function $ade23cc36d243777$var$extractLength(response) {
    const contentLength = response.headers.get("Content-Length");
    if (contentLength == null) return undefined;
    if (!/^\d+$/.test(contentLength)) throw new $ade23cc36d243777$var$FetchResponseError(response, 502, "Invalid Content-Length");
    const length = Number(contentLength);
    if (!Number.isSafeInteger(length)) throw new $ade23cc36d243777$var$FetchResponseError(response, 502, "Content-Length too large");
    return length;
}
module.exports.extractLength = $ade23cc36d243777$var$extractLength;
function $ade23cc36d243777$var$extractMime(response) {
    const contentType = response.headers.get("Content-Type");
    if (contentType == null) return undefined;
    return contentType.split(";", 1)[0].trim();
}
module.exports.extractMime = $ade23cc36d243777$var$extractMime;
/**
 * If the transformer results in an error, ensure that the response body is
 * consumed as, in some environments (Node 👀), the response will not
 * automatically be GC'd.
 *
 * @see {@link https://undici.nodejs.org/#/?id=garbage-collection}
 * @param [onCancellationError] - Callback to handle any async body cancelling
 * error. Defaults to logging the error. Do not use `null` if the request is
 * cloned.
 */ function $ade23cc36d243777$var$cancelBodyOnError(transformer, onCancellationError = $skwSd.logCancellationError) {
    return async (response)=>{
        try {
            return await transformer(response);
        } catch (err) {
            await (0, $skwSd.cancelBody)(response, onCancellationError ?? undefined);
            throw err;
        }
    };
}
module.exports.cancelBodyOnError = $ade23cc36d243777$var$cancelBodyOnError;
function $ade23cc36d243777$var$fetchOkProcessor(customMessage) {
    return $ade23cc36d243777$var$cancelBodyOnError((response)=>{
        return $ade23cc36d243777$var$fetchOkTransformer(response, customMessage);
    });
}
module.exports.fetchOkProcessor = $ade23cc36d243777$var$fetchOkProcessor;
async function $ade23cc36d243777$var$fetchOkTransformer(response, customMessage) {
    if (response.ok) return response;
    throw await $ade23cc36d243777$var$FetchResponseError.from(response, customMessage);
}
module.exports.fetchOkTransformer = $ade23cc36d243777$var$fetchOkTransformer;
function $ade23cc36d243777$var$fetchMaxSizeProcessor(maxBytes) {
    if (maxBytes === Infinity) return (response)=>response;
    if (!Number.isFinite(maxBytes) || maxBytes < 0) throw new TypeError("maxBytes must be a 0, Infinity or a positive number");
    return $ade23cc36d243777$var$cancelBodyOnError((response)=>{
        return $ade23cc36d243777$var$fetchResponseMaxSizeChecker(response, maxBytes);
    });
}
module.exports.fetchMaxSizeProcessor = $ade23cc36d243777$var$fetchMaxSizeProcessor;
function $ade23cc36d243777$var$fetchResponseMaxSizeChecker(response, maxBytes) {
    if (maxBytes === Infinity) return response;
    $ade23cc36d243777$var$checkLength(response, maxBytes);
    // Some engines (react-native 👀) don't expose a body property. In that case,
    // we will only rely on the Content-Length header.
    if (!response.body) return response;
    const transform = new $skwSd.MaxBytesTransformStream(maxBytes);
    return new $70tGi.TransformedResponse(response, transform);
}
module.exports.fetchResponseMaxSizeChecker = $ade23cc36d243777$var$fetchResponseMaxSizeChecker;
function $ade23cc36d243777$var$fetchTypeProcessor(expectedMime, contentTypeRequired = true) {
    const isExpected = typeof expectedMime === "string" ? (mimeType)=>mimeType === expectedMime : expectedMime instanceof RegExp ? (mimeType)=>expectedMime.test(mimeType) : expectedMime;
    return $ade23cc36d243777$var$cancelBodyOnError((response)=>{
        return $ade23cc36d243777$var$fetchResponseTypeChecker(response, isExpected, contentTypeRequired);
    });
}
module.exports.fetchTypeProcessor = $ade23cc36d243777$var$fetchTypeProcessor;
async function $ade23cc36d243777$var$fetchResponseTypeChecker(response, isExpectedMime, contentTypeRequired = true) {
    const mimeType = $ade23cc36d243777$var$extractMime(response);
    if (mimeType) {
        if (!isExpectedMime(mimeType)) throw await $ade23cc36d243777$var$FetchResponseError.from(response, `Unexpected response Content-Type (${mimeType})`, 502);
    } else if (contentTypeRequired) throw await $ade23cc36d243777$var$FetchResponseError.from(response, "Missing response Content-Type header", 502);
    return response;
}
module.exports.fetchResponseTypeChecker = $ade23cc36d243777$var$fetchResponseTypeChecker;
async function $ade23cc36d243777$var$fetchResponseJsonTranformer(response) {
    try {
        const json = await response.json();
        return {
            response: response,
            json: json
        };
    } catch (cause) {
        throw new $ade23cc36d243777$var$FetchResponseError(response, 502, "Unable to parse response as JSON", {
            cause: cause
        });
    }
}
module.exports.fetchResponseJsonTranformer = $ade23cc36d243777$var$fetchResponseJsonTranformer;
function $ade23cc36d243777$var$fetchJsonProcessor(expectedMime = /^application\/(?:[^+]+\+)?json$/, contentTypeRequired = true) {
    return (0, $dmR8n.pipe)($ade23cc36d243777$var$fetchTypeProcessor(expectedMime, contentTypeRequired), $ade23cc36d243777$var$cancelBodyOnError($ade23cc36d243777$var$fetchResponseJsonTranformer));
}
module.exports.fetchJsonProcessor = $ade23cc36d243777$var$fetchJsonProcessor;
function $ade23cc36d243777$var$fetchJsonZodProcessor(schema, params) {
    return async (jsonResponse)=>schema.parseAsync(jsonResponse.json, params);
}
module.exports.fetchJsonZodProcessor = $ade23cc36d243777$var$fetchJsonZodProcessor;

});
parcelRegister("dmR8n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipeTwo = module.exports.pipe = void 0;

var $eQ1TI = parcelRequire("eQ1TI");
Object.defineProperty(module.exports, "pipe", {
    enumerable: true,
    get: function() {
        return $eQ1TI.pipe;
    }
});
Object.defineProperty(module.exports, "pipeTwo", {
    enumerable: true,
    get: function() {
        return $eQ1TI.pipeTwo;
    }
});

});
parcelRegister("eQ1TI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipeTwo = module.exports.pipe = void 0;
function $acd764de3baec96c$var$pipe(...pipeline) {
    return pipeline.reduce($acd764de3baec96c$var$pipeTwo);
}
module.exports.pipe = $acd764de3baec96c$var$pipe;
function $acd764de3baec96c$var$pipeTwo(first, second) {
    return async (input)=>second(await first(input));
}
module.exports.pipeTwo = $acd764de3baec96c$var$pipeTwo;

});


parcelRegister("70tGi", function(module, exports) {
"use strict";
var $519f8e89d169ba72$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $519f8e89d169ba72$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $519f8e89d169ba72$var$_TransformedResponse_response;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransformedResponse = void 0;
class $519f8e89d169ba72$var$TransformedResponse extends Response {
    constructor(response, transform){
        if (!response.body) throw new TypeError("Response body is not available");
        if (response.bodyUsed) throw new TypeError("Response body is already used");
        super(response.body.pipeThrough(transform), {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
        $519f8e89d169ba72$var$_TransformedResponse_response.set(this, void 0);
        $519f8e89d169ba72$var$__classPrivateFieldSet(this, $519f8e89d169ba72$var$_TransformedResponse_response, response, "f");
    }
    /**
     * Some props can't be set through ResponseInit, so we need to proxy them
     */ get url() {
        return $519f8e89d169ba72$var$__classPrivateFieldGet(this, $519f8e89d169ba72$var$_TransformedResponse_response, "f").url;
    }
    get redirected() {
        return $519f8e89d169ba72$var$__classPrivateFieldGet(this, $519f8e89d169ba72$var$_TransformedResponse_response, "f").redirected;
    }
    get type() {
        return $519f8e89d169ba72$var$__classPrivateFieldGet(this, $519f8e89d169ba72$var$_TransformedResponse_response, "f").type;
    }
    get statusText() {
        return $519f8e89d169ba72$var$__classPrivateFieldGet(this, $519f8e89d169ba72$var$_TransformedResponse_response, "f").statusText;
    }
}
module.exports.TransformedResponse = $519f8e89d169ba72$var$TransformedResponse;
$519f8e89d169ba72$var$_TransformedResponse_response = new WeakMap();

});


parcelRegister("gnp1v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindFetch = module.exports.timedFetch = module.exports.loggedFetch = void 0;

var $7jgWp = parcelRequire("7jgWp");

var $5Qs1e = parcelRequire("5Qs1e");

var $70tGi = parcelRequire("70tGi");

var $skwSd = parcelRequire("skwSd");
function $bec234688d1d501f$var$loggedFetch(fetch = globalThis.fetch) {
    return (0, $5Qs1e.toRequestTransformer)(async function(request) {
        const requestMessage = await (0, $skwSd.stringifyMessage)(request);
        console.info(`> ${request.method} ${request.url}\n${(0, $skwSd.padLines)(requestMessage, "  ")}`);
        try {
            const response = await fetch.call(this, request);
            const responseMessage = await (0, $skwSd.stringifyMessage)(response.clone());
            console.info(`< HTTP/1.1 ${response.status} ${response.statusText}\n${(0, $skwSd.padLines)(responseMessage, "  ")}`);
            return response;
        } catch (error) {
            console.error(`< Error:`, error);
            throw error;
        }
    });
}
module.exports.loggedFetch = $bec234688d1d501f$var$loggedFetch;
const $bec234688d1d501f$var$timedFetch = (timeout = 60e3, fetch = globalThis.fetch)=>{
    if (timeout === Infinity) return fetch;
    if (!Number.isFinite(timeout) || timeout <= 0) throw new TypeError("Timeout must be positive");
    return (0, $5Qs1e.toRequestTransformer)(async function(request) {
        const controller = new AbortController();
        const signal = controller.signal;
        const abort = ()=>{
            controller.abort();
        };
        const cleanup = ()=>{
            clearTimeout(timer);
            request.signal?.removeEventListener("abort", abort);
        };
        const timer = setTimeout(abort, timeout);
        if (typeof timer === "object") timer.unref?.(); // only on node
        request.signal?.addEventListener("abort", abort);
        signal.addEventListener("abort", cleanup);
        const response = await fetch.call(this, request, {
            signal: signal
        });
        if (!response.body) {
            cleanup();
            return response;
        } else {
            // Cleanup the timer & event listeners when the body stream is closed
            const transform = new TransformStream({
                flush: cleanup
            });
            return new $70tGi.TransformedResponse(response, transform);
        }
    });
};
module.exports.timedFetch = $bec234688d1d501f$var$timedFetch;
/**
 * Wraps a fetch function to bind it to a specific context, and wrap any thrown
 * errors into a FetchRequestError.
 *
 * @example
 *
 * ```ts
 * class MyClient {
 *   constructor(private fetch = globalThis.fetch) {}
 *
 *   async get(url: string) {
 *     // This will generate an error, because the context used is not a
 *     // FetchContext (it's a MyClient instance).
 *     return this.fetch(url)
 *   }
 * }
 * ```
 *
 * @example
 *
 * ```ts
 * class MyClient {
 *   private fetch: Fetch<unknown>
 *
 *   constructor(fetch = globalThis.fetch) {
 *     this.fetch = bindFetch(fetch)
 *   }
 *
 *   async get(url: string) {
 *     return this.fetch(url) // no more error
 *   }
 * }
 * ```
 */ function $bec234688d1d501f$var$bindFetch(fetch = globalThis.fetch, context = globalThis) {
    return (0, $5Qs1e.toRequestTransformer)(async (request)=>{
        try {
            return await fetch.call(context, request);
        } catch (err) {
            throw $7jgWp.FetchRequestError.from(request, err);
        }
    });
}
module.exports.bindFetch = $bec234688d1d501f$var$bindFetch;

});



parcelRegister("jrEAi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DidPlcMethod = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $dmR8n = parcelRequire("dmR8n");

var $hoXKl = parcelRequire("hoXKl");
const $e280052c183723fd$var$fetchSuccessHandler = (0, $dmR8n.pipe)((0, $8oTqd.fetchOkProcessor)(), (0, $8oTqd.fetchJsonProcessor)(/^application\/(did\+ld\+)?json$/), (0, $8oTqd.fetchJsonZodProcessor)($hoXKl.didDocumentValidator));
class $e280052c183723fd$var$DidPlcMethod {
    constructor(options){
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "plcDirectoryUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.plcDirectoryUrl = new URL(options?.plcDirectoryUrl || "https://plc.directory/");
        this.fetch = (0, $8oTqd.bindFetch)(options?.fetch);
    }
    async resolve(did, options) {
        // Although the did should start with `did:plc:` (thanks to typings), we
        // should still check if the msid is valid.
        (0, $hoXKl.checkDidPlc)(did);
        const url = new URL(`/${did}`, this.plcDirectoryUrl);
        return this.fetch(url, {
            redirect: "error",
            headers: {
                accept: "application/did+ld+json,application/json"
            },
            signal: options?.signal
        }).then($e280052c183723fd$var$fetchSuccessHandler);
    }
}
module.exports.DidPlcMethod = $e280052c183723fd$var$DidPlcMethod;

});

parcelRegister("dAkxw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildDidWebDocumentUrl = module.exports.DidWebMethod = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $dmR8n = parcelRequire("dmR8n");

var $hoXKl = parcelRequire("hoXKl");
const $9e3e91e53a82a00f$var$fetchSuccessHandler = (0, $dmR8n.pipe)((0, $8oTqd.fetchOkProcessor)(), (0, $8oTqd.fetchJsonProcessor)(/^application\/(did\+ld\+)?json$/), (0, $8oTqd.fetchJsonZodProcessor)($hoXKl.didDocumentValidator));
class $9e3e91e53a82a00f$var$DidWebMethod {
    constructor({ fetch: fetch = globalThis.fetch } = {}){
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.fetch = (0, $8oTqd.bindFetch)(fetch);
    }
    async resolve(did, options) {
        const didDocumentUrl = $9e3e91e53a82a00f$var$buildDidWebDocumentUrl(did);
        return this.fetch(didDocumentUrl, {
            redirect: "error",
            headers: {
                accept: "application/did+ld+json,application/json"
            },
            signal: options?.signal
        }).then($9e3e91e53a82a00f$var$fetchSuccessHandler);
    }
}
module.exports.DidWebMethod = $9e3e91e53a82a00f$var$DidWebMethod;
/**
 * @see {@link https://datatracker.ietf.org/doc/html/rfc8615}
 * @see {@link https://w3c-ccg.github.io/did-method-web/#create-register}
 */ function $9e3e91e53a82a00f$var$buildDidWebDocumentUrl(did) {
    const url = (0, $hoXKl.didWebToUrl)(did); // Will throw if the DID is invalid
    // Note: DID cannot end with an `:`, so they cannot end with a `/`. This is
    // true unless when there is no path at all, in which case the URL constructor
    // will set the pathname to `/`.
    // https://w3c-ccg.github.io/did-method-web/#read-resolve
    if (url.pathname === "/") return new URL(`/.well-known/did.json`, url);
    else return new URL(`${url.pathname}/did.json`, url);
}
module.exports.buildDidWebDocumentUrl = $9e3e91e53a82a00f$var$buildDidWebDocumentUrl;

});


parcelRegister("fNvbt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kLeG9", function(module, exports) {
"use strict";
var $f1d3955421a30bd7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f1d3955421a30bd7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f1d3955421a30bd7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f1d3955421a30bd7$var$__exportStar((parcelRequire("jrEAi")), module.exports);

$f1d3955421a30bd7$var$__exportStar((parcelRequire("dAkxw")), module.exports);

});

parcelRegister("iPo4S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("fYfau", function(module, exports) {
"use strict";
var $ba0839b071ae6a44$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ba0839b071ae6a44$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ba0839b071ae6a44$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ba0839b071ae6a44$var$__exportStar((parcelRequire("hIqij")), module.exports);

// Main Handle Resolvers strategies
$ba0839b071ae6a44$var$__exportStar((parcelRequire("g4U3T")), module.exports);

$ba0839b071ae6a44$var$__exportStar((parcelRequire("kZxhz")), module.exports);

$ba0839b071ae6a44$var$__exportStar((parcelRequire("4bQfa")), module.exports);

// Handle Resolver Caching utility
$ba0839b071ae6a44$var$__exportStar((parcelRequire("6hYWA")), module.exports);

});
parcelRegister("hIqij", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isResolvedHandle = void 0;

var $hoXKl = parcelRequire("hoXKl");
/**
 * @see {@link https://atproto.com/specs/did#blessed-did-methods}
 */ function $03540c2640144fd2$var$isResolvedHandle(value) {
    return value === null || (0, $hoXKl.isAtprotoDid)(value);
}
module.exports.isResolvedHandle = $03540c2640144fd2$var$isResolvedHandle;

});

parcelRegister("g4U3T", function(module, exports) {
"use strict";
var $bb4881c1563dc6f9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppViewHandleResolver = module.exports.xrpcErrorSchema = void 0;

const $bb4881c1563dc6f9$var$zod_1 = $bb4881c1563dc6f9$var$__importDefault((parcelRequire("2zDt6")));

var $hIqij = parcelRequire("hIqij");
module.exports.xrpcErrorSchema = $bb4881c1563dc6f9$var$zod_1.default.object({
    error: $bb4881c1563dc6f9$var$zod_1.default.string(),
    message: $bb4881c1563dc6f9$var$zod_1.default.string().optional()
});
class $bb4881c1563dc6f9$var$AppViewHandleResolver {
    static from(service, options) {
        if (typeof service === "string" || service instanceof URL) return new $bb4881c1563dc6f9$var$AppViewHandleResolver(service, options);
        return service;
    }
    constructor(service, options){
        /**
         * URL of the atproto lexicon server. This is the base URL where the
         * `com.atproto.identity.resolveHandle` XRPC method is located.
         */ Object.defineProperty(this, "serviceUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serviceUrl = new URL(service);
        this.fetch = options?.fetch ?? globalThis.fetch;
    }
    async resolve(handle, options) {
        const url = new URL("/xrpc/com.atproto.identity.resolveHandle", this.serviceUrl);
        url.searchParams.set("handle", handle);
        const headers = new Headers();
        if (options?.noCache) headers.set("cache-control", "no-cache");
        const response = await this.fetch.call(null, url, {
            headers: headers,
            signal: options?.signal,
            redirect: "error"
        });
        const payload = await response.json();
        // The response should either be
        // - 400 Bad Request with { error: 'InvalidRequest', message: 'Unable to resolve handle' }
        // - 200 OK with { did: NonNullable<ResolvedHandle> }
        // Any other response is considered unexpected behavior an should throw an error.
        if (response.status === 400) {
            const data = module.exports.xrpcErrorSchema.parse(payload);
            if (data.error === "InvalidRequest" && data.message === "Unable to resolve handle") return null;
        }
        if (!response.ok) throw new TypeError("Invalid response from resolveHandle method");
        const value = payload?.did;
        if (!(0, $hIqij.isResolvedHandle)(value)) throw new TypeError("Invalid DID returned from resolveHandle method");
        return value;
    }
}
module.exports.AppViewHandleResolver = $bb4881c1563dc6f9$var$AppViewHandleResolver;

});

parcelRegister("kZxhz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtprotoDohHandleResolver = void 0;

var $4bQfa = parcelRequire("4bQfa");
class $f483525dff0d1f66$var$AtprotoDohHandleResolver extends $4bQfa.AtprotoHandleResolver {
    constructor(options){
        super({
            ...options,
            resolveTxt: $f483525dff0d1f66$var$dohResolveTxtFactory(options),
            resolveTxtFallback: undefined
        });
    }
}
module.exports.AtprotoDohHandleResolver = $f483525dff0d1f66$var$AtprotoDohHandleResolver;
/**
 * Resolver for DNS-over-HTTPS (DoH) handles. Only works with servers supporting
 * Google Flavoured "application/dns-json" queries.
 *
 * @see {@link https://developers.google.com/speed/public-dns/docs/doh/json}
 * @see {@link https://developers.cloudflare.com/1.1.1.1/encryption/dns-over-https/make-api-requests/dns-json/}
 * @todo Add support for DoH using application/dns-message (?)
 */ function $f483525dff0d1f66$var$dohResolveTxtFactory({ dohEndpoint: dohEndpoint, fetch: fetch = globalThis.fetch }) {
    return async (hostname)=>{
        const url = new URL(dohEndpoint);
        url.searchParams.set("type", "TXT");
        url.searchParams.set("name", hostname);
        const response = await fetch(url, {
            method: "GET",
            headers: {
                accept: "application/dns-json"
            },
            redirect: "follow"
        });
        try {
            const contentType = response.headers.get("content-type")?.trim();
            if (!response.ok) {
                const message = contentType?.startsWith("text/plain") ? await response.text() : `Failed to resolve ${hostname}`;
                throw new TypeError(message);
            } else if (contentType !== "application/dns-json") throw new TypeError("Unexpected response from DoH server");
            const result = $f483525dff0d1f66$var$asResult(await response.json());
            return result.Answer?.filter($f483525dff0d1f66$var$isAnswerTxt).map($f483525dff0d1f66$var$extractTxtData) ?? null;
        } finally{
            // Make sure to always cancel the response body as some engines (Node 👀)
            // do not do this automatically.
            // https://undici.nodejs.org/#/?id=garbage-collection
            if (response.bodyUsed === false) // Handle rejection asynchronously
            response.body?.cancel().catch($f483525dff0d1f66$var$onCancelError);
        }
    };
}
function $f483525dff0d1f66$var$onCancelError(err) {
    if (!(err instanceof DOMException) || err.name !== "AbortError") console.error("An error occurred while cancelling the response body:", err);
}
function $f483525dff0d1f66$var$isResult(result) {
    if (typeof result !== "object" || result === null) return false;
    if (!("Status" in result) || typeof result.Status !== "number") return false;
    if ("Answer" in result && !$f483525dff0d1f66$var$isArrayOf(result.Answer, $f483525dff0d1f66$var$isAnswer)) return false;
    return true;
}
function $f483525dff0d1f66$var$asResult(result) {
    if ($f483525dff0d1f66$var$isResult(result)) return result;
    throw new TypeError("Invalid DoH response");
}
function $f483525dff0d1f66$var$isArrayOf(value, predicate) {
    return Array.isArray(value) && value.every(predicate);
}
function $f483525dff0d1f66$var$isAnswer(answer) {
    return typeof answer === "object" && answer !== null && "name" in answer && typeof answer.name === "string" && "type" in answer && typeof answer.type === "number" && "data" in answer && typeof answer.data === "string" && "TTL" in answer && typeof answer.TTL === "number";
}
function $f483525dff0d1f66$var$isAnswerTxt(answer) {
    return answer.type === 16;
}
function $f483525dff0d1f66$var$extractTxtData(answer) {
    return answer.data.replace(/^"|"$/g, "").replace(/\\"/g, '"');
}

});
parcelRegister("4bQfa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtprotoHandleResolver = void 0;

var $bBMsq = parcelRequire("bBMsq");

var $aIOLP = parcelRequire("aIOLP");
const $30d0b6fed86c608b$var$noop = ()=>{};
/**
 * Implementation of the official ATPROTO handle resolution strategy.
 * This implementation relies on two primitives:
 * - HTTP Well-Known URI resolution (requires a `fetch()` implementation)
 * - DNS TXT record resolution (requires a `resolveTxt()` function)
 */ class $30d0b6fed86c608b$var$AtprotoHandleResolver {
    constructor(options){
        Object.defineProperty(this, "httpResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dnsResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dnsResolverFallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.httpResolver = new $aIOLP.WellKnownHandleResolver(options);
        this.dnsResolver = new $bBMsq.DnsHandleResolver(options.resolveTxt);
        this.dnsResolverFallback = options.resolveTxtFallback ? new $bBMsq.DnsHandleResolver(options.resolveTxtFallback) : undefined;
    }
    async resolve(handle, options) {
        options?.signal?.throwIfAborted();
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        options?.signal?.addEventListener("abort", ()=>abortController.abort(), {
            signal: signal
        });
        const wrappedOptions = {
            ...options,
            signal: signal
        };
        try {
            const dnsPromise = this.dnsResolver.resolve(handle, wrappedOptions);
            const httpPromise = this.httpResolver.resolve(handle, wrappedOptions);
            // Prevent uncaught promise rejection
            httpPromise.catch($30d0b6fed86c608b$var$noop);
            const dnsRes = await dnsPromise;
            if (dnsRes) return dnsRes;
            signal.throwIfAborted();
            const res = await httpPromise;
            if (res) return res;
            signal.throwIfAborted();
            return this.dnsResolverFallback?.resolve(handle, wrappedOptions) ?? null;
        } finally{
            // Cancel pending requests, and remove "abort" listener on incoming signal
            abortController.abort();
        }
    }
}
module.exports.AtprotoHandleResolver = $30d0b6fed86c608b$var$AtprotoHandleResolver;

});
parcelRegister("bBMsq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DnsHandleResolver = void 0;

var $hIqij = parcelRequire("hIqij");
const $8738bd0ae628d690$var$SUBDOMAIN = "_atproto";
const $8738bd0ae628d690$var$PREFIX = "did=";
class $8738bd0ae628d690$var$DnsHandleResolver {
    constructor(resolveTxt){
        Object.defineProperty(this, "resolveTxt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: resolveTxt
        });
    }
    async resolve(handle) {
        const results = await this.resolveTxt.call(null, `${$8738bd0ae628d690$var$SUBDOMAIN}.${handle}`);
        if (!results) return null;
        for(let i = 0; i < results.length; i++){
            // If the line does not start with "did=", skip it
            if (!results[i].startsWith($8738bd0ae628d690$var$PREFIX)) continue;
            // Ensure no other entry starting with "did=" follows
            for(let j = i + 1; j < results.length; j++){
                if (results[j].startsWith($8738bd0ae628d690$var$PREFIX)) return null;
            }
            // Note: No trimming (to be consistent with spec)
            const did = results[i].slice($8738bd0ae628d690$var$PREFIX.length);
            // Invalid DBS record
            return (0, $hIqij.isResolvedHandle)(did) ? did : null;
        }
        return null;
    }
}
module.exports.DnsHandleResolver = $8738bd0ae628d690$var$DnsHandleResolver;

});

parcelRegister("aIOLP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WellKnownHandleResolver = void 0;

var $hIqij = parcelRequire("hIqij");
class $7ce565633a992eb6$var$WellKnownHandleResolver {
    constructor(options){
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.fetch = options?.fetch ?? globalThis.fetch;
    }
    async resolve(handle, options) {
        const url = new URL("/.well-known/atproto-did", `https://${handle}`);
        const headers = new Headers();
        if (options?.noCache) headers.set("cache-control", "no-cache");
        try {
            const response = await this.fetch.call(null, url, {
                headers: headers,
                signal: options?.signal,
                redirect: "error"
            });
            const text = await response.text();
            const firstLine = text.split("\n")[0].trim();
            if ((0, $hIqij.isResolvedHandle)(firstLine)) return firstLine;
            return null;
        } catch (err) {
            // The the request failed, assume the handle does not resolve to a DID,
            // unless the failure was due to the signal being aborted.
            options?.signal?.throwIfAborted();
            return null;
        }
    }
}
module.exports.WellKnownHandleResolver = $7ce565633a992eb6$var$WellKnownHandleResolver;

});



parcelRegister("6hYWA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CachedHandleResolver = void 0;

var $559MJ = parcelRequire("559MJ");

var $9eBhV = parcelRequire("9eBhV");
class $49439ad30d73ba85$var$CachedHandleResolver {
    constructor(/**
     * The resolver that will be used to resolve handles.
     */ resolver, cache = new $9eBhV.SimpleStoreMemory({
        max: 1000,
        ttl: 600000
    })){
        Object.defineProperty(this, "getter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.getter = new $559MJ.CachedGetter((handle, options)=>resolver.resolve(handle, options), cache);
    }
    async resolve(handle, options) {
        return this.getter.get(handle, options);
    }
}
module.exports.CachedHandleResolver = $49439ad30d73ba85$var$CachedHandleResolver;

});


parcelRegister("auA9I", function(module, exports) {
"use strict";
var $7a38c0810ae37db1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7a38c0810ae37db1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7a38c0810ae37db1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7a38c0810ae37db1$var$__exportStar((parcelRequire("9Vu2E")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("3bKHb")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("oZl9m")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("iRQEE")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("k1LCj")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("iWdLz")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("kQZHT")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("cICSH")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("8bc9R")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("iUYkl")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("kcXek")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("3e2zX")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("kBqrl")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("4Z3I5")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("invkT")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("cDexx")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("i3oKx")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("jlwgK")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("3ibUR")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("7eEuQ")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("1Da3V")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("ln2nq")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("e9eSC")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("1MJGm")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("LmBbd")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("9Ql4e")), module.exports);

});
parcelRegister("9Vu2E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CLIENT_ASSERTION_TYPE_JWT_BEARER = module.exports.ALLOW_UNSECURE_ORIGINS = void 0;
/**
 * A variable that allows to determine if unsecure origins should be allowed
 * in OAuth related URI's. This variable is only set to `true` when NODE_ENV
 * is either `development` or `test`.
 */ module.exports.ALLOW_UNSECURE_ORIGINS = (()=>{
    // try/catch to support running in a browser, including when process.env is
    // shimmed (e.g. by webpack)
    try {
        const env = "production";
        return env === "development" || env === "test";
    } catch  {
        return false;
    }
})();
module.exports.CLIENT_ASSERTION_TYPE_JWT_BEARER = "urn:ietf:params:oauth:client-assertion-type:jwt-bearer";

});

parcelRegister("3bKHb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.safeUrl = module.exports.isLoopbackUrl = module.exports.isLoopbackHost = module.exports.isIP = void 0;
function $25269ee9f76f0609$var$isIP(hostname) {
    // IPv4
    if (hostname.match(/^\d+\.\d+\.\d+\.\d+$/)) return true;
    // IPv6
    if (hostname.startsWith("[") && hostname.endsWith("]")) return true;
    return false;
}
module.exports.isIP = $25269ee9f76f0609$var$isIP;
function $25269ee9f76f0609$var$isLoopbackHost(host) {
    return host === "localhost" || host === "127.0.0.1" || host === "[::1]";
}
module.exports.isLoopbackHost = $25269ee9f76f0609$var$isLoopbackHost;
function $25269ee9f76f0609$var$isLoopbackUrl(input) {
    const url = typeof input === "string" ? new URL(input) : input;
    return $25269ee9f76f0609$var$isLoopbackHost(url.hostname);
}
module.exports.isLoopbackUrl = $25269ee9f76f0609$var$isLoopbackUrl;
function $25269ee9f76f0609$var$safeUrl(input) {
    try {
        return new URL(input);
    } catch  {
        return null;
    }
}
module.exports.safeUrl = $25269ee9f76f0609$var$safeUrl;

});

parcelRegister("oZl9m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.accessTokenSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.accessTokenSchema = $2zDt6.z.string().min(1);

});

parcelRegister("iRQEE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.atprotoLoopbackClientMetadata = void 0;

var $iWdLz = parcelRequire("iWdLz");

var $8UbG1 = parcelRequire("8UbG1");
function $dbc6055dc564f417$var$atprotoLoopbackClientMetadata(clientId) {
    if (!(0, $iWdLz.isOAuthClientIdLoopback)(clientId)) throw new TypeError(`Invalid loopback client ID ${clientId}`);
    const { origin: origin, pathname: pathname, searchParams: searchParams } = (0, $8UbG1.parseOAuthClientIdUrl)(clientId);
    for (const name of searchParams.keys()){
        if (name !== "redirect_uri") throw new TypeError(`Invalid query parameter ${name} in client ID`);
    }
    const redirectUris = searchParams.getAll("redirect_uri");
    return {
        client_id: clientId,
        client_name: "Loopback client",
        response_types: [
            "code"
        ],
        grant_types: [
            "authorization_code",
            "refresh_token"
        ],
        redirect_uris: redirectUris.length ? redirectUris : [
            "127.0.0.1",
            "[::1]"
        ].map((ip)=>Object.assign(new URL(pathname, origin), {
                hostname: ip
            }).href),
        token_endpoint_auth_method: "none",
        application_type: "native",
        dpop_bound_access_tokens: true
    };
}
module.exports.atprotoLoopbackClientMetadata = $dbc6055dc564f417$var$atprotoLoopbackClientMetadata;

});
parcelRegister("iWdLz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseOAuthLoopbackClientId = module.exports.isOAuthClientIdLoopback = void 0;

var $8UbG1 = parcelRequire("8UbG1");
function $dc9852751fa33862$var$isOAuthClientIdLoopback(clientId) {
    try {
        $dc9852751fa33862$var$parseOAuthLoopbackClientId(clientId);
        return true;
    } catch  {
        return false;
    }
}
module.exports.isOAuthClientIdLoopback = $dc9852751fa33862$var$isOAuthClientIdLoopback;
function $dc9852751fa33862$var$parseOAuthLoopbackClientId(clientId) {
    const url = (0, $8UbG1.parseOAuthClientIdUrl)(clientId);
    // Optimization: cheap checks first
    if (url.protocol !== "http:") throw new TypeError('Loopback ClientID must use the "http:" protocol');
    if (url.hostname !== "localhost") throw new TypeError('Loopback ClientID must use the "localhost" hostname');
    if (url.hash) throw new TypeError("Loopback ClientID must not contain a fragment");
    if (url.username || url.password) throw new TypeError("Loopback ClientID must not contain credentials");
    if (url.port) throw new TypeError("Loopback ClientID must not contain a port");
    // Note: url.pathname === '/' is allowed for loopback URIs
    if (url.pathname !== "/" && url.pathname.endsWith("/")) throw new TypeError("Loopback ClientID must not end with a trailing slash");
    if (url.pathname.includes("//")) throw new TypeError(`Loopback ClientID must not contain any double slashes in its path`);
    // Note: Query string is allowed
    return url;
}
module.exports.parseOAuthLoopbackClientId = $dc9852751fa33862$var$parseOAuthLoopbackClientId;

});
parcelRegister("8UbG1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseOAuthClientIdUrl = void 0;
function $67bc9c70d88fe633$var$parseOAuthClientIdUrl(clientId) {
    if (clientId.endsWith("/")) throw new TypeError("ClientID must not end with a trailing slash");
    const url = new URL(clientId);
    if (url.protocol !== "https:" && url.protocol !== "http:") throw new TypeError('ClientID must use the "https:" or "http:" protocol');
    url.searchParams.sort();
    // URL constructor normalizes the URL, so we need to compare the canonical form
    const canonicalUri = url.pathname === "/" ? url.origin + url.search : url.href;
    if (canonicalUri !== clientId) throw new TypeError(`ClientID must be in canonical form ("${canonicalUri}", got "${clientId}")`);
    return url;
}
module.exports.parseOAuthClientIdUrl = $67bc9c70d88fe633$var$parseOAuthClientIdUrl;

});



parcelRegister("k1LCj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseOAuthDiscoverableClientId = module.exports.isOAuthClientIdDiscoverable = void 0;

var $8UbG1 = parcelRequire("8UbG1");

var $3bKHb = parcelRequire("3bKHb");
function $e948d659bf33c2b7$var$isOAuthClientIdDiscoverable(clientId) {
    try {
        $e948d659bf33c2b7$var$parseOAuthDiscoverableClientId(clientId);
        return true;
    } catch  {
        return false;
    }
}
module.exports.isOAuthClientIdDiscoverable = $e948d659bf33c2b7$var$isOAuthClientIdDiscoverable;
function $e948d659bf33c2b7$var$parseOAuthDiscoverableClientId(clientId) {
    const url = (0, $8UbG1.parseOAuthClientIdUrl)(clientId);
    // Optimization: cheap checks first
    if (url.hostname === "localhost") throw new TypeError("ClientID must not be a loopback hostname");
    if (url.protocol !== "https:") throw new TypeError('ClientID must use the "https:" protocol');
    if (url.hash) throw new TypeError("ClientID must not contain a fragment");
    if (url.username || url.password) throw new TypeError("ClientID must not contain credentials");
    if (url.pathname === "/") throw new TypeError('ClientID must contain a path (e.g. "/client-metadata")');
    if (url.pathname !== "/" && url.pathname.endsWith("/")) throw new TypeError("ClientID must not end with a trailing slash");
    if (url.pathname.includes("//")) throw new TypeError(`ClientID must not contain any double slashes in its path`);
    // Note: Query string is allowed
    // Note: no restriction on the port for non-loopback URIs
    if ((0, $3bKHb.isIP)(url.hostname)) throw new TypeError("ClientID must not be an IP address");
    return url;
}
module.exports.parseOAuthDiscoverableClientId = $e948d659bf33c2b7$var$parseOAuthDiscoverableClientId;

});

parcelRegister("kQZHT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthAuthenticationRequestParametersSchema = void 0;

var $4EOoK = parcelRequire("4EOoK");

var $2zDt6 = parcelRequire("2zDt6");

var $cICSH = parcelRequire("cICSH");

var $kcXek = parcelRequire("kcXek");

var $1Da3V = parcelRequire("1Da3V");

var $1MJGm = parcelRequire("1MJGm");

var $LmBbd = parcelRequire("LmBbd");

var $9Ql4e = parcelRequire("9Ql4e");
/**
 * @see {@link https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest | OIDC}
 */ module.exports.oauthAuthenticationRequestParametersSchema = $2zDt6.z.object({
    client_id: $kcXek.oauthClientIdSchema,
    state: $2zDt6.z.string().optional(),
    nonce: $2zDt6.z.string().optional(),
    dpop_jkt: $2zDt6.z.string().optional(),
    response_type: $1Da3V.oauthResponseTypeSchema,
    // Default depend on response_type
    response_mode: $2zDt6.z.enum([
        "query",
        "fragment",
        "form_post"
    ]).optional(),
    // PKCE
    code_challenge: $2zDt6.z.string().optional(),
    code_challenge_method: $2zDt6.z.enum([
        "S256",
        "plain"
    ]).default("S256").optional(),
    redirect_uri: $2zDt6.z.string().url().optional(),
    // https://datatracker.ietf.org/doc/html/draft-ietf-oauth-v2-1-11#section-1.4.1
    // scope       = scope-token *( SP scope-token )
    // scope-token = 1*( %x21 / %x23-5B / %x5D-7E )
    // = Basically most ASCII characters except backslash and double quote
    scope: $2zDt6.z.string().regex(/^[!\x23-\x5B\x5D-\x7E]+( [!\x23-\x5B\x5D-\x7E]+)*$/).optional(),
    // OIDC
    // Specifies the allowable elapsed time in seconds since the last time the
    // End-User was actively authenticated by the OP. If the elapsed time is
    // greater than this value, the OP MUST attempt to actively re-authenticate
    // the End-User. (The max_age request parameter corresponds to the OpenID 2.0
    // PAPE [OpenID.PAPE] max_auth_age request parameter.) When max_age is used,
    // the ID Token returned MUST include an auth_time Claim Value. Note that
    // max_age=0 is equivalent to prompt=login.
    max_age: $2zDt6.z.number().int().min(0).optional(),
    claims: $2zDt6.z.record($9Ql4e.oidcEntityTypeSchema, $2zDt6.z.record($1MJGm.oidcClaimsParameterSchema, $2zDt6.z.union([
        $2zDt6.z.literal(null),
        $LmBbd.oidcClaimsPropertiesSchema
    ]))).optional(),
    // https://openid.net/specs/openid-connect-core-1_0.html#RegistrationParameter
    // Not supported by this library (yet?)
    // registration: clientMetadataSchema.optional(),
    login_hint: $2zDt6.z.string().min(1).optional(),
    ui_locales: $2zDt6.z.string().regex(/^[a-z]{2}(-[A-Z]{2})?( [a-z]{2}(-[A-Z]{2})?)*$/) // fr-CA fr en
    .optional(),
    // Previous ID Token, should be provided when prompt=none is used
    id_token_hint: $4EOoK.signedJwtSchema.optional(),
    // Type of UI the AS is displayed on
    display: $2zDt6.z.enum([
        "page",
        "popup",
        "touch"
    ]).optional(),
    /**
     * - "none" will only be allowed if the user already allowed the client on the same device
     * - "login" will force the user to login again, unless he very recently logged in
     * - "consent" will force the user to consent again
     * - "select_account" will force the user to select an account
     */ prompt: $2zDt6.z.enum([
        "none",
        "login",
        "consent",
        "select_account"
    ]).optional(),
    // https://datatracker.ietf.org/doc/html/rfc9396
    authorization_details: $cICSH.oauthAuthorizationDetailsSchema.optional()
});

});
parcelRegister("cICSH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthAuthorizationDetailsSchema = module.exports.oauthAuthorizationDetailSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
/**
 * @see {@link https://datatracker.ietf.org/doc/html/rfc9396#section-2 | RFC 9396, Section 2}
 */ module.exports.oauthAuthorizationDetailSchema = $2zDt6.z.object({
    type: $2zDt6.z.string(),
    locations: $2zDt6.z.array($2zDt6.z.string().url()).optional(),
    actions: $2zDt6.z.array($2zDt6.z.string()).optional(),
    datatypes: $2zDt6.z.array($2zDt6.z.string()).optional(),
    identifier: $2zDt6.z.string().optional(),
    privileges: $2zDt6.z.array($2zDt6.z.string()).optional()
});
/**
 * @see {@link https://datatracker.ietf.org/doc/html/rfc9396#section-2 | RFC 9396, Section 2}
 */ module.exports.oauthAuthorizationDetailsSchema = $2zDt6.z.array(module.exports.oauthAuthorizationDetailSchema);

});

parcelRegister("kcXek", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthClientIdSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthClientIdSchema = $2zDt6.z.string().min(1);

});

parcelRegister("1Da3V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthResponseTypeSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthResponseTypeSchema = $2zDt6.z.enum([
    // OAuth2 (https://datatracker.ietf.org/doc/html/draft-ietf-oauth-v2-1-10#section-4.1.1)
    "code",
    "token",
    // OIDC (https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html)
    "none",
    "code id_token token",
    "code id_token",
    "code token",
    "id_token token",
    "id_token"
]);

});

parcelRegister("1MJGm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oidcClaimsParameterSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oidcClaimsParameterSchema = $2zDt6.z.enum([
    // https://openid.net/specs/openid-provider-authentication-policy-extension-1_0.html#rfc.section.5.2
    // if client metadata "require_auth_time" is true, this *must* be provided
    "auth_time",
    // OIDC
    "nonce",
    "acr",
    // OpenID: "profile" scope
    "name",
    "family_name",
    "given_name",
    "middle_name",
    "nickname",
    "preferred_username",
    "gender",
    "picture",
    "profile",
    "website",
    "birthdate",
    "zoneinfo",
    "locale",
    "updated_at",
    // OpenID: "email" scope
    "email",
    "email_verified",
    // OpenID: "phone" scope
    "phone_number",
    "phone_number_verified",
    // OpenID: "address" scope
    "address"
]);

});

parcelRegister("LmBbd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oidcClaimsPropertiesSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
const $08e5eb870ba9a4ad$var$oidcClaimsValueSchema = $2zDt6.z.union([
    $2zDt6.z.string(),
    $2zDt6.z.number(),
    $2zDt6.z.boolean()
]);
module.exports.oidcClaimsPropertiesSchema = $2zDt6.z.object({
    essential: $2zDt6.z.boolean().optional(),
    value: $08e5eb870ba9a4ad$var$oidcClaimsValueSchema.optional(),
    values: $2zDt6.z.array($08e5eb870ba9a4ad$var$oidcClaimsValueSchema).optional()
});

});

parcelRegister("9Ql4e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oidcEntityTypeSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oidcEntityTypeSchema = $2zDt6.z.enum([
    "userinfo",
    "id_token"
]);

});


parcelRegister("8bc9R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthAuthorizationServerMetadataValidator = module.exports.oauthAuthorizationServerMetadataSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $i3oKx = parcelRequire("i3oKx");
/**
 * @see {@link https://datatracker.ietf.org/doc/html/rfc8414}
 */ module.exports.oauthAuthorizationServerMetadataSchema = $2zDt6.z.object({
    issuer: $i3oKx.oauthIssuerIdentifierSchema,
    claims_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    claims_locales_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    claims_parameter_supported: $2zDt6.z.boolean().optional(),
    request_parameter_supported: $2zDt6.z.boolean().optional(),
    request_uri_parameter_supported: $2zDt6.z.boolean().optional(),
    require_request_uri_registration: $2zDt6.z.boolean().optional(),
    scopes_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    subject_types_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    response_types_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    response_modes_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    grant_types_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    code_challenge_methods_supported: $2zDt6.z.array($2zDt6.z.string()).min(1).optional(),
    ui_locales_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    id_token_signing_alg_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    display_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    request_object_signing_alg_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    authorization_response_iss_parameter_supported: $2zDt6.z.boolean().optional(),
    authorization_details_types_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    request_object_encryption_alg_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    request_object_encryption_enc_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    jwks_uri: $2zDt6.z.string().url().optional(),
    authorization_endpoint: $2zDt6.z.string().url(),
    token_endpoint: $2zDt6.z.string().url(),
    token_endpoint_auth_methods_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    token_endpoint_auth_signing_alg_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    revocation_endpoint: $2zDt6.z.string().url().optional(),
    introspection_endpoint: $2zDt6.z.string().url().optional(),
    pushed_authorization_request_endpoint: $2zDt6.z.string().url().optional(),
    require_pushed_authorization_requests: $2zDt6.z.boolean().optional(),
    userinfo_endpoint: $2zDt6.z.string().url().optional(),
    end_session_endpoint: $2zDt6.z.string().url().optional(),
    registration_endpoint: $2zDt6.z.string().url().optional(),
    // https://datatracker.ietf.org/doc/html/rfc9449#section-5.1
    dpop_signing_alg_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    // https://datatracker.ietf.org/doc/html/draft-ietf-oauth-resource-metadata-05#section-4
    protected_resources: $2zDt6.z.array($2zDt6.z.string().url()).optional(),
    // https://drafts.aaronpk.com/draft-parecki-oauth-client-id-metadata-document/draft-parecki-oauth-client-id-metadata-document.html
    client_id_metadata_document_supported: $2zDt6.z.boolean().optional()
});
module.exports.oauthAuthorizationServerMetadataValidator = module.exports.oauthAuthorizationServerMetadataSchema.superRefine((data, ctx)=>{
    if (data.require_pushed_authorization_requests && !data.pushed_authorization_request_endpoint) ctx.addIssue({
        code: $2zDt6.z.ZodIssueCode.custom,
        message: '"pushed_authorization_request_endpoint" required when "require_pushed_authorization_requests" is true'
    });
}).superRefine((data, ctx)=>{
    if (data.response_types_supported) {
        if (!data.response_types_supported.includes("code")) ctx.addIssue({
            code: $2zDt6.z.ZodIssueCode.custom,
            message: 'Response type "code" is required'
        });
    }
});

});
parcelRegister("i3oKx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthIssuerIdentifierSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $9Vu2E = parcelRequire("9Vu2E");

var $3bKHb = parcelRequire("3bKHb");
module.exports.oauthIssuerIdentifierSchema = $2zDt6.z.string().superRefine((value, ctx)=>{
    // Validate the issuer (MIX-UP attacks)
    if (value.endsWith("/")) ctx.addIssue({
        code: $2zDt6.z.ZodIssueCode.custom,
        message: "Issuer URL must not end with a slash"
    });
    const url = (0, $3bKHb.safeUrl)(value);
    if (!url) return ctx.addIssue({
        code: $2zDt6.z.ZodIssueCode.custom,
        message: "Invalid url"
    });
    if (url.protocol !== "https:") {
        if ($9Vu2E.ALLOW_UNSECURE_ORIGINS && url.protocol === "http:") ;
        else ctx.addIssue({
            code: $2zDt6.z.ZodIssueCode.custom,
            message: "Issuer must be an HTTPS URL"
        });
    }
    if (url.username || url.password) ctx.addIssue({
        code: $2zDt6.z.ZodIssueCode.custom,
        message: "Issuer URL must not contain a username or password"
    });
    if (url.hash || url.search) ctx.addIssue({
        code: $2zDt6.z.ZodIssueCode.custom,
        message: "Issuer URL must not contain a query or fragment"
    });
    const canonicalValue = url.pathname === "/" ? url.origin : url.href;
    if (value !== canonicalValue) ctx.addIssue({
        code: $2zDt6.z.ZodIssueCode.custom,
        message: "Issuer URL must be in the canonical form"
    });
});

});


parcelRegister("iUYkl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthClientCredentialsSchema = module.exports.oauthClientCredentialsSecretPostSchema = module.exports.oauthClientCredentialsJwtBearerSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $4EOoK = parcelRequire("4EOoK");

var $kcXek = parcelRequire("kcXek");

var $9Vu2E = parcelRequire("9Vu2E");
module.exports.oauthClientCredentialsJwtBearerSchema = $2zDt6.z.object({
    client_id: $kcXek.oauthClientIdSchema,
    client_assertion_type: $2zDt6.z.literal($9Vu2E.CLIENT_ASSERTION_TYPE_JWT_BEARER),
    /**
     * - "sub" the subject MUST be the "client_id" of the OAuth client
     * - "iat" is required and MUST be less than one minute
     * - "aud" must containing a value that identifies the authorization server
     * - The JWT MAY contain a "jti" (JWT ID) claim that provides a unique identifier for the token.
     * - Note that the authorization server may reject JWTs with an "exp" claim value that is unreasonably far in the future.
     *
     * @see {@link https://datatracker.ietf.org/doc/html/draft-ietf-oauth-jwt-bearer-11#section-3}
     */ client_assertion: $4EOoK.signedJwtSchema
});
module.exports.oauthClientCredentialsSecretPostSchema = $2zDt6.z.object({
    client_id: $kcXek.oauthClientIdSchema,
    client_secret: $2zDt6.z.string()
});
module.exports.oauthClientCredentialsSchema = $2zDt6.z.union([
    module.exports.oauthClientCredentialsJwtBearerSchema,
    module.exports.oauthClientCredentialsSecretPostSchema
]);

});

parcelRegister("3e2zX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthClientIdentificationSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $kcXek = parcelRequire("kcXek");

var $iUYkl = parcelRequire("iUYkl");
module.exports.oauthClientIdentificationSchema = $2zDt6.z.union([
    $iUYkl.oauthClientCredentialsSchema,
    // Must be last since it is less specific
    $2zDt6.z.object({
        client_id: $kcXek.oauthClientIdSchema
    })
]);

});

parcelRegister("kBqrl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthClientMetadataSchema = void 0;

var $4EOoK = parcelRequire("4EOoK");

var $2zDt6 = parcelRequire("2zDt6");

var $kcXek = parcelRequire("kcXek");

var $4Z3I5 = parcelRequire("4Z3I5");

var $cDexx = parcelRequire("cDexx");

var $1Da3V = parcelRequire("1Da3V");
// https://openid.net/specs/openid-connect-registration-1_0.html
// https://datatracker.ietf.org/doc/html/rfc7591
module.exports.oauthClientMetadataSchema = $2zDt6.z.object({
    redirect_uris: $2zDt6.z.array($2zDt6.z.string().url()).nonempty(),
    response_types: $2zDt6.z.array($1Da3V.oauthResponseTypeSchema).nonempty()// > If omitted, the default is that the client will use only the "code"
    // > response type.
    .default([
        "code"
    ]),
    grant_types: $2zDt6.z.array($cDexx.oauthGrantTypeSchema).nonempty()// > If omitted, the default behavior is that the client will use only the
    // > "authorization_code" Grant Type.
    .default([
        "authorization_code"
    ]),
    scope: $2zDt6.z.string().optional(),
    token_endpoint_auth_method: $4Z3I5.oauthEndpointAuthMethod.default("none").optional(),
    token_endpoint_auth_signing_alg: $2zDt6.z.string().optional(),
    userinfo_signed_response_alg: $2zDt6.z.string().optional(),
    userinfo_encrypted_response_alg: $2zDt6.z.string().optional(),
    jwks_uri: $2zDt6.z.string().url().optional(),
    jwks: $4EOoK.jwksPubSchema.optional(),
    application_type: $2zDt6.z.enum([
        "web",
        "native"
    ]).default("web").optional(),
    subject_type: $2zDt6.z.enum([
        "public",
        "pairwise"
    ]).default("public").optional(),
    request_object_signing_alg: $2zDt6.z.string().optional(),
    id_token_signed_response_alg: $2zDt6.z.string().optional(),
    authorization_signed_response_alg: $2zDt6.z.string().default("RS256").optional(),
    authorization_encrypted_response_enc: $2zDt6.z.enum([
        "A128CBC-HS256"
    ]).optional(),
    authorization_encrypted_response_alg: $2zDt6.z.string().optional(),
    client_id: $kcXek.oauthClientIdSchema.optional(),
    client_name: $2zDt6.z.string().optional(),
    client_uri: $2zDt6.z.string().url().optional(),
    policy_uri: $2zDt6.z.string().url().optional(),
    tos_uri: $2zDt6.z.string().url().optional(),
    logo_uri: $2zDt6.z.string().url().optional(),
    /**
     * Default Maximum Authentication Age. Specifies that the End-User MUST be
     * actively authenticated if the End-User was authenticated longer ago than
     * the specified number of seconds. The max_age request parameter overrides
     * this default value. If omitted, no default Maximum Authentication Age is
     * specified.
     */ default_max_age: $2zDt6.z.number().optional(),
    require_auth_time: $2zDt6.z.boolean().optional(),
    contacts: $2zDt6.z.array($2zDt6.z.string().email()).optional(),
    tls_client_certificate_bound_access_tokens: $2zDt6.z.boolean().optional(),
    // https://datatracker.ietf.org/doc/html/rfc9449#section-5.2
    dpop_bound_access_tokens: $2zDt6.z.boolean().optional(),
    // https://datatracker.ietf.org/doc/html/rfc9396#section-14.5
    authorization_details_types: $2zDt6.z.array($2zDt6.z.string()).optional()
});

});
parcelRegister("4Z3I5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthEndpointAuthMethod = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthEndpointAuthMethod = $2zDt6.z.enum([
    "client_secret_basic",
    "client_secret_jwt",
    "client_secret_post",
    "none",
    "private_key_jwt",
    "self_signed_tls_client_auth",
    "tls_client_auth"
]);

});

parcelRegister("cDexx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthGrantTypeSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthGrantTypeSchema = $2zDt6.z.enum([
    "authorization_code",
    "implicit",
    "refresh_token",
    "password",
    "client_credentials",
    "urn:ietf:params:oauth:grant-type:jwt-bearer",
    "urn:ietf:params:oauth:grant-type:saml2-bearer"
]);

});


parcelRegister("invkT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAUTH_ENDPOINT_NAMES = void 0;
module.exports.OAUTH_ENDPOINT_NAMES = [
    "token",
    "revocation",
    "introspection",
    "pushed_authorization_request"
];

});

parcelRegister("jlwgK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthParResponseSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthParResponseSchema = $2zDt6.z.object({
    request_uri: $2zDt6.z.string()
});

});

parcelRegister("3ibUR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthProtectedResourceMetadataSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $i3oKx = parcelRequire("i3oKx");
/**
 * @see {@link https://datatracker.ietf.org/doc/html/draft-ietf-oauth-resource-metadata-05#name-protected-resource-metadata-r}
 */ module.exports.oauthProtectedResourceMetadataSchema = $2zDt6.z.object({
    /**
     * REQUIRED. The protected resource's resource identifier, which is a URL that
     * uses the https scheme and has no query or fragment components. Using these
     * well-known resources is described in Section 3.
     */ resource: $2zDt6.z.string().url(),
    /**
     * OPTIONAL. JSON array containing a list of OAuth authorization server issuer
     * identifiers, as defined in [RFC8414], for authorization servers that can be
     * used with this protected resource. Protected resources MAY choose not to
     * advertise some supported authorization servers even when this parameter is
     * used. In some use cases, the set of authorization servers will not be
     * enumerable, in which case this metadata parameter would not be used.
     */ authorization_servers: $2zDt6.z.array($i3oKx.oauthIssuerIdentifierSchema).optional(),
    /**
     * OPTIONAL. URL of the protected resource's JWK Set [JWK] document. This
     * contains public keys belonging to the protected resource, such as signing
     * key(s) that the resource server uses to sign resource responses. This URL
     * MUST use the https scheme. When both signing and encryption keys are made
     * available, a use (public key use) parameter value is REQUIRED for all keys
     * in the referenced JWK Set to indicate each key's intended usage.
     */ jwks_uri: $2zDt6.z.string().url().optional(),
    /**
     * RECOMMENDED. JSON array containing a list of the OAuth 2.0 [RFC6749] scope
     * values that are used in authorization requests to request access to this
     * protected resource. Protected resources MAY choose not to advertise some
     * scope values supported even when this parameter is used.
     */ scopes_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    /**
     * OPTIONAL. JSON array containing a list of the supported methods of sending
     * an OAuth 2.0 Bearer Token [RFC6750] to the protected resource. Defined
     * values are ["header", "body", "query"], corresponding to Sections 2.1, 2.2,
     * and 2.3 of RFC 6750.
     */ bearer_methods_supported: $2zDt6.z.array($2zDt6.z.enum([
        "header",
        "body",
        "query"
    ])).optional(),
    /**
     * OPTIONAL. JSON array containing a list of the JWS [JWS] signing algorithms
     * (alg values) [JWA] supported by the protected resource for signing resource
     * responses, for instance, as described in [FAPI.MessageSigning]. No default
     * algorithms are implied if this entry is omitted. The value none MUST NOT be
     * used.
     */ resource_signing_alg_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    /**
     * OPTIONAL. URL of a page containing human-readable information that
     * developers might want or need to know when using the protected resource
     */ resource_documentation: $2zDt6.z.string().url().optional(),
    /**
     * OPTIONAL. URL that the protected resource provides to read about the
     * protected resource's requirements on how the client can use the data
     * provided by the protected resource
     */ resource_policy_uri: $2zDt6.z.string().url().optional(),
    /**
     * OPTIONAL. URL that the protected resource provides to read about the
     * protected resource's terms of service
     */ resource_tos_uri: $2zDt6.z.string().url().optional()
});

});

parcelRegister("7eEuQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthResponseModeSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthResponseModeSchema = $2zDt6.z.enum([
    "query",
    "fragment",
    "form_post"
]);

});

parcelRegister("ln2nq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthTokenResponseSchema = void 0;

var $4EOoK = parcelRequire("4EOoK");

var $2zDt6 = parcelRequire("2zDt6");

var $cICSH = parcelRequire("cICSH");

var $e9eSC = parcelRequire("e9eSC");
/**
 * @see {@link https://www.rfc-editor.org/rfc/rfc6749.html#section-5.1 | RFC 6749 (OAuth2), Section 5.1}
 */ module.exports.oauthTokenResponseSchema = $2zDt6.z.object({
    access_token: $2zDt6.z.string(),
    token_type: $e9eSC.oauthTokenTypeSchema,
    issuer: $2zDt6.z.string().url().optional(),
    scope: $2zDt6.z.string().optional(),
    id_token: $4EOoK.signedJwtSchema.optional(),
    refresh_token: $2zDt6.z.string().optional(),
    expires_in: $2zDt6.z.number().optional(),
    authorization_details: $cICSH.oauthAuthorizationDetailsSchema.optional()
})// https://www.rfc-editor.org/rfc/rfc6749.html#section-5.1
// > The client MUST ignore unrecognized value names in the response.
.passthrough();

});
parcelRegister("e9eSC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthTokenTypeSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
// Case insensitive input, normalized output
module.exports.oauthTokenTypeSchema = $2zDt6.z.union([
    $2zDt6.z.string().regex(/^DPoP$/i).transform(()=>"DPoP"),
    $2zDt6.z.string().regex(/^Bearer$/i).transform(()=>"Bearer")
]);

});



parcelRegister("6oTi5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthAuthorizationServerMetadataResolver = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $559MJ = parcelRequire("559MJ");

var $auA9I = parcelRequire("auA9I");

var $96UnS = parcelRequire("96UnS");
/**
 * @see {@link https://datatracker.ietf.org/doc/html/rfc8414}
 */ class $4a8fdf8c389ec91b$var$OAuthAuthorizationServerMetadataResolver extends $559MJ.CachedGetter {
    constructor(cache, fetch){
        super(async (issuer, options)=>this.fetchMetadata(issuer, options), cache);
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.fetch = (0, $8oTqd.bindFetch)(fetch);
    }
    async get(issuer, options) {
        return super.get($auA9I.oauthIssuerIdentifierSchema.parse(issuer), options);
    }
    async fetchMetadata(issuer, options) {
        const headers = new Headers([
            [
                "accept",
                "application/json"
            ]
        ]);
        if (options?.noCache) headers.set("cache-control", "no-cache");
        const url = new URL(`/.well-known/oauth-authorization-server`, issuer);
        const request = new Request(url, {
            signal: options?.signal,
            headers: headers,
            redirect: "manual"
        });
        const response = await this.fetch(request);
        // https://datatracker.ietf.org/doc/html/rfc8414#section-3.2
        if (response.status !== 200) {
            await (0, $8oTqd.cancelBody)(response, "log");
            throw await $8oTqd.FetchResponseError.from(response, `Unexpected status code ${response.status} for "${url}"`, undefined, {
                cause: request
            });
        }
        if ((0, $96UnS.contentMime)(response.headers) !== "application/json") {
            await (0, $8oTqd.cancelBody)(response, "log");
            throw await $8oTqd.FetchResponseError.from(response, `Unexpected content type for "${url}"`, undefined, {
                cause: request
            });
        }
        const metadata = $auA9I.oauthAuthorizationServerMetadataValidator.parse(await response.json());
        // Validate the issuer (MIX-UP attacks)
        // https://datatracker.ietf.org/doc/html/draft-ietf-oauth-security-topics#name-mix-up-attacks
        // https://datatracker.ietf.org/doc/html/rfc8414#section-2
        if (metadata.issuer !== issuer) throw new TypeError(`Invalid issuer ${metadata.issuer}`);
        // ATPROTO requires client_id_metadata_document
        // http://drafts.aaronpk.com/draft-parecki-oauth-client-id-metadata-document/draft-parecki-oauth-client-id-metadata-document.html
        if (metadata.client_id_metadata_document_supported !== true) throw new TypeError(`Authorization server "${issuer}" does not support client_id_metadata_document`);
        return metadata;
    }
}
module.exports.OAuthAuthorizationServerMetadataResolver = $4a8fdf8c389ec91b$var$OAuthAuthorizationServerMetadataResolver;

});
parcelRegister("96UnS", function(module, exports) {
"use strict";
var $6a2069511784c76e$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6a2069511784c76e$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomEventTarget = module.exports.CustomEvent = module.exports.contentMime = module.exports.timeoutSignal = void 0;
// @ts-expect-error
Symbol.dispose ?? (Symbol.dispose = Symbol("@@dispose"));
/**
 * @todo (?) move to common package
 */ const $6a2069511784c76e$var$timeoutSignal = (timeout, options)=>{
    if (!Number.isInteger(timeout) || timeout < 0) throw new TypeError("Expected a positive integer");
    options?.signal?.throwIfAborted();
    const controller = new AbortController();
    const { signal: signal } = controller;
    options?.signal?.addEventListener("abort", (reason)=>controller.abort(reason), {
        once: true,
        signal: signal
    });
    const timeoutId = setTimeout((err)=>controller.abort(err), timeout, // create Error here to keep original stack trace
    new Error("Timeout"));
    timeoutId?.unref?.(); // NodeJS only
    signal.addEventListener("abort", ()=>clearTimeout(timeoutId), {
        once: true,
        signal: signal
    });
    Object.defineProperty(signal, Symbol.dispose, {
        value: ()=>controller.abort()
    });
    return signal;
};
module.exports.timeoutSignal = $6a2069511784c76e$var$timeoutSignal;
function $6a2069511784c76e$var$contentMime(headers) {
    return headers.get("content-type")?.split(";")[0].trim();
}
module.exports.contentMime = $6a2069511784c76e$var$contentMime;
/**
 * Ponyfill for `CustomEvent` constructor.
 */ module.exports.CustomEvent = globalThis.CustomEvent ?? (()=>{
    var _CustomEvent_detail;
    class CustomEvent extends Event {
        constructor(type, options){
            if (!arguments.length) throw new TypeError("type argument is required");
            super(type, options);
            _CustomEvent_detail.set(this, void 0);
            $6a2069511784c76e$var$__classPrivateFieldSet(this, _CustomEvent_detail, options?.detail ?? null, "f");
        }
        get detail() {
            return $6a2069511784c76e$var$__classPrivateFieldGet(this, _CustomEvent_detail, "f");
        }
    }
    _CustomEvent_detail = new WeakMap();
    Object.defineProperties(CustomEvent.prototype, {
        [Symbol.toStringTag]: {
            writable: false,
            enumerable: false,
            configurable: true,
            value: "CustomEvent"
        },
        detail: {
            enumerable: true
        }
    });
    return CustomEvent;
})();
class $6a2069511784c76e$var$CustomEventTarget {
    constructor(){
        Object.defineProperty(this, "eventTarget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new EventTarget()
        });
    }
    addEventListener(type, callback, options) {
        this.eventTarget.addEventListener(type, callback, options);
    }
    removeEventListener(type, callback, options) {
        this.eventTarget.removeEventListener(type, callback, options);
    }
    dispatchCustomEvent(type, detail, init) {
        return this.eventTarget.dispatchEvent(new module.exports.CustomEvent(type, {
            ...init,
            detail: detail
        }));
    }
}
module.exports.CustomEventTarget = $6a2069511784c76e$var$CustomEventTarget;

});


parcelRegister("lfpNx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthCallbackError = void 0;
class $f77f02a138075c32$var$OAuthCallbackError extends Error {
    static from(err, params, state) {
        if (err instanceof $f77f02a138075c32$var$OAuthCallbackError) return err;
        const message = err instanceof Error ? err.message : undefined;
        return new $f77f02a138075c32$var$OAuthCallbackError(params, message, state, err);
    }
    constructor(params, message = params.get("error_description") || "OAuth callback error", state, cause){
        super(message, {
            cause: cause
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: params
        });
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: state
        });
    }
}
module.exports.OAuthCallbackError = $f77f02a138075c32$var$OAuthCallbackError;

});

parcelRegister("gwEzH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthClient = void 0;

var $k2dJf = parcelRequire("k2dJf");

var $fYfau = parcelRequire("fYfau");

var $bGbIW = parcelRequire("bGbIW");

var $9eBhV = parcelRequire("9eBhV");

var $4EOoK = parcelRequire("4EOoK");

var $auA9I = parcelRequire("auA9I");

var $59fWx = parcelRequire("59fWx");

var $5QfU8 = parcelRequire("5QfU8");

var $6oTi5 = parcelRequire("6oTi5");

var $lfpNx = parcelRequire("lfpNx");

var $fFwT5 = parcelRequire("fFwT5");

var $b1J1b = parcelRequire("b1J1b");

var $4H3QM = parcelRequire("4H3QM");

var $6aqH9 = parcelRequire("6aqH9");

var $f60TT = parcelRequire("f60TT");

var $5u6ZB = parcelRequire("5u6ZB");

var $96UnS = parcelRequire("96UnS");

var $5cQ7D = parcelRequire("5cQ7D");
class $c07f1bc9b04139ab$var$OAuthClient extends $96UnS.CustomEventTarget {
    static async fetchMetadata({ clientId: clientId, fetch: fetch = globalThis.fetch, signal: signal }) {
        signal?.throwIfAborted();
        const request = new Request(clientId, {
            redirect: "error",
            signal: signal
        });
        const response = await fetch(request);
        if (response.status !== 200) {
            response.body?.cancel?.();
            throw new TypeError(`Failed to fetch client metadata: ${response.status}`);
        }
        // https://drafts.aaronpk.com/draft-parecki-oauth-client-id-metadata-document/draft-parecki-oauth-client-id-metadata-document.html#section-4.1
        const mime = response.headers.get("content-type")?.split(";")[0].trim();
        if (mime !== "application/json") {
            response.body?.cancel?.();
            throw new TypeError(`Invalid client metadata content type: ${mime}`);
        }
        const json = await response.json();
        signal?.throwIfAborted();
        return $auA9I.oauthClientMetadataSchema.parse(json);
    }
    constructor({ fetch: fetch = globalThis.fetch, stateStore: stateStore, sessionStore: sessionStore, didCache: didCache, dpopNonceCache: dpopNonceCache = new $9eBhV.SimpleStoreMemory({
        ttl: 60e3,
        max: 100
    }), handleCache: handleCache, authorizationServerMetadataCache: authorizationServerMetadataCache = new $9eBhV.SimpleStoreMemory({
        ttl: 60e3,
        max: 100
    }), protectedResourceMetadataCache: protectedResourceMetadataCache = new $9eBhV.SimpleStoreMemory({
        ttl: 60e3,
        max: 100
    }), responseMode: responseMode, clientMetadata: clientMetadata, handleResolver: handleResolver, plcDirectoryUrl: plcDirectoryUrl, runtimeImplementation: runtimeImplementation, keyset: keyset }){
        super();
        // Config
        Object.defineProperty(this, "clientMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "responseMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "keyset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Services
        Object.defineProperty(this, "runtime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "oauthResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "serverFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Stores
        Object.defineProperty(this, "sessionGetter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.keyset = keyset ? keyset instanceof $4EOoK.Keyset ? keyset : new $4EOoK.Keyset(keyset) : undefined;
        this.clientMetadata = (0, $5cQ7D.validateClientMetadata)(clientMetadata, this.keyset);
        this.responseMode = responseMode;
        this.runtime = new $f60TT.Runtime(runtimeImplementation);
        this.fetch = fetch;
        this.oauthResolver = new $b1J1b.OAuthResolver(new $bGbIW.IdentityResolver(new $k2dJf.DidResolverCached(new $k2dJf.DidResolverCommon({
            fetch: fetch,
            plcDirectoryUrl: plcDirectoryUrl
        }), didCache), new $fYfau.CachedHandleResolver($fYfau.AppViewHandleResolver.from(handleResolver, {
            fetch: fetch
        }), handleCache)), new $fFwT5.OAuthProtectedResourceMetadataResolver(protectedResourceMetadataCache, fetch), new $6oTi5.OAuthAuthorizationServerMetadataResolver(authorizationServerMetadataCache, fetch));
        this.serverFactory = new $4H3QM.OAuthServerFactory(this.clientMetadata, this.runtime, this.oauthResolver, this.fetch, this.keyset, dpopNonceCache);
        this.sessionGetter = new $5u6ZB.SessionGetter(sessionStore, this.serverFactory, this.runtime);
        this.stateStore = stateStore;
        // Proxy sessionGetter events
        for (const type of [
            "deleted",
            "updated"
        ])this.sessionGetter.addEventListener(type, (event)=>{
            if (!this.dispatchCustomEvent(type, event.detail)) event.preventDefault();
        });
    }
    // Exposed as public API for convenience
    get identityResolver() {
        return this.oauthResolver.identityResolver;
    }
    // Exposed as public API for convenience
    get didResolver() {
        return this.identityResolver.didResolver;
    }
    // Exposed as public API for convenience
    get handleResolver() {
        return this.identityResolver.handleResolver;
    }
    get jwks() {
        return this.keyset?.publicJwks ?? {
            keys: []
        };
    }
    async authorize(input, options) {
        const redirectUri = options?.redirect_uri ?? this.clientMetadata.redirect_uris[0];
        if (!this.clientMetadata.redirect_uris.includes(redirectUri)) // The server will enforce this, but let's catch it early
        throw new TypeError("Invalid redirect_uri");
        const { identity: identity, metadata: metadata } = await this.oauthResolver.resolve(input, options);
        const pkce = await this.runtime.generatePKCE();
        const dpopKey = await this.runtime.generateKey(metadata.dpop_signing_alg_values_supported || [
            $59fWx.FALLBACK_ALG
        ]);
        const state = await this.runtime.generateNonce();
        await this.stateStore.set(state, {
            iss: metadata.issuer,
            dpopKey: dpopKey,
            verifier: pkce.verifier,
            appState: options?.state
        });
        const parameters = {
            client_id: this.clientMetadata.client_id,
            redirect_uri: redirectUri,
            code_challenge: pkce.challenge,
            code_challenge_method: pkce.method,
            state: state,
            login_hint: identity ? input // If input is a handle or a DID, use it as a login_hint
             : undefined,
            response_mode: this.responseMode,
            response_type: // Negotiate by using the order in the client metadata
            this.clientMetadata.response_types?.find((t)=>metadata["response_types_supported"]?.includes(t)) ?? "code",
            display: options?.display,
            prompt: options?.prompt,
            scope: options?.scope || undefined,
            ui_locales: options?.ui_locales
        };
        if (metadata.pushed_authorization_request_endpoint) {
            const server = await this.serverFactory.fromMetadata(metadata, dpopKey);
            const parResponse = await server.request("pushed_authorization_request", parameters);
            const authorizationUrl = new URL(metadata.authorization_endpoint);
            authorizationUrl.searchParams.set("client_id", this.clientMetadata.client_id);
            authorizationUrl.searchParams.set("request_uri", parResponse.request_uri);
            return authorizationUrl;
        } else if (metadata.require_pushed_authorization_requests) throw new Error("Server requires pushed authorization requests (PAR) but no PAR endpoint is available");
        else {
            const authorizationUrl = new URL(metadata.authorization_endpoint);
            for (const [key, value] of Object.entries(parameters))if (value) authorizationUrl.searchParams.set(key, String(value));
            // Length of the URL that will be sent to the server
            const urlLength = authorizationUrl.pathname.length + authorizationUrl.search.length;
            if (urlLength < 2048) return authorizationUrl;
            else if (!metadata.pushed_authorization_request_endpoint) throw new Error("Login URL too long");
        }
        throw new Error("Server does not support pushed authorization requests (PAR)");
    }
    /**
     * This method allows the client to proactively revoke the request_uri it
     * created through PAR.
     */ async abortRequest(authorizeUrl) {
        const requestUri = authorizeUrl.searchParams.get("request_uri");
        if (!requestUri) return;
    // @NOTE This is not implemented here because, 1) the request server should
    // invalidate the request_uri after some delay anyways, and 2) I am not sure
    // that the revocation endpoint is even supposed to support this (and I
    // don't want to spend the time checking now).
    // @TODO investigate actual necessity & feasibility of this feature
    }
    async callback(params) {
        const responseJwt = params.get("response");
        if (responseJwt != null) // https://openid.net/specs/oauth-v2-jarm.html
        throw new $lfpNx.OAuthCallbackError(params, "JARM not supported");
        const issuerParam = params.get("iss");
        const stateParam = params.get("state");
        const errorParam = params.get("error");
        const codeParam = params.get("code");
        if (!stateParam) throw new $lfpNx.OAuthCallbackError(params, 'Missing "state" parameter');
        const stateData = await this.stateStore.get(stateParam);
        if (stateData) // Prevent any kind of replay
        await this.stateStore.del(stateParam);
        else throw new $lfpNx.OAuthCallbackError(params, `Unknown authorization session "${stateParam}"`);
        try {
            if (errorParam != null) throw new $lfpNx.OAuthCallbackError(params, undefined, stateData.appState);
            if (!codeParam) throw new $lfpNx.OAuthCallbackError(params, 'Missing "code" query param', stateData.appState);
            const server = await this.serverFactory.fromIssuer(stateData.iss, stateData.dpopKey);
            if (issuerParam != null) {
                if (!server.serverMetadata.issuer) throw new $lfpNx.OAuthCallbackError(params, "Issuer not found in metadata", stateData.appState);
                if (server.serverMetadata.issuer !== issuerParam) throw new $lfpNx.OAuthCallbackError(params, "Issuer mismatch", stateData.appState);
            } else if (server.serverMetadata.authorization_response_iss_parameter_supported) throw new $lfpNx.OAuthCallbackError(params, "iss missing from the response", stateData.appState);
            const tokenSet = await server.exchangeCode(codeParam, stateData.verifier);
            try {
                await this.sessionGetter.setStored(tokenSet.sub, {
                    dpopKey: stateData.dpopKey,
                    tokenSet: tokenSet
                });
                const session = this.createSession(server, tokenSet.sub);
                return {
                    session: session,
                    state: stateData.appState ?? null
                };
            } catch (err) {
                await server.revoke(tokenSet.access_token);
                throw err;
            }
        } catch (err) {
            // Make sure, whatever the underlying error, that the appState is
            // available in the calling code
            throw $lfpNx.OAuthCallbackError.from(err, params, stateData.appState);
        }
    }
    /**
     * Load a stored session. This will refresh the token only if needed (about to
     * expire) by default.
     *
     * @param refresh See {@link SessionGetter.getSession}
     */ async restore(sub, refresh) {
        const { dpopKey: dpopKey, tokenSet: tokenSet } = await this.sessionGetter.getSession(sub, refresh);
        const server = await this.serverFactory.fromIssuer(tokenSet.iss, dpopKey, {
            noCache: refresh === true,
            allowStale: refresh === false
        });
        return this.createSession(server, sub);
    }
    async revoke(sub) {
        const { dpopKey: dpopKey, tokenSet: tokenSet } = await this.sessionGetter.getSession(sub, false);
        // NOT using `;(await this.restore(sub, false)).signOut()` because we want
        // the tokens to be deleted even if it was not possible to fetch the issuer
        // data.
        try {
            const server = await this.serverFactory.fromIssuer(tokenSet.iss, dpopKey);
            await server.revoke(tokenSet.access_token);
        } finally{
            await this.sessionGetter.delStored(sub, new $5QfU8.TokenRevokedError(sub));
        }
    }
    createSession(server, sub) {
        return new $6aqH9.OAuthSession(server, sub, this.sessionGetter, this.fetch);
    }
}
module.exports.OAuthClient = $c07f1bc9b04139ab$var$OAuthClient;

});
parcelRegister("bGbIW", function(module, exports) {
"use strict";
var $880cb614e83fc2ef$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $880cb614e83fc2ef$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $880cb614e83fc2ef$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$880cb614e83fc2ef$var$__exportStar((parcelRequire("kSYEu")), module.exports);

});
parcelRegister("kSYEu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IdentityResolver = void 0;

var $fYfau = parcelRequire("fYfau");

var $UiDXP = parcelRequire("UiDXP");
class $f347e6040623c103$var$IdentityResolver {
    constructor(didResolver, handleResolver){
        Object.defineProperty(this, "didResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: didResolver
        });
        Object.defineProperty(this, "handleResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: handleResolver
        });
    }
    async resolve(input, options) {
        const document = (0, $fYfau.isResolvedHandle)(input) ? await this.getDocumentFromDid(input, options) : await this.getDocumentFromHandle(input, options);
        const service = document.service?.find($f347e6040623c103$var$isAtprotoPersonalDataServerService, document);
        if (!service) throw new TypeError(`No valid "AtprotoPersonalDataServer" service found in "${document.id}" DID document`);
        return {
            did: document.id,
            pds: new URL(service.serviceEndpoint)
        };
    }
    async getDocumentFromDid(did, options) {
        return this.didResolver.resolve(did, options);
    }
    async getDocumentFromHandle(input, options) {
        const handle = (0, $UiDXP.normalizeAndEnsureValidHandle)(input);
        const did = await this.handleResolver.resolve(handle, options);
        if (!did) throw new TypeError(`Handle "${handle}" does not resolve to a DID`);
        options?.signal?.throwIfAborted();
        // Note: Not using "return this.resolveDid(did, options)" to make the extra
        // check for the handle in the DID document:
        const document = await this.didResolver.resolve(did, options);
        // Ensure that the handle is included in the document
        if (!document.alsoKnownAs?.includes(`at://${handle}`)) throw new TypeError(`Did document for "${did}" does not include the handle "${handle}"`);
        return document;
    }
}
module.exports.IdentityResolver = $f347e6040623c103$var$IdentityResolver;
function $f347e6040623c103$var$isAtprotoPersonalDataServerService(s) {
    return typeof s.serviceEndpoint === "string" && s.type === "AtprotoPersonalDataServer" && (s.id.startsWith("#") ? s.id === "#atproto_pds" : s.id === `${this.id}#atproto_pds`);
}

});
parcelRegister("UiDXP", function(module, exports) {
"use strict";
var $0a93b14deb5a0596$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0a93b14deb5a0596$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0a93b14deb5a0596$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0a93b14deb5a0596$var$__exportStar((parcelRequire("1MpES")), module.exports);

$0a93b14deb5a0596$var$__exportStar((parcelRequire("3gKOw")), module.exports);

$0a93b14deb5a0596$var$__exportStar((parcelRequire("hDhgK")), module.exports);

$0a93b14deb5a0596$var$__exportStar((parcelRequire("lyyoE")), module.exports);

$0a93b14deb5a0596$var$__exportStar((parcelRequire("s45NF")), module.exports);

$0a93b14deb5a0596$var$__exportStar((parcelRequire("4mRLS")), module.exports);

$0a93b14deb5a0596$var$__exportStar((parcelRequire("ckHH9")), module.exports);

});
parcelRegister("1MpES", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DisallowedDomainError = module.exports.UnsupportedDomainError = module.exports.ReservedHandleError = module.exports.InvalidHandleError = module.exports.isValidTld = module.exports.isValidHandle = module.exports.normalizeAndEnsureValidHandle = module.exports.normalizeHandle = module.exports.ensureValidHandleRegex = module.exports.ensureValidHandle = module.exports.DISALLOWED_TLDS = module.exports.INVALID_HANDLE = void 0;
module.exports.INVALID_HANDLE = "handle.invalid";
// Currently these are registration-time restrictions, not protocol-level
// restrictions. We have a couple accounts in the wild that we need to clean up
// before hard-disallow.
// See also: https://en.wikipedia.org/wiki/Top-level_domain#Reserved_domains
module.exports.DISALLOWED_TLDS = [
    ".local",
    ".arpa",
    ".invalid",
    ".localhost",
    ".internal",
    ".example",
    ".alt",
    // policy could concievably change on ".onion" some day
    ".onion"
];
// Handle constraints, in English:
//  - must be a possible domain name
//    - RFC-1035 is commonly referenced, but has been updated. eg, RFC-3696,
//      section 2. and RFC-3986, section 3. can now have leading numbers (eg,
//      4chan.org)
//    - "labels" (sub-names) are made of ASCII letters, digits, hyphens
//    - can not start or end with a hyphen
//    - TLD (last component) should not start with a digit
//    - can't end with a hyphen (can end with digit)
//    - each segment must be between 1 and 63 characters (not including any periods)
//    - overall length can't be more than 253 characters
//    - separated by (ASCII) periods; does not start or end with period
//    - case insensitive
//    - domains (handles) are equal if they are the same lower-case
//    - punycode allowed for internationalization
//  - no whitespace, null bytes, joining chars, etc
//  - does not validate whether domain or TLD exists, or is a reserved or
//    special TLD (eg, .onion or .local)
//  - does not validate punycode
const $14be2d5be930bc8e$var$ensureValidHandle = (handle)=>{
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9.-]*$/.test(handle)) throw new $14be2d5be930bc8e$var$InvalidHandleError("Disallowed characters in handle (ASCII letters, digits, dashes, periods only)");
    if (handle.length > 253) throw new $14be2d5be930bc8e$var$InvalidHandleError("Handle is too long (253 chars max)");
    const labels = handle.split(".");
    if (labels.length < 2) throw new $14be2d5be930bc8e$var$InvalidHandleError("Handle domain needs at least two parts");
    for(let i = 0; i < labels.length; i++){
        const l = labels[i];
        if (l.length < 1) throw new $14be2d5be930bc8e$var$InvalidHandleError("Handle parts can not be empty");
        if (l.length > 63) throw new $14be2d5be930bc8e$var$InvalidHandleError("Handle part too long (max 63 chars)");
        if (l.endsWith("-") || l.startsWith("-")) throw new $14be2d5be930bc8e$var$InvalidHandleError("Handle parts can not start or end with hyphens");
        if (i + 1 == labels.length && !/^[a-zA-Z]/.test(l)) throw new $14be2d5be930bc8e$var$InvalidHandleError("Handle final component (TLD) must start with ASCII letter");
    }
};
module.exports.ensureValidHandle = $14be2d5be930bc8e$var$ensureValidHandle;
// simple regex translation of above constraints
const $14be2d5be930bc8e$var$ensureValidHandleRegex = (handle)=>{
    if (!/^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/.test(handle)) throw new $14be2d5be930bc8e$var$InvalidHandleError("Handle didn't validate via regex");
    if (handle.length > 253) throw new $14be2d5be930bc8e$var$InvalidHandleError("Handle is too long (253 chars max)");
};
module.exports.ensureValidHandleRegex = $14be2d5be930bc8e$var$ensureValidHandleRegex;
const $14be2d5be930bc8e$var$normalizeHandle = (handle)=>{
    return handle.toLowerCase();
};
module.exports.normalizeHandle = $14be2d5be930bc8e$var$normalizeHandle;
const $14be2d5be930bc8e$var$normalizeAndEnsureValidHandle = (handle)=>{
    const normalized = (0, module.exports.normalizeHandle)(handle);
    (0, module.exports.ensureValidHandle)(normalized);
    return normalized;
};
module.exports.normalizeAndEnsureValidHandle = $14be2d5be930bc8e$var$normalizeAndEnsureValidHandle;
const $14be2d5be930bc8e$var$isValidHandle = (handle)=>{
    try {
        (0, module.exports.ensureValidHandle)(handle);
    } catch (err) {
        if (err instanceof $14be2d5be930bc8e$var$InvalidHandleError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidHandle = $14be2d5be930bc8e$var$isValidHandle;
const $14be2d5be930bc8e$var$isValidTld = (handle)=>{
    return !module.exports.DISALLOWED_TLDS.some((domain)=>handle.endsWith(domain));
};
module.exports.isValidTld = $14be2d5be930bc8e$var$isValidTld;
class $14be2d5be930bc8e$var$InvalidHandleError extends Error {
}
module.exports.InvalidHandleError = $14be2d5be930bc8e$var$InvalidHandleError;
class $14be2d5be930bc8e$var$ReservedHandleError extends Error {
}
module.exports.ReservedHandleError = $14be2d5be930bc8e$var$ReservedHandleError;
class $14be2d5be930bc8e$var$UnsupportedDomainError extends Error {
}
module.exports.UnsupportedDomainError = $14be2d5be930bc8e$var$UnsupportedDomainError;
class $14be2d5be930bc8e$var$DisallowedDomainError extends Error {
}
module.exports.DisallowedDomainError = $14be2d5be930bc8e$var$DisallowedDomainError;

});

parcelRegister("3gKOw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidDidError = module.exports.ensureValidDidRegex = module.exports.ensureValidDid = void 0;
// Human-readable constraints:
//   - valid W3C DID (https://www.w3.org/TR/did-core/#did-syntax)
//      - entire URI is ASCII: [a-zA-Z0-9._:%-]
//      - always starts "did:" (lower-case)
//      - method name is one or more lower-case letters, followed by ":"
//      - remaining identifier can have any of the above chars, but can not end in ":"
//      - it seems that a bunch of ":" can be included, and don't need spaces between
//      - "%" is used only for "percent encoding" and must be followed by two hex characters (and thus can't end in "%")
//      - query ("?") and fragment ("#") stuff is defined for "DID URIs", but not as part of identifier itself
//      - "The current specification does not take a position on the maximum length of a DID"
//   - in current atproto, only allowing did:plc and did:web. But not *forcing* this at lexicon layer
//   - hard length limit of 8KBytes
//   - not going to validate "percent encoding" here
const $26172df72b56388e$var$ensureValidDid = (did)=>{
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9._:%-]*$/.test(did)) throw new $26172df72b56388e$var$InvalidDidError("Disallowed characters in DID (ASCII letters, digits, and a couple other characters only)");
    const parts = did.split(":");
    if (parts.length < 3) throw new $26172df72b56388e$var$InvalidDidError("DID requires prefix, method, and method-specific content");
    if (parts[0] != "did") throw new $26172df72b56388e$var$InvalidDidError('DID requires "did:" prefix');
    if (!/^[a-z]+$/.test(parts[1])) throw new $26172df72b56388e$var$InvalidDidError("DID method must be lower-case letters");
    if (did.endsWith(":") || did.endsWith("%")) throw new $26172df72b56388e$var$InvalidDidError('DID can not end with ":" or "%"');
    if (did.length > 2048) throw new $26172df72b56388e$var$InvalidDidError("DID is too long (2048 chars max)");
};
module.exports.ensureValidDid = $26172df72b56388e$var$ensureValidDid;
const $26172df72b56388e$var$ensureValidDidRegex = (did)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints
    if (!/^did:[a-z]+:[a-zA-Z0-9._:%-]*[a-zA-Z0-9._-]$/.test(did)) throw new $26172df72b56388e$var$InvalidDidError("DID didn't validate via regex");
    if (did.length > 2048) throw new $26172df72b56388e$var$InvalidDidError("DID is too long (2048 chars max)");
};
module.exports.ensureValidDidRegex = $26172df72b56388e$var$ensureValidDidRegex;
class $26172df72b56388e$var$InvalidDidError extends Error {
}
module.exports.InvalidDidError = $26172df72b56388e$var$InvalidDidError;

});

parcelRegister("hDhgK", function(module, exports) {
"use strict";
/*
Grammar:

alpha     = "a" / "b" / "c" / "d" / "e" / "f" / "g" / "h" / "i" / "j" / "k" / "l" / "m" / "n" / "o" / "p" / "q" / "r" / "s" / "t" / "u" / "v" / "w" / "x" / "y" / "z" / "A" / "B" / "C" / "D" / "E" / "F" / "G" / "H" / "I" / "J" / "K" / "L" / "M" / "N" / "O" / "P" / "Q" / "R" / "S" / "T" / "U" / "V" / "W" / "X" / "Y" / "Z"
number    = "1" / "2" / "3" / "4" / "5" / "6" / "7" / "8" / "9" / "0"
delim     = "."
segment   = alpha *( alpha / number / "-" )
authority = segment *( delim segment )
name      = alpha *( alpha )
nsid      = authority delim name

*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidNsidError = module.exports.ensureValidNsidRegex = module.exports.ensureValidNsid = module.exports.NSID = void 0;
class $cd63797be799f977$var$NSID {
    static parse(nsid) {
        return new $cd63797be799f977$var$NSID(nsid);
    }
    static create(authority, name) {
        const segments = [
            ...authority.split(".").reverse(),
            name
        ].join(".");
        return new $cd63797be799f977$var$NSID(segments);
    }
    static isValid(nsid) {
        try {
            $cd63797be799f977$var$NSID.parse(nsid);
            return true;
        } catch (e) {
            return false;
        }
    }
    constructor(nsid){
        Object.defineProperty(this, "segments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        (0, module.exports.ensureValidNsid)(nsid);
        this.segments = nsid.split(".");
    }
    get authority() {
        return this.segments.slice(0, this.segments.length - 1).reverse().join(".");
    }
    get name() {
        return this.segments.at(this.segments.length - 1);
    }
    toString() {
        return this.segments.join(".");
    }
}
module.exports.NSID = $cd63797be799f977$var$NSID;
// Human readable constraints on NSID:
// - a valid domain in reversed notation
// - followed by an additional period-separated name, which is camel-case letters
const $cd63797be799f977$var$ensureValidNsid = (nsid)=>{
    const toCheck = nsid;
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9.-]*$/.test(toCheck)) throw new $cd63797be799f977$var$InvalidNsidError("Disallowed characters in NSID (ASCII letters, digits, dashes, periods only)");
    if (toCheck.length > 317) throw new $cd63797be799f977$var$InvalidNsidError("NSID is too long (317 chars max)");
    const labels = toCheck.split(".");
    if (labels.length < 3) throw new $cd63797be799f977$var$InvalidNsidError("NSID needs at least three parts");
    for(let i = 0; i < labels.length; i++){
        const l = labels[i];
        if (l.length < 1) throw new $cd63797be799f977$var$InvalidNsidError("NSID parts can not be empty");
        if (l.length > 63) throw new $cd63797be799f977$var$InvalidNsidError("NSID part too long (max 63 chars)");
        if (l.endsWith("-") || l.startsWith("-")) throw new $cd63797be799f977$var$InvalidNsidError("NSID parts can not start or end with hyphen");
        if (/^[0-9]/.test(l) && i == 0) throw new $cd63797be799f977$var$InvalidNsidError("NSID first part may not start with a digit");
        if (!/^[a-zA-Z]+$/.test(l) && i + 1 == labels.length) throw new $cd63797be799f977$var$InvalidNsidError("NSID name part must be only letters");
    }
};
module.exports.ensureValidNsid = $cd63797be799f977$var$ensureValidNsid;
const $cd63797be799f977$var$ensureValidNsidRegex = (nsid)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints
    if (!/^[a-zA-Z]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(\.[a-zA-Z]([a-zA-Z]{0,61}[a-zA-Z])?)$/.test(nsid)) throw new $cd63797be799f977$var$InvalidNsidError("NSID didn't validate via regex");
    if (nsid.length > 317) throw new $cd63797be799f977$var$InvalidNsidError("NSID is too long (317 chars max)");
};
module.exports.ensureValidNsidRegex = $cd63797be799f977$var$ensureValidNsidRegex;
class $cd63797be799f977$var$InvalidNsidError extends Error {
}
module.exports.InvalidNsidError = $cd63797be799f977$var$InvalidNsidError;

});

parcelRegister("lyyoE", function(module, exports) {
"use strict";
var $fb17746a31b5b5a3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fb17746a31b5b5a3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fb17746a31b5b5a3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtUri = module.exports.ATP_URI_REGEX = void 0;

$fb17746a31b5b5a3$var$__exportStar((parcelRequire("k7vdJ")), module.exports);
module.exports.ATP_URI_REGEX = // proto-    --did--------------   --name----------------   --path----   --query--   --hash--
/^(at:\/\/)?((?:did:[a-z0-9:%-]+)|(?:[a-z0-9][a-z0-9.:-]*))(\/[^?#\s]*)?(\?[^#\s]+)?(#[^\s]+)?$/i;
//                       --path-----   --query--  --hash--
const $fb17746a31b5b5a3$var$RELATIVE_REGEX = /^(\/[^?#\s]*)?(\?[^#\s]+)?(#[^\s]+)?$/i;
class $fb17746a31b5b5a3$var$AtUri {
    constructor(uri, base){
        Object.defineProperty(this, "hash", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "host", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pathname", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "searchParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        let parsed;
        if (base) {
            parsed = $fb17746a31b5b5a3$var$parse(base);
            if (!parsed) throw new Error(`Invalid at uri: ${base}`);
            const relativep = $fb17746a31b5b5a3$var$parseRelative(uri);
            if (!relativep) throw new Error(`Invalid path: ${uri}`);
            Object.assign(parsed, relativep);
        } else {
            parsed = $fb17746a31b5b5a3$var$parse(uri);
            if (!parsed) throw new Error(`Invalid at uri: ${uri}`);
        }
        this.hash = parsed.hash;
        this.host = parsed.host;
        this.pathname = parsed.pathname;
        this.searchParams = parsed.searchParams;
    }
    static make(handleOrDid, collection, rkey) {
        let str = handleOrDid;
        if (collection) str += "/" + collection;
        if (rkey) str += "/" + rkey;
        return new $fb17746a31b5b5a3$var$AtUri(str);
    }
    get protocol() {
        return "at:";
    }
    get origin() {
        return `at://${this.host}`;
    }
    get hostname() {
        return this.host;
    }
    set hostname(v) {
        this.host = v;
    }
    get search() {
        return this.searchParams.toString();
    }
    set search(v) {
        this.searchParams = new URLSearchParams(v);
    }
    get collection() {
        return this.pathname.split("/").filter(Boolean)[0] || "";
    }
    set collection(v) {
        const parts = this.pathname.split("/").filter(Boolean);
        parts[0] = v;
        this.pathname = parts.join("/");
    }
    get rkey() {
        return this.pathname.split("/").filter(Boolean)[1] || "";
    }
    set rkey(v) {
        const parts = this.pathname.split("/").filter(Boolean);
        if (!parts[0]) parts[0] = "undefined";
        parts[1] = v;
        this.pathname = parts.join("/");
    }
    get href() {
        return this.toString();
    }
    toString() {
        let path = this.pathname || "/";
        if (!path.startsWith("/")) path = `/${path}`;
        let qs = this.searchParams.toString();
        if (qs && !qs.startsWith("?")) qs = `?${qs}`;
        let hash = this.hash;
        if (hash && !hash.startsWith("#")) hash = `#${hash}`;
        return `at://${this.host}${path}${qs}${hash}`;
    }
}
module.exports.AtUri = $fb17746a31b5b5a3$var$AtUri;
function $fb17746a31b5b5a3$var$parse(str) {
    const match = module.exports.ATP_URI_REGEX.exec(str);
    if (match) return {
        hash: match[5] || "",
        host: match[2] || "",
        pathname: match[3] || "",
        searchParams: new URLSearchParams(match[4] || "")
    };
    return undefined;
}
function $fb17746a31b5b5a3$var$parseRelative(str) {
    const match = $fb17746a31b5b5a3$var$RELATIVE_REGEX.exec(str);
    if (match) return {
        hash: match[3] || "",
        pathname: match[1] || "",
        searchParams: new URLSearchParams(match[2] || "")
    };
    return undefined;
}

});
parcelRegister("k7vdJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ensureValidAtUriRegex = module.exports.ensureValidAtUri = void 0;

var $1MpES = parcelRequire("1MpES");

var $3gKOw = parcelRequire("3gKOw");

var $hDhgK = parcelRequire("hDhgK");
// Human-readable constraints on ATURI:
//   - following regular URLs, a 8KByte hard total length limit
//   - follows ATURI docs on website
//      - all ASCII characters, no whitespace. non-ASCII could be URL-encoded
//      - starts "at://"
//      - "authority" is a valid DID or a valid handle
//      - optionally, follow "authority" with "/" and valid NSID as start of path
//      - optionally, if NSID given, follow that with "/" and rkey
//      - rkey path component can include URL-encoded ("percent encoded"), or:
//          ALPHA / DIGIT / "-" / "." / "_" / "~" / ":" / "@" / "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
//          [a-zA-Z0-9._~:@!$&'\(\)*+,;=-]
//      - rkey must have at least one char
//      - regardless of path component, a fragment can follow  as "#" and then a JSON pointer (RFC-6901)
const $ea5cadd46dce823d$var$ensureValidAtUri = (uri)=>{
    // JSON pointer is pretty different from rest of URI, so split that out first
    const uriParts = uri.split("#");
    if (uriParts.length > 2) throw new Error('ATURI can have at most one "#", separating fragment out');
    const fragmentPart = uriParts[1] || null;
    uri = uriParts[0];
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9._~:@!$&')(*+,;=%/-]*$/.test(uri)) throw new Error("Disallowed characters in ATURI (ASCII)");
    const parts = uri.split("/");
    if (parts.length >= 3 && (parts[0] != "at:" || parts[1].length != 0)) throw new Error('ATURI must start with "at://"');
    if (parts.length < 3) throw new Error("ATURI requires at least method and authority sections");
    try {
        if (parts[2].startsWith("did:")) (0, $3gKOw.ensureValidDid)(parts[2]);
        else (0, $1MpES.ensureValidHandle)(parts[2]);
    } catch  {
        throw new Error("ATURI authority must be a valid handle or DID");
    }
    if (parts.length >= 4) {
        if (parts[3].length == 0) throw new Error("ATURI can not have a slash after authority without a path segment");
        try {
            (0, $hDhgK.ensureValidNsid)(parts[3]);
        } catch  {
            throw new Error("ATURI requires first path segment (if supplied) to be valid NSID");
        }
    }
    if (parts.length >= 5) {
        if (parts[4].length == 0) throw new Error("ATURI can not have a slash after collection, unless record key is provided");
    // would validate rkey here, but there are basically no constraints!
    }
    if (parts.length >= 6) throw new Error("ATURI path can have at most two parts, and no trailing slash");
    if (uriParts.length >= 2 && fragmentPart == null) throw new Error("ATURI fragment must be non-empty and start with slash");
    if (fragmentPart != null) {
        if (fragmentPart.length == 0 || fragmentPart[0] != "/") throw new Error("ATURI fragment must be non-empty and start with slash");
        // NOTE: enforcing *some* checks here for sanity. Eg, at least no whitespace
        if (!/^\/[a-zA-Z0-9._~:@!$&')(*+,;=%[\]/-]*$/.test(fragmentPart)) throw new Error("Disallowed characters in ATURI fragment (ASCII)");
    }
    if (uri.length > 8192) throw new Error("ATURI is far too long");
};
module.exports.ensureValidAtUri = $ea5cadd46dce823d$var$ensureValidAtUri;
const $ea5cadd46dce823d$var$ensureValidAtUriRegex = (uri)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints. whew!
    const aturiRegex = /^at:\/\/(?<authority>[a-zA-Z0-9._:%-]+)(\/(?<collection>[a-zA-Z0-9-.]+)(\/(?<rkey>[a-zA-Z0-9._~:@!$&%')(*+,;=-]+))?)?(#(?<fragment>\/[a-zA-Z0-9._~:@!$&%')(*+,;=\-[\]/\\]*))?$/;
    const rm = uri.match(aturiRegex);
    if (!rm || !rm.groups) throw new Error("ATURI didn't validate via regex");
    const groups = rm.groups;
    try {
        (0, $1MpES.ensureValidHandleRegex)(groups.authority);
    } catch  {
        try {
            (0, $3gKOw.ensureValidDidRegex)(groups.authority);
        } catch  {
            throw new Error("ATURI authority must be a valid handle or DID");
        }
    }
    if (groups.collection) try {
        (0, $hDhgK.ensureValidNsidRegex)(groups.collection);
    } catch  {
        throw new Error("ATURI collection path segment must be a valid NSID");
    }
    if (uri.length > 8192) throw new Error("ATURI is far too long");
};
module.exports.ensureValidAtUriRegex = $ea5cadd46dce823d$var$ensureValidAtUriRegex;

});


parcelRegister("s45NF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidTidError = module.exports.isValidTid = module.exports.ensureValidTid = void 0;
const $0545ca55ce53b8ae$var$ensureValidTid = (tid)=>{
    if (tid.length != 13) throw new $0545ca55ce53b8ae$var$InvalidTidError("TID must be 13 characters");
    // simple regex to enforce most constraints via just regex and length.
    if (!/^[234567abcdefghij][234567abcdefghijklmnopqrstuvwxyz]{12}$/.test(tid)) throw new $0545ca55ce53b8ae$var$InvalidTidError("TID syntax not valid (regex)");
};
module.exports.ensureValidTid = $0545ca55ce53b8ae$var$ensureValidTid;
const $0545ca55ce53b8ae$var$isValidTid = (tid)=>{
    try {
        (0, module.exports.ensureValidTid)(tid);
    } catch (err) {
        if (err instanceof $0545ca55ce53b8ae$var$InvalidTidError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidTid = $0545ca55ce53b8ae$var$isValidTid;
class $0545ca55ce53b8ae$var$InvalidTidError extends Error {
}
module.exports.InvalidTidError = $0545ca55ce53b8ae$var$InvalidTidError;

});

parcelRegister("4mRLS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidRecordKeyError = module.exports.isValidRecordKey = module.exports.ensureValidRecordKey = void 0;
const $32e2ed51e04bd9d2$var$ensureValidRecordKey = (rkey)=>{
    if (rkey.length > 512 || rkey.length < 1) throw new $32e2ed51e04bd9d2$var$InvalidRecordKeyError("record key must be 1 to 512 characters");
    // simple regex to enforce most constraints via just regex and length.
    if (!/^[a-zA-Z0-9_~.:-]{1,512}$/.test(rkey)) throw new $32e2ed51e04bd9d2$var$InvalidRecordKeyError("record key syntax not valid (regex)");
    if (rkey == "." || rkey == "..") throw new $32e2ed51e04bd9d2$var$InvalidRecordKeyError('record key can not be "." or ".."');
};
module.exports.ensureValidRecordKey = $32e2ed51e04bd9d2$var$ensureValidRecordKey;
const $32e2ed51e04bd9d2$var$isValidRecordKey = (rkey)=>{
    try {
        (0, module.exports.ensureValidRecordKey)(rkey);
    } catch (err) {
        if (err instanceof $32e2ed51e04bd9d2$var$InvalidRecordKeyError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidRecordKey = $32e2ed51e04bd9d2$var$isValidRecordKey;
class $32e2ed51e04bd9d2$var$InvalidRecordKeyError extends Error {
}
module.exports.InvalidRecordKeyError = $32e2ed51e04bd9d2$var$InvalidRecordKeyError;

});

parcelRegister("ckHH9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidDatetimeError = module.exports.normalizeDatetimeAlways = module.exports.normalizeDatetime = module.exports.isValidDatetime = module.exports.ensureValidDatetime = void 0;
/* Validates datetime string against atproto Lexicon 'datetime' format.
 * Syntax is described at: https://atproto.com/specs/lexicon#datetime
 */ const $8fa93f32b4709543$var$ensureValidDatetime = (dtStr)=>{
    const date = new Date(dtStr);
    // must parse as ISO 8601; this also verifies semantics like month is not 13 or 00
    if (isNaN(date.getTime())) throw new $8fa93f32b4709543$var$InvalidDatetimeError("datetime did not parse as ISO 8601");
    if (date.toISOString().startsWith("-")) throw new $8fa93f32b4709543$var$InvalidDatetimeError("datetime normalized to a negative time");
    // regex and other checks for RFC-3339
    if (!/^[0-9]{4}-[01][0-9]-[0-3][0-9]T[0-2][0-9]:[0-6][0-9]:[0-6][0-9](.[0-9]{1,20})?(Z|([+-][0-2][0-9]:[0-5][0-9]))$/.test(dtStr)) throw new $8fa93f32b4709543$var$InvalidDatetimeError("datetime didn't validate via regex");
    if (dtStr.length > 64) throw new $8fa93f32b4709543$var$InvalidDatetimeError("datetime is too long (64 chars max)");
    if (dtStr.endsWith("-00:00")) throw new $8fa93f32b4709543$var$InvalidDatetimeError('datetime can not use "-00:00" for UTC timezone');
    if (dtStr.startsWith("000")) throw new $8fa93f32b4709543$var$InvalidDatetimeError("datetime so close to year zero not allowed");
};
module.exports.ensureValidDatetime = $8fa93f32b4709543$var$ensureValidDatetime;
/* Same logic as ensureValidDatetime(), but returns a boolean instead of throwing an exception.
 */ const $8fa93f32b4709543$var$isValidDatetime = (dtStr)=>{
    try {
        (0, module.exports.ensureValidDatetime)(dtStr);
    } catch (err) {
        if (err instanceof $8fa93f32b4709543$var$InvalidDatetimeError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidDatetime = $8fa93f32b4709543$var$isValidDatetime;
/* Takes a flexible datetime string and normalizes representation.
 *
 * This function will work with any valid atproto datetime (eg, anything which isValidDatetime() is true for). It *additionally* is more flexible about accepting datetimes that don't comply to RFC 3339, or are missing timezone information, and normalizing them to a valid datetime.
 *
 * One use-case is a consistent, sortable string. Another is to work with older invalid createdAt datetimes.
 *
 * Successful output will be a valid atproto datetime with millisecond precision (3 sub-second digits) and UTC timezone with trailing 'Z' syntax. Throws `InvalidDatetimeError` if the input string could not be parsed as a datetime, even with permissive parsing.
 *
 * Expected output format: YYYY-MM-DDTHH:mm:ss.sssZ
 */ const $8fa93f32b4709543$var$normalizeDatetime = (dtStr)=>{
    if ((0, module.exports.isValidDatetime)(dtStr)) {
        const outStr = new Date(dtStr).toISOString();
        if ((0, module.exports.isValidDatetime)(outStr)) return outStr;
    }
    // check if this permissive datetime is missing a timezone
    if (!/.*(([+-]\d\d:?\d\d)|[a-zA-Z])$/.test(dtStr)) {
        const date = new Date(dtStr + "Z");
        if (!isNaN(date.getTime())) {
            const tzStr = date.toISOString();
            if ((0, module.exports.isValidDatetime)(tzStr)) return tzStr;
        }
    }
    // finally try parsing as simple datetime
    const date = new Date(dtStr);
    if (isNaN(date.getTime())) throw new $8fa93f32b4709543$var$InvalidDatetimeError("datetime did not parse as any timestamp format");
    const isoStr = date.toISOString();
    if ((0, module.exports.isValidDatetime)(isoStr)) return isoStr;
    else throw new $8fa93f32b4709543$var$InvalidDatetimeError("datetime normalized to invalid timestamp string");
};
module.exports.normalizeDatetime = $8fa93f32b4709543$var$normalizeDatetime;
/* Variant of normalizeDatetime() which always returns a valid datetime strings.
 *
 * If a InvalidDatetimeError is encountered, returns the UNIX epoch time as a UTC datetime (1970-01-01T00:00:00.000Z).
 */ const $8fa93f32b4709543$var$normalizeDatetimeAlways = (dtStr)=>{
    try {
        return (0, module.exports.normalizeDatetime)(dtStr);
    } catch (err) {
        if (err instanceof $8fa93f32b4709543$var$InvalidDatetimeError) return new Date(0).toISOString();
        throw err;
    }
};
module.exports.normalizeDatetimeAlways = $8fa93f32b4709543$var$normalizeDatetimeAlways;
/* Indicates a datetime string did not pass full atproto Lexicon datetime string format checks.
 */ class $8fa93f32b4709543$var$InvalidDatetimeError extends Error {
}
module.exports.InvalidDatetimeError = $8fa93f32b4709543$var$InvalidDatetimeError;

});




parcelRegister("59fWx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FALLBACK_ALG = void 0;
/**
 * Per ATProto spec (OpenID uses RS256)
 */ module.exports.FALLBACK_ALG = "ES256";

});

parcelRegister("5QfU8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenRevokedError = void 0;
class $440e25566cb2860b$var$TokenRevokedError extends Error {
    constructor(sub, message = `The session for "${sub}" was successfully revoked`, options){
        super(message, options);
        Object.defineProperty(this, "sub", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: sub
        });
    }
}
module.exports.TokenRevokedError = $440e25566cb2860b$var$TokenRevokedError;

});

parcelRegister("fFwT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthProtectedResourceMetadataResolver = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $559MJ = parcelRequire("559MJ");

var $auA9I = parcelRequire("auA9I");

var $96UnS = parcelRequire("96UnS");
/**
 * @see {@link https://datatracker.ietf.org/doc/html/draft-ietf-oauth-resource-metadata-05}
 */ class $b6843221b3288950$var$OAuthProtectedResourceMetadataResolver extends $559MJ.CachedGetter {
    constructor(cache, fetch = globalThis.fetch){
        super(async (origin, options)=>this.fetchMetadata(origin, options), cache);
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.fetch = (0, $8oTqd.bindFetch)(fetch);
    }
    async get(resource, options) {
        const { protocol: protocol, origin: origin } = new URL(resource);
        if (protocol === "https:" || protocol === "http:" && $auA9I.ALLOW_UNSECURE_ORIGINS) return super.get(origin, options);
        throw new TypeError(`Forbidden resource sercure protocol "${protocol}"`);
    }
    async fetchMetadata(origin, options) {
        const headers = new Headers([
            [
                "accept",
                "application/json"
            ]
        ]);
        if (options?.noCache) headers.set("cache-control", "no-cache");
        const url = new URL(`/.well-known/oauth-protected-resource`, origin);
        const request = new Request(url, {
            signal: options?.signal,
            headers: headers,
            redirect: "manual"
        });
        const response = await this.fetch(request);
        // https://datatracker.ietf.org/doc/html/draft-ietf-oauth-resource-metadata-05#section-3.2
        if (response.status !== 200) {
            await (0, $8oTqd.cancelBody)(response, "log");
            throw await $8oTqd.FetchResponseError.from(response, `Unexpected status code ${response.status} for "${url}"`, undefined, {
                cause: request
            });
        }
        if ((0, $96UnS.contentMime)(response.headers) !== "application/json") {
            await (0, $8oTqd.cancelBody)(response, "log");
            throw await $8oTqd.FetchResponseError.from(response, `Unexpected content type for "${url}"`, undefined, {
                cause: request
            });
        }
        const metadata = $auA9I.oauthProtectedResourceMetadataSchema.parse(await response.json());
        // https://datatracker.ietf.org/doc/html/draft-ietf-oauth-resource-metadata-05#section-3.3
        if (metadata.resource !== origin) throw new TypeError(`Invalid issuer ${metadata.resource}`);
        return metadata;
    }
}
module.exports.OAuthProtectedResourceMetadataResolver = $b6843221b3288950$var$OAuthProtectedResourceMetadataResolver;

});

parcelRegister("b1J1b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthResolver = void 0;

var $auA9I = parcelRequire("auA9I");

var $90baw = parcelRequire("90baw");
class $8072b561bd459c16$var$OAuthResolver {
    constructor(identityResolver, protectedResourceMetadataResolver, authorizationServerMetadataResolver){
        Object.defineProperty(this, "identityResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: identityResolver
        });
        Object.defineProperty(this, "protectedResourceMetadataResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: protectedResourceMetadataResolver
        });
        Object.defineProperty(this, "authorizationServerMetadataResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: authorizationServerMetadataResolver
        });
    }
    /**
     * @param input - A handle, DID, PDS URL or Entryway URL
     */ async resolve(input, options) {
        // Allow using an entryway, or PDS url, directly as login input (e.g.
        // when the user forgot their handle, or when the handle does not
        // resolve to a DID)
        return /^https?:\/\//.test(input) ? this.resolveFromService(input, options) : this.resolveFromIdentity(input, options);
    }
    /**
     * @note this method can be used to verify if a particular uri supports OAuth
     * based sign-in (for compatibility with legacy implementation).
     */ async resolveFromService(input, options) {
        try {
            // Assume first that input is a PDS URL (as required by ATPROTO)
            const metadata = await this.getResourceServerMetadata(input, options);
            return {
                metadata: metadata
            };
        } catch (err) {
            if (!options?.signal?.aborted && err instanceof $90baw.OAuthResolverError) try {
                // Fallback to trying to fetch as an issuer (Entryway)
                const result = $auA9I.oauthIssuerIdentifierSchema.safeParse(input);
                if (result.success) {
                    const metadata = await this.getAuthorizationServerMetadata(result.data, options);
                    return {
                        metadata: metadata
                    };
                }
            } catch  {
            // Fallback failed, throw original error
            }
            throw err;
        }
    }
    async resolveFromIdentity(input, options) {
        const identity = await this.resolveIdentity(input, options);
        options?.signal?.throwIfAborted();
        const metadata = await this.getResourceServerMetadata(identity.pds, options);
        return {
            identity: identity,
            metadata: metadata
        };
    }
    async resolveIdentity(input, options) {
        try {
            return await this.identityResolver.resolve(input, options);
        } catch (cause) {
            throw $90baw.OAuthResolverError.from(cause, `Failed to resolve identity: ${input}`);
        }
    }
    async getAuthorizationServerMetadata(issuer, options) {
        try {
            return await this.authorizationServerMetadataResolver.get(issuer, options);
        } catch (cause) {
            throw $90baw.OAuthResolverError.from(cause, `Failed to resolve OAuth server metadata for issuer: ${issuer}`);
        }
    }
    async getResourceServerMetadata(pdsUrl, options) {
        try {
            const rsMetadata = await this.protectedResourceMetadataResolver.get(pdsUrl, options);
            // ATPROTO requires one, and only one, authorization server entry
            if (rsMetadata.authorization_servers?.length !== 1) throw new $90baw.OAuthResolverError(rsMetadata.authorization_servers?.length ? `Unable to determine authorization server for PDS: ${pdsUrl}` : `No authorization servers found for PDS: ${pdsUrl}`);
            const issuer = rsMetadata.authorization_servers[0];
            options?.signal?.throwIfAborted();
            const asMetadata = await this.getAuthorizationServerMetadata(issuer, options);
            // https://datatracker.ietf.org/doc/html/draft-ietf-oauth-resource-metadata-05#section-4
            if (asMetadata.protected_resources) {
                if (!asMetadata.protected_resources.includes(rsMetadata.resource)) throw new $90baw.OAuthResolverError(`PDS "${pdsUrl}" not protected by issuer "${issuer}"`);
            }
            return asMetadata;
        } catch (cause) {
            throw $90baw.OAuthResolverError.from(cause, `Failed to resolve OAuth server metadata for resource: ${pdsUrl}`);
        }
    }
}
module.exports.OAuthResolver = $8072b561bd459c16$var$OAuthResolver;

});
parcelRegister("90baw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthResolverError = void 0;
class $68dcc705cf1f2548$var$OAuthResolverError extends Error {
    constructor(message, options){
        super(message, options);
    }
    static from(cause, message) {
        if (cause instanceof $68dcc705cf1f2548$var$OAuthResolverError) return cause;
        return new $68dcc705cf1f2548$var$OAuthResolverError(message ?? `Unable to resolve identity`, {
            cause: cause
        });
    }
}
module.exports.OAuthResolverError = $68dcc705cf1f2548$var$OAuthResolverError;

});


parcelRegister("4H3QM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthServerFactory = void 0;

var $eXxXt = parcelRequire("eXxXt");
class $36ae2a2fbefa4567$var$OAuthServerFactory {
    constructor(clientMetadata, runtime, resolver, fetch, keyset, dpopNonceCache){
        Object.defineProperty(this, "clientMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: clientMetadata
        });
        Object.defineProperty(this, "runtime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: runtime
        });
        Object.defineProperty(this, "resolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: resolver
        });
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: fetch
        });
        Object.defineProperty(this, "keyset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: keyset
        });
        Object.defineProperty(this, "dpopNonceCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: dpopNonceCache
        });
    }
    async fromIssuer(issuer, dpopKey, options) {
        const serverMetadata = await this.resolver.getAuthorizationServerMetadata(issuer, options);
        return this.fromMetadata(serverMetadata, dpopKey);
    }
    async fromMetadata(serverMetadata, dpopKey) {
        return new $eXxXt.OAuthServerAgent(dpopKey, serverMetadata, this.clientMetadata, this.dpopNonceCache, this.resolver, this.runtime, this.keyset, this.fetch);
    }
}
module.exports.OAuthServerFactory = $36ae2a2fbefa4567$var$OAuthServerFactory;

});
parcelRegister("eXxXt", function(module, exports) {
"use strict";
var $ae40eacc1aa528fc$var$__addDisposableResource = module.exports && module.exports.__addDisposableResource || function(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
};
var $ae40eacc1aa528fc$var$__disposeResources = module.exports && module.exports.__disposeResources || function(SuppressedError1) {
    return function(env) {
        function fail(e) {
            env.error = env.hasError ? new SuppressedError1(e, env.error, "An error was suppressed during disposal.") : e;
            env.hasError = true;
        }
        function next() {
            while(env.stack.length){
                var rec = env.stack.pop();
                try {
                    var result = rec.dispose && rec.dispose.call(rec.value);
                    if (rec.async) return Promise.resolve(result).then(next, function(e) {
                        fail(e);
                        return next();
                    });
                } catch (e) {
                    fail(e);
                }
            }
            if (env.hasError) throw env.error;
        }
        return next();
    };
}(typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
});
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthServerAgent = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $auA9I = parcelRequire("auA9I");

var $59fWx = parcelRequire("59fWx");

var $gbHhk = parcelRequire("gbHhk");

var $9oKOU = parcelRequire("9oKOU");

var $3e91q = parcelRequire("3e91q");

var $96UnS = parcelRequire("96UnS");
class $ae40eacc1aa528fc$var$OAuthServerAgent {
    constructor(dpopKey, serverMetadata, clientMetadata, dpopNonces, oauthResolver, runtime, keyset, fetch){
        Object.defineProperty(this, "dpopKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: dpopKey
        });
        Object.defineProperty(this, "serverMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: serverMetadata
        });
        Object.defineProperty(this, "clientMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: clientMetadata
        });
        Object.defineProperty(this, "dpopNonces", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: dpopNonces
        });
        Object.defineProperty(this, "oauthResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: oauthResolver
        });
        Object.defineProperty(this, "runtime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: runtime
        });
        Object.defineProperty(this, "keyset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: keyset
        });
        Object.defineProperty(this, "dpopFetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.dpopFetch = (0, $9oKOU.dpopFetchWrapper)({
            fetch: (0, $8oTqd.bindFetch)(fetch),
            iss: clientMetadata.client_id,
            key: dpopKey,
            supportedAlgs: serverMetadata.dpop_signing_alg_values_supported,
            sha256: async (v)=>runtime.sha256(v),
            nonces: dpopNonces,
            isAuthServer: true
        });
    }
    async revoke(token) {
        try {
            await this.request("revocation", {
                token: token
            });
        } catch  {
        // Don't care
        }
    }
    async exchangeCode(code, verifier) {
        const tokenResponse = await this.request("token", {
            grant_type: "authorization_code",
            redirect_uri: this.clientMetadata.redirect_uris[0],
            code: code,
            code_verifier: verifier
        });
        try {
            return this.processTokenResponse(tokenResponse);
        } catch (err) {
            await this.revoke(tokenResponse.access_token);
            throw err;
        }
    }
    async refresh(tokenSet) {
        if (!tokenSet.refresh_token) throw new $gbHhk.TokenRefreshError(tokenSet.sub, "No refresh token available");
        const tokenResponse = await this.request("token", {
            grant_type: "refresh_token",
            refresh_token: tokenSet.refresh_token
        });
        try {
            if (tokenSet.sub !== tokenResponse.sub) throw new $gbHhk.TokenRefreshError(tokenSet.sub, `Unexpected "sub" in token response (${tokenResponse.sub})`);
            if (tokenSet.iss !== this.serverMetadata.issuer) throw new $gbHhk.TokenRefreshError(tokenSet.sub, "Issuer mismatch");
            return this.processTokenResponse(tokenResponse);
        } catch (err) {
            await this.revoke(tokenResponse.access_token);
            throw err;
        }
    }
    /**
     * VERY IMPORTANT ! Always call this to process token responses.
     *
     * Whenever an OAuth token response is received, we **MUST** verify that the
     * "sub" is a DID, whose issuer authority is indeed the server we just
     * obtained credentials from. This check is a critical step to actually be
     * able to use the "sub" (DID) as being the actual user's identifier.
     */ async processTokenResponse(tokenResponse) {
        const env_1 = {
            stack: [],
            error: void 0,
            hasError: false
        };
        try {
            const { sub: sub } = tokenResponse;
            if (!sub || typeof sub !== "string") throw new TypeError(`Unexpected ${typeof sub} "sub" in token response`);
            // Using an array to check for the presence of the "atproto" scope (we don't
            // want atproto to be a substring of another scope)
            const scopes = tokenResponse.scope?.split(" ");
            if (!scopes?.includes("atproto")) throw new TypeError('Missing "atproto" scope in token response');
            // @TODO (?) make timeout configurable
            const signal = $ae40eacc1aa528fc$var$__addDisposableResource(env_1, (0, $96UnS.timeoutSignal)(10e3), false);
            const resolved = await this.oauthResolver.resolveFromIdentity(sub, {
                signal: signal
            });
            if (this.serverMetadata.issuer !== resolved.metadata.issuer) // Best case scenario; the user switched PDS. Worst case scenario; a bad
            // actor is trying to impersonate a user. In any case, we must not allow
            // this token to be used.
            throw new TypeError("Issuer mismatch");
            return {
                aud: resolved.identity.pds.href,
                iss: resolved.metadata.issuer,
                sub: sub,
                scope: tokenResponse.scope,
                refresh_token: tokenResponse.refresh_token,
                access_token: tokenResponse.access_token,
                token_type: tokenResponse.token_type ?? "Bearer",
                expires_at: typeof tokenResponse.expires_in === "number" ? new Date(Date.now() + tokenResponse.expires_in * 1000).toISOString() : undefined
            };
        } catch (e_1) {
            env_1.error = e_1;
            env_1.hasError = true;
        } finally{
            $ae40eacc1aa528fc$var$__disposeResources(env_1);
        }
    }
    async request(endpoint, payload) {
        const url = this.serverMetadata[`${endpoint}_endpoint`];
        if (!url) throw new Error(`No ${endpoint} endpoint available`);
        const auth = await this.buildClientAuth(endpoint);
        const { response: response, json: json } = await this.dpopFetch(url, {
            method: "POST",
            headers: {
                ...auth.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                ...payload,
                ...auth.payload
            })
        }).then((0, $8oTqd.fetchJsonProcessor)());
        if (response.ok) switch(endpoint){
            case "token":
                return $auA9I.oauthTokenResponseSchema.parse(json);
            case "pushed_authorization_request":
                return $auA9I.oauthParResponseSchema.parse(json);
            default:
                return json;
        }
        else throw new $3e91q.OAuthResponseError(response, json);
    }
    async buildClientAuth(endpoint) {
        const methodSupported = this.serverMetadata[`token_endpoint_auth_methods_supported`];
        const method = this.clientMetadata[`token_endpoint_auth_method`];
        if (method === "private_key_jwt" || this.keyset && !method && (methodSupported?.includes("private_key_jwt") ?? false)) {
            if (!this.keyset) throw new Error("No keyset available");
            try {
                const alg = this.serverMetadata[`token_endpoint_auth_signing_alg_values_supported`] ?? $59fWx.FALLBACK_ALG;
                // If jwks is defined, make sure to only sign using a key that exists in
                // the jwks. If jwks_uri is defined, we can't be sure that the key we're
                // looking for is in there so we will just assume it is.
                const kid = this.clientMetadata.jwks?.keys.map(({ kid: kid })=>kid).filter((v)=>typeof v === "string");
                return {
                    payload: {
                        client_id: this.clientMetadata.client_id,
                        client_assertion_type: $auA9I.CLIENT_ASSERTION_TYPE_JWT_BEARER,
                        client_assertion: await this.keyset.createJwt({
                            alg: alg,
                            kid: kid
                        }, {
                            iss: this.clientMetadata.client_id,
                            sub: this.clientMetadata.client_id,
                            aud: this.serverMetadata.issuer,
                            jti: await this.runtime.generateNonce(),
                            iat: Math.floor(Date.now() / 1000)
                        })
                    }
                };
            } catch (err) {
                if (method === "private_key_jwt") throw err;
            // Else try next method
            }
        }
        if (method === "none" || !method && (methodSupported?.includes("none") ?? true)) return {
            payload: {
                client_id: this.clientMetadata.client_id
            }
        };
        throw new Error(`Unsupported ${endpoint} authentication method`);
    }
}
module.exports.OAuthServerAgent = $ae40eacc1aa528fc$var$OAuthServerAgent;

});
parcelRegister("gbHhk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenRefreshError = void 0;
class $bc8f3e9c231b56c2$var$TokenRefreshError extends Error {
    constructor(sub, message, options){
        super(message, options);
        Object.defineProperty(this, "sub", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: sub
        });
    }
}
module.exports.TokenRefreshError = $bc8f3e9c231b56c2$var$TokenRefreshError;

});

parcelRegister("9oKOU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dpopFetchWrapper = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $j3YM6 = parcelRequire("j3YM6");
// "undefined" in non https environments or environments without crypto
const $6d7aac6c3c01655b$var$subtle = globalThis.crypto?.subtle;
const $6d7aac6c3c01655b$var$ReadableStream = globalThis.ReadableStream;
function $6d7aac6c3c01655b$var$dpopFetchWrapper({ key: key, iss: iss, supportedAlgs: supportedAlgs, nonces: nonces, sha256: sha256 = typeof $6d7aac6c3c01655b$var$subtle !== "undefined" ? $6d7aac6c3c01655b$var$subtleSha256 : undefined, isAuthServer: isAuthServer, fetch: fetch = globalThis.fetch }) {
    if (!sha256) throw new TypeError(`crypto.subtle is not available in this environment. Please provide a sha256 function.`);
    const alg = $6d7aac6c3c01655b$var$negotiateAlg(key, supportedAlgs);
    return async function(input, init) {
        if (!key.algorithms.includes(alg)) throw new TypeError(`Key does not support the algorithm ${alg}`);
        const request = init == null && input instanceof Request ? input : new Request(input, init);
        const authorizationHeader = request.headers.get("Authorization");
        const ath = authorizationHeader?.startsWith("DPoP ") ? await sha256(authorizationHeader.slice(5)) : undefined;
        const { method: method, url: url } = request;
        const { origin: origin } = new URL(url);
        let initNonce;
        try {
            initNonce = await nonces.get(origin);
        } catch  {
        // Ignore get errors, we will just not send a nonce
        }
        const initProof = await $6d7aac6c3c01655b$var$buildProof(key, alg, iss, method, url, initNonce, ath);
        request.headers.set("DPoP", initProof);
        const initResponse = await fetch.call(this, request);
        // Make sure the response body is consumed. Either by the caller (when the
        // response is returned), of if an error is thrown (catch block).
        const nextNonce = initResponse.headers.get("DPoP-Nonce");
        if (!nextNonce || nextNonce === initNonce) // No nonce was returned or it is the same as the one we sent. No need to
        // update the nonce store, or retry the request.
        return initResponse;
        // Store the fresh nonce for future requests
        try {
            await nonces.set(origin, nextNonce);
        } catch  {
        // Ignore set errors
        }
        const shouldRetry = await $6d7aac6c3c01655b$var$isUseDpopNonceError(initResponse, isAuthServer);
        if (!shouldRetry) // Not a "use_dpop_nonce" error, so there is no need to retry
        return initResponse;
        // If the input stream was already consumed, we cannot retry the request. A
        // solution would be to clone() the request but that would bufferize the
        // entire stream in memory which can lead to memory starvation. Instead, we
        // will return the original response and let the calling code handle retries.
        if (input === request) // The input request body was consumed. We cannot retry the request.
        return initResponse;
        if ($6d7aac6c3c01655b$var$ReadableStream && init?.body instanceof $6d7aac6c3c01655b$var$ReadableStream) // The init body was consumed. We cannot retry the request.
        return initResponse;
        // We will now retry the request with the fresh nonce.
        // The initial response body must be consumed (see cancelBody's doc).
        await (0, $8oTqd.cancelBody)(initResponse, "log");
        const nextProof = await $6d7aac6c3c01655b$var$buildProof(key, alg, iss, method, url, nextNonce, ath);
        const nextRequest = new Request(input, init);
        nextRequest.headers.set("DPoP", nextProof);
        return fetch.call(this, nextRequest);
    };
}
module.exports.dpopFetchWrapper = $6d7aac6c3c01655b$var$dpopFetchWrapper;
async function $6d7aac6c3c01655b$var$buildProof(key, alg, iss, htm, htu, nonce, ath) {
    if (!key.bareJwk) throw new Error("Only asymmetric keys can be used as DPoP proofs");
    const now = Math.floor(Date.now() / 1e3);
    return key.createJwt(// https://datatracker.ietf.org/doc/html/rfc9449#section-4.2
    {
        alg: alg,
        typ: "dpop+jwt",
        jwk: key.bareJwk
    }, {
        iss: iss,
        iat: now,
        // Any collision will cause the request to be rejected by the server. no biggie.
        jti: Math.random().toString(36).slice(2),
        htm: htm,
        htu: htu,
        nonce: nonce,
        ath: ath
    });
}
async function $6d7aac6c3c01655b$var$isUseDpopNonceError(response, isAuthServer) {
    // https://datatracker.ietf.org/doc/html/rfc6750#section-3
    // https://datatracker.ietf.org/doc/html/rfc9449#name-resource-server-provided-no
    if (isAuthServer === undefined || isAuthServer === false) {
        if (response.status === 401) {
            const wwwAuth = response.headers.get("WWW-Authenticate");
            if (wwwAuth?.startsWith("DPoP")) return wwwAuth.includes('error="use_dpop_nonce"');
        }
    }
    // https://datatracker.ietf.org/doc/html/rfc9449#name-authorization-server-provid
    if (isAuthServer === undefined || isAuthServer === true) {
        if (response.status === 400) try {
            const json = await (0, $8oTqd.peekJson)(response, 10240);
            return typeof json === "object" && json?.["error"] === "use_dpop_nonce";
        } catch  {
            // Response too big (to be "use_dpop_nonce" error) or invalid JSON
            return false;
        }
    }
    return false;
}
function $6d7aac6c3c01655b$var$negotiateAlg(key, supportedAlgs) {
    if (supportedAlgs) {
        // Use order of supportedAlgs as preference
        const alg = supportedAlgs.find((a)=>key.algorithms.includes(a));
        if (alg) return alg;
    } else {
        const [alg] = key.algorithms;
        if (alg) return alg;
    }
    throw new Error("Key does not match any alg supported by the server");
}
async function $6d7aac6c3c01655b$var$subtleSha256(input) {
    if ($6d7aac6c3c01655b$var$subtle == null) throw new Error(`crypto.subtle is not available in this environment. Please provide a sha256 function.`);
    const bytes = new TextEncoder().encode(input);
    const digest = await $6d7aac6c3c01655b$var$subtle.digest("SHA-256", bytes);
    const digestBytes = new Uint8Array(digest);
    return $j3YM6.base64url.baseEncode(digestBytes);
}

});

parcelRegister("3e91q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthResponseError = void 0;

var $8oTqd = parcelRequire("8oTqd");
class $2599ad8042ef1054$var$OAuthResponseError extends Error {
    constructor(response, payload){
        const error = (0, $8oTqd.ifString)((0, $8oTqd.ifObject)(payload)?.["error"]);
        const errorDescription = (0, $8oTqd.ifString)((0, $8oTqd.ifObject)(payload)?.["error_description"]);
        const messageError = error ? `"${error}"` : "unknown";
        const messageDesc = errorDescription ? `: ${errorDescription}` : "";
        const message = `OAuth ${messageError} error${messageDesc}`;
        super(message);
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: response
        });
        Object.defineProperty(this, "payload", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: payload
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorDescription", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.error = error;
        this.errorDescription = errorDescription;
    }
    get status() {
        return this.response.status;
    }
    get headers() {
        return this.response.headers;
    }
}
module.exports.OAuthResponseError = $2599ad8042ef1054$var$OAuthResponseError;

});



parcelRegister("6aqH9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthSession = void 0;

var $hoXKl = parcelRequire("hoXKl");

var $8oTqd = parcelRequire("8oTqd");

var $5F6X2 = parcelRequire("5F6X2");

var $5QfU8 = parcelRequire("5QfU8");

var $9oKOU = parcelRequire("9oKOU");
const $47d8624fc3b88b76$var$ReadableStream = globalThis.ReadableStream;
class $47d8624fc3b88b76$var$OAuthSession {
    constructor(server, sub, sessionGetter, fetch = globalThis.fetch){
        Object.defineProperty(this, "server", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: server
        });
        Object.defineProperty(this, "sub", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: sub
        });
        Object.defineProperty(this, "sessionGetter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: sessionGetter
        });
        Object.defineProperty(this, "dpopFetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.dpopFetch = (0, $9oKOU.dpopFetchWrapper)({
            fetch: (0, $8oTqd.bindFetch)(fetch),
            iss: server.clientMetadata.client_id,
            key: server.dpopKey,
            supportedAlgs: server.serverMetadata.dpop_signing_alg_values_supported,
            sha256: async (v)=>server.runtime.sha256(v),
            nonces: server.dpopNonces,
            isAuthServer: false
        });
    }
    get did() {
        return (0, $hoXKl.asDid)(this.sub);
    }
    get serverMetadata() {
        return this.server.serverMetadata;
    }
    /**
     * @param refresh See {@link SessionGetter.getSession}
     */ async getTokenSet(refresh) {
        const { tokenSet: tokenSet } = await this.sessionGetter.getSession(this.sub, refresh);
        return tokenSet;
    }
    async getTokenInfo(refresh) {
        const tokenSet = await this.getTokenSet(refresh);
        const expiresAt = tokenSet.expires_at == null ? undefined : new Date(tokenSet.expires_at);
        return {
            expiresAt: expiresAt,
            get expired () {
                return expiresAt == null ? undefined : expiresAt.getTime() < Date.now() - 5e3;
            },
            scope: tokenSet.scope,
            iss: tokenSet.iss,
            aud: tokenSet.aud,
            sub: tokenSet.sub
        };
    }
    async signOut() {
        try {
            const { tokenSet: tokenSet } = await this.sessionGetter.getSession(this.sub, false);
            await this.server.revoke(tokenSet.access_token);
        } finally{
            await this.sessionGetter.delStored(this.sub, new $5QfU8.TokenRevokedError(this.sub));
        }
    }
    async fetchHandler(pathname, init) {
        // This will try and refresh the token if it is known to be expired
        const tokenSet = await this.getTokenSet(undefined);
        const initialUrl = new URL(pathname, tokenSet.aud);
        const initialAuth = `${tokenSet.token_type} ${tokenSet.access_token}`;
        const headers = new Headers(init?.headers);
        headers.set("Authorization", initialAuth);
        const initialResponse = await this.dpopFetch(initialUrl, {
            ...init,
            headers: headers
        });
        // If the token is not expired, we don't need to refresh it
        if (!$47d8624fc3b88b76$var$isInvalidTokenResponse(initialResponse)) return initialResponse;
        let tokenSetFresh;
        try {
            // Force a refresh
            tokenSetFresh = await this.getTokenSet(true);
        } catch (err) {
            return initialResponse;
        }
        // The stream was already consumed. We cannot retry the request. A solution
        // would be to tee() the input stream but that would bufferize the entire
        // stream in memory which can lead to memory starvation. Instead, we will
        // return the original response and let the calling code handle retries.
        if ($47d8624fc3b88b76$var$ReadableStream && init?.body instanceof $47d8624fc3b88b76$var$ReadableStream) return initialResponse;
        const finalAuth = `${tokenSetFresh.token_type} ${tokenSetFresh.access_token}`;
        const finalUrl = new URL(pathname, tokenSetFresh.aud);
        headers.set("Authorization", finalAuth);
        const finalResponse = await this.dpopFetch(finalUrl, {
            ...init,
            headers: headers
        });
        // The token was successfully refreshed, but is still not accepted by the
        // resource server. This might be due to the resource server not accepting
        // credentials from the authorization server (e.g. because some migration
        // occurred). Any ways, there is no point in keeping the session.
        if ($47d8624fc3b88b76$var$isInvalidTokenResponse(finalResponse)) // TODO: Is there a "softer" way to handle this, e.g. by marking the
        // session as "expired" in the session store, allowing the user to trigger
        // a new login (using login_hint)?
        await this.sessionGetter.delStored(this.sub, new $5F6X2.TokenInvalidError(this.sub));
        return finalResponse;
    }
}
module.exports.OAuthSession = $47d8624fc3b88b76$var$OAuthSession;
/**
 * @see {@link https://datatracker.ietf.org/doc/html/rfc6750#section-3}
 * @see {@link https://datatracker.ietf.org/doc/html/rfc9449#name-resource-server-provided-no}
 */ function $47d8624fc3b88b76$var$isInvalidTokenResponse(response) {
    if (response.status !== 401) return false;
    const wwwAuth = response.headers.get("WWW-Authenticate");
    return wwwAuth != null && (wwwAuth.startsWith("Bearer ") || wwwAuth.startsWith("DPoP ")) && wwwAuth.includes('error="invalid_token"');
}

});
parcelRegister("5F6X2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenInvalidError = void 0;
class $41f62c72fd3526dc$var$TokenInvalidError extends Error {
    constructor(sub, message = `The session for "${sub}" is invalid`, options){
        super(message, options);
        Object.defineProperty(this, "sub", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: sub
        });
    }
}
module.exports.TokenInvalidError = $41f62c72fd3526dc$var$TokenInvalidError;

});


parcelRegister("f60TT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Runtime = void 0;

var $j3YM6 = parcelRequire("j3YM6");

var $lvqTT = parcelRequire("lvqTT");
class $afd81d65222e188e$var$Runtime {
    constructor(implementation){
        Object.defineProperty(this, "implementation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: implementation
        });
        Object.defineProperty(this, "hasImplementationLock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "usingLock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const { requestLock: requestLock } = implementation;
        this.hasImplementationLock = requestLock != null;
        this.usingLock = requestLock?.bind(implementation) || // Falling back to a local lock
        $lvqTT.requestLocalLock;
    }
    async generateKey(algs) {
        const algsSorted = Array.from(algs).sort($afd81d65222e188e$var$compareAlgos);
        return this.implementation.createKey(algsSorted);
    }
    async sha256(text) {
        const bytes = new TextEncoder().encode(text);
        const digest = await this.implementation.digest(bytes, {
            name: "sha256"
        });
        return $j3YM6.base64url.baseEncode(digest);
    }
    async generateNonce(length = 16) {
        const bytes = await this.implementation.getRandomValues(length);
        return $j3YM6.base64url.baseEncode(bytes);
    }
    async generatePKCE(byteLength) {
        const verifier = await this.generateVerifier(byteLength);
        return {
            verifier: verifier,
            challenge: await this.sha256(verifier),
            method: "S256"
        };
    }
    async calculateJwkThumbprint(jwk) {
        const components = $afd81d65222e188e$var$extractJktComponents(jwk);
        const data = JSON.stringify(components);
        return this.sha256(data);
    }
    /**
     * @see {@link https://datatracker.ietf.org/doc/html/rfc7636#section-4.1}
     * @note It is RECOMMENDED that the output of a suitable random number generator
     * be used to create a 32-octet sequence. The octet sequence is then
     * base64url-encoded to produce a 43-octet URL safe string to use as the code
     * verifier.
     */ async generateVerifier(byteLength = 32) {
        if (byteLength < 32 || byteLength > 96) throw new TypeError("Invalid code_verifier length");
        const bytes = await this.implementation.getRandomValues(byteLength);
        return $j3YM6.base64url.baseEncode(bytes);
    }
}
module.exports.Runtime = $afd81d65222e188e$var$Runtime;
function $afd81d65222e188e$var$extractJktComponents(jwk) {
    const get = (field)=>{
        const value = jwk[field];
        if (typeof value !== "string" || !value) throw new TypeError(`"${field}" Parameter missing or invalid`);
        return value;
    };
    switch(jwk.kty){
        case "EC":
            return {
                crv: get("crv"),
                kty: get("kty"),
                x: get("x"),
                y: get("y")
            };
        case "OKP":
            return {
                crv: get("crv"),
                kty: get("kty"),
                x: get("x")
            };
        case "RSA":
            return {
                e: get("e"),
                kty: get("kty"),
                n: get("n")
            };
        case "oct":
            return {
                k: get("k"),
                kty: get("kty")
            };
        default:
            throw new TypeError('"kty" (Key Type) Parameter missing or unsupported');
    }
}
/**
 * 256K > ES (256 > 384 > 512) > PS (256 > 384 > 512) > RS (256 > 384 > 512) > other (in original order)
 */ function $afd81d65222e188e$var$compareAlgos(a, b) {
    if (a === "ES256K") return -1;
    if (b === "ES256K") return 1;
    for (const prefix of [
        "ES",
        "PS",
        "RS"
    ]){
        if (a.startsWith(prefix)) {
            if (b.startsWith(prefix)) {
                const aLen = parseInt(a.slice(2, 5));
                const bLen = parseInt(b.slice(2, 5));
                // Prefer shorter key lengths
                return aLen - bLen;
            }
            return -1;
        } else if (b.startsWith(prefix)) return 1;
    }
    // Don't know how to compare, keep original order
    return 0;
}

});
parcelRegister("lvqTT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.requestLocalLock = void 0;
const $fa815c16c44025ef$var$locks = new Map();
function $fa815c16c44025ef$var$acquireLocalLock(name) {
    return new Promise((resolveAcquire)=>{
        const prev = $fa815c16c44025ef$var$locks.get(name) ?? Promise.resolve();
        const next = prev.then(()=>{
            return new Promise((resolveRelease)=>{
                const release = ()=>{
                    // Only delete the lock if it is still the current one
                    if ($fa815c16c44025ef$var$locks.get(name) === next) $fa815c16c44025ef$var$locks.delete(name);
                    resolveRelease();
                };
                resolveAcquire(release);
            });
        });
        $fa815c16c44025ef$var$locks.set(name, next);
    });
}
const $fa815c16c44025ef$var$requestLocalLock = (name, fn)=>{
    return $fa815c16c44025ef$var$acquireLocalLock(name).then(async (release)=>{
        try {
            return await fn();
        } finally{
            release();
        }
    });
};
module.exports.requestLocalLock = $fa815c16c44025ef$var$requestLocalLock;

});


parcelRegister("5u6ZB", function(module, exports) {
"use strict";
var $3fe52db2d4c599e9$var$__addDisposableResource = module.exports && module.exports.__addDisposableResource || function(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
};
var $3fe52db2d4c599e9$var$__disposeResources = module.exports && module.exports.__disposeResources || function(SuppressedError1) {
    return function(env) {
        function fail(e) {
            env.error = env.hasError ? new SuppressedError1(e, env.error, "An error was suppressed during disposal.") : e;
            env.hasError = true;
        }
        function next() {
            while(env.stack.length){
                var rec = env.stack.pop();
                try {
                    var result = rec.dispose && rec.dispose.call(rec.value);
                    if (rec.async) return Promise.resolve(result).then(next, function(e) {
                        fail(e);
                        return next();
                    });
                } catch (e) {
                    fail(e);
                }
            }
            if (env.hasError) throw env.error;
        }
        return next();
    };
}(typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
});
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SessionGetter = void 0;

var $559MJ = parcelRequire("559MJ");

var $5F6X2 = parcelRequire("5F6X2");

var $gbHhk = parcelRequire("gbHhk");

var $5QfU8 = parcelRequire("5QfU8");

var $3e91q = parcelRequire("3e91q");

var $96UnS = parcelRequire("96UnS");
/**
 * There are several advantages to wrapping the sessionStore in a (single)
 * CachedGetter, the main of which is that the cached getter will ensure that at
 * most one fresh call is ever being made. Another advantage, is that it
 * contains the logic for reading from the cache which, if the cache is based on
 * localStorage/indexedDB, will sync across multiple tabs (for a given sub).
 */ class $3fe52db2d4c599e9$var$SessionGetter extends $559MJ.CachedGetter {
    constructor(sessionStore, serverFactory, runtime){
        super(async (sub, options, storedSession)=>{
            // There needs to be a previous session to be able to refresh. If
            // storedSession is undefined, it means that the store does not contain
            // a session for the given sub.
            if (storedSession === undefined) {
                // Because the session is not in the store, this.delStored() method
                // will not be called by the CachedGetter class (because there is
                // nothing to delete). This would typically happen if there is no
                // synchronization mechanism between instances of this class. Let's
                // make sure an event is dispatched here if this occurs.
                const msg = "The session was deleted by another process";
                const cause = new $gbHhk.TokenRefreshError(sub, msg);
                this.dispatchEvent("deleted", {
                    sub: sub,
                    cause: cause
                });
                throw cause;
            }
            // From this point forward, throwing a TokenRefreshError will result in
            // this.delStored() being called, resulting in an event being
            // dispatched, even if the session was removed from the store through a
            // concurrent access (which, normally, should not happen if a proper
            // runtime lock was provided).
            if (sub !== storedSession.tokenSet.sub) // Fool-proofing (e.g. against invalid session storage)
            throw new $gbHhk.TokenRefreshError(sub, "Stored session sub mismatch");
            // Since refresh tokens can only be used once, we might run into
            // concurrency issues if multiple tabs/instances are trying to refresh
            // the same token. The chances of this happening when multiple instances
            // are started simultaneously is reduced by randomizing the expiry time
            // (see isStale() below). Even so, There still exist chances that
            // multiple tabs will try to refresh the token at the same time. The
            // best solution would be to use a mutex/lock to ensure that only one
            // instance is refreshing the token at a time. A simpler workaround is
            // to check if the value stored in the session store is the same as the
            // one in memory. If it isn't, then another instance has already
            // refreshed the token.
            const { tokenSet: tokenSet, dpopKey: dpopKey } = storedSession;
            const server = await serverFactory.fromIssuer(tokenSet.iss, dpopKey);
            // Because refresh tokens can only be used once, we must not use the
            // "signal" to abort the refresh, or throw any abort error beyond this
            // point. Any thrown error beyond this point will prevent the
            // SessionGetter from obtaining, and storing, the new token set,
            // effectively rendering the currently saved session unusable.
            options?.signal?.throwIfAborted();
            try {
                const newTokenSet = await server.refresh(tokenSet);
                if (sub !== newTokenSet.sub) // The server returned another sub. Was the tokenSet manipulated?
                throw new $gbHhk.TokenRefreshError(sub, "Token set sub mismatch");
                return {
                    dpopKey: dpopKey,
                    tokenSet: newTokenSet
                };
            } catch (cause) {
                // If the refresh token is invalid, let's try to recover from
                // concurrency issues, or make sure the session is deleted by throwing
                // a TokenRefreshError.
                if (cause instanceof $3e91q.OAuthResponseError && cause.status === 400 && cause.error === "invalid_grant") {
                    // In case there is no lock implementation in the runtime, we will
                    // wait for a short time to give the other concurrent instances a
                    // chance to finish their refreshing of the token. If a concurrent
                    // refresh did occur, we will pretend that this one succeeded.
                    if (!runtime.hasImplementationLock) {
                        await new Promise((r)=>setTimeout(r, 1000));
                        const stored = await this.getStored(sub);
                        if (stored === undefined) {
                            // A concurrent refresh occurred and caused the session to be
                            // deleted (for a reason we can't know at this point).
                            // Using a distinct error message mainly for debugging
                            // purposes. Also, throwing a TokenRefreshError to trigger
                            // deletion through the deleteOnError callback.
                            const msg = "The session was deleted by another process";
                            throw new $gbHhk.TokenRefreshError(sub, msg, {
                                cause: cause
                            });
                        } else if (stored.tokenSet.access_token !== tokenSet.access_token || stored.tokenSet.refresh_token !== tokenSet.refresh_token) // A concurrent refresh occurred. Pretend this one succeeded.
                        return {
                            dpopKey: dpopKey,
                            tokenSet: stored.tokenSet
                        };
                    }
                    // Make sure the session gets deleted from the store
                    const msg = cause.errorDescription ?? "The session was revoked";
                    throw new $gbHhk.TokenRefreshError(sub, msg, {
                        cause: cause
                    });
                }
                throw cause;
            }
        }, sessionStore, {
            isStale: (sub, { tokenSet: tokenSet })=>{
                return tokenSet.expires_at != null && new Date(tokenSet.expires_at).getTime() < // Add some lee way to ensure the token is not expired when it
                // reaches the server.
                Date.now() + 60e3;
            },
            onStoreError: async (err, sub, { tokenSet: tokenSet, dpopKey: dpopKey })=>{
                // If the token data cannot be stored, let's revoke it
                const server = await serverFactory.fromIssuer(tokenSet.iss, dpopKey);
                await server.revoke(tokenSet.refresh_token ?? tokenSet.access_token);
                throw err;
            },
            deleteOnError: async (err)=>// Optimization: More likely to happen first
                err instanceof $gbHhk.TokenRefreshError || err instanceof $5QfU8.TokenRevokedError || err instanceof $5F6X2.TokenInvalidError
        });
        Object.defineProperty(this, "runtime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: runtime
        });
        Object.defineProperty(this, "eventTarget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new $96UnS.CustomEventTarget()
        });
    }
    addEventListener(type, callback, options) {
        this.eventTarget.addEventListener(type, callback, options);
    }
    removeEventListener(type, callback, options) {
        this.eventTarget.removeEventListener(type, callback, options);
    }
    dispatchEvent(type, detail) {
        return this.eventTarget.dispatchCustomEvent(type, detail);
    }
    async setStored(sub, session) {
        await super.setStored(sub, session);
        this.dispatchEvent("updated", {
            sub: sub,
            ...session
        });
    }
    async delStored(sub, cause) {
        await super.delStored(sub, cause);
        this.dispatchEvent("deleted", {
            sub: sub,
            cause: cause
        });
    }
    /**
     * @param refresh When `true`, the credentials will be refreshed even if they
     * are not expired. When `false`, the credentials will not be refreshed even
     * if they are expired. When `undefined`, the credentials will be refreshed
     * if, and only if, they are (about to be) expired. Defaults to `undefined`.
     */ async getSession(sub, refresh) {
        const session = await this.get(sub, {
            noCache: refresh === true,
            allowStale: refresh === false
        });
        if (sub !== session.tokenSet.sub) // Fool-proofing (e.g. against invalid session storage)
        throw new Error("Token set does not match the expected sub");
        return session;
    }
    async get(sub, options) {
        return this.runtime.usingLock(`@atproto-oauth-client-${sub}`, async ()=>{
            const env_1 = {
                stack: [],
                error: void 0,
                hasError: false
            };
            try {
                // Make sure, even if there is no signal in the options, that the request
                // will be cancelled after at most 30 seconds.
                const signal = $3fe52db2d4c599e9$var$__addDisposableResource(env_1, (0, $96UnS.timeoutSignal)(30e3, options), false);
                return await super.get(sub, {
                    ...options,
                    signal: signal
                });
            } catch (e_1) {
                env_1.error = e_1;
                env_1.hasError = true;
            } finally{
                $3fe52db2d4c599e9$var$__disposeResources(env_1);
            }
        });
    }
}
module.exports.SessionGetter = $3fe52db2d4c599e9$var$SessionGetter;

});

parcelRegister("5cQ7D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateClientMetadata = void 0;

var $fr8VS = parcelRequire("fr8VS");
const $3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_METHOD = `token_endpoint_auth_method`;
const $3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_SIGNING_ALG = `token_endpoint_auth_signing_alg`;
function $3ca6811f8b134d00$var$validateClientMetadata(input, keyset) {
    if (input.jwks) {
        if (!keyset) throw new TypeError(`Keyset must not be provided when jwks is provided`);
        for (const key of input.jwks.keys){
            if (!key.kid) throw new TypeError(`Key must have a "kid" property`);
            else if (!keyset.has(key.kid)) throw new TypeError(`Key with kid "${key.kid}" not found in keyset`);
        }
    }
    // Allow to pass a keyset and omit the jwks/jwks_uri properties
    if (!input.jwks && !input.jwks_uri && keyset?.size) input = {
        ...input,
        jwks: keyset.toJSON()
    };
    const metadata = $fr8VS.clientMetadataSchema.parse(input);
    // ATPROTO uses client metadata discovery
    try {
        new URL(metadata.client_id);
    } catch (cause) {
        throw new TypeError(`client_id must be a valid URL`, {
            cause: cause
        });
    }
    const method = metadata[$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_METHOD];
    switch(method){
        case undefined:
            throw new TypeError(`${$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_METHOD} must be provided`);
        case "none":
            if (metadata[$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_SIGNING_ALG]) throw new TypeError(`${$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_SIGNING_ALG} must not be provided when ${$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_METHOD} is "${method}"`);
            break;
        case "private_key_jwt":
            if (!keyset?.size) throw new TypeError(`A non-empty keyset must be provided when ${$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_METHOD} is "${method}"`);
            if (!metadata[$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_SIGNING_ALG]) throw new TypeError(`${$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_SIGNING_ALG} must be provided when ${$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_METHOD} is "${method}"`);
            break;
        default:
            throw new TypeError(`Invalid "token_endpoint_auth_method" value: ${method}`);
    }
    return metadata;
}
module.exports.validateClientMetadata = $3ca6811f8b134d00$var$validateClientMetadata;

});
parcelRegister("fr8VS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clientMetadataSchema = void 0;

var $auA9I = parcelRequire("auA9I");
module.exports.clientMetadataSchema = $auA9I.oauthClientMetadataSchema.extend({
    client_id: $auA9I.oauthClientIdSchema.url()
});

});



parcelRegister("8vaR3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lfiD0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("7JhZC", function(module, exports) {
"use strict";
var $5a0ab15eeffedffa$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserOAuthClient = void 0;

var $cNZAj = parcelRequire("cNZAj");

var $auA9I = parcelRequire("auA9I");

var $l4NzH = parcelRequire("l4NzH");

var $20NiT = parcelRequire("20NiT");

var $51ST3 = parcelRequire("51ST3");

var $4B1hY = parcelRequire("4B1hY");
const $5a0ab15eeffedffa$var$NAMESPACE = `@@atproto/oauth-client-browser`;
//- Popup channel
const $5a0ab15eeffedffa$var$POPUP_CHANNEL_NAME = `${$5a0ab15eeffedffa$var$NAMESPACE}(popup-channel)`;
const $5a0ab15eeffedffa$var$POPUP_STATE_PREFIX = `${$5a0ab15eeffedffa$var$NAMESPACE}(popup-state):`;
const $5a0ab15eeffedffa$var$syncChannel = new BroadcastChannel(`${$5a0ab15eeffedffa$var$NAMESPACE}(synchronization-channel)`);
class $5a0ab15eeffedffa$var$BrowserOAuthClient extends $cNZAj.OAuthClient {
    static async load({ clientId: clientId, ...options }) {
        if ((0, $auA9I.isOAuthClientIdLoopback)(clientId)) {
            const clientMetadata = (0, $auA9I.atprotoLoopbackClientMetadata)(clientId);
            return new $5a0ab15eeffedffa$var$BrowserOAuthClient({
                clientMetadata: clientMetadata,
                ...options
            });
        } else if ((0, $auA9I.isOAuthClientIdDiscoverable)(clientId)) {
            const clientMetadata = await $cNZAj.OAuthClient.fetchMetadata({
                clientId: clientId,
                ...options
            });
            return new $5a0ab15eeffedffa$var$BrowserOAuthClient({
                clientMetadata: clientMetadata,
                ...options
            });
        } else throw new TypeError(`Invalid client id: ${clientId}`);
    }
    constructor({ handleResolver: handleResolver, clientMetadata: clientMetadata = (0, $auA9I.atprotoLoopbackClientMetadata)((0, $4B1hY.buildLoopbackClientId)(window.location)), responseMode: // "fragment" is a safer default as the query params will not be sent to the server
    responseMode = "fragment", plcDirectoryUrl: plcDirectoryUrl, fetch: fetch }){
        if (!globalThis.crypto?.subtle) throw new Error("WebCrypto API is required");
        if (![
            "query",
            "fragment"
        ].includes(responseMode)) // Make sure "form_post" is not used as it is not supported in the browser
        throw new TypeError(`Invalid response mode: ${responseMode}`);
        const database = new $l4NzH.BrowserOAuthDatabase();
        super({
            clientMetadata: clientMetadata,
            responseMode: responseMode,
            fetch: fetch,
            plcDirectoryUrl: plcDirectoryUrl,
            handleResolver: handleResolver,
            runtimeImplementation: new $20NiT.BrowserRuntimeImplementation(),
            sessionStore: database.getSessionStore(),
            stateStore: database.getStateStore(),
            didCache: database.getDidCache(),
            handleCache: database.getHandleCache(),
            dpopNonceCache: database.getDpopNonceCache(),
            authorizationServerMetadataCache: database.getAuthorizationServerMetadataCache(),
            protectedResourceMetadataCache: database.getProtectedResourceMetadataCache()
        });
        Object.defineProperty(this, $5a0ab15eeffedffa$var$_a, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // TODO: replace with AsyncDisposableStack once they are standardized
        const ac = new AbortController();
        const { signal: signal } = ac;
        this[Symbol.dispose] = ()=>ac.abort();
        signal.addEventListener("abort", ()=>database[Symbol.asyncDispose](), {
            once: true
        });
        // Keep track of the current session
        this.addEventListener("deleted", ({ detail: { sub: sub } })=>{
            if (localStorage.getItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`) === sub) localStorage.removeItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`);
        });
        // Session synchronization across tabs
        for (const type of [
            "deleted",
            "updated"
        ])this.sessionGetter.addEventListener(type, ({ detail: detail })=>{
            // Notify other tabs when a session is deleted or updated
            $5a0ab15eeffedffa$var$syncChannel.postMessage([
                type,
                detail
            ]);
        });
        $5a0ab15eeffedffa$var$syncChannel.addEventListener("message", (event)=>{
            if (event.source !== window) {
                // Trigger listeners when an event is received from another tab
                const [type, detail] = event.data;
                this.dispatchCustomEvent(type, detail);
            }
        }, // Remove the listener when the client is disposed
        {
            signal: signal
        });
    }
    async init(refresh) {
        await $5a0ab15eeffedffa$var$fixLocation(this.clientMetadata);
        const signInResult = await this.signInCallback();
        if (signInResult) {
            localStorage.setItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`, signInResult.session.sub);
            return signInResult;
        }
        const sub = localStorage.getItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`);
        if (sub) try {
            const session = await this.restore(sub, refresh);
            return {
                session: session
            };
        } catch (err) {
            localStorage.removeItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`);
            throw err;
        }
    }
    async restore(sub, refresh) {
        const session = await super.restore(sub, refresh);
        localStorage.setItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`, session.sub);
        return session;
    }
    async revoke(sub) {
        localStorage.removeItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`);
        return super.revoke(sub);
    }
    async signIn(input, options) {
        if (options?.display === "popup") return this.signInPopup(input, options);
        else return this.signInRedirect(input, options);
    }
    async signInRedirect(input, options) {
        const url = await this.authorize(input, options);
        window.location.href = url.href;
        // back-forward cache
        return new Promise((resolve, reject)=>{
            setTimeout((err)=>{
                // Take the opportunity to proactively cancel the pending request
                this.abortRequest(url).then(()=>reject(err), (reason)=>reject(new AggregateError([
                        err,
                        reason
                    ])));
            }, 5e3, new Error("User navigated back"));
        });
    }
    async signInPopup(input, options) {
        // Open new window asap to prevent popup busting by browsers
        const popupFeatures = "width=600,height=600,menubar=no,toolbar=no";
        let popup = window.open("about:blank", "_blank", popupFeatures);
        const stateKey = `${Math.random().toString(36).slice(2)}`;
        const url = await this.authorize(input, {
            ...options,
            state: `${$5a0ab15eeffedffa$var$POPUP_STATE_PREFIX}${stateKey}`,
            display: options?.display ?? "popup"
        });
        options?.signal?.throwIfAborted();
        if (popup) popup.window.location.href = url.href;
        else popup = window.open(url.href, "_blank", popupFeatures);
        popup?.focus();
        return new Promise((resolve, reject)=>{
            const popupChannel = new BroadcastChannel($5a0ab15eeffedffa$var$POPUP_CHANNEL_NAME);
            const cleanup = ()=>{
                clearTimeout(timeout);
                popupChannel.removeEventListener("message", onMessage);
                popupChannel.close();
                options?.signal?.removeEventListener("abort", cancel);
                popup?.close();
            };
            const cancel = ()=>{
                // @TODO: Store fact that the request was cancelled, allowing any
                // callback (e.g. in the popup) to revoke the session or credentials.
                reject(new Error(options?.signal?.aborted ? "Aborted" : "Timeout"));
                cleanup();
            };
            options?.signal?.addEventListener("abort", cancel);
            const timeout = setTimeout(cancel, 300000);
            const onMessage = async ({ data: data })=>{
                if (data.key !== stateKey) return;
                if (!("result" in data)) return;
                // Send acknowledgment to popup window
                popupChannel.postMessage({
                    key: stateKey,
                    ack: true
                });
                cleanup();
                const { result: result } = data;
                if (result.status === "fulfilled") {
                    const sub = result.value;
                    try {
                        options?.signal?.throwIfAborted();
                        resolve(await this.restore(sub, false));
                    } catch (err) {
                        reject(err);
                        this.revoke(sub);
                    }
                } else {
                    const { message: message, params: params } = result.reason;
                    reject(new $cNZAj.OAuthCallbackError(new URLSearchParams(params), message));
                }
            };
            popupChannel.addEventListener("message", onMessage);
        });
    }
    readCallbackParams() {
        const params = this.responseMode === "fragment" ? new URLSearchParams(location.hash.slice(1)) : new URLSearchParams(location.search);
        // Only if the current URL contains a valid oauth response params
        if (!params.has("state") || !(params.has("code") || params.has("error"))) return null;
        const matchesLocation = (url)=>location.origin === url.origin && location.pathname === url.pathname;
        const redirectUrls = this.clientMetadata.redirect_uris.map((uri)=>new URL(uri));
        // Only if the current URL is one of the redirect_uris
        if (!redirectUrls.some(matchesLocation)) return null;
        return params;
    }
    async signInCallback() {
        const params = this.readCallbackParams();
        // Not a (valid) OAuth redirect
        if (!params) return null;
        // Replace the current history entry without the params (this will prevent
        // the following code to run again if the user refreshes the page)
        history.replaceState(null, "", location.pathname);
        // Utility function to send the result of the popup to the parent window
        const sendPopupResult = (message)=>{
            const popupChannel = new BroadcastChannel($5a0ab15eeffedffa$var$POPUP_CHANNEL_NAME);
            return new Promise((resolve)=>{
                const cleanup = (result)=>{
                    clearTimeout(timer);
                    popupChannel.removeEventListener("message", onMessage);
                    popupChannel.close();
                    resolve(result);
                };
                const onMessage = ({ data: data })=>{
                    if ("ack" in data && message.key === data.key) cleanup(true);
                };
                popupChannel.addEventListener("message", onMessage);
                popupChannel.postMessage(message);
                // Receiving of "ack" should be very fast, giving it 500 ms anyway
                const timer = setTimeout(cleanup, 500, false);
            });
        };
        return this.callback(params).then(async (result)=>{
            if (result.state?.startsWith($5a0ab15eeffedffa$var$POPUP_STATE_PREFIX)) {
                const receivedByParent = await sendPopupResult({
                    key: result.state.slice($5a0ab15eeffedffa$var$POPUP_STATE_PREFIX.length),
                    result: {
                        status: "fulfilled",
                        value: result.session.sub
                    }
                });
                // Revoke the credentials if the parent window was closed
                if (!receivedByParent) await result.session.signOut();
                throw new $51ST3.LoginContinuedInParentWindowError(); // signInPopup
            }
            return result;
        }).catch(async (err)=>{
            if (err instanceof $cNZAj.OAuthCallbackError && err.state?.startsWith($5a0ab15eeffedffa$var$POPUP_STATE_PREFIX)) {
                await sendPopupResult({
                    key: err.state.slice($5a0ab15eeffedffa$var$POPUP_STATE_PREFIX.length),
                    result: {
                        status: "rejected",
                        reason: {
                            message: err.message,
                            params: Array.from(err.params.entries())
                        }
                    }
                });
                throw new $51ST3.LoginContinuedInParentWindowError(); // signInPopup
            }
            // Most probable cause at this point is that the "state" parameter is
            // invalid.
            throw err;
        }).catch((err)=>{
            if (err instanceof $51ST3.LoginContinuedInParentWindowError) // parent will also try to close the popup
            window.close();
            throw err;
        });
    }
    dispose() {
        this[Symbol.dispose]();
    }
}
module.exports.BrowserOAuthClient = $5a0ab15eeffedffa$var$BrowserOAuthClient;
$5a0ab15eeffedffa$var$_a = Symbol.dispose;
/**
 * Since "localhost" is often used either in IP mode or in hostname mode,
 * and because the redirect uris must use the IP mode, we need to make sure
 * that the current location url is not using "localhost".
 *
 * This is required for the IndexedDB to work properly. Indeed, the IndexedDB
 * is shared by origin, so we must ensure to be on the same origin as the
 * redirect uris.
 */ function $5a0ab15eeffedffa$var$fixLocation(clientMetadata) {
    if (!(0, $auA9I.isOAuthClientIdLoopback)(clientMetadata.client_id)) return;
    if (window.location.hostname !== "localhost") return;
    const locationUrl = new URL(window.location.href);
    for (const uri of clientMetadata.redirect_uris){
        const url = new URL(uri);
        if ((url.hostname === "127.0.0.1" || url.hostname === "[::1]") && (!url.port || url.port === locationUrl.port) && url.protocol === locationUrl.protocol && url.pathname === locationUrl.pathname) {
            url.port = locationUrl.port;
            window.location.href = url.href;
            // Prevent init() on the wrong origin
            throw new Error("Redirecting to loopback IP...");
        }
    }
    throw new Error(`Please use the loopback IP address instead of ${locationUrl}`);
}

});
parcelRegister("l4NzH", function(module, exports) {
"use strict";
var $f5806d3d78b686b9$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $f5806d3d78b686b9$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_cleanupInterval;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserOAuthDatabase = void 0;

var $h3MMF = parcelRequire("h3MMF");

var $kZIXW = parcelRequire("kZIXW");
function $f5806d3d78b686b9$var$encodeKey(key) {
    if (!(key instanceof $h3MMF.WebcryptoKey) || !key.kid) throw new Error("Invalid key object");
    return {
        keyId: key.kid,
        keyPair: key.cryptoKeyPair
    };
}
async function $f5806d3d78b686b9$var$decodeKey(encoded) {
    return $h3MMF.WebcryptoKey.fromKeypair(encoded.keyPair, encoded.keyId);
}
const $f5806d3d78b686b9$var$STORES = [
    "state",
    "session",
    "didCache",
    "dpopNonceCache",
    "handleCache",
    "authorizationServerMetadataCache",
    "protectedResourceMetadataCache"
];
class $f5806d3d78b686b9$var$BrowserOAuthDatabase {
    constructor(options){
        $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise.set(this, void 0);
        $f5806d3d78b686b9$var$_BrowserOAuthDatabase_cleanupInterval.set(this, void 0);
        $f5806d3d78b686b9$var$__classPrivateFieldSet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, $kZIXW.DB.open(options?.name ?? "@atproto-oauth-client", [
            (db)=>{
                for (const name of $f5806d3d78b686b9$var$STORES){
                    const store = db.createObjectStore(name, {
                        autoIncrement: true
                    });
                    store.createIndex("expiresAt", "expiresAt", {
                        unique: false
                    });
                }
            }
        ], {
            durability: options?.durability ?? "strict"
        }), "f");
        $f5806d3d78b686b9$var$__classPrivateFieldSet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_cleanupInterval, setInterval(()=>{
            this.cleanup();
        }, options?.cleanupInterval ?? 30e3), "f");
    }
    async run(storeName, mode, fn) {
        const db = await $f5806d3d78b686b9$var$__classPrivateFieldGet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, "f");
        return await db.transaction([
            storeName
        ], mode, (tx)=>fn(tx.objectStore(storeName)));
    }
    createStore(name, { encode: encode, decode: decode, expiresAt: expiresAt }) {
        return {
            get: async (key)=>{
                // Find item in store
                const item = await this.run(name, "readonly", (store)=>store.get(key));
                // Not found
                if (item === undefined) return undefined;
                // Too old (delete)
                if (item.expiresAt != null && new Date(item.expiresAt) < new Date()) {
                    await this.run(name, "readwrite", (store)=>store.delete(key));
                    return undefined;
                }
                // Item found and valid. Decode
                return decode(item.value);
            },
            set: async (key, value)=>{
                // Create encoded item record
                const item = {
                    value: await encode(value),
                    expiresAt: expiresAt(value)?.toISOString()
                };
                // Store item record
                await this.run(name, "readwrite", (store)=>store.put(item, key));
            },
            del: async (key)=>{
                // Delete
                await this.run(name, "readwrite", (store)=>store.delete(key));
            }
        };
    }
    getSessionStore() {
        return this.createStore("session", {
            expiresAt: ({ tokenSet: tokenSet })=>tokenSet.refresh_token || tokenSet.expires_at == null ? null : new Date(tokenSet.expires_at),
            encode: ({ dpopKey: dpopKey, ...session })=>({
                    ...session,
                    dpopKey: $f5806d3d78b686b9$var$encodeKey(dpopKey)
                }),
            decode: async ({ dpopKey: dpopKey, ...encoded })=>({
                    ...encoded,
                    dpopKey: await $f5806d3d78b686b9$var$decodeKey(dpopKey)
                })
        });
    }
    getStateStore() {
        return this.createStore("state", {
            expiresAt: (_value)=>new Date(Date.now() + 600000),
            encode: ({ dpopKey: dpopKey, ...session })=>({
                    ...session,
                    dpopKey: $f5806d3d78b686b9$var$encodeKey(dpopKey)
                }),
            decode: async ({ dpopKey: dpopKey, ...encoded })=>({
                    ...encoded,
                    dpopKey: await $f5806d3d78b686b9$var$decodeKey(dpopKey)
                })
        });
    }
    getDpopNonceCache() {
        return this.createStore("dpopNonceCache", {
            expiresAt: (_value)=>new Date(Date.now() + 600e3),
            encode: (value)=>value,
            decode: (encoded)=>encoded
        });
    }
    getDidCache() {
        return this.createStore("didCache", {
            expiresAt: (_value)=>new Date(Date.now() + 60e3),
            encode: (value)=>value,
            decode: (encoded)=>encoded
        });
    }
    getHandleCache() {
        return this.createStore("handleCache", {
            expiresAt: (_value)=>new Date(Date.now() + 60e3),
            encode: (value)=>value,
            decode: (encoded)=>encoded
        });
    }
    getAuthorizationServerMetadataCache() {
        return this.createStore("authorizationServerMetadataCache", {
            expiresAt: (_value)=>new Date(Date.now() + 60e3),
            encode: (value)=>value,
            decode: (encoded)=>encoded
        });
    }
    getProtectedResourceMetadataCache() {
        return this.createStore("protectedResourceMetadataCache", {
            expiresAt: (_value)=>new Date(Date.now() + 60e3),
            encode: (value)=>value,
            decode: (encoded)=>encoded
        });
    }
    async cleanup() {
        const db = await $f5806d3d78b686b9$var$__classPrivateFieldGet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, "f");
        for (const name of $f5806d3d78b686b9$var$STORES)await db.transaction([
            name
        ], "readwrite", (tx)=>tx.objectStore(name).index("expiresAt").deleteAll(IDBKeyRange.upperBound(Date.now())));
    }
    async [($f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise = new WeakMap(), $f5806d3d78b686b9$var$_BrowserOAuthDatabase_cleanupInterval = new WeakMap(), Symbol.asyncDispose)]() {
        clearInterval($f5806d3d78b686b9$var$__classPrivateFieldGet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_cleanupInterval, "f"));
        $f5806d3d78b686b9$var$__classPrivateFieldSet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_cleanupInterval, undefined, "f");
        const dbPromise = $f5806d3d78b686b9$var$__classPrivateFieldGet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, "f");
        $f5806d3d78b686b9$var$__classPrivateFieldSet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, Promise.reject(new Error("Database has been disposed")), "f");
        // Avoid "unhandled promise rejection"
        $f5806d3d78b686b9$var$__classPrivateFieldGet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, "f").catch(()=>null);
        // Spec recommends not to throw errors in dispose
        const db = await dbPromise.catch(()=>null);
        if (db) await (db[Symbol.asyncDispose] || db[Symbol.dispose]).call(db);
    }
}
module.exports.BrowserOAuthDatabase = $f5806d3d78b686b9$var$BrowserOAuthDatabase;

});
parcelRegister("kZIXW", function(module, exports) {
"use strict";
var $f48c62705f0c0a58$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f48c62705f0c0a58$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f48c62705f0c0a58$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
parcelRequire("6AwK3");

$f48c62705f0c0a58$var$__exportStar((parcelRequire("bnJpA")), module.exports);

$f48c62705f0c0a58$var$__exportStar((parcelRequire("bLaWA")), module.exports);

$f48c62705f0c0a58$var$__exportStar((parcelRequire("6u4mF")), module.exports);

$f48c62705f0c0a58$var$__exportStar((parcelRequire("95IS0")), module.exports);

});
parcelRegister("6AwK3", function(module, exports) {
"use strict";
// Code compiled with tsc supports "using" and "await using" syntax. This
// features is supported by downleveling the code to ES2017. The downleveling
// relies on `Symbol.dispose` and `Symbol.asyncDispose` symbols. These symbols
// might not be available in all environments. This package provides a polyfill
// for these symbols.
// @ts-expect-error
Symbol.dispose ?? (Symbol.dispose = Symbol("@@dispose"));
// @ts-expect-error
Symbol.asyncDispose ?? (Symbol.asyncDispose = Symbol("@@asyncDispose"));

});

parcelRegister("bnJpA", function(module, exports) {
"use strict";
var $849511834b38a66e$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $849511834b38a66e$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $849511834b38a66e$var$_DB_db;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DB = void 0;

var $95IS0 = parcelRequire("95IS0");
class $849511834b38a66e$var$DB {
    static async open(dbName, migrations, txOptions) {
        const db = await new Promise((resolve, reject)=>{
            const request = indexedDB.open(dbName, migrations.length);
            request.onerror = ()=>reject(request.error);
            request.onsuccess = ()=>resolve(request.result);
            request.onupgradeneeded = ({ oldVersion: oldVersion, newVersion: newVersion })=>{
                const db = request.result;
                try {
                    for(let version = oldVersion; version < (newVersion ?? migrations.length); ++version){
                        const migration = migrations[version];
                        if (migration) migration(db);
                        else throw new Error(`Missing migration for version ${version}`);
                    }
                } catch (err) {
                    db.close();
                    reject(err);
                }
            };
        });
        return new $849511834b38a66e$var$DB(db, txOptions);
    }
    constructor(db, txOptions){
        Object.defineProperty(this, "txOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: txOptions
        });
        $849511834b38a66e$var$_DB_db.set(this, void 0);
        $849511834b38a66e$var$__classPrivateFieldSet(this, $849511834b38a66e$var$_DB_db, db, "f");
        const cleanup = ()=>{
            $849511834b38a66e$var$__classPrivateFieldSet(this, $849511834b38a66e$var$_DB_db, null, "f");
            db.removeEventListener("versionchange", cleanup);
            db.removeEventListener("close", cleanup);
            db.close(); // Can we call close on a "closed" database?
        };
        db.addEventListener("versionchange", cleanup);
        db.addEventListener("close", cleanup);
    }
    get db() {
        if (!$849511834b38a66e$var$__classPrivateFieldGet(this, $849511834b38a66e$var$_DB_db, "f")) throw new Error("Database closed");
        return $849511834b38a66e$var$__classPrivateFieldGet(this, $849511834b38a66e$var$_DB_db, "f");
    }
    get name() {
        return this.db.name;
    }
    get objectStoreNames() {
        return this.db.objectStoreNames;
    }
    get version() {
        return this.db.version;
    }
    async transaction(storeNames, mode, run) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject)=>{
            try {
                const tx = this.db.transaction(storeNames, mode, this.txOptions);
                let result = {
                    done: false
                };
                tx.oncomplete = ()=>{
                    if (result.done) resolve(result.value);
                    else reject(new Error("Transaction completed without result"));
                };
                tx.onerror = ()=>reject(tx.error);
                tx.onabort = ()=>reject(tx.error || new Error("Transaction aborted"));
                try {
                    const value = await run(new $95IS0.DBTransaction(tx));
                    result = {
                        done: true,
                        value: value
                    };
                    tx.commit();
                } catch (err) {
                    tx.abort();
                    throw err;
                }
            } catch (err) {
                reject(err);
            }
        });
    }
    close() {
        const { db: db } = this;
        $849511834b38a66e$var$__classPrivateFieldSet(this, $849511834b38a66e$var$_DB_db, null, "f");
        db.close();
    }
    [($849511834b38a66e$var$_DB_db = new WeakMap(), Symbol.dispose)]() {
        if ($849511834b38a66e$var$__classPrivateFieldGet(this, $849511834b38a66e$var$_DB_db, "f")) return this.close();
    }
}
module.exports.DB = $849511834b38a66e$var$DB;

});
parcelRegister("95IS0", function(module, exports) {
"use strict";
var $69e762f62ba077bf$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $69e762f62ba077bf$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $69e762f62ba077bf$var$_DBTransaction_tx;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DBTransaction = void 0;

var $6u4mF = parcelRequire("6u4mF");
class $69e762f62ba077bf$var$DBTransaction {
    constructor(tx){
        $69e762f62ba077bf$var$_DBTransaction_tx.set(this, void 0);
        $69e762f62ba077bf$var$__classPrivateFieldSet(this, $69e762f62ba077bf$var$_DBTransaction_tx, tx, "f");
        const onAbort = ()=>{
            cleanup();
        };
        const onComplete = ()=>{
            cleanup();
        };
        const cleanup = ()=>{
            $69e762f62ba077bf$var$__classPrivateFieldSet(this, $69e762f62ba077bf$var$_DBTransaction_tx, null, "f");
            tx.removeEventListener("abort", onAbort);
            tx.removeEventListener("complete", onComplete);
        };
        tx.addEventListener("abort", onAbort);
        tx.addEventListener("complete", onComplete);
    }
    get tx() {
        if (!$69e762f62ba077bf$var$__classPrivateFieldGet(this, $69e762f62ba077bf$var$_DBTransaction_tx, "f")) throw new Error("Transaction already ended");
        return $69e762f62ba077bf$var$__classPrivateFieldGet(this, $69e762f62ba077bf$var$_DBTransaction_tx, "f");
    }
    async abort() {
        const { tx: tx } = this;
        $69e762f62ba077bf$var$__classPrivateFieldSet(this, $69e762f62ba077bf$var$_DBTransaction_tx, null, "f");
        tx.abort();
    }
    async commit() {
        const { tx: tx } = this;
        $69e762f62ba077bf$var$__classPrivateFieldSet(this, $69e762f62ba077bf$var$_DBTransaction_tx, null, "f");
        tx.commit?.();
    }
    objectStore(name) {
        const store = this.tx.objectStore(name);
        return new $6u4mF.DBObjectStore(store);
    }
    [($69e762f62ba077bf$var$_DBTransaction_tx = new WeakMap(), Symbol.dispose)]() {
        if ($69e762f62ba077bf$var$__classPrivateFieldGet(this, $69e762f62ba077bf$var$_DBTransaction_tx, "f")) this.commit();
    }
}
module.exports.DBTransaction = $69e762f62ba077bf$var$DBTransaction;

});
parcelRegister("6u4mF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DBObjectStore = void 0;

var $bLaWA = parcelRequire("bLaWA");

var $3yVAC = parcelRequire("3yVAC");
class $4b88ee2538b66a6f$var$DBObjectStore {
    constructor(idbObjStore){
        Object.defineProperty(this, "idbObjStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: idbObjStore
        });
    }
    get name() {
        return this.idbObjStore.name;
    }
    index(name) {
        return new $bLaWA.DBIndex(this.idbObjStore.index(name));
    }
    get(key) {
        return (0, $3yVAC.promisify)(this.idbObjStore.get(key));
    }
    getKey(query) {
        return (0, $3yVAC.promisify)(this.idbObjStore.getKey(query));
    }
    getAll(query, count) {
        return (0, $3yVAC.promisify)(this.idbObjStore.getAll(query, count));
    }
    getAllKeys(query, count) {
        return (0, $3yVAC.promisify)(this.idbObjStore.getAllKeys(query, count));
    }
    add(value, key) {
        return (0, $3yVAC.promisify)(this.idbObjStore.add(value, key));
    }
    put(value, key) {
        return (0, $3yVAC.promisify)(this.idbObjStore.put(value, key));
    }
    delete(key) {
        return (0, $3yVAC.promisify)(this.idbObjStore.delete(key));
    }
    clear() {
        return (0, $3yVAC.promisify)(this.idbObjStore.clear());
    }
}
module.exports.DBObjectStore = $4b88ee2538b66a6f$var$DBObjectStore;

});
parcelRegister("bLaWA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DBIndex = void 0;

var $3yVAC = parcelRequire("3yVAC");
class $88fc92c22f0674d7$var$DBIndex {
    constructor(idbIndex){
        Object.defineProperty(this, "idbIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: idbIndex
        });
    }
    count(query) {
        return (0, $3yVAC.promisify)(this.idbIndex.count(query));
    }
    get(query) {
        return (0, $3yVAC.promisify)(this.idbIndex.get(query));
    }
    getKey(query) {
        return (0, $3yVAC.promisify)(this.idbIndex.getKey(query));
    }
    getAll(query, count) {
        return (0, $3yVAC.promisify)(this.idbIndex.getAll(query, count));
    }
    getAllKeys(query, count) {
        return (0, $3yVAC.promisify)(this.idbIndex.getAllKeys(query, count));
    }
    deleteAll(query) {
        return new Promise((resolve, reject)=>{
            const result = this.idbIndex.openCursor(query);
            result.onsuccess = function(event) {
                const cursor = event.target.result;
                if (cursor) {
                    cursor.delete();
                    cursor.continue();
                } else resolve();
            };
            result.onerror = function(event) {
                reject(event.target?.error || new Error("Unexpected error"));
            };
        });
    }
}
module.exports.DBIndex = $88fc92c22f0674d7$var$DBIndex;

});
parcelRegister("3yVAC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.promisify = module.exports.handleRequest = void 0;
function $2981382c10919bdc$var$handleRequest(request, onSuccess, onError) {
    const cleanup = ()=>{
        request.removeEventListener("success", success);
        request.removeEventListener("error", error);
    };
    const success = ()=>{
        onSuccess(request.result);
        cleanup();
    };
    const error = ()=>{
        onError(request.error || new Error("Unknown error"));
        cleanup();
    };
    request.addEventListener("success", success);
    request.addEventListener("error", error);
}
module.exports.handleRequest = $2981382c10919bdc$var$handleRequest;
function $2981382c10919bdc$var$promisify(request) {
    return new Promise((resolve, reject)=>{
        $2981382c10919bdc$var$handleRequest(request, resolve, reject);
    });
}
module.exports.promisify = $2981382c10919bdc$var$promisify;

});







parcelRegister("20NiT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserRuntimeImplementation = void 0;

var $h3MMF = parcelRequire("h3MMF");
/**
 * @see {@link // https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request}
 */ const $1771d387fe46e6bc$var$nativeRequestLock = navigator.locks?.request ? (name, fn)=>navigator.locks.request(name, {
        mode: "exclusive"
    }, async ()=>fn()) : undefined;
class $1771d387fe46e6bc$var$BrowserRuntimeImplementation {
    constructor(){
        Object.defineProperty(this, "requestLock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $1771d387fe46e6bc$var$nativeRequestLock
        });
        if (typeof crypto !== "object" || !crypto?.subtle) throw new Error("Crypto with CryptoSubtle is required. If running in a browser, make sure the current page is loaded over HTTPS.");
        if (!this.requestLock) // There is no real need to polyfill this on older browsers. Indeed, the
        // oauth-client library will try and recover from concurrency issues when
        // refreshing tokens.
        console.warn("Locks API not available. You should consider using a more recent browser.");
    }
    async createKey(algs) {
        return $h3MMF.WebcryptoKey.generate(algs);
    }
    getRandomValues(byteLength) {
        return crypto.getRandomValues(new Uint8Array(byteLength));
    }
    async digest(data, { name: name }) {
        switch(name){
            case "sha256":
            case "sha384":
            case "sha512":
                {
                    const buf = await crypto.subtle.digest(`SHA-${name.slice(3)}`, data);
                    return new Uint8Array(buf);
                }
            default:
                throw new Error(`Unsupported digest algorithm: ${name}`);
        }
    }
}
module.exports.BrowserRuntimeImplementation = $1771d387fe46e6bc$var$BrowserRuntimeImplementation;

});

parcelRegister("51ST3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoginContinuedInParentWindowError = void 0;
/**
 * Special error class destined to be thrown when the login process was
 * performed in a popup and should be continued in the parent/initiating window.
 */ class $3a979f2a0e419d70$var$LoginContinuedInParentWindowError extends Error {
    constructor(){
        super("Login complete, please close the popup window.");
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "LOGIN_CONTINUED_IN_PARENT_WINDOW"
        });
    }
}
module.exports.LoginContinuedInParentWindowError = $3a979f2a0e419d70$var$LoginContinuedInParentWindowError;

});

parcelRegister("4B1hY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildLoopbackClientId = void 0;

var $auA9I = parcelRequire("auA9I");
/**
 * @example
 * ```ts
 * const clientId = buildLoopbackClientId(window.location)
 * ```
 */ function $358b9e0f3e39cebe$var$buildLoopbackClientId(location, localhost = "127.0.0.1") {
    if (!(0, $auA9I.isLoopbackHost)(location.hostname)) throw new TypeError(`Expected a loopback host, got ${location.hostname}`);
    const redirectUri = `http://${location.hostname === "localhost" ? localhost : location.hostname}${location.port && !location.port.startsWith(":") ? `:${location.port}` : location.port}${location.pathname}`;
    return `http://localhost${location.pathname === "/" ? "" : location.pathname}?redirect_uri=${encodeURIComponent(redirectUri)}`;
}
module.exports.buildLoopbackClientId = $358b9e0f3e39cebe$var$buildLoopbackClientId;

});


// import { Agent } from '@atproto/api'
var $a0b2960f62553c3e$exports = {};
"use strict";
var $a0b2960f62553c3e$var$__createBinding = $a0b2960f62553c3e$exports && $a0b2960f62553c3e$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a0b2960f62553c3e$var$__exportStar = $a0b2960f62553c3e$exports && $a0b2960f62553c3e$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a0b2960f62553c3e$var$__createBinding(exports1, m, p);
};
Object.defineProperty($a0b2960f62553c3e$exports, "__esModule", {
    value: true
});
$a0b2960f62553c3e$exports.buildLoopbackClientId = void 0;
parcelRequire("6AwK3");

$a0b2960f62553c3e$var$__exportStar((parcelRequire("h3MMF")), $a0b2960f62553c3e$exports);

$a0b2960f62553c3e$var$__exportStar((parcelRequire("cNZAj")), $a0b2960f62553c3e$exports);

$a0b2960f62553c3e$var$__exportStar((parcelRequire("7JhZC")), $a0b2960f62553c3e$exports);

$a0b2960f62553c3e$var$__exportStar((parcelRequire("51ST3")), $a0b2960f62553c3e$exports);

var $4B1hY = parcelRequire("4B1hY");
Object.defineProperty($a0b2960f62553c3e$exports, "buildLoopbackClientId", {
    enumerable: true,
    get: function() {
        return $4B1hY.buildLoopbackClientId;
    }
});


async function $f43313d21d3fd8e2$var$main() {
    const oauthClient = await (0, $a0b2960f62553c3e$exports.BrowserOAuthClient).load({
        clientId: "https://atp-oauth-test.pages.dev/client-metadata.json",
        handleResolver: "https://bsky.social/"
    });
    const result = await oauthClient.init();
    const agent = result?.agent;
    if (result) {
        if ("state" in result) console.log("The user was just redirected back from the authorization page");
        console.log(`The user is currently signed in as`, result);
    /*const doThisThing = async () => {

            console.log(await result?.agent.oauthAgent);
        }
        
        doThisThing();*/ }
    //const session = result?.session
    if (!agent) {
        const handle = prompt("Enter your atproto handle to authenticate");
        if (!handle) throw new Error("Authentication process canceled by the user");
        const url = await oauthClient.authorize(handle);
        // Redirect the user to the authorization page
        window.open(url, "_self", "noopener");
        // Protect against browser's back-forward cache
        await new Promise((resolve, reject)=>{
            setTimeout(reject, 10000, new Error("User navigated back from the authorization page"));
        });
    }
    if (agent) {
        //const agent = new Agent(session)
        const fetchProfile = async ()=>{
            const profile = await agent.getProfile({
                actor: agent.did
            });
            return profile.data;
        };
        // Update the user interface
        document.body.textContent = `Authenticated as ${agent.did}`;
        const profileBtn = document.createElement("button");
        document.body.appendChild(profileBtn);
        profileBtn.textContent = "Fetch Profile";
        profileBtn.onclick = async ()=>{
            const profile = await fetchProfile();
            outputPre.textContent = JSON.stringify(profile, null, 2);
        };
        const logoutBtn = document.createElement("button");
        document.body.appendChild(logoutBtn);
        logoutBtn.textContent = "Logout";
        logoutBtn.onclick = async ()=>{
            await result.agent.oauthAgent.signOut(); // await session.signOut()
            window.location.reload();
        };
        const outputPre = document.createElement("pre");
        document.body.appendChild(outputPre);
    }
}
document.addEventListener("DOMContentLoaded", $f43313d21d3fd8e2$var$main);


//# sourceMappingURL=index.44c6d76d.js.map
